export const QUESTIONS = [
    {
       "id":1122,
       "practice_test_id":"",
       "topic_id":1,
       "question":"All of the following are methods of dividend payment except:",
       "choice_a":"Stock",
       "choice_b":"Cash",
       "choice_c":"Rights",
       "choice_d":"Product",
       "correct_answer":"C",
       "explanation":"While dividends are normally paid in cash, they may be paid in stock or product. Pre­emptive rights are created when an established corporation decides to raise capital by issuing additional shares of stock, with existing share­ holders getting first crack at the new shares."
    },
    {
       "id":1123,
       "practice_test_id":"",
       "topic_id":1,
       "question":"Which of the following does not pay a dividend?",
       "choice_a":"Warrant",
       "choice_b":"Mutual fund",
       "choice_c":"ADR",
       "choice_d":"Unit investment trust",
       "correct_answer":"A",
       "explanation":"Warrants are long-term options to buy stock and do not pay dividends."
    },
    {
       "id":1124,
       "practice_test_id":"",
       "topic_id":1,
       "question":"Regarding a cash dividend, an issuer\u0027s board of directors sets all of the following except the:",
       "choice_a":"Declaration date",
       "choice_b":"Ex-dividend date",
       "choice_c":"Record date",
       "choice_d":"Payable date",
       "correct_answer":"B",
       "explanation":"When an issuer\u0027s board of directors declares a cash dividend, it establishes the declaration date, the record date and the payable date. The ex-dividend date is set by FINRA under the uniform practice code."
    },
    {
       "id":1125,
       "practice_test_id":"",
       "topic_id":1,
       "question":"SIA currently has earnings of $4 and pays a $.50 quarterly dividend. SIA\u0027s market price is $40. What is the current yield?",
       "choice_a":"1.25%",
       "choice_b":"5%",
       "choice_c":"10%",
       "choice_d":"15%",
       "correct_answer":"B",
       "explanation":"The quarterly dividend is $.50; therefore, the annual dividend is $2. $2 divided by the $40 market price equals a 5% current yield."
    },
    {
       "id":1126,
       "practice_test_id":"",
       "topic_id":1,
       "question":"For tax purposes, cash dividends are taxable to stockholders as of the:",
       "choice_a":"Declaration date",
       "choice_b":"Ex-date",
       "choice_c":"Record date",
       "choice_d":"Payable date",
       "correct_answer":"D",
       "explanation":"Cash dividends are not taxable until rendered, which is the payable date."
    },
    {
       "id":1127,
       "practice_test_id":"",
       "topic_id":1,
       "question":"SIA Enterprises, which has a 7% $100 par cumulative preferred stock outstanding, has the following dividend record: last year, 5% was paid to preferred stockholders; the full preferred dividend was paid until last year. Now SIA wishes to declare a common dividend. Before SIA can pay dividends to the common stockholders, how much must it pay on each preferred share outstanding?",
       "choice_a":"$3",
       "choice_b":"$7",
       "choice_c":"$9",
       "choice_d":"$15",
       "correct_answer":"C",
       "explanation":"To pay this year\u0027s common dividend, the corporation must pay the preferred stockholders the 2% not paid last year and this year\u0027s 7% dividend in total, 9%, or $9. Remember, the preferred stock is cumulative, which gives holders the right to dividends in arrears."
    },
    {
       "id":1128,
       "practice_test_id":"",
       "topic_id":1,
       "question":"SIA common stock is currently selling for $75 per share with a quarterly dividend of $.75. The current yield for SIA common stock is:",
       "choice_a":"1%",
       "choice_b":"4%",
       "choice_c":"12.50%",
       "choice_d":"25%",
       "correct_answer":"B",
       "explanation":"The $3 annual dividend divided by the $75 market price equals 4%."
    },
    {
       "id":1129,
       "practice_test_id":"",
       "topic_id":1,
       "question":"Which of the following statements regarding the effects of a stock dividend is true?",
       "choice_a":"The par value of the stock is decreased",
       "choice_b":"Capital surplus is reduced",
       "choice_c":"New capital is channeled to the company",
       "choice_d":"Net current assets are decreased",
       "correct_answer":"A",
       "explanation":"A stock dividend results in an increased number of outstanding shares, each with a lower value per share. The total value of stock outstanding is unchanged. On the issuer\u0027s balance sheet, the par value per share is reduced. There is no new capital generated from a stock dividend; current assets are unchanged because there is no increase or decrease to the company\u0027s cash as a result of the stock dividend."
    },
    {
       "id":1130,
       "practice_test_id":"",
       "topic_id":1,
       "question":"SIA is currently paying an $.80 quarterly dividend. The stock has a $10 par value and is trading in the market for $50 per share. What is its current yield?",
       "choice_a":"1.60%",
       "choice_b":"6.40%",
       "choice_c":"8%",
       "choice_d":"32%",
       "correct_answer":"B",
       "explanation":"The quarterly dividend is $.80; multiplying the quarterly dividend by 4 results in an annualized dividend of $3.20. The annualized dividend divided by the current price equals the current yield: $3.20 / $50 = 6.4% current yield."
    },
    {
       "id":1131,
       "practice_test_id":"",
       "topic_id":1,
       "question":"Which of the following must be paid before a corporation can pay a cash dividend on its common stock? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Straight preferred stock dividends </li><li>Bond interest </li><li>Cumulative preferred stock dividend arrearages </li><li>Callable preferred stock dividends</li></ol>",
       "choice_a":"I only",
       "choice_b":"II only",
       "choice_c":"I, III and IV",
       "choice_d":"I, II, III and IV",
       "correct_answer":"D",
       "explanation":"A corporation must pay interest to its bondholders and dividends to its preferred stock holders before it may pay a dividend to common stockholders."
    },
    {
       "id":1132,
       "practice_test_id":1,
       "topic_id":1,
       "question":"A 2-for-l split has which of the following effects on the issuer\u0027s financial position? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Increase in the number of outstanding shares </li><li>Decrease in retained earnings </li><li>Decrease in par value per share</li></ol>",
       "choice_a":"I only",
       "choice_b":"I and III",
       "choice_c":"II only",
       "choice_d":"I, II and III",
       "correct_answer":"B",
       "explanation":"After a 2-for-l stock split, the number of outstanding shares doubles, and the par value per share decreases by half. Retained earnings are not affected."
    },
    {
       "id":1133,
       "practice_test_id":2,
       "topic_id":1,
       "question":"Which of the following statements regarding the effects of a stock dividend is true?",
       "choice_a":"The par value of the stock is decreased",
       "choice_b":"Capital surplus is reduced",
       "choice_c":"New capital is channeled to the company",
       "choice_d":"Net current assets are decreased",
       "correct_answer":"A",
       "explanation":"A stock dividend results in an increased number of outstanding shares, each with a lower value per share. The total value of stock outstanding is unchanged. On the issuer\u0027s balance sheet, the par value per share is reduced. There is no new capital generated from a stock dividend; current assets are unchanged because there is no increase or decrease to the company\u0027s cash as a result of the stock dividend."
    },
    {
       "id":1134,
       "practice_test_id":3,
       "topic_id":1,
       "question":"SIA is authorized to issue 1 million shares of common stock. It originally issued 600,000 shares and later repurchased 40,000 shares for its treasury. SIA declares a dividend of S2 per share. How many shares of common stock will receive the dividend?",
       "choice_a":"40,000",
       "choice_b":"560,000",
       "choice_c":"600,000",
       "choice_d":"1,000,000",
       "correct_answer":"B",
       "explanation":"Treasury stock are shares that have been reacquired by the corporation. Stock issued minus stock reacquired equals the amount of stock out standing."
    },
    {
       "id":1135,
       "practice_test_id":4,
       "topic_id":1,
       "question":"SIA Corporation declares a 5-4 stock split. On the ex-date, the price of SIA common will be reduced by:",
       "choice_a":"20%",
       "choice_b":"25%",
       "choice_c":"50%",
       "choice_d":"80%",
       "correct_answer":"A",
       "explanation":"As a result of a stock split, an investor will have more shares at less value per share, but overall value of the investment will remain the same. For example: an investor owns 100 shares at $50 per share worth $5000. After a 5-for-4 split, the investor will have 125 shares (100 x 5 / 4); the total ownership interest of $5000 is divided by the new number of shares to determine the per share price of $40. The decrease of 50 to 40 is a 20% reduction. Generally, the percent decrease in price will always be less than the percent increase in the number of shares. The percent increase in shares in a 5-for-4 split is 25%."
    },
    {
       "id":1136,
       "practice_test_id":5,
       "topic_id":1,
       "question":"SIA Corp. has set Friday, January 23rd, as the record date for its next quarterly dividend distribution. In order to receive the dividend, a customer, long 1 SIA Feb 40 call, must issue exercise instructions on or before",
       "choice_a":"Monday, January 19th",
       "choice_b":"Tuesday, January 20th",
       "choice_c":"Friday, January 23rd",
       "choice_d":"Tuesday, January 27th",
       "correct_answer":"B",
       "explanation":"Dividends are paid to investors who are owners of record as of the close of business on record date. When a call option is exercised, money and stock are exchanged on the third business day after notice is given to the OCC. There fore, an investor who wishes to receive a dividend must exercise a call no later than the third business day prior to the record date, i.e., before the ex-date."
    },
    {
       "id":1137,
       "practice_test_id":6,
       "topic_id":1,
       "question":"SIA, Inc. will issue new stock through a rights offering. Terms of the offering are 10 rights plus $10 to purchase one new share of stock, with any fractional shares to be considered whole shares. SIA is currently trading at $13. If your customer owns 85 shares of SIA and wishes to subscribe to the new offering, how many shares can he purchase at the subscription price and how much money will be required?",
       "choice_a":"Eight shares; $80",
       "choice_b":"Eight shares; $90",
       "choice_c":"Nine shares; $80",
       "choice_d":"Nine shares; $90",
       "correct_answer":"D",
       "explanation":"Your customer is entitled to 90 rights with his current holding of 85 shares (fractional shares are rounded up). Because each share requires 10 rights and $10, the customer can buy 90 shares and must pay $90."
    },
    {
       "id":1138,
       "practice_test_id":"",
       "topic_id":1,
       "question":"Which of the following actions of SIA Corporation would raise additional capital? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Issue callable preferred stock </li><li>Declare a stock dividend </li><li>Make a rights offering </li><li>Encourage convertible bondholders to convert to common stock</li></ol>",
       "choice_a":"I, II and IV",
       "choice_b":"I and III",
       "choice_c":"I, III and IV",
       "choice_d":"II and IV",
       "correct_answer":"B",
       "explanation":"Issuing new stock either through an underwriting or a rights offering allows a corporation to raise capital. Stock dividends represent more shares given to existing shareholders, but no money is raised. Conversion results in the exchange of one security for another and no money is involved."
    },
    {
       "id":1139,
       "practice_test_id":"",
       "topic_id":1,
       "question":"The rate on an adjustable preferred stock may be indexed to the:",
       "choice_a":"Treasury bill rate",
       "choice_b":"consumer Price Index",
       "choice_c":"Producer Price Index",
       "choice_d":"Dow Jones Industrial Average",
       "correct_answer":"A",
       "explanation":"The dividend on an adjustable rate preferred is tied to a particular interest rate. The Treasury bill rate is a common benchmark."
    },
    {
       "id":1140,
       "practice_test_id":"",
       "topic_id":1,
       "question":"A bank with a short fall meeting their reserve requirement could borrow money from another bank and pay the:",
       "choice_a":"Prime rate",
       "choice_b":"Discount Rate",
       "choice_c":"Federal funds rate",
       "choice_d":"Broker call loan rate",
       "correct_answer":"C",
       "explanation":"A bank may borrow money from another bank to meet their reserve requirement and it will pay the other bank the federal funds rate."
    },
    {
       "id":1141,
       "practice_test_id":"",
       "topic_id":1,
       "question":"A bond which pays no semi-annual interest is:",
       "choice_a":"Subordinated debentures",
       "choice_b":"Convertible bonds",
       "choice_c":"Income/Adjustment bonds",
       "choice_d":"Zero coupon bonds",
       "correct_answer":"D",
       "explanation":"Zero coupon bonds pay no semi-annual interest; they are issued at a steep discount and are expected to appreciate greatly by maturity."
    },
    {
       "id":1142,
       "practice_test_id":"",
       "topic_id":1,
       "question":"A bond\u0027s yield to maturity is all of the following except:",
       "choice_a":"The most important yield for the investor",
       "choice_b":"The investor\u0027s total annualized return",
       "choice_c":"Has the lowest return if the bond is a premium bond",
       "choice_d":"Is the lowest return if the bond is a discount bond",
       "correct_answer":"D",
       "explanation":"If the bond is bought at a discounted price, the bond\u0027s yield to maturity will be the highest yield."
    },
    {
       "id":1143,
       "practice_test_id":"",
       "topic_id":1,
       "question":"A brokerage firm making markets in an over the counter security is acting in its capacity as a:",
       "choice_a":"Broker",
       "choice_b":"Dealer",
       "choice_c":"Agent",
       "choice_d":"Underwriter",
       "correct_answer":"B",
       "explanation":"A brokerage firm making markets over the counter is acting as a dealer."
    },
    {
       "id":1144,
       "practice_test_id":"",
       "topic_id":1,
       "question":"A business cycle is defined as having how many distinct stages?",
       "choice_a":2,
       "choice_b":3,
       "choice_c":4,
       "choice_d":5,
       "correct_answer":"C",
       "explanation":"The business cycle has four distinct stages: expansion, peak, contraction, and trough."
    },
    {
       "id":1145,
       "practice_test_id":"",
       "topic_id":1,
       "question":"A company doing a pre-emptive rights offering would most likely use what type of underwriting agreement:",
       "choice_a":"Firm commitment",
       "choice_b":"Best efforts",
       "choice_c":"Stand by",
       "choice_d":"All or none",
       "correct_answer":"C",
       "explanation":"A company doing a pre-emptive rights offering will use a standby underwriting agreement where the underwriter will \u0022standby\u0022 ready to purchase any shares not purchased by shareholders."
    },
    {
       "id":1146,
       "practice_test_id":"",
       "topic_id":1,
       "question":"A corporate bond purchased at 100 with an annual interest rate of 9% has what current yield?",
       "choice_a":"9%",
       "choice_b":"90%",
       "choice_c":"11.10%",
       "choice_d":"$90",
       "correct_answer":"A",
       "explanation":"Annual income ($90) divided by the current market price ($1000) = 9%."
    },
    {
       "id":1147,
       "practice_test_id":"",
       "topic_id":1,
       "question":"A corporate bond purchased at 150 with an annual interest rate of 8% has what current yield?",
       "choice_a":"5.33%",
       "choice_b":"12%",
       "choice_c":"7.50%",
       "choice_d":"$120",
       "correct_answer":"A",
       "explanation":"Annual income ($80) divided by the current market price ($1500) = 5.33%."
    },
    {
       "id":1148,
       "practice_test_id":"",
       "topic_id":1,
       "question":"A corporate bond purchased at 92 with an annual interest rate of 7% has what current yield?",
       "choice_a":"6.44%",
       "choice_b":"7.60%",
       "choice_c":"8.20%",
       "choice_d":"$64.40",
       "correct_answer":"B",
       "explanation":"Annual income ($70) divided by the current market price ($920) = 7.6%."
    },
    {
       "id":1149,
       "practice_test_id":"",
       "topic_id":1,
       "question":"A corporation announces on May 7th that it will pay a dividend to holders of record as of July 16th. If a transaction is made on Monday, July 14th:",
       "choice_a":"The buyer will receive a due bill for the dividend",
       "choice_b":"The buyer will receive the dividend when it is distributed",
       "choice_c":"The seller will receive the dividend",
       "choice_d":"The seller will receive a due bill",
       "correct_answer":"C",
       "explanation":"Monday, July 14 is the ex-dividend date. Therefore, the buyer will not be an owner of record on the record date and the seller will be entitled to receive the dividend."
    },
    {
       "id":1150,
       "practice_test_id":"",
       "topic_id":1,
       "question":"A corporation has recently had its debt rated by S\u0026P. It was assigned an initial rating of BB+. What can be said about these bonds?",
       "choice_a":"They are investment grade",
       "choice_b":"They are a low investment grade bond",
       "choice_c":"They are speculative",
       "choice_d":"They are nearing default",
       "correct_answer":"C",
       "explanation":"A rating of BB+ would be in the speculative, or junk bond rating, for S\u0026P."
    },
    {
       "id":1151,
       "practice_test_id":"",
       "topic_id":1,
       "question":"A corporation may issue additional shares of stock for all of the following reasons except:",
       "choice_a":"To raise additional funds",
       "choice_b":"To expand operations",
       "choice_c":"To regain control of the company",
       "choice_d":"To exchange common shares for convertible bonds",
       "correct_answer":"C",
       "explanation":"A company would not issue more stock to regain control of the company. This would sell off more of the company to outsiders."
    },
    {
       "id":1152,
       "practice_test_id":"",
       "topic_id":1,
       "question":"A corporation may pay a dividend in which of the following ways?",
       "choice_a":"Stock",
       "choice_b":"Cash",
       "choice_c":"Stock of another company",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"All of the ways listed are ways that a company can pay a dividend."
    },
    {
       "id":1153,
       "practice_test_id":"",
       "topic_id":1,
       "question":"A decline in the GDP must last at least how long to be considered a recession?",
       "choice_a":"One quarter",
       "choice_b":"Two quarters",
       "choice_c":"Four quarters",
       "choice_d":"Six quarters",
       "correct_answer":"B",
       "explanation":"A decline in the gross domestic product must last at least 2 quarters or 6 months to be considered a recession."
    },
    {
       "id":1154,
       "practice_test_id":"",
       "topic_id":1,
       "question":"A quote for a corporate bond from the GSC Company of 96.125 translates into:",
       "choice_a":"$96.13",
       "choice_b":"$961.25",
       "choice_c":"$9,612.50",
       "choice_d":"Cannot be determined",
       "correct_answer":"B",
       "explanation":"Corporate bonds are quoted as a percentage of par. A quote of 96.125 = 96.125% x $1000 = $961.25."
    },
    {
       "id":1155,
       "practice_test_id":"",
       "topic_id":1,
       "question":"A secured bond is one which:",
       "choice_a":"Is backed by a pledge of unnamed assets",
       "choice_b":"Offers the company\u0027s entire inventory as collateral",
       "choice_c":"Gives a trustee title to the collateral, which will be sold off to repay bondholders in the event of default",
       "choice_d":"Is held in trust by a trustee who will protect the investors",
       "correct_answer":"C",
       "explanation":"A secured bond is backed by a pledge of very specific collateral which a trustee will attempt to sell off in an effort to pay the bondholders in the event of default."
    },
    {
       "id":1156,
       "practice_test_id":1,
       "topic_id":1,
       "question":"A small town might issue a general obligation bond (GO bond) for which of the following?",
       "choice_a":"To fund a private corporation that is purchasing equipment",
       "choice_b":"To build a new school",
       "choice_c":"To improve a theatre which will pay back the investors from its revenues collected",
       "choice_d":"To lower the sales tax for that state or municipality",
       "correct_answer":"B",
       "explanation":"A general obligation bond is issued to fund projects which will benefit an entire community and the financed projects generally do not produce any kind of revenue."
    },
    {
       "id":1157,
       "practice_test_id":2,
       "topic_id":1,
       "question":"A small town might issue a revenue bond for which of the following?",
       "choice_a":"To fund a private corporation that is purchasing equipment",
       "choice_b":"To build a new school",
       "choice_c":"To improve a theatre which will pay back the investors from its revenues collected",
       "choice_d":"To lower the sales tax for that state or municipality",
       "correct_answer":"C",
       "explanation":"Revenue bonds support investors\u0027 return from the revenues generated from the theatre."
    },
    {
       "id":1158,
       "practice_test_id":3,
       "topic_id":1,
       "question":"A small town might issue an industrial development bond for which of the following?",
       "choice_a":"To fund a private corporation that is purchasing equipment",
       "choice_b":"To build a new school",
       "choice_c":"To improve a theatre which will pay back the investors from its revenues collected",
       "choice_d":"To lower the income tax for that state or municipality",
       "correct_answer":"A",
       "explanation":"An industrial development bond is a municipal bond issued for the benefit of a corporation which will then lease the improved facility or equipment back to the municipality to support the repayment of the bond."
    },
    {
       "id":1159,
       "practice_test_id":4,
       "topic_id":1,
       "question":"A technology company whose shares are in high demand would most likely have what type of underwriting agreement?",
       "choice_a":"All or none",
       "choice_b":"Mini/maxi",
       "choice_c":"Best efforts",
       "choice_d":"Firm commitment",
       "correct_answer":"D",
       "explanation":"Any company going public whose shares are in high demand will have a firm commitment underwriting."
    },
    {
       "id":1160,
       "practice_test_id":5,
       "topic_id":1,
       "question":"A warrant is issued and attached to a bond issue to provide the issuer with which of the following",
       "choice_a":"Higher interest rate",
       "choice_b":"Higher ratings",
       "choice_c":"Lower interest rate",
       "choice_d":"Lower risk of default",
       "correct_answer":"C",
       "explanation":"The advantage to attaching warrants to a bond issuer is that it generally allows the issuer to offer a lower state rate of interest on the bonds. Warrants improve the marketability of bonds with low credit ratings as well."
    },
    {
       "id":1161,
       "practice_test_id":6,
       "topic_id":1,
       "question":"ABC common stock has declined dramatically in value over the last quarter, but the dividend it has declared for payment this quarter has remained the same. The dividend yield on the stock has:",
       "choice_a":"Not changed because the board has to declare the dividend amount",
       "choice_b":"Gone down because the yield is a stated rate",
       "choice_c":"Gone up as the price of ABC has fallen",
       "choice_d":"Been fixed at the time of issuance",
       "correct_answer":"C",
       "explanation":"The yield on the stock will have gone up as the price has fallen because the dividend has remained constant."
    },
    {
       "id":1162,
       "practice_test_id":"",
       "topic_id":1,
       "question":"ABC Company wishes to issue additional shares to raise money to build a new plant. The issuance of the new shares will cause them to exceed the number of shares which have been authorized for issuance. Which of the following is true?",
       "choice_a":"ABC may be in violation of the corporate finance act",
       "choice_b":"ABC must get approval of the board of directors before issuing the shares",
       "choice_c":"ABC must get the approval of FINRA\u0027s corporate finance committee",
       "choice_d":"ABC must get approval from the outstanding shares",
       "correct_answer":"D",
       "explanation":"In order to increase the number of authorized shares, ABC must get the approval of the outstanding shares."
    },
    {
       "id":1163,
       "practice_test_id":"",
       "topic_id":1,
       "question":"ABC has issued 7% subordinated debentures, which are convertible into common shares at $12.50 per share. Which of the following are true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The bonds are backed by common stock </li><li>The bonds are backed by the full faith of ABC </li><li>The holder of the bond is an owner of ABC since the bonds are convertible </li><li>The holder of the bonds is a creditor of the company and has a senior position relative to common stockholders.</li></ol>",
       "choice_a":"II and IV",
       "choice_b":"I and II",
       "choice_c":"II and III",
       "choice_d":"IV only",
       "correct_answer":"A",
       "explanation":"The bonds are debentures and are backed by the full faith and credit of the issuer. Since the holder of the bond is a creditor of the company, they have a senior position if the company is forced to liquidate."
    },
    {
       "id":1164,
       "practice_test_id":"",
       "topic_id":1,
       "question":"Airlines, railroads and large shipping firms will sell what types of bonds?",
       "choice_a":"Real estate trust certificates",
       "choice_b":"Mortgage bonds",
       "choice_c":"Equipment trust certificates",
       "choice_d":"Collateral trust certificates",
       "correct_answer":"C",
       "explanation":"These large companies will often sell equipment trust certificates in order to purchase new equipment for the businesses."
    },
    {
       "id":1165,
       "practice_test_id":"",
       "topic_id":1,
       "question":"All but which of the following are possible outcomes for options?",
       "choice_a":"Many investors will sell the options to another investor rather than exercise them.",
       "choice_b":"Many investors will exercise their options by buying or selling the stocks involved.",
       "choice_c":"Some options are allowed to expire, being neither bought nor sold.",
       "choice_d":"Some options can be deposited with the OCC for exercising in the future",
       "correct_answer":"D",
       "explanation":"Options cannot be deposited with any company or held by any company for future purchases."
    },
    {
       "id":1166,
       "practice_test_id":"",
       "topic_id":1,
       "question":"All of the following actions may take place with a warrant except?",
       "choice_a":"Exercise",
       "choice_b":"Call",
       "choice_c":"Expire",
       "choice_d":"Sold",
       "correct_answer":"B",
       "explanation":"Warrants may be exercised, sold, or they can expire. They are usually not callable by the company."
    },
    {
       "id":1167,
       "practice_test_id":"",
       "topic_id":1,
       "question":"All of the following are backed by pools of mortgages except:",
       "choice_a":"CMOs",
       "choice_b":"GNMAs",
       "choice_c":"Fannie Mae bonds",
       "choice_d":"Treasury STRIPs",
       "correct_answer":"D",
       "explanation":"Ginnie Mae\u0027s CMO\u0027s and Fannie Mae all deal in the secondary mortgage market. Treasury STRIPs are US Government issued zero coupon bonds."
    },
    {
       "id":1168,
       "practice_test_id":"",
       "topic_id":1,
       "question":"All of the following are corporate money market instruments except:",
       "choice_a":"Negotiable certificates of deposit",
       "choice_b":"Treasury bills",
       "choice_c":"Federal funds",
       "choice_d":"Commercial paper",
       "correct_answer":"B",
       "explanation":"Treasury bills are government money market instruments, not corporate money market instruments."
    },
    {
       "id":1169,
       "practice_test_id":"",
       "topic_id":1,
       "question":"All of the following are examples of a security except:",
       "choice_a":"Fixed annuity",
       "choice_b":"Mortgage bond",
       "choice_c":"Adjustment bond",
       "choice_d":"CMO",
       "correct_answer":"A",
       "explanation":"A fixed annuity is an insurance contract. The investor is guaranteed a rate of return."
    },
    {
       "id":1170,
       "practice_test_id":"",
       "topic_id":1,
       "question":"All of the following are examples of a security except:",
       "choice_a":"Fixed annuity",
       "choice_b":"Adjustment bond",
       "choice_c":"Mortgage bond",
       "choice_d":"CMO",
       "correct_answer":"A",
       "explanation":"A fixed annuity is an insurance product, not a security."
    },
    {
       "id":1171,
       "practice_test_id":"",
       "topic_id":1,
       "question":"All of the following are non-securities except:",
       "choice_a":"Variable life insurance",
       "choice_b":"Whole life insurance",
       "choice_c":"Mutual funds",
       "choice_d":"Fixed annuities",
       "correct_answer":"C",
       "explanation":"Mutual funds are securities which contain investment risk."
    },
    {
       "id":1172,
       "practice_test_id":"",
       "topic_id":1,
       "question":"All of the following are reasons a corporation would attach a warrant to their bond except:",
       "choice_a":"To save money",
       "choice_b":"To make the bond more attractive",
       "choice_c":"To increase the number of shares outstanding when the warrants are exercised",
       "choice_d":"To lower the Coupon",
       "correct_answer":"C",
       "explanation":"All of the choices listed are reasons a corporation would attach warrants to their bonds except to increase the number of shares outstanding."
    },
    {
       "id":1173,
       "practice_test_id":"",
       "topic_id":1,
       "question":"All of the following are true about municipal bonds except:",
       "choice_a":"If an investor buys a municipal bond issued within the state where they reside, the interest is free from federal, state, and local taxes",
       "choice_b":"If an investor buys a municipal bond and sells it at a profit, the capital gain is taxed as ordinary income",
       "choice_c":"If an investor buys a municipal bond and sells it at a profit, the capital gain is not taxed federally, but it is taxed by the state and local governments",
       "choice_d":"If an investor buys a municipal bond issued by a territory such as Guam or the Virgin Islands, the interest is tax-free on all levels",
       "correct_answer":"C",
       "explanation":"If an investor realizes a profit on a sale of a municipal bond, the capital gain is taxed as ordinary income, by federal, state, and local governments."
    },
    {
       "id":1174,
       "practice_test_id":"",
       "topic_id":1,
       "question":"All of the following are true regarding unsecured bonds except:",
       "choice_a":"They can be pledged as collateral for a bond issue of another company",
       "choice_b":"They are known as debentures",
       "choice_c":"In the event of liquidation, their bondholders are paid first, before general creditors",
       "choice_d":"They are backed only by good faith and credit of the issuer",
       "correct_answer":"C",
       "explanation":"In the event of liquidation, unsecured bonds treat their bondholders as general creditors."
    },
    {
       "id":1175,
       "practice_test_id":1,
       "topic_id":1,
       "question":"All of the following pay semi-annual interest except a:",
       "choice_a":"Mortgage bond",
       "choice_b":"Subordinated debenture",
       "choice_c":"Treasury bond",
       "choice_d":"Treasury receipt",
       "correct_answer":"D",
       "explanation":"All of those listed pay semiannual interest except treasury receipts. They are issued at a discount and mature at par."
    },
    {
       "id":1176,
       "practice_test_id":2,
       "topic_id":1,
       "question":"An 11% bond has a rating of BBB+ from S&P. It is currently quoted at a 9.9% YTM. This bond is selling:",
       "choice_a":"At par",
       "choice_b":"At parity",
       "choice_c":"At a discount",
       "choice_d":"At a premium",
       "correct_answer":"D",
       "explanation":"The yield to maturity is lower than the nominal yield, so the bond has to be trading at a premium."
    },
    {
       "id":1177,
       "practice_test_id":3,
       "topic_id":1,
       "question":"An 11% corporate bond is quoted at a 9% yield to maturity. Which of the following is most likely true?",
       "choice_a":"Interest rates have risen since the bond was issued",
       "choice_b":"Interest rates have remained unchanged",
       "choice_c":"Interest rates have fallen",
       "choice_d":"Investors have become more risk averse and are investing more money in the conservative bond markets",
       "correct_answer":"C",
       "explanation":"When interest rates fall, the value of outstanding bonds rise. The price of bonds move in an inverse relationship to a change in interest rates."
    },
    {
       "id":1178,
       "practice_test_id":4,
       "topic_id":1,
       "question":"An ABC corporate bond is quoted at 110 and is convertible into ABC common at $20 per share. Parity price for the stock is:",
       "choice_a":21,
       "choice_b":22,
       "choice_c":23,
       "choice_d":24,
       "correct_answer":"B",
       "explanation":"The parity price of the stock is found by using the following formulas: # of shares = PAR / CVP  1000/ 20 = 50 Parity Price =  CMV of Bond / # of shares =1100/ 50 = 22."
    },
    {
       "id":1179,
       "practice_test_id":5,
       "topic_id":1,
       "question":"An economist looking at the consumer price index has noticed that it has been consistently rising over the last four quarters. Which of the following is true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Consumer prices are rising  </li><li>Bond yields are falling </li><li> Bond yields are rising </li><li>Bond prices are falling</li></ol>",
       "choice_a":"I & IV",
       "choice_b":"II & IV",
       "choice_c":"I & II",
       "choice_d":"I, III, & IV",
       "correct_answer":"D",
       "explanation":"As the CPI rises, bonds prices are falling, while interest rates and consumer prices are rising."
    },
    {
       "id":1180,
       "practice_test_id":6,
       "topic_id":1,
       "question":"As interest rates change, the rates on which of the following will change the most?",
       "choice_a":"Preferred stock",
       "choice_b":"Long term corporate debt",
       "choice_c":"Intermediate term corporate debt",
       "choice_d":"T-Bills",
       "correct_answer":"D",
       "explanation":"Interest rates on short-term instruments change more quickly than rates on longer-term instruments."
    },
    {
       "id":1181,
       "practice_test_id":"",
       "topic_id":1,
       "question":"Authorized stock is all of the following except:",
       "choice_a":"The maximum number of shares a company may sell",
       "choice_b":"Arbitrarily determined at the time of incorporation and may not be changed",
       "choice_c":"May be sold in total or in part at the beginning of the company",
       "choice_d":"Sold to investors to raise operating capital for the company",
       "correct_answer":"B",
       "explanation":"If the shareholders vote and approve an increase in the number of authorized shares, then more stock may be issued."
    },
    {
       "id":1182,
       "practice_test_id":"",
       "topic_id":1,
       "question":"Bonds and other debt instruments are all of the following except:",
       "choice_a":"They have no set maturity date associated with them",
       "choice_b":"A loan an investor has made to a corporation",
       "choice_c":"A means of raising working capital for the company",
       "choice_d":"They have risk associated with them",
       "correct_answer":"A",
       "explanation":"All bonds and other debt instruments have a set maturity date at which time the principal will be repaid to the investor, and he will no longer be a creditor of the company."
    },
    {
       "id":1183,
       "practice_test_id":"",
       "topic_id":1,
       "question":"Capitalization refers to:",
       "choice_a":"The total amount of money invested in a company",
       "choice_b":"The sources and makeup of the company\u0027s financial picture",
       "choice_c":"A corporation\u0027s assets",
       "choice_d":"The company\u0027s net worth",
       "correct_answer":"B",
       "explanation":"Capitalization refers to the overall picture of a company\u0027s financial situation, including its assets, liabilities, company\u0027s net worth, and the stockholders\u0027 equity as shown on its balance sheet."
    },
    {
       "id":1184,
       "practice_test_id":"",
       "topic_id":1,
       "question":"Collateral trust certificates use which of the following as collateral?",
       "choice_a":"Real estate",
       "choice_b":"Mortgage",
       "choice_c":"Stocks and bonds issued by the same company",
       "choice_d":"Stocks and bonds issued by another company",
       "correct_answer":"D",
       "explanation":"Collateral trust certificates have pledged securities which they own issued by another company."
    },
    {
       "id":1185,
       "practice_test_id":"",
       "topic_id":1,
       "question":"Collateralized mortgage obligations (CMO) may experience which of the following if interest rates change?",
       "choice_a":"If interest rates fall, homeowners will refinance more quickly and the investors will be paid off more quickly than they hoped",
       "choice_b":"The rate of principal payments may vary",
       "choice_c":"If interest rates rise, refinancing may slow down and investors will be paid off more slowly than they hoped",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"All of the choices are correct."
    },
    {
       "id":1186,
       "practice_test_id":"",
       "topic_id":1,
       "question":"During a broad based market advance, which of the following would most likely realize the least amount of capital gains.",
       "choice_a":"A technology fund",
       "choice_b":"A large cap growth fund",
       "choice_c":"An option income fund",
       "choice_d":"A small cap growth fund",
       "correct_answer":"C",
       "explanation":"An option income fund sells call options against its portfolio of common shares to increase the income into the portfolio. As the market price of the shares in the portfolio increase, the shares will be called away and the upside appreciation will therefore be limited."
    },
    {
       "id":1187,
       "practice_test_id":"",
       "topic_id":1,
       "question":"During an inflationary period the price of which of the following will fall the most?",
       "choice_a":"Common stock",
       "choice_b":"Preferred stock",
       "choice_c":"Treasury bonds",
       "choice_d":"Treasury bills",
       "correct_answer":"C",
       "explanation":"During an inflationary period, the price of a treasury bond will fall the most. The fixed income security with the longest maturity will change the most in price as interest rates change."
    },
    {
       "id":1188,
       "practice_test_id":"",
       "topic_id":1,
       "question":"During an inflationary period you would expect: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Bond prices to go up </li><li>Bond prices to go down </li><li>Yields to go up </li><li>Yields to go down</li></ol>",
       "choice_a":"I and IV",
       "choice_b":"II only",
       "choice_c":"II and III",
       "choice_d":"II and IV",
       "correct_answer":"C",
       "explanation":"Anytime you have inflation, bond prices go down and the yields on the bonds go up."
    },
    {
       "id":1189,
       "practice_test_id":"",
       "topic_id":1,
       "question":"During an inflationary period, the FED will:",
       "choice_a":"Reduce spending",
       "choice_b":"Lower rates",
       "choice_c":"Increase spending",
       "choice_d":"Raise rates",
       "correct_answer":"D",
       "explanation":"The Federal Reserve Board controls monetary policy and will always raise rates to fight inflation."
    },
    {
       "id":1190,
       "practice_test_id":"",
       "topic_id":1,
       "question":"Economics involves all of the following except:",
       "choice_a":"The study of supply and demand",
       "choice_b":"As demand rises, price tends to rise",
       "choice_c":"As supply rises, price tends to fall",
       "choice_d":"As supply rises, price tends to rise",
       "correct_answer":"D",
       "explanation":"The main theory of economics is one of supply and demand; if the supply outpaces the demand, the price of the goods will fall."
    },
    {
       "id":1191,
       "practice_test_id":"",
       "topic_id":1,
       "question":"Economists chart the health of a nation\u0027s economy by measuring which of the following the following:",
       "choice_a":"The country\u0027s GDP",
       "choice_b":"The country\u0027s supply and demand models",
       "choice_c":"The country\u0027s business cycle",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"Economists gain a clearer picture of a nation\u0027s economic state by measuring its GDP, by monitoring supply and demand models, and by charting its business cycle."
    },
    {
       "id":1192,
       "practice_test_id":1,
       "topic_id":1,
       "question":"Equity is synonymous with:",
       "choice_a":"Mutual funds",
       "choice_b":"Bonds",
       "choice_c":"Stocks",
       "choice_d":"Annuities",
       "correct_answer":"C",
       "explanation":"Stocks and equity are synonymous."
    },
    {
       "id":1193,
       "practice_test_id":2,
       "topic_id":1,
       "question":"Fiscal policy is controlled by: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>President </li><li>FOMC </li><li>Congress </li><li>FRB</li></ol>",
       "choice_a":"II and IV",
       "choice_b":"I and III",
       "choice_c":"I and IV",
       "choice_d":"I and II",
       "correct_answer":"B",
       "explanation":"Fiscal policy is controlled by the President and Congress."
    },
    {
       "id":1194,
       "practice_test_id":3,
       "topic_id":1,
       "question":"Fiscal policy:",
       "choice_a":"Is controlled by the President and the FRB",
       "choice_b":"Determines how to manage the budget and governmental spending",
       "choice_c":"May change levels of interest, taxation, and spending",
       "choice_d":"All of the choices listed",
       "correct_answer":"B",
       "explanation":"Fiscal policy is controlled by the President and Congress, and it may change levels of Federal spending and Federal taxation."
    },
    {
       "id":1195,
       "practice_test_id":4,
       "topic_id":1,
       "question":"If a bond certificate is issued, it must contain the name of issuer, principal amount, issuing date, maturity date, and interest payment dates, as well as each of the following except:",
       "choice_a":"Place where the interest is to be paid",
       "choice_b":"Type of bond",
       "choice_c":"Par value of the bond",
       "choice_d":"Interest rate",
       "correct_answer":"C",
       "explanation":"Par value is the same as the principal amount already on the bond."
    },
    {
       "id":1196,
       "practice_test_id":5,
       "topic_id":1,
       "question":"It may be necessary for a company to repurchase some of its stock, to increase its treasury stock, for which of the following reasons:",
       "choice_a":"To maintain control of the company",
       "choice_b":"To allow the company to pay itself dividends",
       "choice_c":"To increase the funding in the company\u0027s treasury",
       "choice_d":"To reassure its investors that all is well",
       "correct_answer":"A",
       "explanation":"In addition to maintaining control, a company may want to increase its earnings per share, fund employee stock option plans, or use shares to pay for a merger or acquisition."
    },
    {
       "id":1197,
       "practice_test_id":6,
       "topic_id":1,
       "question":"MAH has an 11% convertible preferred stock trading in the marketplace that is quoted at $117. What is its current yield?",
       "choice_a":"12%",
       "choice_b":"9.40%",
       "choice_c":"11%",
       "choice_d":"8.20%",
       "correct_answer":"B",
       "explanation":"The current yield can be found by dividing the annual income by the current market price or in this case 11 / 117 = 9.4%."
    },
    {
       "id":1198,
       "practice_test_id":"",
       "topic_id":1,
       "question":"Mark owns 5% of all outstanding common shares of EZ-Corp Travel. EZ-Corp Travel decides to issue 100,000 new shares, they must notify Mark and allow him to purchase his proportionate number of the new shares before they can go out to the public. Mark has been allowed by ______________ to purchase new shares.",
       "choice_a":"Warrant",
       "choice_b":"Option",
       "choice_c":"Pre-emptive Rights",
       "choice_d":"Elective Right",
       "correct_answer":"C",
       "explanation":"Pre-emptive Rights allow the existing shareholders the first chance to purchase additional shares of the newly issued stock, to maintain their proportionate amount of the total shares of outstanding stock. This is usually limited to a short period of time before the stockholder waives his pre-emptive right. Warrants and Options are agreements to purchase or sell at a specified price, and time."
    },
    {
       "id":1199,
       "practice_test_id":"",
       "topic_id":1,
       "question":"MBIA and AMBAC insure against:",
       "choice_a":"Losses on municipal bonds",
       "choice_b":"Interest rate risk relating to municipal bonds",
       "choice_c":"Market losses on municipal bonds for long term investors",
       "choice_d":"Credit risk of the issuer of municipal bonds",
       "correct_answer":"D",
       "explanation":"MBIA and AMBAC insure credit risk for municipal bonds. Credit risk is also known as default risk."
    },
    {
       "id":1200,
       "practice_test_id":"",
       "topic_id":1,
       "question":"Money market instruments are all of the following except:",
       "choice_a":"Highly liquid fixed income securities",
       "choice_b":"Issued by corporations with high credit ratings, thus considered safe",
       "choice_c":"Considered risky because of the short-term maturities",
       "choice_d":"A method used to obtain short-term financing",
       "correct_answer":"C",
       "explanation":"The short-term maturity and the fact that the issuers have solid credit ratings make money market instruments very safe."
    },
    {
       "id":1201,
       "practice_test_id":"",
       "topic_id":1,
       "question":"Most bonds issued in the United States are issued in:",
       "choice_a":"Barer form",
       "choice_b":"Registered as to principal",
       "choice_c":"Book entry",
       "choice_d":"Fully registered",
       "correct_answer":"D",
       "explanation":"Most bonds issued in the US are fully registered."
    },
    {
       "id":1202,
       "practice_test_id":"",
       "topic_id":1,
       "question":"Most standard options are how long in length?",
       "choice_a":"One month",
       "choice_b":"Three months",
       "choice_c":"Nine months",
       "choice_d":"Twelve months",
       "correct_answer":"C",
       "explanation":"Most standardized options are 9 months in length."
    },
    {
       "id":1203,
       "practice_test_id":"",
       "topic_id":1,
       "question":"Municipal bonds are all of the following except:",
       "choice_a":"Issued by state or county or city governments",
       "choice_b":"Issued to raise working capital for general needs or special projects",
       "choice_c":"Have interest earned taxed by the federal, state, and local governments",
       "choice_d":"Have interest earned free of taxes by the federal, state, and local governments if the investor purchases a bond from the state in which he lives.",
       "correct_answer":"C",
       "explanation":"Interest earned on munis is free of federal and local taxes, and it is also free of state taxes if the investor purchases the municipal bond in the state where he lives."
    },
    {
       "id":1204,
       "practice_test_id":"",
       "topic_id":1,
       "question":"Municipal bonds are all of the following except:",
       "choice_a":"Are as safe as Treasury securities since the federal government guarantees them",
       "choice_b":"Are issued by state and local governments",
       "choice_c":"Are issued to help state and local governments meet their financial needs",
       "choice_d":"Are nearly as safe as Treasury securities but the degree of safety varies from state to state or municipality to municipality",
       "correct_answer":"A",
       "explanation":"Municipal bonds are not guaranteed by the Federal government, but rather by the state or municipality issuing them."
    },
    {
       "id":1205,
       "practice_test_id":"",
       "topic_id":1,
       "question":"Non-marketable government securities are all of the following except:",
       "choice_a":"Treasury STRIPs and treasury receipts",
       "choice_b":"Debt securities which can only be purchased from the US government and which must be redeemed by the government",
       "choice_c":"Series EE bonds, known as Savings Bonds",
       "choice_d":"Include Series HH bonds",
       "correct_answer":"A",
       "explanation":"Treasury STRIPs and treasury receipts are marketable securities."
    },
    {
       "id":1206,
       "practice_test_id":"",
       "topic_id":1,
       "question":"Of the following, which can issue a Municipal Bond? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Counties </li><li>States </li><li>Cities  </li><li>Turnpike Authorities</li></ol>",
       "choice_a":"II and III",
       "choice_b":"I, II, and III",
       "choice_c":"I Only",
       "choice_d":"I, II, III, IV",
       "correct_answer":"D",
       "explanation":"Municipal Bonds, or Munis, are the debts incurred by any public body, or authority. Even though Turnpike Authority Bonds are generally referred to as Revenue Bonds, they still fall under the broad classification of Municipal Bonds."
    },
    {
       "id":1207,
       "practice_test_id":"",
       "topic_id":1,
       "question":"Once a company decides to raise capital to meet its long term needs, it will:",
       "choice_a":"Hire an underwriter to advise the issuer about the type of securities to issue",
       "choice_b":"Approach the money market to determine how much capital can be raised",
       "choice_c":"Hire a broker to issue stocks for public purchase",
       "choice_d":"Approach a dealer to advise the issuer about issuing stock",
       "correct_answer":"A",
       "explanation":"A business must first hire an underwriter to advise the issuer about the type of securities to issue."
    },
    {
       "id":1208,
       "practice_test_id":"",
       "topic_id":1,
       "question":"Outstanding stock is best described as:",
       "choice_a":"The number of shares that were issued as an IPO",
       "choice_b":"The number of shares that have been sold to the public",
       "choice_c":"The number of shares that the public owns",
       "choice_d":"The number of shares that were repurchased from the public by the company",
       "correct_answer":"C",
       "explanation":"Outstanding stock is best described as the stock that the public owns."
    },
    {
       "id":1209,
       "practice_test_id":"",
       "topic_id":1,
       "question":"Overall interest rates depend on:",
       "choice_a":"The supply and demand for money",
       "choice_b":"Any rise in the cost of goods and services known as inflation",
       "choice_c":"Any changes in the discount rate, the federal funds rate, the broker call loan rate, or the prime rate",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"All of the factors help to determine the overall interest rates."
    },
    {
       "id":1210,
       "practice_test_id":"",
       "topic_id":1,
       "question":"People buy common stock for which reasons?  <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>For capital appreciation  </li><li>The right to receive dividends   </li><li>The senior claim on assets   </li><li>To enjoy a senior security position</li></ol>",
       "choice_a":"I, II, and III",
       "choice_b":"II, III, and IV",
       "choice_c":"I and II",
       "choice_d":"I and IV",
       "correct_answer":"C",
       "explanation":"People buy common stock hoping to have their money grow over a period of time and to receive dividends."
    },
    {
       "id":1211,
       "practice_test_id":"",
       "topic_id":1,
       "question":"People may get warrants in all of the following ways except:",
       "choice_a":"Companies will issue warrants to people who have bought their common stock during their initial public offering",
       "choice_b":"Companies may attach warrants to their bonds to make the bonds more attractive to the public and to help market the bond",
       "choice_c":"Investors may buy warrants attached to preferred stock from the company which is offering it",
       "choice_d":"Investors who wish to share in the potential price appreciation of the common stock may elect to purchase its warrant instead of its common shares",
       "correct_answer":"C",
       "explanation":"Warrants are usually not attached to preferred stock."
    },
    {
       "id":1212,
       "practice_test_id":"",
       "topic_id":1,
       "question":"Preferred stock is interest rate sensitive; this means that:",
       "choice_a":"As interest rates rise, the value of the preferred stock rises",
       "choice_b":"As interest rates fall, the value of the preferred stock rises",
       "choice_c":"As interest rates fall, the value of the preferred stock falls",
       "choice_d":"As interest rates fluctuate, the value of the preferred stock and the value of the common stock fluctuate equally.",
       "correct_answer":"B",
       "explanation":"The relationship between interest rates and preferred stock value is known as an inverse relationship; like a seesaw, when one rises, the other falls."
    },
    {
       "id":1213,
       "practice_test_id":"",
       "topic_id":1,
       "question":"Preferred stock is:",
       "choice_a":"An equity security with a variable rate of interest",
       "choice_b":"An equity security with a fixed income component",
       "choice_c":"An equity security which is purchased for financial growth",
       "choice_d":"An equity security with a varying dividend rate which the company must pay to its stockholders semi-annually",
       "correct_answer":"B",
       "explanation":"People invest in preferred stock for the fixed income that the preferred shares generate semi-annually."
    },
    {
       "id":1214,
       "practice_test_id":"",
       "topic_id":1,
       "question":"Preferred stock pays dividends:",
       "choice_a":"Annually",
       "choice_b":"Semi-annually",
       "choice_c":"Quarterly",
       "choice_d":"As stated on the preferred stock certificate",
       "correct_answer":"B",
       "explanation":"Preferred stock pays dividends semi-annually."
    },
    {
       "id":1215,
       "practice_test_id":1,
       "topic_id":1,
       "question":"Securities which are not listed on any of the centralized exchanges trade:",
       "choice_a":"At a location in New York, known as NASDAQ headquarters",
       "choice_b":"Over the counter (OTC) or on the NASDAQ via computers and phone lines",
       "choice_c":"In auction markets known as NASDAQ",
       "choice_d":"Investor to broker directly on the phone or computer",
       "correct_answer":"B",
       "explanation":"NASDAQ has no physical location, is not an auction market, and stocks are traded broker to broker without the investors being aware of the terms."
    },
    {
       "id":1216,
       "practice_test_id":2,
       "topic_id":1,
       "question":"Standardized options trade on such exchanges as:",
       "choice_a":"OCC",
       "choice_b":"ASE",
       "choice_c":"SEC",
       "choice_d":"OPEC",
       "correct_answer":"B",
       "explanation":"The American Stock Exchange trades options as well as all other types of securities."
    },
    {
       "id":1217,
       "practice_test_id":3,
       "topic_id":1,
       "question":"Stock does all of the following, except:",
       "choice_a":"Provides main source of business capital for many corporations",
       "choice_b":"Creates ownership relationship with issuing company",
       "choice_c":"Raises working capital for companies",
       "choice_d":"Has set maturity date for selling shares of stock",
       "correct_answer":"D",
       "explanation":"Equity is perpetual, meaning that the owners own the shares until they decide to sell them."
    },
    {
       "id":1218,
       "practice_test_id":4,
       "topic_id":1,
       "question":"Straight preferred stock and cumulative preferred stock differ in what way?",
       "choice_a":"Straight preferred stock pays lower dividends than cumulative preferred stock",
       "choice_b":"Straight preferred stockholders are entitled to the stated dividend rate, while cumulative preferred stockholders are entitled to a fluctuating dividend rate",
       "choice_c":"If a company cannot pay dividends for two years, the straight preferred stockholder is not owed arrears, while the cumulative preferred stockholder is owed arrears first",
       "choice_d":"Cumulative preferred stock pays dividends increasing in value as they accumulate from year to year.",
       "correct_answer":"C",
       "explanation":"If a company is in financial difficulty and cannot pay dividends for a year or two, the straight preferred stockholder is owed nothing, while the cumulative stockholder is owed arrears, before the common stockholders are paid anything."
    },
    {
       "id":1219,
       "practice_test_id":5,
       "topic_id":1,
       "question":"The amount by which par exceeds the price paid for a bond is known as the:",
       "choice_a":"Premium",
       "choice_b":"Amortization",
       "choice_c":"Discount",
       "choice_d":"Money yield",
       "correct_answer":"C",
       "explanation":"The amount by which the par value of a bond exceeds the price paid for the bond is known as the discount."
    },
    {
       "id":1220,
       "practice_test_id":6,
       "topic_id":1,
       "question":"The book value of a common share may best be described as:",
       "choice_a":"The current price of the stock",
       "choice_b":"The total par value of all the common shares",
       "choice_c":"The total market value of all of the common shares",
       "choice_d":"The theoretical liquidation value of the shares",
       "correct_answer":"D",
       "explanation":"The book value of the stock is its theoretical liquidation value, or assets minus liabilities."
    },
    {
       "id":1221,
       "practice_test_id":"",
       "topic_id":1,
       "question":"The Consumer Price Index (CPI) is all of the following except:",
       "choice_a":"A collection of goods and services which consumers use most in their daily lives",
       "choice_b":"Used to measure the rate of change in overall prices",
       "choice_c":"Predicts inflation when prices rise continually",
       "choice_d":"Predicts deflation when prices rise continually",
       "correct_answer":"D",
       "explanation":"The CPI is used to predict deflation when prices fall continually."
    },
    {
       "id":1237,
       "practice_test_id":"",
       "topic_id":1,
       "question":"The maximum duration of a right is:",
       "choice_a":"20 days",
       "choice_b":"45 days",
       "choice_c":"10 years",
       "choice_d":"90 days",
       "correct_answer":"B",
       "explanation":"The maximum duration of a right is 45 days."
    },
    {
       "id":1238,
       "practice_test_id":"",
       "topic_id":1,
       "question":"The measure of the overall health of a nation\u0027s economy is:",
       "choice_a":"The prime rate",
       "choice_b":"The gross domestic product",
       "choice_c":"The supply and demand analysis",
       "choice_d":"The Federal Reserve Board Quarterly Analysis",
       "correct_answer":"B",
       "explanation":"The overall health of a nation\u0027s economy is measured by the Gross Domestic Product (GDP), defined as the value of all goods and services produced in a country during a given year."
    },
    {
       "id":1239,
       "practice_test_id":"",
       "topic_id":1,
       "question":"The minimum denomination for a GNMA pass through certificate is:",
       "choice_a":"$10,000",
       "choice_b":"$1,000",
       "choice_c":"$500",
       "choice_d":"$25,000",
       "correct_answer":"B",
       "explanation":"The minimum denomination for a GNMA pass through certificate is $1,000."
    },
    {
       "id":1240,
       "practice_test_id":"",
       "topic_id":1,
       "question":"The minimum dollar amount required for a negotiable CD is:",
       "choice_a":"$1, 000",
       "choice_b":"$10,000",
       "choice_c":"$100,000",
       "choice_d":"$1,000,000",
       "correct_answer":"C",
       "explanation":"The minimum dollar amount for a negotiable CD is $100,000. The FDIC only protects the first $250,000."
    },
    {
       "id":1241,
       "practice_test_id":"",
       "topic_id":1,
       "question":"The money market is a place where issuers go to:",
       "choice_a":"Obtain long-term financing",
       "choice_b":"Obtain short term financing",
       "choice_c":"Offer higher interest rates for higher yield",
       "choice_d":"Exchange money market instruments to their mutual benefit",
       "correct_answer":"B",
       "explanation":"The money market is a place where issuers go solely for short-term financing, typically under a year."
    },
    {
       "id":1242,
       "practice_test_id":"",
       "topic_id":1,
       "question":"The OCC is:",
       "choice_a":"Options Counseling Committee",
       "choice_b":"Options Clearing Corporation",
       "choice_c":"Options Clearing Committee",
       "choice_d":"Options and Claims Corporation",
       "correct_answer":"B",
       "explanation":"The Options Clearing Corporation issues all option contracts and guarantees their performance."
    },
    {
       "id":1243,
       "practice_test_id":"",
       "topic_id":1,
       "question":"The PPC Company declares a $0.25 dividend to shareholders of record with a reord date December 21, With its stock valued at $18.00 a share on December 19th, What will be the value of the stock at the opening of business on December 20th?",
       "choice_a":"$18.00",
       "choice_b":"$18.25",
       "choice_c":"$17.50",
       "choice_d":"$17.75",
       "correct_answer":"D",
       "explanation":"The value of a stock is reduced on the ex-dividend date by the amount of the dividend to be paid. In this case: $18.00 (the closing price) - $0.25 (the dividend) = $17.75."
    },
    {
       "id":1244,
       "practice_test_id":"",
       "topic_id":1,
       "question":"The PPC Company is currently paying a $1.25 quarterly dividend to its shareholders. The stock is currently trading at $75 a share. What is its dividend yield?",
       "choice_a":"67%",
       "choice_b":"6.70%",
       "choice_c":"16%",
       "choice_d":"1.60%",
       "correct_answer":"B",
       "explanation":"Determine the dividend yield or current yield for a stock you must divide the annual income by the market price of the security. The question states that the company pays a dividend of $1.25 per quarter which translates into an annual dividend of $5 per share. using this information we get:  Current market price ($75) divided into the annual income ($1.25 X 4= $5.00) is 6.7%."
    },
    {
       "id":1245,
       "practice_test_id":"",
       "topic_id":1,
       "question":"The price of bonds in the secondary market depends on:",
       "choice_a":"Supply & demand",
       "choice_b":"Interest rates",
       "choice_c":"Issuer",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"All of the choices listed are correct."
    },
    {
       "id":1246,
       "practice_test_id":"",
       "topic_id":1,
       "question":"The price of which of the following would be most affected by a change in interest rates?",
       "choice_a":"Treasury bills",
       "choice_b":"Preferred stock",
       "choice_c":"Commercial paper",
       "choice_d":"Treasury bonds",
       "correct_answer":"D",
       "explanation":"The price of long term bonds will be more sensitive to changes in interest rates than the price of a short-term debt."
    },
    {
       "id":1247,
       "practice_test_id":"",
       "topic_id":1,
       "question":"The prime rate is:",
       "choice_a":"The rate that member banks charge each other for overnight loans",
       "choice_b":"The rate that banks charge their most creditworthy corporate customers on loans",
       "choice_c":"The rate that the Federal Reserve Bank charges member banks on loans",
       "choice_d":"The rate that banks charge to broker dealers to finance their customers\u0027 margin purchases",
       "correct_answer":"B",
       "explanation":"The prime rate is the rate that banks charge their most creditworthy corporate customers on loans."
    },
    {
       "id":1248,
       "practice_test_id":"",
       "topic_id":1,
       "question":"The PRT Company with assets of $130,000 and liabilities of $100,000 has a net worth of:",
       "choice_a":"$230,000",
       "choice_b":"$130,000",
       "choice_c":"$30,000",
       "choice_d":"Unable to determine without more information",
       "correct_answer":"C",
       "explanation":"Assets minus liabilities equals net worth."
    },
    {
       "id":1249,
       "practice_test_id":"",
       "topic_id":1,
       "question":"The purpose of the Government National Mortgage Association (Ginnie Mae) is to do which of the following?",
       "choice_a":"To provide mortgage guarantees for the purchases of the US Government",
       "choice_b":"To provide liquidity to mortgage markets by buying up pools of mortgages and then offering investors an agency issue",
       "choice_c":"To provide mortgage guarantees for the federal, state, and local banks and loan institutions",
       "choice_d":"To provide a hedge against the refinancing of mortgages caused by falling interest rates",
       "correct_answer":"B",
       "explanation":"The GNMA buys up pools of mortgages and offers pass through certificates which pay interest to the investors, an unsecured debenture in that it is backed by the full faith and credit of the US Government."
    },
    {
       "id":1250,
       "practice_test_id":"",
       "topic_id":1,
       "question":"The ROC Company, with assets of $250,000 and liabilities of $310,000, has a net worth of:",
       "choice_a":"$560,000",
       "choice_b":"$60,000",
       "choice_c":"($60,000)",
       "choice_d":"Unable to determine without more information",
       "correct_answer":"C",
       "explanation":"Assets minus liabilities gives this company a negative net worth."
    },
    {
       "id":1251,
       "practice_test_id":2,
       "topic_id":1,
       "question":"The subscription price of a warrant is always:",
       "choice_a":"Below the stock price when issued",
       "choice_b":"Equal to the stock price when issued",
       "choice_c":"Above the stock price when issued",
       "choice_d":"Determined on the exercise date",
       "correct_answer":"C",
       "explanation":"The subscription price of a warrant is always above the market value of the stock when it is originally issued. The value of the warrant is that it is long term, up to 10 years."
    },
    {
       "id":1252,
       "practice_test_id":3,
       "topic_id":1,
       "question":"The subscription price of right is:",
       "choice_a":"The price of buying shares from a broker",
       "choice_b":"The price offered to current stockholders notified of their right and below market value",
       "choice_c":"The price at which the new shareholders can purchase new shares",
       "choice_d":"The price a broker who has subscribed to a particular company has to pay to buy shares",
       "correct_answer":"B",
       "explanation":"When existing stockholders are offered their \u0022right,\u0022 they may buy stock at the subscription price, which is below market value and to their benefit, also preserving their percentage holding in the company."
    },
    {
       "id":1253,
       "practice_test_id":4,
       "topic_id":1,
       "question":"The Third Market and the Fourth Market differ in that:",
       "choice_a":"In the Third Market, brokers deal directly with individuals on exchange-listed stocks, and the Fourth Market individuals deal with individuals directly on exchange-listed stocks.",
       "choice_b":"In the Third Market, brokers deal directly with brokers on exchange-listed stocks, and the Fourth Market brokers deal with individuals directly on exchange-listed stocks.",
       "choice_c":"In the Third Market, brokers deal directly with brokers on exchange-listed stocks, and the Fourth Market brokers deal with large corporations directly on exchange-listed stocks.",
       "choice_d":"In the Third Market, brokers deal directly with brokers on exchange-listed stocks, and the Fourth Market large corporations deal with large corporations directly on exchange-listed stocks.",
       "correct_answer":"D",
       "explanation":"Neither the Third Market nor the Fourth Market uses the floor of the exchange, but rather deals directly through the NASDAQ environment. This environment for the Fourth Market is called INSTINET."
    },
    {
       "id":1254,
       "practice_test_id":5,
       "topic_id":1,
       "question":"The type of bond which is secured by real estate is called:",
       "choice_a":"Real estate trust certificates",
       "choice_b":"Mortgage bond",
       "choice_c":"Equipment trust certificates",
       "choice_d":"Collateral trust certificates",
       "correct_answer":"B",
       "explanation":"A mortgage bond is secured by real estate."
    },
    {
       "id":1255,
       "practice_test_id":6,
       "topic_id":1,
       "question":"The types of options are:",
       "choice_a":"Calls, which give the buyer the right to buy, and sells, which give the buyer the right to sell",
       "choice_b":"Calls, which give the buyer the right to buy, and puts, which give the buyer the right to sell",
       "choice_c":"Calls, which give the buyer the right to sell, and puts, which give the buyer the right to buy",
       "choice_d":"Calls, which give the buyer the right to sell, and trades, which give the buyer the right to buy",
       "correct_answer":"B",
       "explanation":"There are two types of options: calls and puts. The first give the buyer the right to buy, and the second give the buyer the right to sell."
    },
    {
       "id":1256,
       "practice_test_id":"",
       "topic_id":1,
       "question":"The way that money grows in the Federal Reserve Banking system is known as:",
       "choice_a":"The multiplier effect",
       "choice_b":"Inflation",
       "choice_c":"Deflation",
       "choice_d":"Stagflation",
       "correct_answer":"A",
       "explanation":"The way that money grows in the Federal Reserve System is known as the multiplier effect."
    },
    {
       "id":1257,
       "practice_test_id":"",
       "topic_id":1,
       "question":"This bond may be exchanged for common stock:",
       "choice_a":"Subordinated debentures",
       "choice_b":"Convertible bonds",
       "choice_c":"Income/Adjustment bonds",
       "choice_d":"Zero coupon bonds",
       "correct_answer":"B",
       "explanation":"Convertible bonds may be converted or exchanged for common stock at a predetermined conversion price."
    },
    {
       "id":1258,
       "practice_test_id":"",
       "topic_id":1,
       "question":"To determine the number of shares of common stock which can be obtained on conversion from a bond, use which of the following:",
       "choice_a":"Par value divided by conversion price",
       "choice_b":"Conversion price divided by par value",
       "choice_c":"Par value multiplied by conversion price",
       "choice_d":"Conversion price multiplied by par value",
       "correct_answer":"A",
       "explanation":"The formula to convert bonds to common stock is par value divided by conversion price."
    },
    {
       "id":1259,
       "practice_test_id":"",
       "topic_id":1,
       "question":"Treasury stock has been issued and repurchased by a corporation for which of the following reasons?",
       "choice_a":"Raise new capital",
       "choice_b":"Add to outstanding shares",
       "choice_c":"Increase earnings per share",
       "choice_d":"Create a sinking fund",
       "correct_answer":"C",
       "explanation":"A corporation can increase it\u0027s earning per share or EPS without increasing income by repurchasing outstanding shares from the public."
    },
    {
       "id":1260,
       "practice_test_id":"",
       "topic_id":1,
       "question":"United States Government Bonds are all except which of the following:",
       "choice_a":"Issued by the US Government, the largest issuer of debt",
       "choice_b":"Guaranteed by the US Government, which has shown a great amount of debt risk",
       "choice_c":"Issued with maturities from 3 months to 30 years",
       "choice_d":"Have the interest paid from the US Government bonds taxed only by the federal government, not the state or local government.",
       "correct_answer":"B",
       "explanation":"The United States Government is the issuer of bonds with the least amount of default risk or credit risk."
    },
    {
       "id":1261,
       "practice_test_id":"",
       "topic_id":1,
       "question":"US Savings bonds are formally known as:",
       "choice_a":"Zero bonds",
       "choice_b":"Treasury STRIPs",
       "choice_c":"Treasury receipts",
       "choice_d":"EE\u0027s",
       "correct_answer":"D",
       "explanation":"US savings bonds are formally known as EE\u0027s."
    },
    {
       "id":1262,
       "practice_test_id":"",
       "topic_id":1,
       "question":"What are market makers?",
       "choice_a":"Brokers who are specialists in over the counter market trading",
       "choice_b":"Brokers who create a market for their own specialty stocks and for the companies whose stocks they sell",
       "choice_c":"A firm who display a two-sided market, both buying and selling stock through a network of computers which connects firms throughout the world",
       "choice_d":"Brokers who make their profit from buying cheaply, creating a demand by promoting the stocks, then selling at a higher price",
       "correct_answer":"C",
       "explanation":"There are no specialists in OTC trading, and brokers do not create markets or demand; they buy at bid price and sell at the offering price; their profit is the difference."
    },
    {
       "id":1263,
       "practice_test_id":"",
       "topic_id":1,
       "question":"What can happen to a right?",
       "choice_a":"The shareholder can elect to purchase additional shares, or exercise the right",
       "choice_b":"The shareholder can choose not to purchase the additional shares, and may choose to sell these rights to another investor",
       "choice_c":"The original shareholder or the new investor can allow the 45 days to lapse without purchasing the shares offered",
       "choice_d":"All of the choices listed are correct",
       "correct_answer":"D",
       "explanation":"All of the choices listed can happen; and a corporation may also retain a brokerage firm to purchase any unsold shares and resell to the public, called standby underwriting."
    },
    {
       "id":1264,
       "practice_test_id":"",
       "topic_id":1,
       "question":"What is not a characteristic of a security?",
       "choice_a":"Readily transferable between two parties",
       "choice_b":"May be in the form of stocks, mutual funds, or fixed annuities",
       "choice_c":"Can be exchanged for value",
       "choice_d":"Must contain some risk",
       "correct_answer":"B",
       "explanation":"Fixed annuities are not securities, since they contain no risk."
    },
    {
       "id":1265,
       "practice_test_id":"",
       "topic_id":1,
       "question":"What is not a feature of preferred stock?",
       "choice_a":"Par value for all preferred stock is $250",
       "choice_b":"Dividends must be paid to preferred stockholders before common stockholders",
       "choice_c":"Preferred stock is perpetual with no maturity date",
       "choice_d":"Most preferred stock is non-voting",
       "correct_answer":"A",
       "explanation":"Par value for all preferred is the same, set at $100;  companies generally express the par value as a percentage of par value for the preferred stock."
    },
    {
       "id":1266,
       "practice_test_id":"",
       "topic_id":1,
       "question":"What is the balance sheet equation?",
       "choice_a":"Assets + liabilities = net worth",
       "choice_b":"Assets - liabilities = net worth",
       "choice_c":"Liabilities / assets = net worth",
       "choice_d":"Liabilities - assets = net worth",
       "correct_answer":"B",
       "explanation":"Everything that a company owns (assets) minus everything that a company owes (liabilities) results in the corporation\u0027s net worth and the stockholders\u0027 equity."
    },
    {
       "id":1267,
       "practice_test_id":"",
       "topic_id":1,
       "question":"What is the best definition of interest rates?",
       "choice_a":"The cost of money",
       "choice_b":"The amount paid to investors based on inflation",
       "choice_c":"The amount paid to investors based on their total investment",
       "choice_d":"The amount paid to investors on money borrowed by stock and bond issuers",
       "correct_answer":"A",
       "explanation":"The best definition is simply the cost of money."
    },
    {
       "id":1268,
       "practice_test_id":"",
       "topic_id":1,
       "question":"What is the difference between a warrant and a right?",
       "choice_a":"A warrant allows an investor to purchase preferred stock at a subscription price",
       "choice_b":"The subscription price of the right is always higher than the market value, indicating a valuable company to invest in",
       "choice_c":"The holder of a warrant has twenty years during which he may buy the stock at the subscription price",
       "choice_d":"Both the long life of a warrant and its subscription price differ from that of a right",
       "correct_answer":"D",
       "explanation":"A warrant has a subscription that is higher than the market value and a term of up to 10 years, while a right has a subscription price that is lower than the market value and a term up to 45 days."
    },
    {
       "id":1269,
       "practice_test_id":"",
       "topic_id":1,
       "question":"What is the maximum duration for a warrant?",
       "choice_a":"45 days",
       "choice_b":"10 years",
       "choice_c":"9 months",
       "choice_d":"270 days",
       "correct_answer":"B",
       "explanation":"The maximum duration of a warrant is 10 years."
    },
    {
       "id":1270,
       "practice_test_id":"",
       "topic_id":1,
       "question":"What is the most common form of dividend?",
       "choice_a":"Cash dividends",
       "choice_b":"Stock dividends",
       "choice_c":"Products sample dividends",
       "choice_d":"Property portion dividends",
       "correct_answer":"A",
       "explanation":"Cash dividends are the most common form of dividends, usually sent out in the form of a check directly to the investor or the brokerage firm, to the account of the investor."
    },
    {
       "id":1271,
       "practice_test_id":"",
       "topic_id":1,
       "question":"When considering investing in a municipal bond, the opinion stating \u0022it\u0027s a binding obligation of the issuer\u0022 is issued by the:",
       "choice_a":"Governor",
       "choice_b":"MSRB",
       "choice_c":"FINRA",
       "choice_d":"Bond counsel",
       "correct_answer":"D",
       "explanation":"The bond counsel issues a legal opinion about the municipal bond and states that it is a legally binding obligation of the issuer, and that its interest should be free from federal income taxes."
    },
    {
       "id":1272,
       "practice_test_id":"",
       "topic_id":1,
       "question":"When is the interest on an EE Saving Bond paid?",
       "choice_a":"When Redeemed",
       "choice_b":"Annually",
       "choice_c":"Quarterly",
       "choice_d":"Monthly",
       "correct_answer":"A",
       "explanation":"The EE Savings bonds are sold at a discount and at maturity are redeemed at face value, which includes the interest income."
    },
    {
       "id":1276,
       "practice_test_id":"",
       "topic_id":1,
       "question":"Which bonds have been issued with the owner\u0027s name on them as it relates to interest and principal, and have been recorded with the issuer\u0027s name and the buyer\u0027s name?",
       "choice_a":"Bearer bonds",
       "choice_b":"Registered bonds",
       "choice_c":"Principal-only bonds",
       "choice_d":"Book entry / journal entry bonds",
       "correct_answer":"B",
       "explanation":"Registered bonds, the most common type today, are issued with both the owner\u0027s name and the buyer\u0027s name on the certificate."
    },
    {
       "id":1277,
       "practice_test_id":"",
       "topic_id":1,
       "question":"Which is false about municipal bonds?",
       "choice_a":"Most of them are priced quoted on a yield at maturity basis",
       "choice_b":"Some of them are priced at a percentage of par value",
       "choice_c":"Most of them are priced based on predicted inflation",
       "choice_d":"Most of them are issued by city, county or state to raise capital",
       "correct_answer":"C",
       "explanation":"Municipal bonds are not priced based on predicted inflation."
    },
    {
       "id":1278,
       "practice_test_id":"",
       "topic_id":1,
       "question":"Which is the incorrect collection of some items which affect bond yields?",
       "choice_a":"Current interest rates, terms of the bond, purchase price, and credit quality of the purchaser",
       "choice_b":"Current interest rates, terms of the bond, type of collateral, and purchase price",
       "choice_c":"Current interest rates, purchase price, type of collateral, and credit quality of the issuer",
       "choice_d":"Current interest rates, purchase price, terms of the loan, and whether convertible or callable",
       "correct_answer":"A",
       "explanation":"The credit quality of the purchaser is of no concern in the purchase of any bonds."
    },
    {
       "id":1279,
       "practice_test_id":2,
       "topic_id":1,
       "question":"Which is true?",
       "choice_a":"Treasury bills, notes, and bonds differ in their price and term only",
       "choice_b":"Treasury bill, notes, and bonds differ in their interest, term and price",
       "choice_c":"Treasury bills, notes, and bonds differ in their interest and term only",
       "choice_d":"Treasury bills, notes, and bonds differ in their interest and price, but have the same terms",
       "correct_answer":"B",
       "explanation":"Treasury bills, notes, and bonds differ in their interest, term, and price."
    },
    {
       "id":1280,
       "practice_test_id":3,
       "topic_id":1,
       "question":"Which of the following are backed by the full faith and credit of the United States Government?",
       "choice_a":"Federal National Mortgage Association",
       "choice_b":"Federal Home Loan Mortgage Corporation",
       "choice_c":"United States Trust Certificates",
       "choice_d":"Government National Mortgage Association",
       "correct_answer":"D",
       "explanation":"Only the Government National Mortgage Association is backed by the full faith and credit of the US Government. If GNMA defaults, the government covers the loss."
    },
    {
       "id":1281,
       "practice_test_id":4,
       "topic_id":1,
       "question":"Which of the following are characteristics of common stock? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Right to vote  </li><li>Ownership </li><li>Unlimited liability </li><li>Residual claim on assets</li></ol>",
       "choice_a":"I and III",
       "choice_b":"III and IV",
       "choice_c":"I, II, and IV",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"C",
       "explanation":"A common stock has all of the characteristics listed except unlimited liability. A stockholder\u0027s liability is limited to the amount of their investment."
    },
    {
       "id":1282,
       "practice_test_id":5,
       "topic_id":1,
       "question":"Which of the following could trade in the money market?",
       "choice_a":"Short term equity",
       "choice_b":"Newly issued corporate bond",
       "choice_c":"Newly issued option contract",
       "choice_d":"Treasury note issued 9 years ago",
       "correct_answer":"D",
       "explanation":"A high quality debt instrument with less than one year to maturity regardless of its original maturity may trade in the money market."
    },
    {
       "id":1291,
       "practice_test_id":6,
       "topic_id":1,
       "question":"Which of the following is true regarding American Depository Receipts (ADRs)?",
       "choice_a":"They are receipts of ownership of foreign shares being held abroad in a US bank",
       "choice_b":"Each ADR represents one hundred shares of foreign stock, and the ADR holder may request delivery of the foreign shares",
       "choice_c":"ADR holders do not have the right to vote and to receive dividends, which the foreign corporation declares for shareholders",
       "choice_d":"ADRs are not considered securities",
       "correct_answer":"A",
       "explanation":"Each ADR represents between one to ten shares, and ADR holders do have the right to vote and receive dividends."
    },
    {
       "id":1292,
       "practice_test_id":"",
       "topic_id":1,
       "question":"Which of the following may always trade in the money market?",
       "choice_a":"T-bond",
       "choice_b":"T-note",
       "choice_c":"ADR",
       "choice_d":"Banker\u0027s acceptance",
       "correct_answer":"D",
       "explanation":"Only banker\u0027s acceptances have an original maturity of less than a year."
    },
    {
       "id":1293,
       "practice_test_id":"",
       "topic_id":1,
       "question":"Which of the following only relates to the fixed income securities of an issuer?",
       "choice_a":"Systematic risk",
       "choice_b":"Credit risk",
       "choice_c":"Legislative risk",
       "choice_d":"Purchasing power risk",
       "correct_answer":"B",
       "explanation":"Credit risk is the risk of default, which only relates to fixed income securities."
    },
    {
       "id":1294,
       "practice_test_id":"",
       "topic_id":1,
       "question":"XVC, a marginally profitable company with a spotty credit history, has promised bondholders to set aside money to repay the principal of the bonds. This money will be used to pay off the bonds at maturity. The money will be deposited in:",
       "choice_a":"A separate account",
       "choice_b":"A general account",
       "choice_c":"A sinking fund",
       "choice_d":"A bond repayment fund",
       "correct_answer":"C",
       "explanation":"Money set aside for the purpose of paying off bondholders is placed in a sinking fund."
    },
    {
       "id":1295,
       "practice_test_id":"",
       "topic_id":1,
       "question":"XYZ 8 % bonds due 10 1, 2030 are quoted at 95. What is the current yield on the bond?",
       "choice_a":"8.40%",
       "choice_b":"7.50%",
       "choice_c":"6.40%",
       "choice_d":"7.80%",
       "correct_answer":"A",
       "explanation":"The current yield on the bond is approximately 8.4%, found by dividing the annual income of the bond by its price 80 / 950."
    },
    {
       "id":1296,
       "practice_test_id":"",
       "topic_id":1,
       "question":"XYZ has 8% subordinated debentures trading in the marketplace at $120. They are convertible into XYZ common stock at $25 per share. What is the parity price of the common stock?",
       "choice_a":28,
       "choice_b":29,
       "choice_c":30,
       "choice_d":31,
       "correct_answer":"C",
       "explanation":"The parity price is found by determining the number of shares that can be received upon conversion: par / conversion price = 1000 / 25 = 40 shares, then the parity price equals the current market value of the convertible / # of shares. 1200 / 40 = $30."
    },
    {
       "id":1297,
       "practice_test_id":"",
       "topic_id":1,
       "question":"XYZ has EPS of $2 a quarterly dividend of $.70, and is quoted in the marketplace at 20. What is the current yield?",
       "choice_a":"10%",
       "choice_b":"14%",
       "choice_c":"3.50%",
       "choice_d":"7%",
       "correct_answer":"B",
       "explanation":"The current yield is found by multiplying the quarterly dividend by 4 = $.70 X 4 = $2.80. Then divide it by the market price: $2.80 / 20 = 14%."
    },
    {
       "id":1298,
       "practice_test_id":"",
       "topic_id":1,
       "question":"XYZ has EPS of a $2 a quarterly dividend of $.70 and is quoted in the marketplace at 20. What is the current yield?",
       "choice_a":"10%",
       "choice_b":"14%",
       "choice_c":"3.50%",
       "choice_d":"7%",
       "correct_answer":"B",
       "explanation":"The current yield is found by multiplying the quarterly dividend by 4 = $.70 X 4 = $2.80. Then divide it by the market price: $2.80 / 20 = 14%."
    },
    {
       "id":1299,
       "practice_test_id":"",
       "topic_id":1,
       "question":"XYZ Incorporated has 15,000,000 shares of common stock authorized; 11,000,000 shares have been issued and there are 4,000,000 shares of treasury stock. How many shares are outstanding?",
       "choice_a":"15,000,000",
       "choice_b":"7,000,000",
       "choice_c":"11,000,000",
       "choice_d":"8,000,000",
       "correct_answer":"B",
       "explanation":"There are 7,000,000 shares outstanding. Issued stock - treasury stock = outstanding stock."
    },
    {
       "id":1300,
       "practice_test_id":"",
       "topic_id":1,
       "question":"XYZ manufacturing needs $10,000,000 to build a plant. They asked the state for help raising the funds. The new plant will create jobs and will help the economy of the state. The state decides to raise the money for the company through the sale of municipal bonds. What type of bonds are these?",
       "choice_a":"Revenue bonds",
       "choice_b":"Double barreled bonds",
       "choice_c":"Industrial development bonds",
       "choice_d":"General obligation bonds",
       "correct_answer":"C",
       "explanation":"This is an industrial revenue bond, a municipal bond sold to benefit a private corporation."
    },
    {
       "id":1301,
       "practice_test_id":"",
       "topic_id":1,
       "question":"You are working for a bank that is unable to meet its reserve requirement for the evening. The bank may borrow money to meet this short fall directly from the FRB and pay:",
       "choice_a":"The Federal funds rate",
       "choice_b":"The Banking call rate",
       "choice_c":"The discount rate",
       "choice_d":"The prime rate",
       "correct_answer":"C",
       "explanation":"A bank may borrow money from the Federal Reserve Board and may pay the discount rate."
    },
    {
       "id":1302,
       "practice_test_id":"",
       "topic_id":1,
       "question":"Your brokerage firm regularly trades stock in the third market. Which of the following best describes what they do?",
       "choice_a":"They regularly trade stocks with institutions",
       "choice_b":"They regularly act as an underwriter",
       "choice_c":"They regularly trade listed stocks over the NASDAQ system",
       "choice_d":"They regularly participate in private securities transactions",
       "correct_answer":"C",
       "explanation":"A third market transaction is a transaction in an exchange listed security executed over the NASDAQ workstation."
    },
    {
       "id":1303,
       "practice_test_id":"",
       "topic_id":1,
       "question":"Your firm is underwriting a corporate bond for a large shipping company. The bonds are equipment trust certificates. What is the bondholder going to take title to if they default?",
       "choice_a":"Real estate",
       "choice_b":"Securities",
       "choice_c":"Ships",
       "choice_d":"Residual assets",
       "correct_answer":"C",
       "explanation":"These bonds are mostly backed by ships. Equipment trust certificates  are backed by a pledge of heavy equipment."
    },
    {
       "id":1304,
       "practice_test_id":"",
       "topic_id":1,
       "question":"A customer believes that the interest rates have peaked and wants to buy long-term fixed income securities providing semiannual interest payments. You would recommend:",
       "choice_a":"Treasury Strips",
       "choice_b":"Premium bonds with low call premiums",
       "choice_c":"Non-callable bonds",
       "choice_d":"Puttable bonds",
       "correct_answer":"C",
       "explanation":"The purchase of non-callable bonds provides the investor a constant flow of semiannual interest income until maturity. Treasury strips do not make regular interest payments. If interest rates fall, callable bonds are likely to be called by the issuer, and a put feature would not likely be used by the investor. A premium bond indicates the coupon is higher than the market rate for comparable bonds. If a premium bond has a low call premium, it will, in all likelihood, be called. High coupon, low call premium bonds are the first to be called by an insurer."
    },
    {
       "id":1305,
       "practice_test_id":"",
       "topic_id":1,
       "question":"The result of declining inflation would be:",
       "choice_a":"Higher prices and lower yields",
       "choice_b":"Lower prices and higher yields",
       "choice_c":"Higher prices and higher yields",
       "choice_d":"Lower prices and lower yields",
       "correct_answer":"A",
       "explanation":"Declining inflation means declining interest rates. If interest rates decline, bond prices rise."
    },
    {
       "id":1306,
       "practice_test_id":"",
       "topic_id":1,
       "question":"In terms of safety of principal, municipal bonds are considered second only to:",
       "choice_a":"Preferred stock",
       "choice_b":"Common stock",
       "choice_c":"U.S. government and agency bonds",
       "choice_d":"AAA rated corporate bonds",
       "correct_answer":"C",
       "explanation":"Municipal securities are considered second in safety of principal only to U.S. government and agency issues."
    },
    {
       "id":1307,
       "practice_test_id":"",
       "topic_id":1,
       "question":"All of the following are advantages of purchasing a put over selling a security short except:",
       "choice_a":"The capital commitment is less",
       "choice_b":"There is no requirement to locate the security",
       "choice_c":"There is less maximum loss potential",
       "choice_d":"There is no loss of time value as the position is held",
       "correct_answer":"D",
       "explanation":"The premium on an option is clearly much less than the capital commitment of 50% of the market value of a short sale (margin deposit). Short selling involves unlimited loss potential should the stock\u0027s price rise, whereas maximum loss when buying options is limited to the premium paid. However, the time value associated with option premiums does erode as the option approaches expiration. As stock has no expiration date, the concept of time value erosion does not exist."
    },
    {
       "id":1308,
       "practice_test_id":"",
       "topic_id":1,
       "question":"Which two of the following statements are true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Systematic risk can be diversified away </li><li>Systematic risk cannot be diversified away  </li><li>Nonsystematic risk can be diversified away </li><li>Nonsystematic risk cannot be diversified away</li></ol>",
       "choice_a":"I and III",
       "choice_b":"I and IV",
       "choice_c":"II and III",
       "choice_d":"II and IV",
       "correct_answer":"C",
       "explanation":"Systematic risk is market risk, the risk that the market will move downward, dragging down one\u0027s portfolio with it. This risk cannot be diversified away. However, an investor can hedge against systematic risk by buying index puts. Nonsystematic risk is company risk, the risk that a particular investment will perform poorly irrespective of market conditions. This risk can be diversified away by adding more and more stocks to one\u0027s portfolio."
    },
    {
       "id":1309,
       "practice_test_id":"",
       "topic_id":1,
       "question":"Which of the following securities are interest rate sensitive? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Utility Stocks </li><li>Growth Stocks </li><li>Preferred Stocks </li><li>Common Stocks</li></ol>",
       "choice_a":"I and II",
       "choice_b":"I and III",
       "choice_c":"I and IV",
       "choice_d":"III and IV",
       "correct_answer":"B",
       "explanation":"Utility stocks are interest rate sensitive because utility companies are highly leveraged. Preferred stocks have a fixed dividend rate and as a result fluctuate in price like bonds, which are sensitive to interest rates."
    },
    {
       "id":24708,
       "practice_test_id":2,
       "topic_id":1,
       "question":"A 90 year old man living on social security has just won a legal settlement in the amount of $250,000 and wants to invest the money to receive additional income to supplement his monthly social security check. He would also like to leave some money for his children. Which of the following would be the best selection?",
       "choice_a":"A ladder treasury bond portfolio",
       "choice_b":"A ladder municipal bond portfolio",
       "choice_c":"An index ETF and CMOs",
       "choice_d":"A portfolio of both common and preferred stock",
       "correct_answer":"A",
       "explanation":"This is an elderly person who has an investment objective of current income and preservation of capital. His objective of preservation of capital is identified by the fact that he wants to leave money to his heirs. A laddered portfolio of Treasury bonds would be the best option . A bond ladder consists of a portfolio of bonds with maturities ranging over a period of years. The interest payments will be received frequently as the interest payment dates will vary. The treasury bonds will also protect the principal investment."
    },
    {
       "id":24715,
       "practice_test_id":3,
       "topic_id":1,
       "question":"A client who is risk averse is speaking to his registered representative about brokered CDs as an option for $200,000 he has in his investment account. Which of the following choices are not features of negotiable CDs sold to clients of broker dealers?",
       "choice_a":"The CDs are available in a wide maturity range",
       "choice_b":"The CDs trade flat in the secondary market",
       "choice_c":"The CDs will be covered under FDIC Insurance for $250,000",
       "choice_d":"The greater the number of compounding periods the greater the return",
       "correct_answer":"B",
       "explanation":"The question asks which is not a feature of negotiable CDs sold through brokers. All of the choices are true except the CDs do not trade flat. The negotiable CDs trade with accrued interest."
    },
    {
       "id":24719,
       "practice_test_id":4,
       "topic_id":1,
       "question":"Which of the following would not be a short term money market instrument?",
       "choice_a":"Banker\u0027s acceptance",
       "choice_b":"Commercial paper",
       "choice_c":"CDs",
       "choice_d":"A warrant with 7 months remaining to maturity",
       "correct_answer":"D",
       "explanation":"Only short term debt securities may be traded in the money market. A warrant is an equity security and therefore not a money market instrument."
    },
    {
       "id":24725,
       "practice_test_id":5,
       "topic_id":1,
       "question":"An income oriented investor purchased a 7 percent bond at 90 when the issuer was having financial trouble. After a series of corporate initiatives the issuer\u0027s prospects are looking up. The bond is now trading in the marketplace at 120. What is the investor\u0027s current yield?",
       "choice_a":"7.77%",
       "choice_b":"5.83%",
       "choice_c":"6.36%",
       "choice_d":"8.10%",
       "correct_answer":"A",
       "explanation":"When an investor purchases a bond the investor locks in the current yield at the time of purchase. In this case it is 7.77%. Found using the formula: CY= AI/CMP 70/ 900 = 7.77. The current yield on the bond for new purchasers will be less because the bond has increased in price. However, the current yield for this investor has not changed"
    },
    {
       "id":24731,
       "practice_test_id":6,
       "topic_id":1,
       "question":"An investor is considering purchasing shares of ABC Utilities, Inc. ABC pays a regular quarterly dividend on its shares. The investor is considering purchasing the shares in December, but does not want to add to his taxable income for the year. ABC declared a dividend for payment on Tuesday, December 5th to shareholders of record Wednesday, December 20th. The dividend is to be paid on Thursday, December 28th. If the investor wishes to purchase the shares this month, which of the following dates would be the earliest he should purchase the shares?",
       "choice_a":"December 6th",
       "choice_b":"December 19th",
       "choice_c":"December 29th",
       "choice_d":"December 27th",
       "correct_answer":"B",
       "explanation":"The record date for the dividend is December 20th. The stock therefore goes ex dividend on December 19th. Investors who purchase a stock on or after the ex date will not receive the dividend. Of the choices listed the earliest day when a person could purchase the stock and not receive the dividend is December 19th."
    },
    {
       "id":24732,
       "practice_test_id":"",
       "topic_id":1,
       "question":"An investor is considering purchasing shares of ABC Utilities, Inc. ABC pays a regular quarterly dividend on its shares. The investor is considering purchasing the shares in December, and wants to receive the dividend this year. ABC declared a dividend for payment on Tuesday, December 5th to shareholders of record Wednesday, December 20th. The dividend is to be paid on Thursday, December 28th. If the investor wishes to purchase the shares this month, which of the following dates would be the latest he should purchase the shares?",
       "choice_a":"December 4th",
       "choice_b":"December 15th",
       "choice_c":"December 26th",
       "choice_d":"December 18th",
       "correct_answer":"D",
       "explanation":"The record date for the dividend is December 20th. The stock therefore goes ex dividend on December 19th. Investors who purchase a stock on or after the ex date will not receive the dividend. Of the choices listed the last day when a person could purchase the stock and receive the dividend is December 18th."
    },
    {
       "id":24741,
       "practice_test_id":"",
       "topic_id":1,
       "question":"Which of the following investments would subject the investor the the greatest interest rate risk?",
       "choice_a":"A 20 year floating rate security",
       "choice_b":"A 15 year zero coupon bond",
       "choice_c":"A 20 year zero coupon bond",
       "choice_d":"A 30 year zero coupon bond",
       "correct_answer":"D",
       "explanation":"As interest rates change the bond with the longest time until maturity and trading the furthest away from par will fall the most in price if interest rates rise. In this case the 30-year zero coupon bond is the correct choice."
    },
    {
       "id":20410,
       "practice_test_id":"",
       "topic_id":1,
       "question":"An investor who is concerned that interest rates will be falling in the near future would be unlikely to buy which of the following?",
       "choice_a":"CMOs",
       "choice_b":"GNMAs",
       "choice_c":"zero coupon bonds",
       "choice_d":"all of the the choices listed",
       "correct_answer":"D",
       "explanation":"Mortgage backed securities like CMOs and GNMAs have refinancing risk, i.e. when interest rates fall homeowners refinance and the holders of these securities will be paid back sooner than anticipated. And zero coupon bonds pay no interest, but are sold at a deep discount making them extremely sensitive to changes in interest rates.  If an investor is concerned about falling interest rates none of these would be appropriate investments."
    },
    {
       "id":20411,
       "practice_test_id":"",
       "topic_id":1,
       "question":"An investor in a high tax bracket would receive the most benefit from the purchase of which of the following securities?",
       "choice_a":"CMOs",
       "choice_b":"Municipal bonds",
       "choice_c":"GMNAs",
       "choice_d":"US Treasury bonds",
       "correct_answer":"B",
       "explanation":"CMOs and GMNAs pay interest that is fully taxable, and US government securities pay interest that is federally taxed only. However, municipal bonds pay interest that is federally tax free. So investors in higher tax brackets receive the most tax benefits from investing in municipal bonds."
    },
    {
       "id":20412,
       "practice_test_id":"",
       "topic_id":1,
       "question":"Which of the following are true of both CMOs and GNMAs? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>They are both mortgage backed securities  </li><li>They are both issued by a US government agency  </li><li>They are both subject to interest rate risk  </li><li>They are both pass through certificates</li></ol>",
       "choice_a":"I only",
       "choice_b":"I,II, IV",
       "choice_c":"II, III, IV",
       "choice_d":"I, III, IV",
       "correct_answer":"D",
       "explanation":"Both CMOs and GNMAs are mortgage backed securities that are classified as pass through certificates, as interest and principal pass through to the investor. As such they are both subject to interest rate risk i.e. if interest rates fall homeowners are more likely to refinance their mortgages resulting in the CMO or GNMA investor being paid off sooner than anticipated. Only GMNAs are issued by a US government agency. CMO\u0027s are issued by investment banks."
    },
    {
       "id":20414,
       "practice_test_id":"",
       "topic_id":1,
       "question":"CMOs are the most appropriate investment for a person seeking:",
       "choice_a":"Tax relief",
       "choice_b":"Long term growth potential",
       "choice_c":"Income",
       "choice_d":"Liquidity",
       "correct_answer":"C",
       "explanation":"CMOs are not a suitable investment for an investor  seeking tax relief, as interest on CMOs is fully taxable. Many of the more complex CMOs can be highly illiquid; and being a pass through investment there is no long term growth potential  However, CMOs do pay regular income in the form of principal, interest or both to the investor."
    },
    {
       "id":20416,
       "practice_test_id":"",
       "topic_id":1,
       "question":"CMOs are issued by all of the following except:",
       "choice_a":"Investment banks",
       "choice_b":"FNMA",
       "choice_c":"US government agencies",
       "choice_d":"FHLMC",
       "correct_answer":"C",
       "explanation":"CMOs are issued by investment banks, FNMA and FHLMC. Unlike GNMAs they are not issued by government agencies."
    },
    {
       "id":20417,
       "practice_test_id":"",
       "topic_id":1,
       "question":"Joe Smith, a customer of XYZ broker dealer wishes to diversify his portfolio by investing in many different types of securities. Joe will have to sign a suitability statement before investing in all of the following except:",
       "choice_a":"A CMO with a planned amortization class",
       "choice_b":"An Industrial development bond",
       "choice_c":"Penny stocks",
       "choice_d":"A real estate limited partnership",
       "correct_answer":"B",
       "explanation":"Due to a high degree of risk and a low degree of liquidity investors are required to sign a suitability statement when investing in CMOs, penny stocks and DPPs. IDRs are a type of municipal note and do not require a suitability statement."
    },
    {
       "id":20440,
       "practice_test_id":"",
       "topic_id":1,
       "question":"The written agreement that contains the specific details related to a bond issue is called the bond:",
       "choice_a":"Indenture",
       "choice_b":"Contract",
       "choice_c":"Subscription",
       "choice_d":"Prospectus",
       "correct_answer":"A",
       "explanation":"The written agreement that contains the specific details related to a bond issue is called the bond indenture. The indenture spells out all of the terms and conditions of the bond."
    },
    {
       "id":20441,
       "practice_test_id":"",
       "topic_id":1,
       "question":"Which of the following economic indicators would be most useful for figuring out whether the economy is growing quickly or slowly?",
       "choice_a":"Leading",
       "choice_b":"Lagging",
       "choice_c":"Coincident",
       "choice_d":"Fiscal",
       "correct_answer":"C",
       "explanation":"Of the three economic indicators, leading, coincident and lagging, the coincident indicators will be the best measure of how fast or slow the economy is growing ."
    },
    {
       "id":20442,
       "practice_test_id":"",
       "topic_id":1,
       "question":"Which one of the following rights is never directly granted to all common shareholders of a publicly-held corporation?",
       "choice_a":"Pre emptive right",
       "choice_b":"Voting right",
       "choice_c":"Right to receive declared dividends",
       "choice_d":"Right to elect the CEO",
       "correct_answer":"D",
       "explanation":"The CEO of a company is appointed by the Board of Directors. Shareholders do not vote directly for the CEO of the company. Shareholders vote for the Board of Directors and the Board determines who should run the day to day operations of the company"
    },
    {
       "id":20444,
       "practice_test_id":"",
       "topic_id":1,
       "question":"1 mill when determining tax liability for real property would best be described as:",
       "choice_a":"$10 per $1,000",
       "choice_b":"$1 per $1,000",
       "choice_c":"$10 per $100,000",
       "choice_d":"$1 per $100",
       "correct_answer":"B",
       "explanation":"1 mil equals $1 of tax for every $1,000 of assessed value of property ."
    },
    {
       "id":20445,
       "practice_test_id":"",
       "topic_id":1,
       "question":"Which of the following municipal bond issues would have the debt supported by revenue received based on a mil rate?",
       "choice_a":"PHA issue",
       "choice_b":"State issued GO",
       "choice_c":"Locally issued GO",
       "choice_d":"State bond anticipation note",
       "correct_answer":"C",
       "explanation":"A locally issued GObondwould have the debt supported by revenue received based on a mil rate. Local GOs are supported by property taxes. State issued GOs are supported by sales taxes."
    },
    {
       "id":20451,
       "practice_test_id":"",
       "topic_id":1,
       "question":"A municipality after years of financial difficulty defaults on an outstanding issue of GO bonds. The bond issue was rather small and had no legal opinion issued. Which of the following are not required in order for the bonds to be considered good delivery? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The bonds must be accompanied by an official default notice </li><li>All past unpaid coupons must be attached </li><li>All coupons for future payment must be attached </li><li>The bonds must be accompanied by an escrow receipt</li></ol>",
       "choice_a":"I only",
       "choice_b":"IV only",
       "choice_c":"II and III",
       "choice_d":"I and IV",
       "correct_answer":"D",
       "explanation":"In order for a bond in default to be considered to be in good deliverable form, all unpaid past coupons and all coupons for future payment must be attached. The bonds do not need to be accompanied by an official default notice or an escrow receipt."
    },
    {
       "id":20452,
       "practice_test_id":2,
       "topic_id":1,
       "question":"A municipality after years of financial difficulty defaults on an outstanding issue of GO bonds. The bond issue was rather small and had no legal opinion issued. In order for the bonds to be considered good delivery , which of the following are true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The bonds must be accompanied by an official default notice </li><li>All past unpaid coupons must be attached </li><li>All coupons for future payment must be attached </li><li>The bonds must be accompanied by an escrow receipt</li></ol>",
       "choice_a":"I and IV",
       "choice_b":"II and III",
       "choice_c":"II, III and IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"B",
       "explanation":"In order for a bond in default to be considered to be in good deliverable form, all unpaid past coupons and all coupons for future payment must be attached. The bonds do not need to be accompanied by an official default notice or an escrow receipt."
    },
    {
       "id":20460,
       "practice_test_id":3,
       "topic_id":1,
       "question":"Which of the following prescribe that lower taxes will encourage economic activity and help the economy grow resulting in a higher overall level tax collection?",
       "choice_a":"Supply side policy",
       "choice_b":"Fiscal policy",
       "choice_c":"Monetary policy",
       "choice_d":"Keynesian policy",
       "correct_answer":"A",
       "explanation":"Supplyside economic policybeleives that lower taxes will encourage economic activity and help the economy grow resulting in a higher overall level tax collection?"
    },
    {
       "id":20465,
       "practice_test_id":4,
       "topic_id":1,
       "question":"Which of the following features would benefit a preferred stock investor during a period of inflation?",
       "choice_a":"Cumulative",
       "choice_b":"Callable",
       "choice_c":"Convertible",
       "choice_d":"Participating",
       "correct_answer":"C",
       "explanation":"During times of inflation the value of fixed payments will become less valuable and the price of the preferred stock may decrease as a result. If the preferred stock is convertible it would lend support to the price of the preferred stock and allow the investor to convert the preferred shares for common shares which tend to do better during times of inflation."
    },
    {
       "id":20468,
       "practice_test_id":5,
       "topic_id":1,
       "question":"The FOMC has been reducing the size of its balance sheet in line with its mandate. Which of the following will occur? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Interest rates will increase  </li><li>The money supply will decrease </li><li>Interest rates will decrease  </li><li>The money supply will increase</li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and III",
       "choice_c":"II and IV",
       "choice_d":"I only",
       "correct_answer":"A",
       "explanation":"When the FOMC reduces the size of its balance sheet it is selling bonds and removing money from the system thereby reducing the money supply. When the FOMC sells bonds interest rates will increase ."
    },
    {
       "id":20469,
       "practice_test_id":6,
       "topic_id":1,
       "question":"A corporation borrows money on an unsecured intermediate basis at a rate of 4.9%. The corporation then takes the borrowed funds and invests in expanding its operations and generates a return of 9%. The corporation is employing:",
       "choice_a":"Arbitrage",
       "choice_b":"Interest rate spreading",
       "choice_c":"Leverage",
       "choice_d":"Expansionary policy",
       "correct_answer":"C",
       "explanation":"When a corporation borrows money and uses the borrowed funds to generate a return that exceeds the cost of the borrowed money the company is employing leverage."
    },
    {
       "id":20472,
       "practice_test_id":"",
       "topic_id":1,
       "question":"Commercial paper with 270 days to maturity trading in the money market has its interest rate calculated based on:",
       "choice_a":"270 days",
       "choice_b":"360 days",
       "choice_c":"Nine 30 day months",
       "choice_d":"Three 90 day quarters",
       "correct_answer":"B",
       "explanation":"Commercial paper with 270 days to maturity trading in the money market has its interest rate calculated based on a 360 day year."
    },
    {
       "id":20473,
       "practice_test_id":"",
       "topic_id":1,
       "question":"The FOMC has been embarking on a bond buying program in line with its mandate. Which of the following will occur? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Interest rates will increase  </li><li>The money supply will decrease </li><li>Interest rates will decrease  </li><li>The money supply will increase</li></ol>",
       "choice_a":"I and II",
       "choice_b":"III and IV",
       "choice_c":"I and IV",
       "choice_d":"II and III",
       "correct_answer":"B",
       "explanation":"When the FOMC purchases bonds it is injecting money into the system increasing the money supply. When the FOMC buys bonds it will lower interest rates ."
    },
    {
       "id":20475,
       "practice_test_id":"",
       "topic_id":1,
       "question":"Bond interest starts to accrue on:",
       "choice_a":"The accrual date",
       "choice_b":"The issue date",
       "choice_c":"The dated date",
       "choice_d":"The payment date",
       "correct_answer":"C",
       "explanation":"Bond interest starts to accrue on a new issue of bonds on the dated date."
    },
    {
       "id":20489,
       "practice_test_id":"",
       "topic_id":1,
       "question":"In response to a customer\u0027s request for information on a private label CMO you may inform them of all of the following except:",
       "choice_a":"The securities in the portfolio are all issued by a US agency and carry the same guarantees",
       "choice_b":"Interest payments due to investors are subject the credit risk of the issuing broker dealer",
       "choice_c":"If the interest payments in the portfolio are guaranteed by a Government agency the investor\u0027s interest payments are equally assured",
       "choice_d":"Private label CMOs may carry additional risks due the nature of the issuer\u0027s business",
       "correct_answer":"C",
       "explanation":"If the collateral in the portfolio of a private label CMO is guaranteed by a Government agency that guarantee does not pass through to the investors in the CMOs. There is no guarantee that the issuer will receive the payments and pass them on to the investors in a timely manner"
    },
    {
       "id":20506,
       "practice_test_id":"",
       "topic_id":1,
       "question":"Which of the following conditions would be persistent during a period of stagflation? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>High unemployment </li><li>Inflation  </li><li>Deflation </li><li>Falling interest rates</li></ol>",
       "choice_a":"I and III",
       "choice_b":"I and II",
       "choice_c":"III and IV",
       "choice_d":"II and IV",
       "correct_answer":"B",
       "explanation":"During a period of stagflation the economy will experience high unemployment and inflation. Interest rates will not decline as rates will remain high to fight inflation. High unemployment and high inflation and interest rates are persistent during a period of stagflation."
    },
    {
       "id":20512,
       "practice_test_id":"",
       "topic_id":1,
       "question":"The expansionary phase of the business cycle is characterized by: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Falling prices </li><li>Falling savings </li><li>Rising prices </li><li>Rising savings</li></ol>",
       "choice_a":"I and II",
       "choice_b":"III and IV",
       "choice_c":"II only",
       "choice_d":"IV only",
       "correct_answer":"B",
       "explanation":"The expansionary phase of the business cycle is characterized by rising prices and rising savings. As people earn more they tend to spend more and save more. This will cause prices to rise as more people buy goods.Balances in savings accounts willalso increase."
    },
    {
       "id":21064,
       "practice_test_id":"",
       "topic_id":1,
       "question":"An investor who is long a variable rate demand obligation is looking to offset his position and liquidate the security. The investor may accomplish this by doing which of the following?",
       "choice_a":"Selling the security in the market",
       "choice_b":"Putting the security to the dealer at any time",
       "choice_c":"Putting  the security to a third party at any time",
       "choice_d":"Putting the security to the dealer on the reset date only",
       "correct_answer":"D",
       "explanation":"An investor may only liquidate the variable rate demand obligation by putting the security to the dealer or to a third party on the reset date."
    },
    {
       "id":21066,
       "practice_test_id":"",
       "topic_id":1,
       "question":"Dallas Texas is seeking to issue $100,000,000 worth of new bonds and publishes an invitation to underwriters who may be interested in offering the bonds for sale to investors. This is known as:",
       "choice_a":"An invitation only sale",
       "choice_b":"A negotiated sale",
       "choice_c":"A competitive bid",
       "choice_d":"A direct issue sale",
       "correct_answer":"C",
       "explanation":"When a municipality wants to offer bonds for sale it will publish an official notice of sale in the Daily Bond Buyer. The underwriting will be awarded through competitive bidding. The underwriter with the lowest net interest cost to the issuer will be awarded the underwriting."
    },
    {
       "id":21068,
       "practice_test_id":"",
       "topic_id":1,
       "question":"ABC Micro has just gone public and has offered 10,000,000 common shares with a par value of $1. The IPO price was $20 per share. The difference between the par value and the IPO price would best be described as:",
       "choice_a":"A premium",
       "choice_b":"Additional paid in capital",
       "choice_c":"Capital surplus",
       "choice_d":"Proceeds to issuer",
       "correct_answer":"B",
       "explanation":"The amount by which the offering price of common shares exceeds the par value is known as additional paid in capital. The total par value along with the additional paid in capital are entered on the company\u0027s balance sheet as part of stockholders equity."
    },
    {
       "id":21069,
       "practice_test_id":2,
       "topic_id":1,
       "question":"In an effort to gain exposure to the market an optimistic investor takes on risk and purchases a stock with a beta equal to 1.4. If the S\u0026 P 500 is up 5 percent over the next several weeks what would the investor\u0027s expected return be on his purchase?",
       "choice_a":"6 Percent",
       "choice_b":"7 Percent",
       "choice_c":"9 percent",
       "choice_d":"11 percent",
       "correct_answer":"B",
       "explanation":"An investment with a beta of 1.4 would be expected to have a return equal to 140 percent of the return of the overall market. In this case the market was up 5 percent. The investor would therefore expect a return of 1.4 X 5 percent or a 7 percent return."
    },
    {
       "id":21070,
       "practice_test_id":3,
       "topic_id":1,
       "question":"A fixed income investor is looking at the yield curve reflecting the current interest rate environment. The investor notices that long term debt is paying significantly higher interest rates than shorter term debt securities. The chart for this would indicate that the yield curve is:",
       "choice_a":"flat",
       "choice_b":"inverted",
       "choice_c":"stable",
       "choice_d":"positive",
       "correct_answer":"D",
       "explanation":"When the interest rates on long term bonds exceed the interest rates on short term bonds, the yield curve is said to be positive or upward sloping. The chart of the yields will increase from the lower left to the upper right when measured by the term to maturity of the bonds."
    },
    {
       "id":21079,
       "practice_test_id":4,
       "topic_id":1,
       "question":"A municipal bond scale reflects which of the following?",
       "choice_a":"Various yields to maturity for bonds of different maturities",
       "choice_b":"Various prices for revenue bonds",
       "choice_c":"Various mil rates for local GO bonds",
       "choice_d":"Various ratings for GO bonds of different quality",
       "correct_answer":"A",
       "explanation":"A municipal bond scale reflects the various yield to maturities for GO bonds with different maturity dates. Bonds with shorter maturities will have lower yields than bonds with longer maturities in a normal interest rate environment."
    },
    {
       "id":21082,
       "practice_test_id":5,
       "topic_id":1,
       "question":"A municipal bond investor is looking at the 30 day visible supply to gauge the condition of the municipal bond market. The 30 day visible supply contains which of the following issues?  <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>GO bonds  </li><li>Revenue bonds  </li><li>Tax anticipation notes </li><li>Revenue anticipation notes</li></ol>",
       "choice_a":"I and II",
       "choice_b":"I only",
       "choice_c":"II, III and IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"A",
       "explanation":"The 30 day visible supply contains the total par value of all GO bonds and revenue bonds to be issued in the next 30 days. The 30 day visible supply does not contain the par value of any short term notes."
    },
    {
       "id":21083,
       "practice_test_id":6,
       "topic_id":1,
       "question":"If the Federal Reserve undertakes an accommodative monetary policy and begins to reduce interest rates, which of the following is most likely to occur?",
       "choice_a":"The value of the dollar will rise versus the Euro",
       "choice_b":"The value of the dollar will fall versus the Euro",
       "choice_c":"The value of the dollar will not be impacted versus the Euro",
       "choice_d":"The value of the dollar will be positively impacted versus the Euro",
       "correct_answer":"B",
       "explanation":"If the Federal Reserve reduces interest rates the value of the dollar will fall versus the value of all other currencies. In this case the value of the dollar will fall versus the Euro. It will now take more dollars to purchase 1 Euro."
    },
    {
       "id":21084,
       "practice_test_id":"",
       "topic_id":1,
       "question":"The manager of a long only fund has been systematically liquidating securities over the past 6 months and has moved the proceeds into money market funds. The manager is now said to be in \u0022cash\u0022. Which of the following would best describe the manager\u0027s outlook?",
       "choice_a":"He is bullish on rates",
       "choice_b":"He is bullish on bonds",
       "choice_c":"He is bearish on stocks",
       "choice_d":"He expects the FRB to reduce rates",
       "correct_answer":"C",
       "explanation":"The manager of a long only fund is not allowed to sell equities short. As a result the only option for this manager when they turn bearish on the stock market is to move to the sidelines and into cash and short term money market funds."
    },
    {
       "id":21085,
       "practice_test_id":"",
       "topic_id":1,
       "question":"A county is offering a new issue of 10 year GO bonds that are not in high demand. As a result the issue must be sold to investors at a price that is equal to 92. An investor who holds the bonds until they mature will have which of the following?",
       "choice_a":"A tax liability of $80 per bond",
       "choice_b":"A reduced yield to maturity",
       "choice_c":"Zero tax liability per bond",
       "choice_d":"Significant reinvestment risk",
       "correct_answer":"C",
       "explanation":"When an investor purchases an original issue discount bond and holds the bonds until maturity, the investor will not have any taxable gain on the appreciation to par."
    },
    {
       "id":21086,
       "practice_test_id":"",
       "topic_id":1,
       "question":"The department of transportation has been inspecting a toll bridge and determines that the bridge is unsafe for traffic. As a result the bridge is condemned. Which of the following would occur?",
       "choice_a":"All of the bonds would go into default",
       "choice_b":"All of the bonds would be called under the catastrophe call",
       "choice_c":"All of the bonds would be paid off from the assets in the sinking fund",
       "choice_d":"All of the bonds would be paid from funds allocated from a moral obligation fund",
       "correct_answer":"B",
       "explanation":"If a revenue producing structure is destroyed or condemned all of the bonds will be called in under the catastrophe call provision. The bonds will be paid off from proceeds from the catastrophe insurance policy."
    },
    {
       "id":21089,
       "practice_test_id":"",
       "topic_id":1,
       "question":"Common stockholders have the right to vote on which of the following?  <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The use of retained earnings to repurchase shares for the treasury </li><li>The issuance of convertible bonds  </li><li>The compensation for senior executives  </li><li>The declaration of bankruptcy</li></ol>",
       "choice_a":"I and III",
       "choice_b":"II and IV",
       "choice_c":"II only",
       "choice_d":"I and IV",
       "correct_answer":"C",
       "explanation":"Of the choices listed the only item that common stockholders may vote on would be the issuance of convertible debt. Common stockholders are entitled to vote for the issuance of any securities that could result in the dilution of shareholder\u0027s equity."
    },
    {
       "id":21094,
       "practice_test_id":"",
       "topic_id":1,
       "question":"As interest rates rise which of the following is true?",
       "choice_a":"The amount of interest paid on outstanding issues will increase",
       "choice_b":"The amount of interest paid on outstanding issues will decrease",
       "choice_c":"The amount of interest paid on outstanding issues will remain constant",
       "choice_d":"The amount of interest paid on outstanding issues will be adjusted to market rates",
       "correct_answer":"C",
       "explanation":"The amount of interest paid on bonds does not change once the bonds have been issued. The nominal yield or the coupon rate will determine the amount of interest that the bond pays over its entire maturity. Prices of bonds do change in the marketplace and that will cause a bond\u0027s current yield and yield to maturity to change based on the change in price."
    },
    {
       "id":21095,
       "practice_test_id":"",
       "topic_id":1,
       "question":"Which of the following issues would have a MIG rating?",
       "choice_a":"A revenue bond",
       "choice_b":"A GO Bond",
       "choice_c":"A limited tax bond",
       "choice_d":"A tax anticipation note",
       "correct_answer":"D",
       "explanation":"A Moody\u0027s Investment Grade or MIG rating is assigned to short term municipal debt. Bonds are long term municipal debt and would not be assigned a MIG rating. Only the Tax anticipation note would receive a MIG rating."
    },
    {
       "id":21096,
       "practice_test_id":2,
       "topic_id":1,
       "question":"A bond issue that is said to trade \u0022flat\u0022 indicates to the investor:",
       "choice_a":"the bond is trading at par value",
       "choice_b":"the bond is in default",
       "choice_c":"the bond price is very stable",
       "choice_d":"the bond does not pay interest",
       "correct_answer":"D",
       "explanation":"A bond that is said to trade flat does not trade with accrued interest. Zero coupon bonds, and other issues that are issued at a discount like T\u0027 bills, commercial paper and banker\u0027s acceptances all trade flat and do not make regular interest payments. These securities are issued at a discount and appreciate up to par."
    },
    {
       "id":21097,
       "practice_test_id":3,
       "topic_id":1,
       "question":"An investor is considering purchasing a 7 percent corporate bond. The bond is trading in the marketplace at 100 and is callable in 10 years at par. The bond has 16 years left until maturity. Which of the following is true?",
       "choice_a":"The YTC is lower than the YTM",
       "choice_b":"The YTC is greater than the YTM",
       "choice_c":"The YTC equals the YTM",
       "choice_d":"The investor would be better off purchasing a non callable issue",
       "correct_answer":"C",
       "explanation":"The bond is trading at 100 or par in the market and callable at par in 10 years. Since the price the investor would pay for the bond is equal to par and the bond is callable at par, the YTC will be equal to the YTM. When an investor buys a bond at par the nominal yield, the current yield and the yield to maturity will all be equal. If the bond is callable at par the YTC will also be the same as the nominal yield."
    },
    {
       "id":21109,
       "practice_test_id":4,
       "topic_id":1,
       "question":"Which of the following investors would be most likely to purchase an inverse ETF?",
       "choice_a":"A long term investor",
       "choice_b":"An institutional investor",
       "choice_c":"A bearish investor",
       "choice_d":"A bullish investor",
       "correct_answer":"C",
       "explanation":"An inverse ETF offers price performance that moves in the opposite direction of the underlying index. The s \u0026 P 500 inverse ETF will increase in price as the value of the S \u0026 P 500 falls. An investor who was bearish or who thought that the market may generally fall would be the most likely to purchase an inverse ETF."
    },
    {
       "id":21110,
       "practice_test_id":5,
       "topic_id":1,
       "question":"An investor who is long a large portfolio of large cap common stocks would most likely execute which of the following to protect the portfolio from a market correction?",
       "choice_a":"Purchase an inverse bond fund ETF",
       "choice_b":"Purchase a bond fund",
       "choice_c":"Purchase the S&P 500 inverse ETF",
       "choice_d":"Purchase puts on each holding in the portfolio",
       "correct_answer":"C",
       "explanation":"An investor who is long a large portfolio of large cap common stocks would most likely purchase the S\u0026 P 500 inverse ETF to provide protection to the overall portfolio in the event of a market correction. The price of the inverse ETF will increase as the value of the S\u0026 P 500 falls. Buying the inverse ETF is more efficient than purchasing puts on each and every stock in the portfolio."
    },
    {
       "id":21111,
       "practice_test_id":6,
       "topic_id":1,
       "question":"An inverse ETF would be suitable for which of the following? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Long term protection  </li><li>Short term protection  </li><li>Gaining short exposure </li><li>Portfolio hedging</li></ol>",
       "choice_a":"I and IV",
       "choice_b":"II and III",
       "choice_c":"I, II and IV",
       "choice_d":"II, III and IV",
       "correct_answer":"D",
       "explanation":"An inverse ETF could be used for short term protection, to gain short exposure to the market, or to hedge an overall portfolio against a market decline. An inverse ETF is not designed for long term protection."
    },
    {
       "id":24763,
       "practice_test_id":"",
       "topic_id":1,
       "question":"The President and Congress have been working to pass legislation that will increase the marginal tax rate. Which two of the following choices are true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The stock market will most likely fall  </li><li>There will be a decrease in the rate of disintermediation  </li><li>Yields on municipal bonds will most likely fall </li><li>The yield curve will become inverted</li></ol>",
       "choice_a":"II and IV",
       "choice_b":"I and III",
       "choice_c":"I and IV",
       "choice_d":"II and III",
       "correct_answer":"B",
       "explanation":"If there is an increase in the marginal tax rate, income taxes will increase. As a result of the increase in income taxes investors will be more likely to purchase municipal bonds. The increase in demand for the municipal bonds will cause the yields on municipal bonds to fall. An increase in taxes is bearish for the stock market and stock prices will likely fall."
    },
    {
       "id":24770,
       "practice_test_id":"",
       "topic_id":1,
       "question":"If investors have priced in the expectation for generally increasing prices in the marketplace, the yield curve most likely to reflect that expectation would be:",
       "choice_a":"Flat",
       "choice_b":"Inverted",
       "choice_c":"Ascending",
       "choice_d":"Correlated",
       "correct_answer":"C",
       "explanation":"An ascending or upward sloping yield curve is one which displays higher interest rates for longer term maturities. The increase in interest rates over time reflect investor\u0027s expectations for inflation ( increase in prices )."
    },
    {
       "id":39191,
       "practice_test_id":"",
       "topic_id":1,
       "question":"A growth investment is best described as being one where:",
       "choice_a":"the value of the investment will increase over time.",
       "choice_b":"the principal and dividends will increase over time.",
       "choice_c":"any investment appreciation will be tax-deferred.",
       "choice_d":"all interest and dividends received will be reinvested.",
       "correct_answer":"A",
       "explanation":"Growth is simply the increase in an investment\u0027s value over time. Remember that interest and dividends received, whether reinvested or not, represent income, not growth."
    },
    {
       "id":39192,
       "practice_test_id":"",
       "topic_id":1,
       "question":"An investor\u2019s portfolio consists of 50% blue-chip stocks (i.e., IBM, GM) and 50% growth stocks (i.e., AMZN, MSFT). This portfolio can best be described as:",
       "choice_a":"a growth and income portfolio.",
       "choice_b":"an aggressive growth portfolio.",
       "choice_c":"a high-yield income portfolio.",
       "choice_d":"a balanced portfolio.",
       "correct_answer":"A",
       "explanation":"A growth and income portfolio typically combines equities. More conservative blue-chip securities are used for their price stability, lending to capital preservation and payment of dividends for income, along with growth stocks for their appreciation potential. An aggressive portfolio contains securities of smaller companies that might have the potential for significant capital appreciation but may not provide much income. A high-yield income portfolio lends itself to lower rated debt securities and a balanced portfolio invests in both stocks and bonds."
    },
    {
       "id":39197,
       "practice_test_id":"",
       "topic_id":1,
       "question":"A client is considering investing in preferred shares of a company but is concerned with inflation risk. Which preferred stock feature if available would make the issue more suitable given his concern?",
       "choice_a":"Convertible",
       "choice_b":"Callable",
       "choice_c":"Cumulative",
       "choice_d":"Noncumulative",
       "correct_answer":"A",
       "explanation":"Some investments are subject to inflation risk; bonds and preferred shares which make fixed interest or dividend distributions among them. The ability to convert to common stock helps to mitigate inflation risk because common shares are more likely to keep pace with inflation."
    },
    {
       "id":954,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Under the Insider Trading Fraud Enforcement Act, the maximum fine for violators is:",
       "choice_a":"Three times the amount of money made",
       "choice_b":"Three times the amount of money investor avoided losing",
       "choice_c":"Treble damages",
       "choice_d":"Unlimited",
       "correct_answer":"D",
       "explanation":"The maximum fine for someone found to have acted on or disseminated inside information is unlimited."
    },
    {
       "id":955,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Under the Keogh plan, employees are vested:",
       "choice_a":"Immediately",
       "choice_b":"After 1 year in the plan",
       "choice_c":"After 2 years in the plan",
       "choice_d":"According to ERISA requirements",
       "correct_answer":"D",
       "explanation":"Employee participants in a Keogh plan will be vested according to ERISA."
    },
    {
       "id":956,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Under FINRA\u0027s Uniform Practice Code, a stock\u0027s ex-dividend date:",
       "choice_a":"Is set by the board of directors",
       "choice_b":"Is the day after the record date",
       "choice_c":"Is two days prior to the record date",
       "choice_d":"Is two business days prior to the record date",
       "correct_answer":"D",
       "explanation":"The ex-dividend date for a stock is always two business days prior to the record date."
    },
    {
       "id":957,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Voluntary withdrawals made from an IRA account prior to age 59 \u00BD are subject to a penalty of:",
       "choice_a":"5% of the amount withdrawn",
       "choice_b":"10% of the amount withdrawn",
       "choice_c":"15% of the amount withdrawn",
       "choice_d":"15% of the entire retirement fund",
       "correct_answer":"B",
       "explanation":"Premature distributions from an IRA are subject to a 10% penalty tax."
    },
    {
       "id":958,
       "practice_test_id":"",
       "topic_id":2,
       "question":"What does SEC stand for?",
       "choice_a":"Security and Election Committee",
       "choice_b":"Security and Exchange Committee",
       "choice_c":"Securities Executive Commission",
       "choice_d":"Securities Exchange Commission",
       "correct_answer":"D",
       "explanation":"You should know the precise name of this commission."
    },
    {
       "id":959,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Which of the following acts concerns itself with the registration of broker dealers and their required net capital?",
       "choice_a":"SIPC Act of 1970",
       "choice_b":"Securities Act of 1933",
       "choice_c":"Broker Dealer Fiscal Responsibility Act of 1937",
       "choice_d":"Securities Exchange Act of 1934",
       "correct_answer":"D",
       "explanation":"The Securities Exchange Act of 1934 regulates the activities of broker dealers and their required capital."
    },
    {
       "id":960,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Which of the following are funded with after-tax dollars? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>TDA </li><li>Roth IRA </li><li>TSA </li><li>Tax Deferred Annuity</li></ol>",
       "choice_a":"I and III",
       "choice_b":"I and II",
       "choice_c":"II and IV",
       "choice_d":"III and IV",
       "correct_answer":"C",
       "explanation":"A Roth IRA and a tax deferred annuity are funded with after-tax dollars."
    },
    {
       "id":961,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Which of the following are funded with pre-tax dollars? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>  Keogh  </li><li> Variable annuity </li><li>Fixed annuity   </li><li>TDA</li></ol>",
       "choice_a":"II and III",
       "choice_b":"I and II",
       "choice_c":"II and IV",
       "choice_d":"I and IV",
       "correct_answer":"D",
       "explanation":"Only the Keogh plan and the TDA are funded with pre-tax dollars. The rest are funded with after-tax dollars."
    },
    {
       "id":962,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Which of the following are true regarding non-qualified plans? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The plan is a trust  </li><li>The cost base equals the deposits into plan </li><li>IRS approval is not needed </li><li>All money is taxed as ordinary income upon receipt</li></ol>",
       "choice_a":"III and IV",
       "choice_b":"I and III",
       "choice_c":"I and IV",
       "choice_d":"II and III",
       "correct_answer":"D",
       "explanation":"A non-qualified plan is not a trust and IRS approval is not needed. Only the growth is taxed as ordinary income upon receipt."
    },
    {
       "id":963,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Which of the following establish rules and membership requirements for FINRA:",
       "choice_a":"Board of Governors",
       "choice_b":"The District Business Conduct Committee",
       "choice_c":"The National Business Conduct Committee",
       "choice_d":"The Office of the Bylaw Administrator",
       "correct_answer":"A",
       "explanation":"FINRA\u0027s Board of Governors establishes rules and membership standards."
    },
    {
       "id":964,
       "practice_test_id":1,
       "topic_id":2,
       "question":"Which of the following gave the Federal Reserve Board the authority to regulate the extension of credit for securities purchases?",
       "choice_a":"Securities Lending Act of 1935",
       "choice_b":"Maloney Act of 1938",
       "choice_c":"Securities Exchange Act of 1934",
       "choice_d":"Securities Act of 1933",
       "correct_answer":"C",
       "explanation":"Regulation T of the Securities Exchange Act of 1934 gave the Federal Reserve board the authority to regulate the extension of credit for securities purchases."
    },
    {
       "id":965,
       "practice_test_id":2,
       "topic_id":2,
       "question":"Which of the following is a non-allowable investment for an IRA?",
       "choice_a":"Stocks and bonds",
       "choice_b":"Rare coins and art",
       "choice_c":"Mutual funds and annuities",
       "choice_d":"US minted coins",
       "correct_answer":"B",
       "explanation":"Rare coins and art are not allowed as investments for an IRA because the investment must be negotiable and allowed to grow in value, tax deferred."
    },
    {
       "id":966,
       "practice_test_id":3,
       "topic_id":2,
       "question":"Which of the following is not a type of underwriting commitment?",
       "choice_a":"Firm commitment",
       "choice_b":"Primary commitment",
       "choice_c":"Best efforts commitment",
       "choice_d":"Standby commitment",
       "correct_answer":"B",
       "explanation":"Primary commitment is not a type of underwriting commitment."
    },
    {
       "id":967,
       "practice_test_id":4,
       "topic_id":2,
       "question":"Which of the following is not a way that an investor may sell mutual fund shares for tax purposes?",
       "choice_a":"FIFO",
       "choice_b":"Average basis",
       "choice_c":"Share Identification",
       "choice_d":"Random assignment",
       "correct_answer":"D",
       "explanation":"An investor may use all of the methods listed except random assignment."
    },
    {
       "id":968,
       "practice_test_id":5,
       "topic_id":2,
       "question":"Which of the following is true about taxation of annuities?",
       "choice_a":"Contributions are made with after-tax money",
       "choice_b":"The investment is allowed to grow tax deferred",
       "choice_c":"When the investor withdraws money from the contract, only the growth is taxed",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"All of the choices listed are true about the taxation of annuities."
    },
    {
       "id":969,
       "practice_test_id":6,
       "topic_id":2,
       "question":"Which of the following persons is ineligible to open a Keogh plan?",
       "choice_a":"A doctor whose income is derived from his practice",
       "choice_b":"An advertising agency executive whose income is derived from a salary plus $5,000 in outside consulting fees",
       "choice_c":"An employee of a brokerage firm whose income is derived from salary plus a year-end bonus",
       "choice_d":"An artist whose annual income is derived from sales of his paintings",
       "correct_answer":"C",
       "explanation":"The employee of the brokerage firm is not self-employed and may not open a Keogh."
    },
    {
       "id":970,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Which of the following plans is non-funded?",
       "choice_a":"Keogh",
       "choice_b":"TSA",
       "choice_c":"TDA",
       "choice_d":"Deferred compensation plan",
       "correct_answer":"D",
       "explanation":"A deferred compensation plan is non-funded. There is no money set aside for the participant in the plan."
    },
    {
       "id":971,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Which of the following statements regarding disciplinary proceedings under the Code of Procedure are correct? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The complaint will initially be heard by the Division of Enforcement </li><li>Appeals will be heard by the NAC. </li><li>All decisions are final and binding with no appeal </li><li>The respondent may wave a hearing by signing an AWAC</li></ol>",
       "choice_a":"I, II and IV",
       "choice_b":"I and II",
       "choice_c":"I and III",
       "choice_d":"II and IV",
       "correct_answer":"A",
       "explanation":"The Division of Enforcement will hear the complaint initially. Appeals will be heard by the National Adjudicatory Council, and the respondent may settle the allegations by signing an Acceptance Waiver and Consent."
    },
    {
       "id":972,
       "practice_test_id":"",
       "topic_id":2,
       "question":"You have been working for the local school system for 15 years and have been contributing to a payroll deduction plan for 9 years. You have deposited $11,000 during the period, and it has grown to $16,200. What is your tax liability upon a lump sum withdrawal if you are in the 30% tax bracket when you retire?",
       "choice_a":"$4,840",
       "choice_b":"$0",
       "choice_c":"$3,300",
       "choice_d":"$1,560",
       "correct_answer":"D",
       "explanation":"The money has been deposited into a non-qualified plan and the $11,000 has therefore been placed into the plan with after-tax dollars. Only the growth in the account is taxable, or in this case: $5,200 X 30% = $1,560."
    },
    {
       "id":973,
       "practice_test_id":"",
       "topic_id":2,
       "question":"You have just joined your company\u0027s pension plan and are asking about the reports that will be furnished to you regarding its investment results. You must get statements at least:",
       "choice_a":"Monthly",
       "choice_b":"Quarterly",
       "choice_c":"Semi-annually",
       "choice_d":"Annually",
       "correct_answer":"D",
       "explanation":"A participant in a corporate pension plan must get reports at least annually."
    },
    {
       "id":974,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Your aunt has died and has left you 1000 shares of VBPF, which she bought for $12 each, before the technology boom of the eighties. The shares are now worth $48.00 per share. Which of the following is true?",
       "choice_a":"Your cost basis is the same as the original cost, $12 per share",
       "choice_b":"Your cost basis is the value of the stock after inheritance taxes have been paid",
       "choice_c":"You have a cost basis of $48 per share, their value when she died",
       "choice_d":"The $48,000 will be treated as ordinary income, and will be taxed at your rate",
       "correct_answer":"C",
       "explanation":"The cost basis of inherited securities is their fair market value on the day of death."
    },
    {
       "id":975,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Your customer has been accumulating shares in a mutual fund through regular investments over a 5 year period. She now wants to sell 750 shares to help with the down payment on a new car. The IRS will use what method to determine her tax liability:",
       "choice_a":"LIFO",
       "choice_b":"FIFO",
       "choice_c":"Average cost",
       "choice_d":"Average price",
       "correct_answer":"B",
       "explanation":"The IRS will use the FIFO method to determine the investor\u0027s gain."
    },
    {
       "id":976,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Your customer has reportable income of $87,000 and lost $11,000 during the year in the stock market. He is in the 34% tax bracket. What does he report for IRS purposes on his tax return?",
       "choice_a":"$87,000",
       "choice_b":"$76,000",
       "choice_c":"$84,000",
       "choice_d":"$81,500",
       "correct_answer":"C",
       "explanation":"The customer may deduct $3,000 of the $11,000 loss from his ordinary income."
    },
    {
       "id":977,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Your firm has the following people working for it. Which one is required to be registered in order to perform their job?",
       "choice_a":"Part time sales assistant who occasionally takes verbal orders from customers",
       "choice_b":"A corporate officer whose sole function is to act as liaison between the Board of Directors and management",
       "choice_c":"Your firm\u0027s receptionist who takes messages from customers inquiring about their accounts",
       "choice_d":"A back office margin clerk who assists the head of the margin department",
       "correct_answer":"A",
       "explanation":"The part time sales assistant who takes orders from customers must be registered, because she is taking orders."
    },
    {
       "id":978,
       "practice_test_id":"",
       "topic_id":2,
       "question":"If a registered representative purchases a limited partnership unit without providing prior written notice to his employing firm, the rep:",
       "choice_a":"Has violated FINRA\u0027s rule prohibit ing outside business activities",
       "choice_b":"Is in compliance with FINRA rules because this is a passive investment",
       "choice_c":"Must have her firm\u0027s written approval before receiving any distributions",
       "choice_d":"Has violated FINRA\u0027s rule against interpositioning",
       "correct_answer":"B",
       "explanation":"The prohibitions against outside business activities do not apply in the case of a passive investment. Holding a limited partnership interest does not entitle the rep to actively manage the partnership; thus, the rep is not in violation."
    },
    {
       "id":979,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Of the following statements describing traditional IRAs, which one is not true of 403(b) qualified plans?",
       "choice_a":"A self-employed person may participate",
       "choice_b":"Contributions are tax deferred",
       "choice_c":"Distributions must begin by age 70\u00BD",
       "choice_d":"Distributions after age 59\u00BD are taxed as ordinary income",
       "correct_answer":"A",
       "explanation":"Only employees of schools, church organizations, and nonprofit organizations are eligible to participate in 403(b) plans. The provisions for contributions and distributions are the same for IRAs and 403(b) qualified plans."
    },
    {
       "id":980,
       "practice_test_id":"",
       "topic_id":2,
       "question":"What are the consequences when a participant in a Keogh plan contributes more than the annual limit? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Contributions are tax deductible. </li><li>Contributions are not tax deductible. </li><li>Interest and dividends are tax deferred. </li><li>Interest and dividends are not tax deferred.</li></ol>",
       "choice_a":"I and III",
       "choice_b":"I and IV",
       "choice_c":"II and III",
       "choice_d":"II and IV",
       "correct_answer":"C",
       "explanation":"Any voluntary contributions a self-employed individual makes to an established Keogh retirement plan are not tax deductible; however, any growth or earnings attributable to the voluntary contributions will accumulate tax deferred until withdrawn at the owner\u0027s retirement."
    },
    {
       "id":981,
       "practice_test_id":"",
       "topic_id":2,
       "question":"All of the following qualified plans are covered by ERISA guidelines except:",
       "choice_a":"Public sector plans",
       "choice_b":"Private sector plans",
       "choice_c":"401K plans",
       "choice_d":"Profit-sharing plans",
       "correct_answer":"A",
       "explanation":"Public sector plans are not covered by ERISA guidelines. Corporate and certain union retirement plans are subject to ERISA guidelines."
    },
    {
       "id":982,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Regulations regarding how contributions are made to tax qualified plans relate to which of the following ERISA requirements?",
       "choice_a":"Vesting",
       "choice_b":"Funding",
       "choice_c":"Nondiscrimination",
       "choice_d":"Reporting and disclosure",
       "correct_answer":"B",
       "explanation":"Vesting describes how quickly rights to a retirement account turn over to an employee. \u0022Non-discrimination\u0022 refers to employee coverage by the plan. All retirement plans must meet ERISA\u0027s fiduciary reporting and disclosure requirements. Only \u0022funding\u0022 covers how an employer contributes to, or funds, a plan."
    },
    {
       "id":983,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Payments received by the owner of a 403(b) plan are:",
       "choice_a":"100% taxable",
       "choice_b":"Taxable only to extent of earnings",
       "choice_c":"Taxable only to extent of the owner\u0027s cost basis",
       "choice_d":"Not taxable",
       "correct_answer":"A",
       "explanation":"When qualified funds are withdrawn, they are fully taxed at ordinary income rates. Qualified funds were contributed pretax and earnings accumulate tax-deferred. Because no taxes were ever paid, the full withdrawal is taxable."
    },
    {
       "id":984,
       "practice_test_id":1,
       "topic_id":2,
       "question":"Which of the following statements about SEP/IRAs is true?",
       "choice_a":"They are used primarily by large corporations",
       "choice_b":"They are used primarily by small businesses",
       "choice_c":"They are set up by employees",
       "choice_d":"They cannot be set up by self employed persons",
       "correct_answer":"B",
       "explanation":"SEP/IRAs are used primarily by small businesses because they are much easier and less expensive to set up than other plans; they are also used by self employed persons. The employer sets up and administers the SEP/IRA."
    },
    {
       "id":985,
       "practice_test_id":2,
       "topic_id":2,
       "question":"Under ERISA, a fund manager wishing to write uncovered calls may do so:",
       "choice_a":"If explicitly allowed in the plan document",
       "choice_b":"Without restriction",
       "choice_c":"If approved by the IRS in writing",
       "choice_d":"Under no circumstances",
       "correct_answer":"D",
       "explanation":"ERISA prohibits retirement plan trustees from making investments that are excessively speculative. An uncovered call writer has unlimited risk."
    },
    {
       "id":986,
       "practice_test_id":3,
       "topic_id":2,
       "question":"When opening a Keogh account, a self-employed individual must make contributions for which of the following employees?",
       "choice_a":"Full-time employees who have worked for one year or more",
       "choice_b":"Part-time employees who have worked for three years or more",
       "choice_c":"All employees scheduled to work for 1,000 hours or more per year",
       "choice_d":"All employees",
       "correct_answer":"A",
       "explanation":"All full-time employees that is, those scheduled to work for more than 1,000 hours a year who have worked for the company for more than one year and are at least 21 years of age must be covered under the employer\u0027s Keogh plan."
    },
    {
       "id":987,
       "practice_test_id":4,
       "topic_id":2,
       "question":"Your 67 year old client owns a nonqualified variable annuity. He originally invested $29,000 four years ago; it now has a value of $39,000. Your client, who is in the 28% tax bracket, makes a lump-sum withdrawal of $15,000. What tax liability results from the withdrawal?",
       "choice_a":"$0",
       "choice_b":"$2,800",
       "choice_c":"$3,800",
       "choice_d":"$4,200",
       "correct_answer":"B",
       "explanation":"This annuity is nonqualified, which means the client has paid for it with after tax dollars and, therefore, has a basis equal to the original $29,000 investment. Consequently, the client pays taxes only on the growth portion of the withdrawal ($10,000). The tax on this is $2,800 ($10,000 x 28%). Because the client is older than age 59\u00BD, he pays no 10% premature distribution penalty tax. However, had the client been younger than age 59\u00BD, he would have paid a $1,000 penalty tax ($10,000 x 10%) in addition to the $2,800 income tax."
    },
    {
       "id":988,
       "practice_test_id":5,
       "topic_id":2,
       "question":"A retiree is paid an annual amount equal to 30% of the average of his last three years\u0027 salary. Which of the following retirement plans offers this type of payment?",
       "choice_a":"Deferred compensation",
       "choice_b":"Profit-sharing",
       "choice_c":"Defined benefit",
       "choice_d":"Defined contribution",
       "correct_answer":"C",
       "explanation":"A retirement plan that establishes in advance the payout to be received by the retiree is a defined benefit plan."
    },
    {
       "id":989,
       "practice_test_id":6,
       "topic_id":2,
       "question":"The requirements of the Employee Retirement Income Security Act apply to pension plans established by which of the following?",
       "choice_a":"All union plans",
       "choice_b":"Only public entities, such as New York City",
       "choice_c":"Only private organizations, such as SIA Corp",
       "choice_d":"Both public and private organizations",
       "correct_answer":"C",
       "explanation":"ERISA was established to protect the retirement funds of employees working in the private sector only. It does not apply to self employed persons, certain union plans, or public organizations like cities and states."
    },
    {
       "id":990,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Which of the following can be rolled over into an IRA? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Another IRA </li><li>Corporate pension plan </li><li>Corporate profit sharing plan </li><li>Keogh plan</li></ol>",
       "choice_a":"I and IV only",
       "choice_b":"II and III only",
       "choice_c":"II, III and IV only",
       "choice_d":"I, II, III and IV",
       "correct_answer":"D",
       "explanation":"Assets from any qualified corporate plan or from another IRA may be rolled over into an IRA."
    },
    {
       "id":991,
       "practice_test_id":"",
       "topic_id":2,
       "question":"What was the primary purpose for creating ERISA?",
       "choice_a":"To promote a retirement fund for government employees",
       "choice_b":"To establish a means for self-employed persons to provide for their own retirements",
       "choice_c":"To protect employees from the mishandling of retirement funds by corporations and unions",
       "choice_d":"To provide all employees, both government and non-government, with an additional source of retirement income in the event that the Social Security system defaults",
       "correct_answer":"C",
       "explanation":"ERISA was created originally to protect the retirement funds of union members and employees of large corporations. ERISA guidelines state that all qualified retirement plans must be in writing, must not be discriminatory, must segregate funds from corporate or union assets, must invest in prudent investments, and must report to participants annually. All of these activities are audited under ERISA."
    },
    {
       "id":992,
       "practice_test_id":"",
       "topic_id":2,
       "question":"A rollover of an IRA may occur:",
       "choice_a":"Quarterly",
       "choice_b":"Semiannually",
       "choice_c":"Annually",
       "choice_d":"Every five years",
       "correct_answer":"C",
       "explanation":"Securities or funds may be rolled over from one account to another only once every year. Transfers from one account to another are not restricted in any way."
    },
    {
       "id":993,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Early withdrawals may be made without penalty from a Keogh plan in all of the following circumstances except:",
       "choice_a":"The account owner\u0027s death",
       "choice_b":"The account owner\u0027s disability",
       "choice_c":"From the voluntary, nondeductible contributions",
       "choice_d":"From the tax-deductible contributions",
       "correct_answer":"D",
       "explanation":"A Keogh account owner can always withdraw his own voluntary contributions, and tax-deductible contributions can be withdrawn without penalty in the event of the account owner\u0027s death or disability."
    },
    {
       "id":994,
       "practice_test_id":"",
       "topic_id":2,
       "question":"When the SEC assesses whether an individual has acted properly in the purchase and sale of securities based on inside information, it considers which of the following factors? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Whether the individual with inside information made a profit on the transaction </li><li>Whether the other party was privy to the same information </li><li>Method by which the information was released to the public </li><li>Time of the transaction in relation to the time when the information was released to the public</li></ol>",
       "choice_a":"I and II only",
       "choice_b":"II and IV only",
       "choice_c":"III and IV only",
       "choice_d":"I, II, III and IV",
       "correct_answer":"C",
       "explanation":"Under the Act of 1934, insiders cannot profit from inside information - that is, information not available to the general public. To determine whether information is still \u0022inside\u0022 (not in the public domain), the SEC considers the method by which the information is released to the public (it must be broadly disseminated) and the timing of trades relative to when other people also have the information. The SEC does not consider the profit made or the loss avoided when determining whether a violation occurred; its concern is whether the information was nonpublic at the time of a trade."
    },
    {
       "id":995,
       "practice_test_id":"",
       "topic_id":2,
       "question":"If a case has gone to the Board of Arbitration the decisions made are:",
       "choice_a":"Not binding on a client but are binding on the member",
       "choice_b":"Binding only if the two parties agree on the decision",
       "choice_c":"Not binding if the two parties decide not to accept the decision",
       "choice_d":"Always binding on all parties to the arbitration",
       "correct_answer":"D",
       "explanation":"The findings of the Board of Arbitration are binding on all parties involved. There is no appeal of arbitration decisions."
    },
    {
       "id":996,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Which of the following describes a fidelity bond?",
       "choice_a":"Bond that protects customer accounts against loss of value",
       "choice_b":"Truth-in-lending statement that must be furnished to customers before they open accounts",
       "choice_c":"Insurance bond that protects broker-dealers from losses due to theft or embezzlement by employees",
       "choice_d":"Corporate debt issue backed by the faith and credit of the issuer",
       "correct_answer":"C",
       "explanation":"A broker-dealer must maintain fidelity bond coverage to protect the firm\u0027s assets from loss due to theft or embezzlement by officers or employees."
    },
    {
       "id":997,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Penalties resulting from a Code of Procedure hearing may include? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Censure </li><li>Expulsion </li><li>Suspension </li><li>Fines</li></ol>",
       "choice_a":"I, II and III only",
       "choice_b":"I and IV only",
       "choice_c":"II, III and IV only",
       "choice_d":"I, II, III and IV",
       "correct_answer":"D",
       "explanation":"Penalties under Code of Procedure may include one or more of the following: Censure, Expulsion, Suspension, Fines."
    },
    {
       "id":998,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Which of the following is the maximum amount of business related gratuities and gifts that may be received by a registered representative from one person per year, according to FINRA rules?",
       "choice_a":"$0",
       "choice_b":"$25",
       "choice_c":"$50",
       "choice_d":"$100",
       "correct_answer":"D",
       "explanation":"FINRA rules permit business related gratuities and gifts of no more than $100 per year."
    },
    {
       "id":999,
       "practice_test_id":"",
       "topic_id":2,
       "question":"The Securities Exchange Act of 1934 contains sections that deal with which of the following? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Regulation of investment companies </li><li>Trading activities such as short sales, stabilizing and registering over-the-counter brokers and dealers </li><li>Form and content of the prospectus that must be given to all prospective purchasers of a security </li><li>Disclosure of information relating to a new issue</li></ol>",
       "choice_a":"I and II only",
       "choice_b":"II only",
       "choice_c":"III and IV only",
       "choice_d":"I, II, III and IV",
       "correct_answer":"B",
       "explanation":"The Securities Exchange Act of 1934, addresses most things effecting the secondary markets. The Investment Company Act of 1940 defines and regulates investment companies. The Securities Act of 1933 addresses registration and prospectus requirements."
    },
    {
       "id":1000,
       "practice_test_id":1,
       "topic_id":2,
       "question":"Which of the following securities are subject to the antifraud provisions of the Securities Act of 1933? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>U.S. government bonds </li><li>Corporate debt instruments maturing in fewer than 270 days </li><li>Corporate equity securities issued and sold intrastate </li><li>Municipal bonds</li></ol>",
       "choice_a":"I, II and III only",
       "choice_b":"I and IV only",
       "choice_c":"II and III only",
       "choice_d":"I, II, III and IV",
       "correct_answer":"D",
       "explanation":"All securities and securities are subject to the antifraud provisions of the act of 1933 even if they are exempt from the registration requirements of the act."
    },
    {
       "id":1001,
       "practice_test_id":2,
       "topic_id":2,
       "question":"Assume that a registered representative\u0027s father wants to purchase a new issue. Under FINRA rules, which of the following factors favor(s) filling his order? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The father is financially independent of the registered representative </li><li>The amount of securities that the father wishes to purchase is insubstantial in relation to the entire issue </li><li>The father has established an investment history of buying new issue securities </li><li>The father does not reside with the registered representative</li></ol>",
       "choice_a":"I and II only",
       "choice_b":"I, II and III only",
       "choice_c":"III only",
       "choice_d":"I, II, III and IV",
       "correct_answer":"D",
       "explanation":"All of the choices listed tend to favor permitting the father\u0027s purchase of the new issue."
    },
    {
       "id":1002,
       "practice_test_id":3,
       "topic_id":2,
       "question":"Which of the following employees of a member firm are not subject to the mandatory fingerprinting rule?",
       "choice_a":"Associated persons employed as sales representatives",
       "choice_b":"Auditors and accountants in charge of the firm\u0027s money and securities accounting records",
       "choice_c":"Officers or partners who supervise the firm\u0027s cashiering and accounting departments",
       "choice_d":"Associated persons engaged exclusively in securities research",
       "correct_answer":"D",
       "explanation":"The SEC requires that all officers and employees of a broker-dealer be fingerprinted if they (1) engage in the sale of securities, (2) have access to physical securities, cash or accounting records or (3) directly supervise employees who handle securities, cash or accounting records."
    },
    {
       "id":1003,
       "practice_test_id":4,
       "topic_id":2,
       "question":"A registered municipal securities representative may never:",
       "choice_a":"Supervise trading",
       "choice_b":"Act as a sales agent",
       "choice_c":"Act as a broker",
       "choice_d":"Act as a buyer\u0027s agent",
       "correct_answer":"A",
       "explanation":"A registered representative may never act in a supervisory capacity. Only a registered principal may do so."
    },
    {
       "id":1004,
       "practice_test_id":5,
       "topic_id":2,
       "question":"Which of the following statements is true of rulings under the FINRA Code of Arbitration Procedure?",
       "choice_a":"They are binding on members but not on customers",
       "choice_b":"They are binding on all parties",
       "choice_c":"They may be appealed to the FINRA National Adjudicatory Council",
       "choice_d":"They may be appealed to the SEC",
       "correct_answer":"B",
       "explanation":"If a customer chooses to submit a claim or problem to arbitration under the FINRA\u0027s Code of Arbitration Procedure, he or she is bound by the decision reached."
    },
    {
       "id":1005,
       "practice_test_id":6,
       "topic_id":2,
       "question":"The Act of 1934 applies to all of the following except:",
       "choice_a":"Regulation of new issues",
       "choice_b":"Registration of broker/dealers",
       "choice_c":"The extension of credit on the purchase of securities",
       "choice_d":"Secondary market trading",
       "correct_answer":"A",
       "explanation":"The Act of 1933 deals with new issues. The Act of 1934 created the SEC, required the registration of broker/dealers, empowered the Federal Reserve to control the extension of credit on securities transactions and created rules dealing with secondary market trading. To summarize, the Act of 1933 deals with the primary (new issue) market, while the Act of 1934 deals with the trading market."
    },
    {
       "id":1006,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Which of the following are characteristics of the Securities Act of 1933? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Requires registration of exchanges </li><li>Called the \u0022Truth in Securities Act\u0022 </li><li>Requires full and fair disclosure </li><li>Requires that debt securities be issued with a trust indenture</li></ol>",
       "choice_a":"I and II",
       "choice_b":"I, II and IV",
       "choice_c":"I and III",
       "choice_d":"II and III",
       "correct_answer":"D",
       "explanation":"The Securities Act of 1933 regulates new issues of corporate securities sold to the public. The Act is also referred to as the Full Disclosure Act, the Paper Act, the Truth in Securities Act, and the Prospectus Act (II). The purpose of the Act is to require full, written disclosure about a new issue (III). The 1934 Securities Exchange Act that requires exchanges to register with the SEC, not the 1933 Act(I). Registration of exchanges is required under the 1934 Exchange Act (1) and the Trust Indenture Act of 1939 requires corporations issuing more than $5 million in bonds to have a trust indenture (IV). The 1934 Act regulates exchanges (I), not the 1933 Act."
    },
    {
       "id":1007,
       "practice_test_id":"",
       "topic_id":2,
       "question":"If an individual fails a qualification exam three straight times, a fourth attempt may not be made for:",
       "choice_a":"30 days",
       "choice_b":"60 days",
       "choice_c":"90 days",
       "choice_d":"6 months",
       "correct_answer":"D",
       "explanation":"If a qualification exam is failed three straight times, a fourth attempt may not be made for 6 months."
    },
    {
       "id":1008,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Under the Securities Exchange Act of 1934, the SEC does which of the following? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Regulates securities exchanges </li><li>Requires the registration of brokers and dealers </li><li>Prohibits inequitable and unfair trade practices </li><li>Regulates over the counter markets</li></ol>",
       "choice_a":"I and II only",
       "choice_b":"I and IV only",
       "choice_c":"II, III and IV only",
       "choice_d":"I, II, III and IV",
       "correct_answer":"D",
       "explanation":"Although the SEC has delegated some of the responsibility of overseeing the securities markets to FINRA, exchanges and other SROs, it is still ultimately responsible for their regulation."
    },
    {
       "id":1009,
       "practice_test_id":"",
       "topic_id":2,
       "question":"If a member wishes to appeal an adverse decision in a Code of Procedure hearing, the member must first appeal to the National Adjudicatory Council within how many days of the decision date?",
       "choice_a":"25 days",
       "choice_b":"30 days",
       "choice_c":"40 days",
       "choice_d":"45 days",
       "correct_answer":"A",
       "explanation":"If either side is displeased with a Code of Procedure decision, an appeal must be made within 25 days of decision date. Otherwise, the decision is final."
    },
    {
       "id":1010,
       "practice_test_id":"",
       "topic_id":2,
       "question":"In settling disputes between member firms, arbitration is an attractive option because arbitration:",
       "choice_a":"Is not binding on both parties",
       "choice_b":"Is relatively inexpensive",
       "choice_c":"Does not allow for arguments from parties outside the industry",
       "choice_d":"Gives more time to prepare arguments",
       "correct_answer":"B",
       "explanation":"Arbitration is the preferred method for settling disputes between member firms because it is less costly than litigation. In addition, all decisions are final and binding."
    },
    {
       "id":1011,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Under terms of the Telephone Consumer Privacy Act, which of the following are true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The firm must maintain a Don\u0027t Call List </li><li>Cold calls can be made only between 8:00 a.m. and 9:00 p.m. </li><li>The time period of the rule applies to the time zone of the representative making the call. </li><li>The time period of the call applies to the time zone of where the phone call is received.</li></ol>",
       "choice_a":"I, II and III",
       "choice_b":"I, II and IV",
       "choice_c":"I and III",
       "choice_d":"II and IV",
       "correct_answer":"B",
       "explanation":"This federal law allows a prospect to request that the firm make no further phone calls. Any solicitation made must occur during a reasonable time period within the time zone of the recipient of the call."
    },
    {
       "id":1012,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Under the Securities Exchange Act of 1934, insiders, for purposes of insider trading, can include which of the following? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Attorney who writes an offering circular for a company </li><li>Bookkeeper in a company\u0027s accounting department </li><li>Wife of a company\u0027s president </li><li> Brother of a company\u0027s president</li></ol>",
       "choice_a":"I only",
       "choice_b":"II only",
       "choice_c":"II, III and IV only",
       "choice_d":"I, II, III and IV",
       "correct_answer":"D",
       "explanation":"While the Act of 1934 defines an insider as an officer, a director or a 10% stockholder of a company, the courts have broadened the definition to include anyone who has or could have access to inside information."
    },
    {
       "id":1013,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Under NYSE rules, which of the following communications with the public requires a supervisory analyst\u0027s approval?",
       "choice_a":"Market letter",
       "choice_b":"Television interview",
       "choice_c":"Research report",
       "choice_d":"Seminar",
       "correct_answer":"C",
       "explanation":"A firm is liable for the accuracy and content of a research report because the firm prepares it and would supposedly put its name and reputation behind the report. All of the other pieces listed are prepared on a more individualized, local basis and do not fall under a supervisory analyst\u0027s jurisdiction."
    },
    {
       "id":1014,
       "practice_test_id":"",
       "topic_id":2,
       "question":"FINRA rules on customer correspondence apply to: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Mail delivered by the US postal service </li><li>Mail delivered by UPS </li><li>Fax transmissions </li><li>Electronic mail</li></ol>",
       "choice_a":"I only",
       "choice_b":"I and II only",
       "choice_c":"I and III only",
       "choice_d":"I, II, III and IV",
       "correct_answer":"D",
       "explanation":"The rules on correspondence apply to any and all forms of incoming and outgoing correspondence."
    },
    {
       "id":1015,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Required information on Form U- 4 includes: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>5 year residency history </li><li>10 year residency history </li><li>5 year employment history </li><li>10 year employment history</li></ol>",
       "choice_a":"I and III",
       "choice_b":"I and IV",
       "choice_c":"II and III",
       "choice_d":"II and IV",
       "correct_answer":"B",
       "explanation":"Form U-4 requires an applicant to provide a five year residency history and a ten year employment history."
    },
    {
       "id":1016,
       "practice_test_id":"",
       "topic_id":2,
       "question":"The maximum contribution allowed to a traditional IRA is 100% of annual earnings",
       "choice_a":"Before taxes or $5,500, whichever is greater",
       "choice_b":"Before taxes or $5,500, whichever is less",
       "choice_c":"After taxes or $5,500, whichever is greater",
       "choice_d":"After taxes or $5,500, whichever is less",
       "correct_answer":"B",
       "explanation":"The maximum annual contribution to an IRA plan is 100% of earnings before taxes or $5,500, whichever is less."
    },
    {
       "id":1017,
       "practice_test_id":1,
       "topic_id":2,
       "question":"Which of the following individuals must observe position and exercise limits on trading in concert? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>An investment adviser placing exercise orders for his discretionary accounts </li><li>Two or more individuals who have an agreement to act together </li><li>A registered rep accepting unsolicited orders to exercise options </li><li>An individual with accounts at several brokerage firms</li></ol>",
       "choice_a":"I only",
       "choice_b":"I, II and IV only",
       "choice_c":"II and IV only",
       "choice_d":"I, II, III and IV",
       "correct_answer":"B",
       "explanation":"An individual investor, or a group of investors acting in concert, must observe position and exercise limits. These limits apply to an individual adviser acting for a group of discretionary accounts and to an individual who has accounts with several firms."
    },
    {
       "id":1018,
       "practice_test_id":2,
       "topic_id":2,
       "question":"A member firm can be taken to arbitration if an investor purchases an open-end fund and: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Receives no prospectus </li><li>Is told an untrue statement by the member or by a person associated with the member </li><li>Is given a prospectus that omits a material fact </li><li>Loses 20% or more in the investment within the first 30 days after the initial purchase</li></ol>",
       "choice_a":"I",
       "choice_b":"I, II and III",
       "choice_c":"II and III",
       "choice_d":"II, III and IV",
       "correct_answer":"B",
       "explanation":"Federal securities laws require that purchasers of newly issued securities be given full disclosure of material information concerning the issuer and the security. Choice I states that the purchaser received no disclosures. Choices II and III imply a measure of fraud or improper disclosure, and in each of these cases the purchaser could seek arbitration to recover damages and costs. Changes in an investment\u0027s value (IV) are not grounds for suit (unless the loss was directly related to improper disclosure by the company)."
    },
    {
       "id":1019,
       "practice_test_id":3,
       "topic_id":2,
       "question":"State securities laws address which of the following? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Provisions set by the Securities Act of 1933 </li><li>Adherence to the laws of each state governing the sale of new issues </li><li>Revocation of the broker dealer\u0027s registration</li></ol>",
       "choice_a":"I",
       "choice_b":"I and III",
       "choice_c":"II",
       "choice_d":"II and III",
       "correct_answer":"D",
       "explanation":"State securities laws (blue sky laws) address registration of securities, broker dealers and registered representatives at the state level. The Securities Act of 1933 deals with federal registration."
    },
    {
       "id":1020,
       "practice_test_id":4,
       "topic_id":2,
       "question":"Under the Code of Arbitration, all monetary awards must be paid within:",
       "choice_a":"15 days of decision date",
       "choice_b":"30 days of decision date",
       "choice_c":"45 days of decision date",
       "choice_d":"60 days of decision date",
       "correct_answer":"B",
       "explanation":"All monetary awards in a Code of Arbitration decision must be paid within 30 days of decision date."
    },
    {
       "id":1021,
       "practice_test_id":5,
       "topic_id":2,
       "question":"The Securities Exchange Act of 1934 regulates or mandates which of the following? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Full and fair disclosure on new offerings </li><li>Creation of the SEC </li><li>Manipulation of the market </li><li>Margin requirements on securities</li></ol>",
       "choice_a":"I",
       "choice_b":"I, II and III",
       "choice_c":"II",
       "choice_d":"II, III and IV",
       "correct_answer":"D",
       "explanation":"The Securities Exchange Act of 1934 set up the SEC and regulates the secondary market. The Securities Act of 1933 requires full and fair dis­closure with regard to new issues. The Securities Exchange Act of 1934 does not address full and fair disclosure issues;  the Securities Act of 1933 addresses such issues. The Securities Exchange Act of 1934 does not address full and fair disclosure. The Securities Exchange Act of 1934 also addresses market manipulation and margin requirements."
    },
    {
       "id":1022,
       "practice_test_id":6,
       "topic_id":2,
       "question":"All of the following employees of a member firm must be fingerprinted except those involved in:",
       "choice_a":"Sales",
       "choice_b":"The transfer of securities",
       "choice_c":"Customer account processing",
       "choice_d":"Cashiering",
       "correct_answer":"C",
       "explanation":"Under SEC Rule 17f-2, all of the following persons must be fingerprinted: persons registered with the FINRA; persons involved in handling customer funds or securities (this includes employees of transfer agents); and persons involved in preparing the firm\u0027s original books and records."
    },
    {
       "id":1023,
       "practice_test_id":"",
       "topic_id":2,
       "question":"If an officer at SIA, Inc.(a listed security), wants to sell some of his stock, then all of the following are true statements except:",
       "choice_a":"The stock he wishes to sell may be considered control stock by the SEC",
       "choice_b":"He could be penalized for selling short any of his stock",
       "choice_c":"The amount of stock he can sell in any 90 day period is limited by Rule 144",
       "choice_d":"He must be an accredited investor in order to sell his stock",
       "correct_answer":"D",
       "explanation":"The term accredited investor applies to Regulation D private placements. The other statements regarding sales of stock by control persons are true."
    },
    {
       "id":1024,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Which of the following must conform to FINRA standards definingretail communication? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Research reports </li><li>Form letters </li><li>Reprints from published articles</li></ol>",
       "choice_a":"I only",
       "choice_b":"II and III only",
       "choice_c":"III only",
       "choice_d":"I, II and III",
       "correct_answer":"D",
       "explanation":"All of the material listed must conform to FINRA guidelines relating to retail communication."
    },
    {
       "id":1025,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Which of the following Acts requires corporations to issue annual reports?",
       "choice_a":"Securities Act of 1933",
       "choice_b":"Securities Exchange Act of 1934",
       "choice_c":"Trust Indenture Act of 1939",
       "choice_d":"Investment Company Act of 1940",
       "correct_answer":"B",
       "explanation":"The Securities Exchange Act of 1934 mandates that public issuers file annual (Form 10K) and quarterly (Form 10-Q) reports with the SEC."
    },
    {
       "id":1026,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Which of the following acts requires full disclosure of all material information about securities offered for the first time to the public?",
       "choice_a":"Securities Act of 1933",
       "choice_b":"Securities Exchange Act of 1934",
       "choice_c":"Trust Indenture Act of 1939",
       "choice_d":"Securities Investor Protection Act of 1970",
       "correct_answer":"A",
       "explanation":"The Securities Act of 1933 regulates new issues of corporate securities sold to the public."
    },
    {
       "id":1027,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Under FINRA rules, a registered representative must complete the Regulatory Element of continuing education within how many days of a registration anniversary date?",
       "choice_a":"30 days",
       "choice_b":"60 days",
       "choice_c":"90 days",
       "choice_d":"120 days",
       "correct_answer":"D",
       "explanation":"The Regulatory Element requires that all registered persons complete a computer-based training session within 120 days of their second registration anniversary and every three years thereafter."
    },
    {
       "id":1028,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Written recommendation prepared by a registered representative, to be sent to a broad audience, needs the prior approval of:",
       "choice_a":"The appropriate SRO",
       "choice_b":"A principal of the firm",
       "choice_c":"The SEC",
       "choice_d":"The FCC",
       "correct_answer":"B",
       "explanation":"Written communication to be sent to a broad audience would be classified as retail communication and would need the prior approval of a principal of the firm."
    },
    {
       "id":1029,
       "practice_test_id":"",
       "topic_id":2,
       "question":"The SEC regulates the trading of all of the following except:",
       "choice_a":"Commodity futures",
       "choice_b":"Options",
       "choice_c":"Preferred stock",
       "choice_d":"Corporate bonds",
       "correct_answer":"A",
       "explanation":"The SEC regulates the trading of all nonexempt securities. Commodity futures, which are not considered securities, are regulated by the CFTC, the Commodities Futures Trading Commission."
    },
    {
       "id":1030,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Under the Code of Procedure, the maximum fine for a minor rule violation is:",
       "choice_a":"$1,000",
       "choice_b":"$2,500",
       "choice_c":"$5,000",
       "choice_d":"$10,000",
       "correct_answer":"B",
       "explanation":"The maximum fine for a minor rule violation is $2,500, according to the FINRA Code of Procedure."
    },
    {
       "id":24712,
       "practice_test_id":"",
       "topic_id":2,
       "question":"A customer sells a stock he has owned at a loss and two weeks later purchases a security that is substantially the same. Which of the following is true?",
       "choice_a":"The customer may claim the loss if the stock was held for more than 1 year",
       "choice_b":"The customer may claim the loss if the stock was held for less than 1 year",
       "choice_c":"The original cost base passes to the new purchase",
       "choice_d":"The loss may only be used to offset a gain in the current year",
       "correct_answer":"C",
       "explanation":"Under the wash sale rule if a person sells a security at a loss and within 30 days purchases a security which is substantially the same, the loss will be disallowed and the investor\u0027s original cost base will be passed along to the new purchase."
    },
    {
       "id":24722,
       "practice_test_id":"",
       "topic_id":2,
       "question":"A city councilman meets a registered representative at a local charity event. During the conversation the registered representative tells the councilman how much he loves sports. A few days later the councilman sends the registered representative two tickets to a hockey game valued at $150 each. Which of the following is correct?",
       "choice_a":"The registered representative may accept the tickets with no obligation as the councilman is not a client",
       "choice_b":"The registered representative may accept the tickets with the approval of the firm",
       "choice_c":"The registered representative may accept the tickets if one of the tickets is intended for the councilman",
       "choice_d":"The registered representative and his wife may use the tickets without further restriction if the councilman is seated in the same box",
       "correct_answer":"C",
       "explanation":"The only way that the representative may accept the tickets is if the councilman is intending on going to the game with the RR. If the councilman attends with the RR it is considered to be entertainment and not a gift."
    },
    {
       "id":24750,
       "practice_test_id":"",
       "topic_id":2,
       "question":"A woman has been investing in a mutual fund by placing her extra savings in the account whenever she has money available. Over the last several years the woman\u0027s investments have been as follows:  <img src='/question_assets/series6/24750.png'></img>The investor now enters a sell order and liquidates $3,500 of the fund providing no further instructions other than to forward her a check. The money will be redeemed as follows:",
       "choice_a":"$3,500 versus her average cost",
       "choice_b":"$2,000 from year four, $1,400 from year three and $100 from year two",
       "choice_c":"$1,300 from Year three, $1,200 from year two and $1,000 from year one",
       "choice_d":"$3,500 versus her average price",
       "correct_answer":"C",
       "explanation":"When an investor liquidates shares of an open end mutual fund, the shares will be sold on a FIFO (first in first out) if the investor does not provide instructions on how to sell the shares."
    },
    {
       "id":24756,
       "practice_test_id":"",
       "topic_id":2,
       "question":"A registered representative who received notice to complete the regulatory continuing education requirement more than 120 days ago but who has not yet completed the required continuing education training may act in which of the following capacities?",
       "choice_a":"As a registered representative so long as the required training is completed within 15 days",
       "choice_b":"As a registered representative who will be subject to daily supervision by a principal until the required training is completed",
       "choice_c":"In administrative capacity posting trades to customer accounts",
       "choice_d":"As a speaker at a seminar for potential clients so long as there is a principal in attendance and all scripts have been approved in advance",
       "correct_answer":"C",
       "explanation":"A registered representative who fails to complete the regulator CE training within the 120 window must cease all activities of a registered representative. The rep may only act in an administrative capacity until the required CE courses have been completed. Of the choices listed only posting trades to accounts would be allowed as all others are activities of a registered representative."
    },
    {
       "id":20388,
       "practice_test_id":"",
       "topic_id":2,
       "question":"All of the following are prohibited practices except:",
       "choice_a":"Front running",
       "choice_b":"Hypothecating",
       "choice_c":"Commingling",
       "choice_d":"Unauthorized trading",
       "correct_answer":"B",
       "explanation":"Hypothecation occurs when a customer has agreed to allow the broker dealer to pledge his securities to the bank as collateral for a margin loan. In order for hypothecation to be permitted a customer must sign a hypothecation agreement. Front running, commingling, and unauthorized trading are all examples of prohibited practices."
    },
    {
       "id":20389,
       "practice_test_id":2,
       "topic_id":2,
       "question":"According to regulation S-P which of the following are true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Customers must receive an initial privacy notice from the broker dealer no later than at account opening </li><li>Customers must receive annual privacy notices from the broker dealer </li><li>Customers may elect to receive the annual privacy notice electronically </li><li>Regulation S-P was designed to safeguard the financial information of the customers</li></ol>",
       "choice_a":"IV only",
       "choice_b":"I, II",
       "choice_c":"I, II, III",
       "choice_d":"I, II, III, IV",
       "correct_answer":"D",
       "explanation":"Regulation S-P was derived from the Gramm-Leach-Bliley Act to ensure that broker dealers had procedures in place to protect customer\u2019s sensitive financial information."
    },
    {
       "id":20390,
       "practice_test_id":3,
       "topic_id":2,
       "question":"The rules governing the issuing of corporate securities to the public are covered under which act?",
       "choice_a":"Act of 1929",
       "choice_b":"Act of 1933",
       "choice_c":"Act of 1934",
       "choice_d":"Act of 1935",
       "correct_answer":"B",
       "explanation":"The Act of 1933 was the first legislation Congress passed to address the regulation of the securities markets; and it dealt with the primary, or new issue, market. The Act of 1934 dealt with the secondary market places and the Act of 1935 regulated public utility holding companies."
    },
    {
       "id":20391,
       "practice_test_id":4,
       "topic_id":2,
       "question":"Which of the following statements are true regarding the Act of 1933? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>It regulates the new issues] </li><li>It regulates the primary market </li><li>It regulates trades between issuers and the public </li><li> It regulates investor to investor trades</li></ol>",
       "choice_a":"I, II",
       "choice_b":"III, IV",
       "choice_c":"I, II, III",
       "choice_d":"I, II, III, IV",
       "correct_answer":"C",
       "explanation":"The Act of 1933 regulates the primary market, also known as the new issue market, where issuers sell securities to the public for the first time. Once the securities are in the public hands, they are traded between investors, and those trades are regulated by the Act of 1934."
    },
    {
       "id":20392,
       "practice_test_id":5,
       "topic_id":2,
       "question":"Which of the following is a non-exempt issuer according to the Act of 1933?",
       "choice_a":"ABC, Inc",
       "choice_b":"The State of NY",
       "choice_c":"The City of Miami",
       "choice_d":"The US government",
       "correct_answer":"A",
       "explanation":"In order to become a publicly traded entity a non-exempt security must file a registration statement with the SEC. Most corporate entities are non-exempt. Exempt securities do not need to file with the SEC. Examples of exempt issuers are municipalities and national governments."
    },
    {
       "id":20393,
       "practice_test_id":6,
       "topic_id":2,
       "question":"Which of the following activities may an underwriter engage in during the cooling off period? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Blue Sky the issue  </li><li>Obtain indications of interest </li><li>Send out red herrings</li></ol>",
       "choice_a":"II only",
       "choice_b":"I, II",
       "choice_c":"II, III",
       "choice_d":"I, II, III",
       "correct_answer":"D",
       "explanation":"During the cooling off period an underwriter cannot solicit sales, but they can obtain indications of interest from investors, which will help them gauge the demand for the new issue. Any customer who gives an indication of interest is given a preliminary prospectus, or red herring. The underwriter will also use the time during the cooling off period to register the securities in the states in which they will be sold, otherwise known as Blue Skying the issue."
    },
    {
       "id":20394,
       "practice_test_id":"",
       "topic_id":2,
       "question":"All of the following are true when a customer gives an indication of interest for a new issue of corporate securities except:",
       "choice_a":"The indication is not binding on the customer",
       "choice_b":"The indication is binding on the broker dealer",
       "choice_c":"The customer will receive a preliminary prospectus",
       "choice_d":"The red herring will not contain the price of the securities",
       "correct_answer":"B",
       "explanation":"Indications of interest are not binding on the part of the customer or the broker dealer. They are used solely to help the underwriter determine demand. When a customer gives an indication of interest he will receive a preliminary prospectus (red herring) which will not contain the final offering price. The final price will be stated in the final prospectus."
    },
    {
       "id":20395,
       "practice_test_id":"",
       "topic_id":2,
       "question":"ECS, Inc., a non-exempt issuer, wishes to issue securities to the public for the first time. All of the following statements are true except:",
       "choice_a":"ECS, Inc. must file a registration statement with the SEC",
       "choice_b":"The cooling off period for ECS, Inc. will last a maximum of 20 days",
       "choice_c":"ECS, Inc. securities will have to be registered in the states in which they will be offered",
       "choice_d":"The preliminary prospectus for ECS, Inc. will be given to prospective buyers",
       "correct_answer":"B",
       "explanation":"The cooling off period for a non-exempt security begins when the issuer\u0027s registration statement is filed with the SEC. It is a minimum of 20 days, and could be longer as the SEC deems necessary. During the cooling off period the issuer\u0027s securities are registered in the states they will be offered in (Blue Sky the issue) and the underwriter will garner indications of interest from prospective investors, who will then receive a preliminary prospectus (red herring)."
    },
    {
       "id":20396,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Which of the following are true regarding a final prospectus for a new issue of corporate securities? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> The final prospectus must be delivered to all purchasers  </li><li>If the prospectus is posted on the SEC website it is considered to have been delivered to the purchasers  </li><li>The prospectus will contain the date and price of the offering  </li><li>The prospectus will contain the underwriter\u0027s discount</li></ol>",
       "choice_a":"I, III",
       "choice_b":"III, IV",
       "choice_c":"I, II, III",
       "choice_d":"I, II, III, IV",
       "correct_answer":"D",
       "explanation":"A final prospectus contains the date and price of the offering, as well as information regarding how the underwriters are compensated for their services, and must be delivered to all purchasers of a new issue. As per the \u0022access equals delivery\u0022 rule, if the prospectus is posted on the SEC website for inspection it is considered delivered to the customer."
    },
    {
       "id":20397,
       "practice_test_id":"",
       "topic_id":2,
       "question":"When a corporate issuer is granted an effective date by the SEC it means that:",
       "choice_a":"The SEC has approved the securities for sale to the public",
       "choice_b":"The SEC has reviewed the documents and checked for accuracy",
       "choice_c":"The SEC has received the required documentation",
       "choice_d":"The SEC guarantees the integrity of the new issue",
       "correct_answer":"C",
       "explanation":"The SEC disclaimer specifically states that they do not endorse or guarantee anything that relates to the issuer or its securities. When the SEC ends the cooling off period by granting the issuer an effective date it is because they have received all the necessary documentation from the issuer."
    },
    {
       "id":20398,
       "practice_test_id":"",
       "topic_id":2,
       "question":"All of the following statements are true when an issuer runs a tombstone ad except:",
       "choice_a":"The tombstone must be filed with the SEC",
       "choice_b":"The tombstone may run in a National newspaper during the cooling off period",
       "choice_c":"The tombstone will list the names of the underwriters and where to obtain a prospectus",
       "choice_d":"A tombstone is not considered an offer to sell securities",
       "correct_answer":"A",
       "explanation":"Tombstone ads are announcements only and may be run during the cooling off period. The ad contains the names of the underwriters, where to obtain a prospectus and a disclaimer that this is not a solicitation to buy. It does not need to be filed with the SEC."
    },
    {
       "id":20399,
       "practice_test_id":"",
       "topic_id":2,
       "question":"According to FINRA Rule 5130, when a broker dealer is acting as an underwriter for an issuer of securities they must make a bonafide distribution of the securities being offered, and are therefore prohibited from which of the following?",
       "choice_a":"Withholding securities for their own account",
       "choice_b":"Withholding securities for another broker dealer",
       "choice_c":"Withholding securities for the account of a registered representative",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"In making a bonafide distribution of a new issue the underwriter is prohibited from withholding securities for their own account, accounts of other broker dealers or FINRA members, and employees or financially dependent family members of the broker dealer."
    },
    {
       "id":20400,
       "practice_test_id":"",
       "topic_id":2,
       "question":"In an IPO of corporate securities the investment banker is responsible for all of the following except:",
       "choice_a":"Marketing the issuers securities to the public",
       "choice_b":"Establishing the terms of the offering",
       "choice_c":"Buying the securities from the issuer and reselling them to the public",
       "choice_d":"Determining the underwriter\u0027s compensation",
       "correct_answer":"D",
       "explanation":"In an IPO of non-exempt securities the investment banker, or underwriter, is responsible for establishing the terms of the offering and the marketing and selling of the issuer\u2019s securities. The issuer is responsible for determining the duties of the underwriter and how they will be compensated."
    },
    {
       "id":20401,
       "practice_test_id":"",
       "topic_id":2,
       "question":"In an initial offering of non-exempt securities which of the following is the responsibility of the issuer?",
       "choice_a":"Filing a registration statement with the SEC",
       "choice_b":"Marketing the securities to the public",
       "choice_c":"Setting the terms of the offering",
       "choice_d":"Creating and distributing a red herring",
       "correct_answer":"A",
       "explanation":"The issuer is responsible for filing the registration statement with the SEC, registering the securities in the states in which the securities will be offered and determining the underwriters responsibilities and compensation. The underwriter\u2019s duties include setting the terms of the offering, marketing the securities and delivering the red herring."
    },
    {
       "id":20402,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Which of the following is/are true with regard to a hot issue of securities? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>A hot issue trades at an immediate premium to its offering price the first day of trading </li><li>Financially dependent family members of the broker dealer\u0027s employees are prohibited from buying hot issues </li><li>Broker dealers are prohibited from withholding hot issues for their own accounts </li><li>Conditional persons who have never purchased a new issue may buy as long as the amount is insubstantial</li></ol>",
       "choice_a":"I, II",
       "choice_b":"I, III",
       "choice_c":"I, II, III",
       "choice_d":"I, II, III, IV",
       "correct_answer":"C",
       "explanation":"A hot issue is a new issue that trades at an immediate premium to its public offering price the first day of trading. Broker dealers, their employees and their financially dependent family members are all prohibited from purchasing hot issues. Conditional persons may be able to purchase a hot issue if they have a history of buying new issues and the amount is not substantial."
    },
    {
       "id":20403,
       "practice_test_id":"",
       "topic_id":2,
       "question":"All of the following are types of underwriting commitments except:",
       "choice_a":"Firm Commitment",
       "choice_b":"Not held Commitment",
       "choice_c":"Mini max commitment",
       "choice_d":"All or none commitment",
       "correct_answer":"B",
       "explanation":"When acting as an underwriter for an issuer the underwriter can give a firm commitment or a best efforts commitment. Both mini max and all or none are types of best efforts commitments. Not held refers to a type of order, not a type of underwriting commitment."
    },
    {
       "id":20404,
       "practice_test_id":"",
       "topic_id":2,
       "question":"All of the following a regulated under the Act of 1933 except:",
       "choice_a":"An initial public offering",
       "choice_b":"A registered secondary offering",
       "choice_c":"An arbitrated offering",
       "choice_d":"A subsequent primary offering",
       "correct_answer":"C",
       "explanation":"The Act of 1933 regulates the primary market. IPOs, registered secondary offerings and subsequent primary offerings are all primary market transactions. There is no arbitrated offering."
    },
    {
       "id":20405,
       "practice_test_id":"",
       "topic_id":2,
       "question":"A broker dealer that is acting as a selling group member in an initial public offering of corporate securities is paid:",
       "choice_a":"The spread",
       "choice_b":"The total takedown",
       "choice_c":"The underwriting fee",
       "choice_d":"The selling concession",
       "correct_answer":"D",
       "explanation":"When acting as a selling group member the broker dealer assumes no management responsibilities and no risk for the unsold securities and therefore is not entitled to the management fee or the underwriting fee."
    },
    {
       "id":20406,
       "practice_test_id":"",
       "topic_id":2,
       "question":"When acting as a syndicate manager in selling a new issue of corporate securities, how will a broker dealer be compensated if it sells shares?",
       "choice_a":"It will be paid a manager\u0027s fee",
       "choice_b":"It will be paid the underwriting fee",
       "choice_c":"It will be paid the selling concession",
       "choice_d":"It will be paid the underwriting spread",
       "correct_answer":"D",
       "explanation":"When a syndicate manager in an offering of corporate securities sells the securities, the broker dealer will be paid the underwriting spread; which includes the manager\u0027s fee, the underwriting fee and the selling concession."
    },
    {
       "id":20407,
       "practice_test_id":"",
       "topic_id":2,
       "question":"In an offering of corporate securities, which of the following factors determine the size of the underwriting spread? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The number of registered reps the syndicate manager employs </li><li>The type of securities being offered to the public </li><li>The demand for the new issue </li><li>The overall size of the offering</li></ol>",
       "choice_a":"I, III",
       "choice_b":"II, IV",
       "choice_c":"II, III, IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"C",
       "explanation":"The size of the underwriting spread is based on several factors including: the type of securities; the demand for the securities; the size of the offering; the quality of the securities; the quality of the issuer and the type of underwriting agreement the issuer and broker dealer entered into. The number of registered reps employed by the underwriter is not a factor."
    },
    {
       "id":20408,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Which of the following is true with regards to Rule 144?",
       "choice_a":"It allows small businesses to file an abbreviated registration statement with the SEC when issuing securities",
       "choice_b":"It sets limitations on how many shares of control stock can be sold by control persons",
       "choice_c":"It only allows for the sale of private placement shares by accredited investors",
       "choice_d":"It eliminates the need for a cooling off period with SEC",
       "correct_answer":"B",
       "explanation":"Rule 144 determines the procedures and limits for the sale of restricted securities (Reg D securities) and the sale of control stock by control persons. It allows the seller to liquidate either 1% of the outstanding shares or the average of the prior 4 weeks trading volume, whichever is greater, every 90 days."
    },
    {
       "id":20453,
       "practice_test_id":"",
       "topic_id":2,
       "question":"A well established agent who lives in New Jersey and commutes to his office in New York City is working out of his vacation home in Florida during the winter. How long can the agent work out of his vacation home without working in a branch office?",
       "choice_a":"30 days",
       "choice_b":"45 days",
       "choice_c":"60 days",
       "choice_d":"90 days",
       "correct_answer":"A",
       "explanation":"The agent may work out of his vacation home for 30 days without being required to report to a branch office."
    },
    {
       "id":20457,
       "practice_test_id":"",
       "topic_id":2,
       "question":"An uncle had established and contributed to a Coverdell ESA for his nephew\u0027s college education for the last 10 years. The nephew withdraws $7,000 from the growth of the accountto meet $5,000 worth of educational expenses. The remaining $2,000 is:",
       "choice_a":"Taxable to the parents",
       "choice_b":"Taxable to the nephew",
       "choice_c":"Taxable to the uncle",
       "choice_d":"Non taxable to the nephew",
       "correct_answer":"B",
       "explanation":"The excess distribution from the account and is taxable to the beneficiary as it was not used to pay for educational expenses."
    },
    {
       "id":20463,
       "practice_test_id":"",
       "topic_id":2,
       "question":"When evaluating pension plans ERISA would regulate all but which of the following plans?",
       "choice_a":"401K",
       "choice_b":"Public sector plan",
       "choice_c":"Private sector plan",
       "choice_d":"A small business plan administered by a qualified third party",
       "correct_answer":"B",
       "explanation":"ERISA regulates private sector pension plans. ERISA does not regulate plans administered for employees of the public sector."
    },
    {
       "id":20470,
       "practice_test_id":"",
       "topic_id":2,
       "question":"A registered representative invites current and prospective clients to a seminar at an exclusive restaurant in the area. The RR plans to discuss his background, the history of his employing member firm and a mutual fund he is recommending to clients . Which of the following is / are true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>If the cost of each individual attendee exceeds $100 attending would violate FINRA standards and could be seen as a rebate to current customers </li><li>If the RR mentions the fund\u0027s performance he must state the time frame for which the performance information is quoted </li><li>The RR\u0027s attendance at the restaurant is considered retail communication </li><li>If more than 25 people attend a principal of the firm must be there to supervise</li></ol>",
       "choice_a":"I and IV",
       "choice_b":"II and III",
       "choice_c":"I, II and IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"B",
       "explanation":"When a registered rep holds a seminar the seminar is considered to be retail communication. If the RR mentions a fund\u0027s performance the RR must state the time frame during which the performance occurred. There is no requirement that a principal attend the event and a seminar at a nice restaurant would not be considered a rebate."
    },
    {
       "id":20476,
       "practice_test_id":"",
       "topic_id":2,
       "question":"An investment executive decides it is time for a career change after 12 years with his firm and opens up a restaurant. After five years he sells his restaurant and returns to his old firm. He will receive notice of his regulatory CE requirement based on:",
       "choice_a":"His initial date of registration",
       "choice_b":"His date of reassociation",
       "choice_c":"His date of resignation",
       "choice_d":"The date he signs his new U 4",
       "correct_answer":"B",
       "explanation":"The agent left the business for more than 24 months and will therefore have his regulatory continuing education requirement based on his date of re association with the new firm."
    },
    {
       "id":20477,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Congress passed the Sarbanes -- Oxley legislation to place further requirements on:",
       "choice_a":"The board of directors of public companies",
       "choice_b":"High frequency traders",
       "choice_c":"ECN operators",
       "choice_d":"ETFs",
       "correct_answer":"A",
       "explanation":"Congress passes the Sarbanes -- Oxley legislation to place further requirements on the board of public companies to help ensure that the financial statements released by the company meet higher standards of disclosure and are certified."
    },
    {
       "id":20480,
       "practice_test_id":2,
       "topic_id":2,
       "question":"A college graduate joins a FINRA member firm and completes his licensing exam. Shortly thereafter he is called home to deal with family issues and is forced to leave the firm. 15 months later he joins a new firm. He will receive notice of his regulatory CE requirement based on:",
       "choice_a":"His initial date of registration",
       "choice_b":"His date of reassociation",
       "choice_c":"His date of resignation",
       "choice_d":"The date he signs his new U 4",
       "correct_answer":"A",
       "explanation":"The agent left the business for less than 24 months and will therefore have his regulatory continuing education requirement based on his initial date of registration with the original firm."
    },
    {
       "id":20490,
       "practice_test_id":3,
       "topic_id":2,
       "question":"When a registered representative terminates his employment with a broker dealer, the broker dealer files what form with FINRA?",
       "choice_a":"U4",
       "choice_b":"U5",
       "choice_c":"Termination notice form",
       "choice_d":"Registration removal form",
       "correct_answer":"B",
       "explanation":"When an agent joins a firm the agent fills out and the firm files form U4. When an agent is terminated or leaves the firm the firm must submit form U5 within 30 days of the agent leaving or being terminated."
    },
    {
       "id":20500,
       "practice_test_id":4,
       "topic_id":2,
       "question":"Income from which of the following is most likely to subject a high income investor to the AMT (alternative minimum tax)?",
       "choice_a":"General Obligation (GO) bond",
       "choice_b":"Industrial revenue bond",
       "choice_c":"T Bill",
       "choice_d":"T Bond",
       "correct_answer":"B",
       "explanation":"Income from a private purpose municipal bond also known as an industrial revenue development bond is most likely to subject a high income investor to the AMT (alternative minimum tax)."
    },
    {
       "id":20503,
       "practice_test_id":5,
       "topic_id":2,
       "question":"An investor who is in their early 70s account has lost a significant amount of value as the securities his agent recommended have fallen in value. The customer has filed an arbitration claim against the agent after mediation had failed to reach an agreement. After the arbitration hearing the panel rules that the client is entitled to less than what the client claimed were the actual losses due to unsuitable investments. Which of the following is true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The first appeal will go to the National Adjudicatory Council </li><li>The decision is binding on FINRA registered agents but not on members of the public </li><li>The decision is final and may not be appealed </li><li>The award must be paid in 30 days</li></ol>",
       "choice_a":"I only",
       "choice_b":"I and II",
       "choice_c":"II only",
       "choice_d":"III and IV",
       "correct_answer":"D",
       "explanation":"All awards under arbitration are final, binding and there is no appeal . The decision is binding on all parties and all awards must be paid in 30 days."
    },
    {
       "id":20507,
       "practice_test_id":6,
       "topic_id":2,
       "question":"An investor purchased a non qualified annuity by depositing a lump sum when he was 45 years old. He has enjoyed a high paying job for the last 15 years and has not annuitized the contract. At 60 years old he wants to buy a second home and withdraws $20,000 from the account to help with the down payment. What are the tax consequences of the withdrawal?",
       "choice_a":"Ordinary income taxes plus 10% penalty tax on the total amount",
       "choice_b":"Ordinary income taxes plus 10% penalty tax up to the cost base",
       "choice_c":"Ordinary income tax up to the cost base",
       "choice_d":"No tax if the withdrawal is done on a FIFO basis",
       "correct_answer":"C",
       "explanation":"The investor is over 59\u00BD so there is no penalty tax. All random withdrawals from an annuity are done on a LIFO basis. The IRS considers all random withdrawals to come from the growth in the account and it is taxed as ordinary income. In this case if the $20,000 exceeded the growth in the account the portion that was the return of the cost base (deposit) would be returned tax free."
    },
    {
       "id":21065,
       "practice_test_id":"",
       "topic_id":2,
       "question":"A FINRA member firm is seeking to expand its sales force and hire new representatives for a new branch office. Which of the following is true?  <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The advertisement is considered to be retail communication  </li><li>The advertisement must be approved by a principal prior to use </li><li>The advertisement is considered to be institutional communication  </li><li>The advertisement must be filed with FINRA</li></ol>",
       "choice_a":"III only",
       "choice_b":"II and III",
       "choice_c":"I, II and IV",
       "choice_d":"II, III and IV",
       "correct_answer":"C",
       "explanation":"Even though the ad is directed at registered representatives the ad is considered to be part of retail communication. As part of retail communication it must be approved by a principal prior to first use and must be filed with FINRA."
    },
    {
       "id":21067,
       "practice_test_id":"",
       "topic_id":2,
       "question":"XYZ manufacturing has mailed out proxies for its upcoming annual shareholders meeting. A customer of Rock Solid Brokerage has 1,000 shares held in street name. Rock Solid has forwarded the proxy to the customer in line with regulations. The customer signs and returns the proxy to Rock Solid without casting his vote. Under the rules Rock Sold:",
       "choice_a":"Must contact the customer and ask how he wants to vote",
       "choice_b":"Must void the proxy",
       "choice_c":"Must vote the shares anyway it sees fit as the shares are held in street name",
       "choice_d":"Must vote the shares in line with the recommendation of XYZ\u0027s management",
       "correct_answer":"D",
       "explanation":"If a customer signs and returns a blank proxy to a brokerage firm for shares held in street name, the brokerage firm is required to vote those shares in line with the recommendation of the company\u0027s management, in this case as XYZ recommends."
    },
    {
       "id":21071,
       "practice_test_id":"",
       "topic_id":2,
       "question":"An agent at XYZ Broker Dealers, receives a call from and investment advisory client inquiring about Super Chips Inc. a computer chip company that XYZ in taking public next week. The advisor wished to purchase 500 shares of the offering for one of his clients. The interest in Super Chips is strong and the common stock is expected to open at a premium when trading begins. Which of the following is true?",
       "choice_a":"The advisor may not purchase the shares Super Chips for the client",
       "choice_b":"The agent must speak to the client and get the clients authorization to purchase Super Chips",
       "choice_c":"The agent must speak to the client to ensure that the client is not a restricted person",
       "choice_d":"The agent must obtain a representation by the advisor that the client is not a restricted person",
       "correct_answer":"D",
       "explanation":"When a third party with discretionary authority over a client\u0027s account wishes to purchase shares of a new issue on behalf of that client, the third party must provide a representation that the client is not a restricted person. In this case it is the responsibility of the advisor placing the order."
    },
    {
       "id":21074,
       "practice_test_id":"",
       "topic_id":2,
       "question":"As it relates to money laundering which of the following is the first step in the process?",
       "choice_a":"Execution",
       "choice_b":"Placement",
       "choice_c":"Layering",
       "choice_d":"Integration",
       "correct_answer":"B",
       "explanation":"The first step in the money laundering process is the placement of the funds into an account. This is when the process begins. Once the funds are placed in the account Transactions will take place to try to hide the true origin of the funds. This is known as layering."
    },
    {
       "id":21077,
       "practice_test_id":"",
       "topic_id":2,
       "question":"An operations clerk working in the back office of a brokerage firm notices a partner of activity coming from within the firm that seems to violate industry regulations. The clerk has reported the matter to his supervisor several times and the activity still continues. The clerk should do which of the following?",
       "choice_a":"Report the matter to SIPC",
       "choice_b":"Report the matter to the SEC",
       "choice_c":"Report the matter to the FINRA tip line",
       "choice_d":"Report the matter to the NYSE",
       "correct_answer":"C",
       "explanation":"In this case the matter should be reported to FINRA\u0027s tip line in Washington DC. The tip line is operated to allow industry participants to report suspected violations."
    },
    {
       "id":21295,
       "practice_test_id":"",
       "topic_id":2,
       "question":"As it relates to the firm element continuing education plan requirement which of the following is correct?",
       "choice_a":"It is based on the agent\u0027s initial registration date",
       "choice_b":"It is based on the date the agent submitted the most recent U4",
       "choice_c":"It is based on a needs analysis",
       "choice_d":"It must be performed every 2 years",
       "correct_answer":"C",
       "explanation":"The firm element portion of the continuing education plan is based on a needs analysis conducted by the firm. The firm must conduct its firm element training every year."
    },
    {
       "id":21296,
       "practice_test_id":"",
       "topic_id":2,
       "question":"An agent who has been registered continuously for fifteen years leaves the industry for 18 months to pursue other interests. After 18 months the agent becomes re-associated with another member firm. Which of the following is true?",
       "choice_a":"The agent\u0027s regulatory continuing education requirement is based on the date of re-association",
       "choice_b":"The agent\u0027s regulatory continuing education requirement is based on the date on their last U5",
       "choice_c":"The agent\u0027s regulatory continuing education requirement is based on the date of initial association",
       "choice_d":"The agent\u0027s regulatory continuing education requirement is based on the date of original association less the time spent out of the industry",
       "correct_answer":"C",
       "explanation":"An agent who leaves the industry for less than 24 months will have their regulatory continuing education requirement based on the date of initial association."
    },
    {
       "id":21297,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Which of the following people would not be subject to heightened supervisory requirements?",
       "choice_a":"An agent who transacts business in complex structured products",
       "choice_b":"A producing manager whose production is greater than 10 percent of the locations production",
       "choice_c":"An agent who has been sanctioned",
       "choice_d":"A manager who has ignored red flags and violations",
       "correct_answer":"B",
       "explanation":"A producing manager whose production is greater than 20 percent of the location\u0027s production would be subject to heightened supervision by the member."
    },
    {
       "id":21298,
       "practice_test_id":"",
       "topic_id":2,
       "question":"A member has received a written notice from a representative of a customer claiming that the member firm has acted in bad faith by recommending investments that were too risky and which caused the customer to suffer large losses. Which of the following Actions is not required of the member who received the notice?",
       "choice_a":"The firm must electronically file the complaint within 15 calendar days of the end of the quarter",
       "choice_b":"The principal must review the complaint and respond within 10 days",
       "choice_c":"The complaint is subject to retention for 4 years",
       "choice_d":"The complaint must be maintained in a supervising OSJ",
       "correct_answer":"B",
       "explanation":"All of the choices listed are required of a member firm who receives a complaint except there is no time frame in which the firm must respond to the complaint. The principal must review all complaints"
    },
    {
       "id":21299,
       "practice_test_id":"",
       "topic_id":2,
       "question":"A member firm with multiple offices each differing in size, location and function must do which of the following?",
       "choice_a":"Designate an office with custody of customer assets as a corporate headquarters",
       "choice_b":"Designate in writing to FINRA which offices are OSJs",
       "choice_c":"Assign a duly qualified principal to oversee each branch",
       "choice_d":"Require satellite offices to use the address of the satellite and its OSJ on all communications",
       "correct_answer":"B",
       "explanation":"A member firm must designate in writing to FINRA which offices are OSJs. A satellite office may not use its address on communications. It may only use the address of its branch or OSJ. A branch office may be managed by a resident agent and an office with custody of customer assets must be designated as an OSJ."
    },
    {
       "id":21300,
       "practice_test_id":"",
       "topic_id":2,
       "question":"An agent who lives in Connecticut and works in New York maintains a vacation home in Florida. During the Winter the agent spends a considerable amount of time in the vacation home in Florida. The agent must be assigned to a branch if the agent works out of the vacation home:",
       "choice_a":"for more than 45 days",
       "choice_b":"for more than 30 days",
       "choice_c":"for more than 60 days",
       "choice_d":"for more than 90 days",
       "correct_answer":"B",
       "explanation":"The agent must be assigned to a branch if the agent works out of the vacation home for more than 30 days"
    },
    {
       "id":21301,
       "practice_test_id":"",
       "topic_id":2,
       "question":"As it relates to the member firm\u0027s annual compliance review, which of the following are true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The member must inspect each office directly  </li><li>The member must assign a principal to test the firm\u0027s supervisory controls  </li><li>Reports detailing the status of supervisory systems must be filed with senior management  </li><li>Supervisory controls must be in place to provide daily supervision of producing managers</li></ol>",
       "choice_a":"II and III",
       "choice_b":"I and IV",
       "choice_c":"II, III and IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"C",
       "explanation":"All of the choices listed are correct except members are not required to inspect every office. By inspecting the OSJs the member is inspecting all of the branch offices under the supervision of the branch."
    },
    {
       "id":21302,
       "practice_test_id":2,
       "topic_id":2,
       "question":"A firm that receives currency from a client in excess of $10,000 must fill out and submit a currency transaction report (CTR) form 4789:",
       "choice_a":"on the day the currency is received",
       "choice_b":"within 10 days of receipt",
       "choice_c":"within 15 days of receipt",
       "choice_d":"within 48 hours",
       "correct_answer":"C",
       "explanation":"A firm that receives currency from a client in excess of $10,000 must  fill out and submit a currency transaction report (CTR) form 4789 within 15 days of receipt."
    },
    {
       "id":21303,
       "practice_test_id":3,
       "topic_id":2,
       "question":"As it relates to a member\u0027s AML program which of the following are true?  <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>It must be approved by senior management </li><li>A SARs must be filed for any suspicious activity exceeding $10,000 </li><li>All SARs must be kept for 3 years, 2 years readily accessible  </li><li>AML programs must ensure customers do not appear on the OFAC list</li></ol>",
       "choice_a":"I and IV",
       "choice_b":"II and III",
       "choice_c":"II and IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"A",
       "explanation":"All AML programs must be approved by members of senior management. AML programs must ensure that customers do not appear on the OFAC list of known or suspected terrorists. SARs must be filed for suspicious activity involving amounts of $5,000 or more and all SARs must be kept for 5 years."
    },
    {
       "id":21304,
       "practice_test_id":4,
       "topic_id":2,
       "question":"A designated principal at a member firm has just received a new email list of known and suspected persons and entities from FinCen. Upon review of the list the principal notices that one of the businesses on the list has an account with his firm. Which of the following is true?",
       "choice_a":"The principal must take steps to freeze the account",
       "choice_b":"The principal must notify FinCen within 14 days",
       "choice_c":"The principal must take steps to investigate the account and the agent who introduced the account to the firm",
       "choice_d":"The principal must notify senior management",
       "correct_answer":"B",
       "explanation":"If the designated principal finds a match on the FinCen list, the principal must notify FinCen within 14 calendar days."
    },
    {
       "id":21305,
       "practice_test_id":5,
       "topic_id":2,
       "question":"As it relates to the firm element continuing education plan requirement which of the following is correct?",
       "choice_a":"It is based on the agent\u0027s initial registration date",
       "choice_b":"It is based on the date the agent submitted the most recent U4",
       "choice_c":"It is based on a needs analysis",
       "choice_d":"It must be performed every 2 years",
       "correct_answer":"C",
       "explanation":"The firm element portion of the continuing education plan is based on a needs analysis conducted by the firm. The firm must conduct its firm element training every year."
    },
    {
       "id":21306,
       "practice_test_id":6,
       "topic_id":2,
       "question":"An agent who has been registered continuously for fifteen years leaves the industry for 18 months to pursue other interests. After 18 months the agent becomes re-associated with another member firm. Which of the following is true?",
       "choice_a":"The agent\u0027s regulatory continuing education requirement is based on the date of re-association",
       "choice_b":"The agent\u0027s regulatory continuing education requirement is based on the date on their last U5",
       "choice_c":"The agent\u0027s regulatory continuing education requirement is based on the date of initial association",
       "choice_d":"The agent\u0027s regulatory continuing education requirement is based on the date of original association less the time spent out of the industry",
       "correct_answer":"C",
       "explanation":"An agent who leaves the industry for less than 24 months will have their regulatory continuing education requirement based on the date of initial association."
    },
    {
       "id":21307,
       "practice_test_id":"",
       "topic_id":2,
       "question":"Which of the following people would not be subject to heightened supervisory requirements?",
       "choice_a":"An agent who transacts business in complex structured products",
       "choice_b":"A producing manager whose production is greater than 10 percent of the locations production",
       "choice_c":"An agent who has been sanctioned",
       "choice_d":"A manager who has ignored red flags and violations",
       "correct_answer":"B",
       "explanation":"A producing manager whose production is greater than 20 percent of the location\u0027s production would be subject to heightened supervision by the member."
    },
    {
       "id":21308,
       "practice_test_id":"",
       "topic_id":2,
       "question":"A member has received a written notice from a representative of a customer claiming that the member firm has acted in bad faith by recommending investments that were too risky and which caused the customer to suffer large losses. Which of the following Actions is not required of the member who received the notice?",
       "choice_a":"The firm must electronically file the complaint within 15 calendar days of the end of the quarter",
       "choice_b":"The principal must review the complaint and respond within 10 days",
       "choice_c":"The complaint is subject to retention for 4 years",
       "choice_d":"The complaint must be maintained in a supervising OSJ",
       "correct_answer":"B",
       "explanation":"All of the choices listed are required of a member firm who receives a complaint except there is no time frame in which the firm must respond to the complaint. The principal must review all complaints"
    },
    {
       "id":21309,
       "practice_test_id":"",
       "topic_id":2,
       "question":"A member firm with multiple offices each differing in size, location and function must do which of the following?",
       "choice_a":"Designate an office with custody of customer assets as a corporate headquarters",
       "choice_b":"Designate in writing to FINRA which offices are OSJs",
       "choice_c":"Assign a duly qualified principal to oversee each branch",
       "choice_d":"Require satellite offices to use the address of the satellite and its OSJ on all communications",
       "correct_answer":"B",
       "explanation":"A member firm must designate in writing to FINRA which offices are OSJs. A satellite office may not use its address on communications. It may only use the address of its branch or OSJ. A branch office may be managed by a resident agent and an office with custody of customer assets must be designated as an OSJ."
    },
    {
       "id":21310,
       "practice_test_id":"",
       "topic_id":2,
       "question":"An agent who lives in Connecticut and works in New York maintains a vacation home in Florida. During the Winter the agent spends a considerable amount of time in the vacation home in Florida. The agent must be assigned to a branch if the agent works out of the vacation home:",
       "choice_a":"for more than 45 days",
       "choice_b":"for more than 30 days",
       "choice_c":"for more than 60 days",
       "choice_d":"for more than 90 days",
       "correct_answer":"B",
       "explanation":"The agent must be assigned to a branch if the agent works out of the vacation home for more than 30 days"
    },
    {
       "id":21311,
       "practice_test_id":"",
       "topic_id":2,
       "question":"As it relates to the member firm\u0027s annual compliance review, which of the following are true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The member must inspect each office directly  </li><li>The member must assign a principal to test the firm\u0027s supervisory controls  </li><li>Reports detailing the status of supervisory systems must be filed with senior management  </li><li>Supervisory controls must be in place to provide daily supervision of producing managers</li></ol>",
       "choice_a":"II and III",
       "choice_b":"I and IV",
       "choice_c":"II, III and IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"C",
       "explanation":"All of the choices listed are correct except members are not required to inspect every office. By inspecting the OSJs the member is inspecting all of the branch offices under the supervision of the branch."
    },
    {
       "id":21312,
       "practice_test_id":"",
       "topic_id":2,
       "question":"A firm that receives currency from a client in excess of $10,000 must fill out and submit a currency transaction report (CTR) form 4789:",
       "choice_a":"on the day the currency is received",
       "choice_b":"within 10 days of receipt",
       "choice_c":"within 15 days of receipt",
       "choice_d":"within 48 hours",
       "correct_answer":"C",
       "explanation":"A firm that receives currency from a client in excess of $10,000 must  fill out and submit a currency transaction report (CTR) form 4789 within 15 days of receipt."
    },
    {
       "id":21313,
       "practice_test_id":"",
       "topic_id":2,
       "question":"As it relates to a member\u0027s AML program which of the following are true?  <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>It must be approved by senior management </li><li>A SARs must be filed for any suspicious activity exceeding $10,000 </li><li>All SARs must be kept for 3 years, 2 years readily accessible  </li><li>AML programs must ensure customers do not appear on the OFAC list</li></ol>",
       "choice_a":"I and IV",
       "choice_b":"II and III",
       "choice_c":"II and IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"A",
       "explanation":"All AML programs must be approved by members of senior management. AML programs must ensure that customers do not appear on the OFAC list of known or suspected terrorists. SARs must be filed for suspicious activity involving amounts of $5,000 or more and all SARs must be kept for 5 years."
    },
    {
       "id":21314,
       "practice_test_id":"",
       "topic_id":2,
       "question":"A designated principal at a member firm has just received a new email list of known and suspected persons and entities from FinCen. Upon review of the list the principal notices that one of the businesses on the list has an account with his firm. Which of the following is true?",
       "choice_a":"The principal must take steps to freeze the account",
       "choice_b":"The principal must notify FinCen within 14 days",
       "choice_c":"The principal must take steps to investigate the account and the agent who introduced the account to the firm",
       "choice_d":"The principal must notify senior management",
       "correct_answer":"B",
       "explanation":"If the designated principal finds a match on the FinCen list, the principal must notify FinCen within 14 calendar days."
    },
    {
       "id":24757,
       "practice_test_id":"",
       "topic_id":2,
       "question":"A registered representative received notice to complete the regulatory continuing education requirement more than 120 days ago, but has not yet completed the required continuing education course. Which of the following is true?",
       "choice_a":"The representative must cease acting as an agent immediately",
       "choice_b":"The representative has 15 days to complete the required training",
       "choice_c":"The representative must file for a 30 day extension to continue acting as an agent and must complete the training the 30 day time frame",
       "choice_d":"The representative will have their registration terminated",
       "correct_answer":"A",
       "explanation":"A registered representative who fails to complete the regulatory CE training within the 120 day window must immediately cease all activities of a registered representative until the training is completed."
    },
    {
       "id":769,
       "practice_test_id":"",
       "topic_id":3,
       "question":"Which of the following is (are) a discretionary order(s)? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>A customer sends a check for $25,000 to a registered representative and instructs the representative to purchase bank and insurance company stocks when the price appears favorable. </li><li>A customer instructs a registered representative to buy 1,000 shares of ABC Corporation at a time and price determined by the representative. </li><li>A customer instructs a registered representative to purchase as many shares of XYZ as the representative deems appropriate. </li><li>A customer instructs a registered representative to sell 300 shares of LMN, Inc., when the representative thinks the time and price appropriate.</li></ol>",
       "choice_a":"I and III",
       "choice_b":"II and IV",
       "choice_c":"III only",
       "choice_d":"I, II, III and IV",
       "correct_answer":"A",
       "explanation":"Discretion authorizes a representative to choose any of the following: the security, the amount of shares, and whether to buy or sell. Time and price are not discretionary decisions."
    },
    {
       "id":770,
       "practice_test_id":"",
       "topic_id":3,
       "question":"If a registered rep wants to share in the profit or loss in a customer\u0027s account, which of the following statements is (are) true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The account must be approved by a principal. </li><li>FINRA must be notified in writing. </li><li>Sharing is permitted only in proportion to the capital contributed by each party. </li><li>Sharing is permitted without restriction if there is an immediate family relationship between the parties.</li></ol>",
       "choice_a":"I only",
       "choice_b":"I, III and IV",
       "choice_c":"II and III",
       "choice_d":"I, II, III and IV",
       "correct_answer":"B",
       "explanation":"All accounts must be approved by a principal and FINRA is never notified regarding the opening of accounts. In a joint account involving a customer and a registered representative, profit and loss must be shared proportionate to the capital contributed by each party. Further, the proportionate test does not apply if there is an immediate family relationship between the two."
    },
    {
       "id":771,
       "practice_test_id":"",
       "topic_id":3,
       "question":"How are earnings in a UGMA account exceeding the exclusion amount taxed? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>At the minor\u0027s rate until the minor reaches 14 years of age </li><li>At the minor\u0027s rate after the minor reaches 14 years of age </li><li>At the parent\u0027s rate until the minor reaches 14 years of age </li><li>At the parent\u0027s rate after the minor reaches 14 years of age</li></ol>",
       "choice_a":"I and II",
       "choice_b":"I and IV",
       "choice_c":"II and III",
       "choice_d":"III and I",
       "correct_answer":"C",
       "explanation":"Until the minor reaches age 14, income in the UGMA account is taxed at the parent\u0027s tax rate, after excluding the amount the IRS allows and amount taxed at the minor\u0027s tax rate. After the minor reaches age 14, income is taxed at the minor\u0027s own rate."
    },
    {
       "id":772,
       "practice_test_id":"",
       "topic_id":3,
       "question":"If a security is sold by the estate of a deceased person, it will be a good delivery if it is signed by a(n):",
       "choice_a":"Executor",
       "choice_b":"Beneficiary",
       "choice_c":"Spouse",
       "choice_d":"Branch manager",
       "correct_answer":"A",
       "explanation":"The only acceptable signature on a certificate in the name of a deceased person is that of the executor of the deceased\u0027s estate."
    },
    {
       "id":773,
       "practice_test_id":"",
       "topic_id":3,
       "question":"Under terms of the Telephone Consumer Privacy Act, which of the following statements are true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The firm must maintain a Do Not Call list </li><li>Cold calls can be made only between 8:00 a.m. and 9:00 p.m. </li><li>The time period of the call applies to the time zone of the rep making the call </li><li>The time period of the call applies to the time zone of where the phone call is received</li></ol>",
       "choice_a":"I, II and III",
       "choice_b":"I, II and IV",
       "choice_c":"I and III",
       "choice_d":"II and IV",
       "correct_answer":"B",
       "explanation":"This federal law allows a prospect to request that the firm make no further phone calls. Any solicitation made must occur between 8:00 a.m. and 9:00 p.m. in the recipient\u0027s time zone."
    },
    {
       "id":774,
       "practice_test_id":1,
       "topic_id":3,
       "question":"When an account is opened for an incompetent person, which of the following documents are necessary?",
       "choice_a":"Account agreement, customer loan agreement, and credit application",
       "choice_b":"Account agreement and credit application",
       "choice_c":"Customer loan and credit forms",
       "choice_d":"Court-appointed guardianship declaration form and account agreement",
       "correct_answer":"D",
       "explanation":"Guardian accounts require guardianship declaration papers. Trust accounts require trust agreements. Corporate or partnership accounts require the appropriate articles or charters on file."
    },
    {
       "id":775,
       "practice_test_id":2,
       "topic_id":3,
       "question":"When a person owns a convertible bond, he is:",
       "choice_a":"A creditor of the issuer",
       "choice_b":"An owner of the issuer",
       "choice_c":"Neither a creditor nor an owner of the issue",
       "choice_d":"Both a creditor and an owner of the issue",
       "correct_answer":"A",
       "explanation":"A bondholder is a creditor (whether or not the bond is convertible). Only after the bondholder converts is he considered an owner."
    },
    {
       "id":776,
       "practice_test_id":3,
       "topic_id":3,
       "question":"A corporate bond is quoted at 102 5/8. A customer buying 10 bonds would pay?",
       "choice_a":"$10,025.80",
       "choice_b":"$10,258.00",
       "choice_c":"$10,262.50",
       "choice_d":"$10,285.00",
       "correct_answer":"C",
       "explanation":"102 5/8% of par ($1000 for bonds) = $1026.25. 10 x $1026.25 = $10,262.50. 1/8 point equals $1.25 when quoting corporate bonds."
    },
    {
       "id":777,
       "practice_test_id":4,
       "topic_id":3,
       "question":"A client acquires a newly issued $1,000 par, 5% convertible corporate bond convertible into common at $40 per share. The common stock increases 20% from initial parity due to a hopeful earnings projection. What is the parity price of the bond after the rise in the common stock\u0027s price?",
       "choice_a":"$800",
       "choice_b":"$1,000",
       "choice_c":"$1,200",
       "choice_d":"$1,250",
       "correct_answer":"C",
       "explanation":"$1,000 x 120% = $1,200. At par, conversion price and parity price are the same. Therefore, in essence, the common stock is trading at parity, i.e. $40 per share. If the stock rises to $48 per share, and, on conversion, a holder receives 25 shares; 25 shares x $48 = $1,200."
    },
    {
       "id":778,
       "practice_test_id":5,
       "topic_id":3,
       "question":"An annual report sent to shareholders will include which of the following? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Balance sheet </li><li>Income statement </li><li>Statement of change in stockholders\u0027 equity </li><li>Cash flow statement</li></ol>",
       "choice_a":"I and II only",
       "choice_b":"I, II and III only",
       "choice_c":"I and III only",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"D",
       "explanation":"The annual report sent to shareholders is an audited statement including the balance sheet, income statement and shareholder\u0027s equity, or net worth. The inclusion of a cash flow statement is also required."
    },
    {
       "id":779,
       "practice_test_id":6,
       "topic_id":3,
       "question":"A corporation must have stockholder approval to:",
       "choice_a":"Issue convertible bonds",
       "choice_b":"Repurchase 100,000 shares of stock for its treasury",
       "choice_c":"Declare a 15 percent stock dividend",
       "choice_d":"Declare a cash dividend",
       "correct_answer":"A",
       "explanation":"Stockholders are entitled to vote on the issuance of additional securities that would dilute shareholder\u0027s equity (the shareholder\u0027s proportionate interest). If converted, convertible bonds would cause more shares to be outstanding, reducing the proportionate interest of current stockholders. The other choices represent decisions that are made by the board of directors and don\u0027t require a stockholder vote."
    },
    {
       "id":780,
       "practice_test_id":"",
       "topic_id":3,
       "question":"An investor owns 100 shares of MTN common stock. After MTN splits 2-for-l, the investor receives:",
       "choice_a":"Another certificate for 100 shares",
       "choice_b":"Another certificate for 200 shares",
       "choice_c":"Notice that the investor\u0027s 100-share certificate now represents 200 shares",
       "choice_d":"Notice to send in the current certificate to be replaced by a new certificate for 200 shares",
       "correct_answer":"A",
       "explanation":"The transfer agent will send the investor another certificate for 100 shares. The investor is not required to send back the existing stock certificate but receives a sticker to place on the certificate changing its par value."
    },
    {
       "id":781,
       "practice_test_id":"",
       "topic_id":3,
       "question":"Which of the following is the owner of an ADR likely to receive?",
       "choice_a":"Dividends",
       "choice_b":"Capital gains or losses",
       "choice_c":"Both dividends and capital gains or losses",
       "choice_d":"Neither dividends nor capital gains or losses",
       "correct_answer":"C",
       "explanation":"An ADR represents ownership of a foreign corporation. The ADR holder receives a proportionate share of the dividends, if any, paid by the foreign corporation. In addition, the sale of an ADR in the secondary market will likely result in a gain or a loss."
    },
    {
       "id":782,
       "practice_test_id":"",
       "topic_id":3,
       "question":"An investor\u0027s portfolio includes 10 bonds and 200 shares of common stock. If both positions increase by a half point, what is the appreciation?",
       "choice_a":"$50",
       "choice_b":"$105",
       "choice_c":"$110",
       "choice_d":"$150",
       "correct_answer":"D",
       "explanation":"The gain would be $50 for the bonds (1 /2 point for one bond is $5 x 10 bonds) and $100 for the common stock (1 /2 point is $.50 x 200 shares)."
    },
    {
       "id":783,
       "practice_test_id":"",
       "topic_id":3,
       "question":"Common stockholders would vote on all of the following except:",
       "choice_a":"A stock split",
       "choice_b":"A stock dividend",
       "choice_c":"The issuance of convertible securities",
       "choice_d":"A tender offer for the company\u0027s shares",
       "correct_answer":"B",
       "explanation":"Any matters concerning dividends are at the discretion of a company\u0027s board of directors, not the shareholders."
    },
    {
       "id":784,
       "practice_test_id":"",
       "topic_id":3,
       "question":"A customer owns 1,000 shares of SIA. Which of the following actions on the part of SIA Corp. would dilute his equity?",
       "choice_a":"Registered primary offering of shares",
       "choice_b":"Registered secondary offering of shares",
       "choice_c":"Payment of a 10% stock dividend",
       "choice_d":"2 for 1 stock split",
       "correct_answer":"A",
       "explanation":"An additional issue of shares would dilute a present shareholder\u0027s ownership, unless he personally purchases a portion of the new shares (as in a rights offering). B is incorrect because ownership of existing outstanding shares is simply changing hands. C is incorrect because each and every shareholder still owns the same percent of shares as before. D is incorrect because no dilution has occurred; each shareholder now has twice as many shares as before."
    },
    {
       "id":785,
       "practice_test_id":"",
       "topic_id":3,
       "question":"An investor may expect to receive dividends from which of the following securities?",
       "choice_a":"ADR",
       "choice_b":"Put option",
       "choice_c":"Call option",
       "choice_d":"Warrant",
       "correct_answer":"A",
       "explanation":"An American depositary receipt (ADR) represents ownership in a foreign corporation, and dividends declared by the corporation are paid to the ADR owner. The currency conversion is performed by the issuing bank. Options and warrants represent the right to buy or sell stock, but do not grant the holder the right to receive dividends on the underlying stock."
    },
    {
       "id":786,
       "practice_test_id":"",
       "topic_id":3,
       "question":"SIA declares a 3 for 2 stock split. How many additional shares are issued to an investor who owns 200 shares?",
       "choice_a":100,
       "choice_b":300,
       "choice_c":400,
       "choice_d":500,
       "correct_answer":"A",
       "explanation":"Multiplying 3/2 by 200 shares yields 300, the total number of shares the investor will have after the split."
    },
    {
       "id":787,
       "practice_test_id":"",
       "topic_id":3,
       "question":"In a portfolio containing common stock, preferred stock, convertible preferred stock and guaranteed stock, changes in interest rates would be most likely to affect the market price of the:",
       "choice_a":"Common",
       "choice_b":"Preferred",
       "choice_c":"Convertible preferred",
       "choice_d":"Guaranteed",
       "correct_answer":"B",
       "explanation":"Preferred stock most closely resembles bonds and therefore would be the most sensitive to interest rates among the alternatives listed. Choice A is incorrect because common stock is not sensitive to interest rates. Choice C is incorrect because a convertible preferred will be less sensitive to interest rates than a straight preferred because of the equity convertible feature. Choice D is incorrect because a \u0022guaranteed\u0022 bond or preferred simply means that a third party (like a parent company) will pay the interest or dividend if the issuer cannot."
    },
    {
       "id":788,
       "practice_test_id":"",
       "topic_id":3,
       "question":"A client has 100 shares of SIA when the stock undergoes a split. After the split, the client has which of the following?",
       "choice_a":"Proportionately decreased interest in the company",
       "choice_b":"Proportionately increased interest in the company",
       "choice_c":"No effective change in position",
       "choice_d":"Greater exposure",
       "correct_answer":"C",
       "explanation":"When a stock splits, the number of shares each stockholder has either increases or decreases. The customer experiences no effective change in position or proportionate interest."
    },
    {
       "id":789,
       "practice_test_id":"",
       "topic_id":3,
       "question":"Which of the following occurs when a company splits its stock 2 for 1? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The share price is reduced by one half </li><li>The total market value of the outstanding stock decreases </li><li>The stock price typically becomes less attractive to retail investors </li><li>The number of shares doubles</li></ol>",
       "choice_a":"I and IV only",
       "choice_b":"II, III and IV only",
       "choice_c":"IV only",
       "choice_d":"I, II, III and IV",
       "correct_answer":"A",
       "explanation":"A 2 for 1 stock split results in twice the original number of shares outstanding at half the price. The total market value of the stock remains the same. Because the stock price is reduced, the stock may become more attractive to investors as a result of the split."
    },
    {
       "id":790,
       "practice_test_id":"",
       "topic_id":3,
       "question":"A customer who owns 100 shares of SIA reads in the paper about a 2 for 1 stock split that has been declared and is payable next week. To receive the additional 100 shares, he must do which of the following?",
       "choice_a":"Endorse his certificate for 100 shares and send it to the transfer agent, and he will receive a new certificate for 200 shares",
       "choice_b":"Endorse his certificate for 100 shares and send it to the registrar, and he will receive a new certificate for 200 shares",
       "choice_c":"See his registered representative, sign a due bill for 100 shares and have his brokerage firm file a request for the additional 100 shares",
       "choice_d":"Nothing; he will receive a second certificate for 100 shares automatically",
       "correct_answer":"D",
       "explanation":"Existing stockholders need not do anything to receive their additional shares."
    },
    {
       "id":791,
       "practice_test_id":"",
       "topic_id":3,
       "question":"A customer owns 100 shares of stock in a company engaged in a rights offering. After the ex-date, the subscription price is $25 and the market price is $30. Four rights are required to subscribe to one new share. What is the value of a right using the ex-rights formula?",
       "choice_a":"$0.75",
       "choice_b":"$0.80",
       "choice_c":"$1.00",
       "choice_d":"$1.25",
       "correct_answer":"D",
       "explanation":"The ex-rights formula is: Market value Subscription price / Number of rights needed. $30 - $25 = $5. $5 / 4 = $1.25 value per right. Before the ex-date, the stock trades cum rights. On and after the ex-date, the stock trades ex-rights; i.e., purchasers of the stock will not receive the rights."
    },
    {
       "id":792,
       "practice_test_id":"",
       "topic_id":3,
       "question":"An investor owns 100 shares of SIA common stock. After SIA splits 2-for-l, the investor receives:",
       "choice_a":"Another certificate for 100 shares",
       "choice_b":"Another certificate for 200 shares",
       "choice_c":"Notice that the investor\u0027s 100-share certificate now represents 200 shares",
       "choice_d":"Notice to send in the current certificate to be replaced by a new certificate for 200 shares",
       "correct_answer":"A",
       "explanation":"The transfer agent will send the investor another certificate for 100 shares. The investor is not required to send back the existing stock certificate but receives a sticker to place on the certificate changing its par value."
    },
    {
       "id":793,
       "practice_test_id":"",
       "topic_id":3,
       "question":"529 plans may do all of the following except:",
       "choice_a":"As a prepaid tuition plan, a 529 locks in a current tuition rate at a specific school",
       "choice_b":"As a college savings plan, a 529 establishes a savings account to defray the college costs",
       "choice_c":"All contributions are made with after tax dollars and are allowed to grow tax deferred",
       "choice_d":"All assets withdrawn are taxed as normal income",
       "correct_answer":"D",
       "explanation":"Most states allow the assets to be withdrawn tax-free."
    },
    {
       "id":794,
       "practice_test_id":"",
       "topic_id":3,
       "question":"A 401K retirement plan is all of the following except:",
       "choice_a":"A defined contribution plan",
       "choice_b":"A plan that allows the employee to contribute a portion of her salary to it each month",
       "choice_c":"Based on the concept of profit sharing",
       "choice_d":"A plan that allows the employer to match some or all of the employee\u0027s contribution",
       "correct_answer":"C",
       "explanation":"A 401K retirement plan is not involved with profit sharing."
    },
    {
       "id":795,
       "practice_test_id":1,
       "topic_id":3,
       "question":"A 42 year old investor wants to put $20,000 into a plan to help meet the educational expenses of their 12-year-old son. They want to make a lump sum deposit. Which would you recommend?",
       "choice_a":"A 529 plan",
       "choice_b":"A Coverdell IRA",
       "choice_c":"A Roth IRA",
       "choice_d":"A Growth mutual fund",
       "correct_answer":"A",
       "explanation":"A 529 plan would allow the investor to make a lump sum deposit."
    },
    {
       "id":796,
       "practice_test_id":2,
       "topic_id":3,
       "question":"A 45-year-old investor has rolled over $10,000 from an IRA to buy a home. How long does he have to deposit the money in another qualified plan?",
       "choice_a":"45 days",
       "choice_b":"60 days",
       "choice_c":"30 days",
       "choice_d":"90 days",
       "correct_answer":"B",
       "explanation":"An investor may rollover their IRA once per year, and has 60 days to get the money into a qualified plan."
    },
    {
       "id":797,
       "practice_test_id":3,
       "topic_id":3,
       "question":"A client who is 65 years old has invested $10,000 in a Roth IRA. It has now grown to $14,000. He plans to retire and take a lump sum distribution. He will pay taxes on:",
       "choice_a":"$14,000",
       "choice_b":"$4,000",
       "choice_c":"$10,000",
       "choice_d":"$0",
       "correct_answer":"D",
       "explanation":"The money has been deposited in a Roth IRA after taxes. It is allowed to grow tax deferred. If you are over 59\u00BD and the money has been there for at least 5 years, then it may all be returned without paying taxes on the growth."
    },
    {
       "id":798,
       "practice_test_id":4,
       "topic_id":3,
       "question":"A client, who is a lawyer making $230,000 per year, makes the maximum contribution to his Keogh plan. He has a full time paralegal that earns $65,000 per year and wants to know what he must do for his employee\u0027s retirement. You should tell him:",
       "choice_a":"Since you are self employed, you can decide what to pay your own people",
       "choice_b":"You must contribute the same amount of money to the employee\u0027s Keogh as you did to yours",
       "choice_c":"You must make a contribution to the employee\u0027s Keogh at the same percentage rate as your own",
       "choice_d":"The employee is not self-employed and may not have a Keogh plan",
       "correct_answer":"C",
       "explanation":"A self-employed individual who has a full time employee must make a contribution for that employee at the same rate as his or her own contribution."
    },
    {
       "id":799,
       "practice_test_id":5,
       "topic_id":3,
       "question":"A corporation that invests in shares of another must pay taxes on what percentage of the dividends they receive?",
       "choice_a":"70%",
       "choice_b":"60%",
       "choice_c":"50%",
       "choice_d":"30%",
       "correct_answer":"D",
       "explanation":"Corporations must pay taxes only on 30% of the dividends they receive from shares of other companies."
    },
    {
       "id":800,
       "practice_test_id":6,
       "topic_id":3,
       "question":"A customer has been holding $50,000 worth of municipal bonds in her portfolio. The bonds pay interest at 5.5% per year. She is in the 30% bracket and wants to know what her federal tax liability will be. You should tell her:",
       "choice_a":"$725",
       "choice_b":"$2,750",
       "choice_c":"$2,025",
       "choice_d":"$0",
       "correct_answer":"D",
       "explanation":"A municipal bond\u0027s interest is free from federal income taxes."
    },
    {
       "id":801,
       "practice_test_id":"",
       "topic_id":3,
       "question":"A customer has just had their first child and they want to start putting money away for his future. They ask about the maximum contribution to an educational IRA. You should tell them:",
       "choice_a":"The maximum contribution is $2,000 per year, after tax",
       "choice_b":"The maximum contribution is $2,000 per year, pre-tax",
       "choice_c":"The maximum contribution is $500 per year, after tax",
       "choice_d":"The maximum contribution is $500 per year, pre-tax",
       "correct_answer":"A",
       "explanation":"The maximum contribution to an educational IRA is $2,000, after tax dollars."
    },
    {
       "id":802,
       "practice_test_id":"",
       "topic_id":3,
       "question":"A doctor earns more than $150,000 and deposits the maximum into his Keogh plan. What percentage must he deposit for full-time employees?",
       "choice_a":"20%",
       "choice_b":"10%",
       "choice_c":"7.50%",
       "choice_d":"15%",
       "correct_answer":"A",
       "explanation":"A doctor who has full time employees must make a contribution to their Keogh at the same rate as their own contribution."
    },
    {
       "id":803,
       "practice_test_id":"",
       "topic_id":3,
       "question":"A Keogh plan (HR-10) is which of the following?",
       "choice_a":"A qualified retirement plan",
       "choice_b":"Usually set up by individuals, sole proprietors, or un-incorporated businesses",
       "choice_c":"May be funded only with earned income during a period when the business showed a gross profit",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"A Keogh plan allows individuals, sole proprietors, and un-incorporated small businesses to establish a retirement plan for themselves and their employees."
    },
    {
       "id":804,
       "practice_test_id":"",
       "topic_id":3,
       "question":"A Keogh plan is available for all of the following except:",
       "choice_a":"An independent coffee shop owner",
       "choice_b":"A lawyer",
       "choice_c":"A janitor at a local college",
       "choice_d":"A nurse at a local doctor\u0027s office",
       "correct_answer":"C",
       "explanation":"The janitor at a local college is not self-employed, nor do they work for someone who is self-employed."
    },
    {
       "id":805,
       "practice_test_id":"",
       "topic_id":3,
       "question":"A principal in a school has deposited $15,000 in a tax deferred annuity through a payroll deduction plan. The account has grown in value to $22,000. The principal plans to retire and take a lump sum distribution. On what amount does he pay taxes?",
       "choice_a":"$22,000",
       "choice_b":"$15,000",
       "choice_c":"$7,000",
       "choice_d":"$0",
       "correct_answer":"C",
       "explanation":"This is a non-qualified plan, meaning the money is deposited after taxes, so the retiree will only pay taxes on the growth."
    },
    {
       "id":806,
       "practice_test_id":"",
       "topic_id":3,
       "question":"A qualified retirement plan differs from a non-qualified retirement plan in all of the following ways except:",
       "choice_a":"Contributions for the qualified plan are pre-tax, while contributions for the non-qualified plan are after tax",
       "choice_b":"Participation must be allowed for everyone in the qualified plan, while the corporation may choose who participates in the non-qualified plan",
       "choice_c":"IRS approval is required for both plans",
       "choice_d":"Withdrawals from a qualified plan are 100% taxed as ordinary income, while growth in excess of the cost base is taxed as ordinary income in a non-qualified plan",
       "correct_answer":"C",
       "explanation":"IRS approval is required for participation in a qualified plan, but IRS approval is not required for a non-qualified plan."
    },
    {
       "id":807,
       "practice_test_id":"",
       "topic_id":3,
       "question":"A registered representative may borrow money from a client if:",
       "choice_a":"The client is a bank or other business which lends money as its regular business",
       "choice_b":"The representative signs a statement of debt to the client",
       "choice_c":"The client agrees to hold loan documents for a year or less, at which time the loan will be paid off",
       "choice_d":"The money is to be used as investment capital",
       "correct_answer":"A",
       "explanation":"The only way a representative can borrow money from a client is if the client is a bank or other institution whose business it is to lend money."
    },
    {
       "id":808,
       "practice_test_id":1,
       "topic_id":3,
       "question":"A simplified employee pension IRA is:",
       "choice_a":"Frequently used by small companies and individuals to plan for retirement",
       "choice_b":"Attractive to small employers because it allows them to establish a retirement plan for their employees quickly and inexpensively",
       "choice_c":"A plan which requires all eligible employees to participate, as well as the employer, both of whom are contributing to the fund",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"All of the choices listed are true about a SEP IRA."
    },
    {
       "id":809,
       "practice_test_id":2,
       "topic_id":3,
       "question":"A single investor has invested $9,000 in his IRA for the current year. Which of the following is true?",
       "choice_a":"The investor may add an additional $1,000",
       "choice_b":"The investor is subject to a 6% penalty on the overage per year, for as long as it remains in the IRA",
       "choice_c":"The investor is subject to a 10% penalty on the overage",
       "choice_d":"The investor is subject to a 6% penalty on the entire amount",
       "correct_answer":"B",
       "explanation":"The investor is subject to a 6% penalty on the excess amount for each year it remains in the plan."
    },
    {
       "id":810,
       "practice_test_id":3,
       "topic_id":3,
       "question":"A tax-free rollover of an IRA account may be made:",
       "choice_a":"Once a year",
       "choice_b":"Once in two years",
       "choice_c":"Once in three years",
       "choice_d":"At any time",
       "correct_answer":"A",
       "explanation":"An investor may only rollover their IRA once per year. The investor has 60 days to redeposit the funds into another IRA."
    },
    {
       "id":811,
       "practice_test_id":4,
       "topic_id":3,
       "question":"All of the following are true about an educational IRA except:",
       "choice_a":"Individuals may contribute up to $5,000 in after tax money to an educational IRA for each student",
       "choice_b":"The contributions are allowed to grow tax deferred",
       "choice_c":"The growth is allowed to be withdrawn tax-free as long as it is used for educational purposes",
       "choice_d":"If all of the funds have not been used by the time the student is 30 years of age, the account must be rolled over to another family member or distributed to the original student and taxed",
       "correct_answer":"A",
       "explanation":"Individuals may contribute up to $2,000 only to an educational IRA."
    },
    {
       "id":812,
       "practice_test_id":5,
       "topic_id":3,
       "question":"All of the following are true regarding a TSA plan except:",
       "choice_a":"The amount of the employee\u0027s elective deferral must be renewed annually",
       "choice_b":"The maximum amount of the employee\u0027s elective deferral is $8,000 per year",
       "choice_c":"An employee\u0027s elective deferral may be in the form of a forgone pay increase",
       "choice_d":"The agreement will stipulate the frequency of the employee\u0027s contributions.",
       "correct_answer":"B",
       "explanation":"The maximum amount of the employee\u0027s deferral is $19,000 per year. All of the other choices listed are true."
    },
    {
       "id":813,
       "practice_test_id":6,
       "topic_id":3,
       "question":"All of the following are true regarding qualified retirement plans except:",
       "choice_a":"Contributions are currently tax deductible",
       "choice_b":"All eligible employees must be allowed to participate",
       "choice_c":"Excess over cost basis is taxed upon withdrawal",
       "choice_d":"All plans must be approved by the IRS",
       "correct_answer":"C",
       "explanation":"With a qualified plan, there is no cost base, so that all the money is taxed when it is taken out."
    },
    {
       "id":814,
       "practice_test_id":"",
       "topic_id":3,
       "question":"All of the following investments are allowed in an IRA except:",
       "choice_a":"US gold coins",
       "choice_b":"CD\u0027s",
       "choice_c":"Annuities",
       "choice_d":"Rare coins",
       "correct_answer":"D",
       "explanation":"Rare coins are not permitted in an IRA. US minted coins however, are allowed."
    },
    {
       "id":815,
       "practice_test_id":"",
       "topic_id":3,
       "question":"All of the following may participate in a TSA plan except:",
       "choice_a":"A nurse",
       "choice_b":"A town clerk",
       "choice_c":"A school nurse",
       "choice_d":"A self-employed vendor",
       "correct_answer":"D",
       "explanation":"A TSA is only for employees of \u0022not for profit\u0022 organizations and employees of municipal organizations. A self-employed person may not have a TSA."
    },
    {
       "id":816,
       "practice_test_id":"",
       "topic_id":3,
       "question":"All qualified corporate retirement plans must be:",
       "choice_a":"Set up in writing",
       "choice_b":"Set up as a trust",
       "choice_c":"Have a plan administrator or trustee to administer the plan",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"All of the choices listed are true about a qualified corporate retirement plan."
    },
    {
       "id":817,
       "practice_test_id":"",
       "topic_id":3,
       "question":"All qualified dividends are:",
       "choice_a":"Taxed as ordinary income each year",
       "choice_b":"Tax free income",
       "choice_c":"Taxed as special interest-free income",
       "choice_d":"Taxed at a set rate of 15%",
       "correct_answer":"D",
       "explanation":"All qualified dividends are taxed at a set rate of 15% in the year in which they were received."
    },
    {
       "id":818,
       "practice_test_id":"",
       "topic_id":3,
       "question":"An employee must be allowed to participate in a corporate pension plan at:",
       "choice_a":18,
       "choice_b":21,
       "choice_c":25,
       "choice_d":19,
       "correct_answer":"B",
       "explanation":"An employee must be allowed to participate in a corporate pension plan at 21."
    },
    {
       "id":819,
       "practice_test_id":"",
       "topic_id":3,
       "question":"An individual inherits 4000 shares of TYP balanced fund from her aunt. Her aunt had been dollar averaging into the fund for some time and her average cost was 12.20. The niece holds onto the mutual fund for 2\u00BD years before selling the shares to purchase a home. She sells the shares and receives $52,000. On how much does the niece owe taxes, if the shares were worth $12.20 each when she received them from her aunt?",
       "choice_a":"$3,200",
       "choice_b":"$4,000",
       "choice_c":"$52,000",
       "choice_d":"$0",
       "correct_answer":"A",
       "explanation":"She will owe taxes on $3,200; the cost base for shares that are received through an inheritance is the fair market value on the day of death of $48,800. She sold the shares and received $52,000. Her tax will be on the $3,200."
    },
    {
       "id":820,
       "practice_test_id":"",
       "topic_id":3,
       "question":"An investor has been investing in his IRA for the past three years and has deposited a total of $6,000 into his account. He will be vested:",
       "choice_a":"100% after 5 years",
       "choice_b":"20% per year from 3-7 years",
       "choice_c":"100% after 7 years",
       "choice_d":"100% immediately",
       "correct_answer":"D",
       "explanation":"The money put into an IRA by the investor is always theirs. Vesting refers to how an employer\u0027s contribution becomes the property of the employee."
    },
    {
       "id":821,
       "practice_test_id":"",
       "topic_id":3,
       "question":"An investor has deposited $100,000 into a qualified retirement account over a 10-year period. The value of the account has grown to $175,000 and the investor plans to retire and take a lump sum withdrawal. He will pay:",
       "choice_a":"Capital gains tax on $75,000 only",
       "choice_b":"Ordinary income taxes on the $75,000 only",
       "choice_c":"Ordinary income taxes on the whole $175,000",
       "choice_d":"Ordinary income taxes on the $100,000 and capital gains on the $75,000",
       "correct_answer":"C",
       "explanation":"Because the retirement account is qualified, the investor has deposited the money pre-tax, therefore all of the money is taxed as ordinary income when it is withdrawn."
    },
    {
       "id":822,
       "practice_test_id":"",
       "topic_id":3,
       "question":"An investor has just begun the payout phase of their variable annuity and is wondering about the tax consequences of their payments. You should tell them:",
       "choice_a":"Your payments will be tax free",
       "choice_b":"You will have to pay capital gains on the money",
       "choice_c":"You will have to pay ordinary income taxes on the entire amount",
       "choice_d":"You will only be taxed on the growth portion of the payment",
       "correct_answer":"D",
       "explanation":"The investor will only be taxed on the distribution of growth and it will be taxed as ordinary income."
    },
    {
       "id":823,
       "practice_test_id":1,
       "topic_id":3,
       "question":"An investor is in the 30% tax bracket, and invests in a Municipal Bond that yields 5%. The Tax Equivalent Yield would be:",
       "choice_a":"5.26%",
       "choice_b":"9.56%",
       "choice_c":"7.14%",
       "choice_d":"3.84%",
       "correct_answer":"C",
       "explanation":"To calculate the Tax Equivalent Yield for this example, divide the Tax Exempt yield of the Municipal Bond (5% or 0.05) by 1, minus Brad\u0027s tax bracket of 30%, or 1 - 0.30, which equals 0.70. So, 0.05 divided by 0.70 = 0.0714, or 7.14%. This means that the Taxable Equivalent Yield would need to be at least 7.14% if invested in a taxable type vehicle."
    },
    {
       "id":824,
       "practice_test_id":2,
       "topic_id":3,
       "question":"An investor\u0027s aunt has left him shares of a mutual fund which she had been dollar cost averaging into over the last 10 years. Her average cost was $22.74 per share. Her average price was $25.02. The shares had an NAV of $23.77 when they were left to the investor. What is the investor\u0027s cost base for these shares?",
       "choice_a":"$25.02",
       "choice_b":"$23.77",
       "choice_c":"$22.74",
       "choice_d":"$22.74, plus any inheritance taxes that were paid on the money",
       "correct_answer":"B",
       "explanation":"An investor\u0027s cost basis is always the fair market value of the securities on the day of death."
    },
    {
       "id":825,
       "practice_test_id":3,
       "topic_id":3,
       "question":"Another name for an educational IRA is:",
       "choice_a":"A Coverdell",
       "choice_b":"A 529",
       "choice_c":"A UGMA",
       "choice_d":"A SEP",
       "correct_answer":"A",
       "explanation":"An educational IRA is also called a Coverdell IRA."
    },
    {
       "id":826,
       "practice_test_id":4,
       "topic_id":3,
       "question":"Distributions from an IRA must begin no later than at age:",
       "choice_a":"70\u00BD",
       "choice_b":68,
       "choice_c":65,
       "choice_d":60,
       "correct_answer":"A",
       "explanation":"Distribution from a traditional IRA must begin by 70\u00BD."
    },
    {
       "id":827,
       "practice_test_id":5,
       "topic_id":3,
       "question":"ERISA governs retirement plans for all of the following except:",
       "choice_a":"Municipal employee",
       "choice_b":"Corporate vice president",
       "choice_c":"Paralegal",
       "choice_d":"Private Nurse",
       "correct_answer":"A",
       "explanation":"ERISA only governs private sector retirement plans. A municipal employee works in the public sector."
    },
    {
       "id":828,
       "practice_test_id":6,
       "topic_id":3,
       "question":"It is important for the investor to identify which shares are being sold at the time of sale because:",
       "choice_a":"The IRS will assume that the First In are the First Out (FIFO), which may result in the largest possible tax liability",
       "choice_b":"The investor will want to sell the shares, which will give him the most favorable tax consequences",
       "choice_c":"The investor may use capital losses to offset capital gains only if he knows where the loss or gain may be",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"It is important for the investor to keep good records of what shares are purchased when, so that he can create a favorable tax situation for himself as described in the above answers."
    },
    {
       "id":829,
       "practice_test_id":"",
       "topic_id":3,
       "question":"Random withdrawals from a variable annuity are done by:",
       "choice_a":"FIFO",
       "choice_b":"LIFO",
       "choice_c":"Average cost",
       "choice_d":"Exclusion ratio",
       "correct_answer":"B",
       "explanation":"Random withdrawals from a variable annuity will always be done on a LIFO basis. The growth always comes out first and is taxed."
    },
    {
       "id":830,
       "practice_test_id":"",
       "topic_id":3,
       "question":"When looking at the underwriting spread for a corporate stock offering, the largest part is:",
       "choice_a":"Management fee",
       "choice_b":"Underwriting fee",
       "choice_c":"Selling concession",
       "choice_d":"Total take down",
       "correct_answer":"C",
       "explanation":"The largest part of the underwriter\u0027s spread or discount is always the selling concession. The selling concession goes to whoever sells the securities to their client."
    },
    {
       "id":831,
       "practice_test_id":"",
       "topic_id":3,
       "question":"Which of the following are features of a 401K plan  <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> A 401K may be easily rolled over  </li><li>Employee\u0027s contributions are excluded from their gross income </li><li>Employees are 100% vested in all contributions immediately  </li><li>Employers may match a certain percentage of the employee\u0027s contributions</li></ol>",
       "choice_a":"II and IV",
       "choice_b":"I and II",
       "choice_c":"I and III",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"A",
       "explanation":"Of the choices listed, only II and IV are correct. A 401k may not be easily rolled over. Remember that a rollover allows the participant to take possession of the money. A plan participant is only vested immediately in their own contributions. They will become vested in their employer\u0027s contributions based on a vesting schedule."
    },
    {
       "id":832,
       "practice_test_id":"",
       "topic_id":3,
       "question":"XYZ, a publicly traded corporation regularly invests its excess cash in common stocks. During the last quarter, it received $125,000 in dividend income from its common stock portfolio. On how much did it owe in taxes?",
       "choice_a":"$125,000",
       "choice_b":"$87,000",
       "choice_c":"$37,500",
       "choice_d":"$75,000",
       "correct_answer":"C",
       "explanation":"Corporations only pay taxes on 30% of the dividends they receive from investing in other corporation\u0027s stock. This is known as the corporate dividend exclusion."
    },
    {
       "id":833,
       "practice_test_id":"",
       "topic_id":3,
       "question":"Your customer has retired early on a very large inheritance and wants to know about his options for withdrawing money from his IRA that he established 12 years ago. You should tell him:",
       "choice_a":"Since he does not need the money, he could leave the money there to grow indefinitely",
       "choice_b":"He has to begin taking distributions at 59\u00BD",
       "choice_c":"He must begin taking distributions at 65",
       "choice_d":"He must begin taking distributions at 72",
       "correct_answer":"D",
       "explanation":"Investors have to begin taking money out of an IRA at 72 years old."
    },
    {
       "id":834,
       "practice_test_id":"",
       "topic_id":3,
       "question":"Your customer is trying to calculate her capital gains on her PPM Mutual Fund, which she is redeeming now. She bought 1000 shares for $8.25 per share four years ago, and she is receiving $12.25 per share today. What is her capital gain/loss per share and in total?",
       "choice_a":"$20.50; $205,000",
       "choice_b":"$40; $40,000",
       "choice_c":"$4; $4,000",
       "choice_d":"$4; $40,000",
       "correct_answer":"C",
       "explanation":"Subtract the cost from the sales price to get the capital gain per share, then multiply by the number of shares: $12.25 - $.25 = $4.00 x 1000 = $4,000."
    },
    {
       "id":835,
       "practice_test_id":"",
       "topic_id":3,
       "question":"A bond\u0027s nominal yield is all but which one of the following:",
       "choice_a":"The interest rate that is printed on the bond",
       "choice_b":"Is fixed at the time of the bond issuance, but may change once annually",
       "choice_c":"Is always stated as a percentage of par",
       "choice_d":"Is also called the coupon rate",
       "correct_answer":"B",
       "explanation":"The nominal yield of a bond is fixed at the time the bond is issued and it never changes."
    },
    {
       "id":836,
       "practice_test_id":"",
       "topic_id":3,
       "question":"A company you own common stock in has just filed for bankruptcy, as a shareholder you will have the right to receive:",
       "choice_a":"The par value of the common shares",
       "choice_b":"New common shares in the reorganized company",
       "choice_c":"A percentage of your original investment",
       "choice_d":"Your proportional percentage of residual assets",
       "correct_answer":"D",
       "explanation":"As a common stock holder, you will have the right to receive your percentage of any residual assets."
    },
    {
       "id":837,
       "practice_test_id":"",
       "topic_id":3,
       "question":"An investor bought 100 shares of HHC stock 8% preferred. How much will she receive in annual income from this investment?",
       "choice_a":"$400 annually",
       "choice_b":"$400 semi-annually",
       "choice_c":"$80 quarterly",
       "choice_d":"$800 semi-annually",
       "correct_answer":"B",
       "explanation":"$8 per share annually, times $100 = $800, to be paid $400 semi-annually."
    },
    {
       "id":838,
       "practice_test_id":"",
       "topic_id":3,
       "question":"An investor buys 100 shares of XYZ 7% convertible preferred stock which is convertible into XYZ common at $20 per share. How many shares of common shares upon conversion?",
       "choice_a":5,
       "choice_b":400,
       "choice_c":500,
       "choice_d":5000,
       "correct_answer":"C",
       "explanation":"First, you must determine the number of shares: Par / conversion price = 100/20 = 5 multiplied by the number of preferred shares. 5 x 100 = 500"
    },
    {
       "id":839,
       "practice_test_id":"",
       "topic_id":3,
       "question":"An investor who buys 500 shares of common stock at $25 per share in a regular way transaction is required to deposit the money by:",
       "choice_a":"Trade date",
       "choice_b":"Settlement date",
       "choice_c":"Trade date, plus 3 business days",
       "choice_d":"Trade date, plus 4 business days.",
       "correct_answer":"D",
       "explanation":"Under Regulation T, the investor is required to deposit the money by the fourth business day."
    },
    {
       "id":840,
       "practice_test_id":"",
       "topic_id":3,
       "question":"An investor buys a 10% preferred stock at 110; what is their current yield?",
       "choice_a":"10.40%",
       "choice_b":"9.50%",
       "choice_c":"10%",
       "choice_d":"9.10%",
       "correct_answer":"D",
       "explanation":"The current yield is found by using the following formula: annual income / current market price of $10 / $110 = 9.1%."
    },
    {
       "id":841,
       "practice_test_id":"",
       "topic_id":3,
       "question":"An investor has an 8% convertible debenture in YBO Inc., trading in the marketplace at 160, which he wants to convert to common stock at $25 per share. What will the parity price be?",
       "choice_a":"$32",
       "choice_b":"$36",
       "choice_c":"$40",
       "choice_d":"$64",
       "correct_answer":"C",
       "explanation":"$1000 divided by $25 = 40 shares; $1600 (current market value) divided by 40 (number of shares) = $40 parity value per share."
    },
    {
       "id":842,
       "practice_test_id":"",
       "topic_id":3,
       "question":"An investor has an 8% convertible debenture in YBO Inc. which he wants to convert to common stock at $25 per share. How many shares will he get?",
       "choice_a":"$8000 divided by $25 = 320 shares of stock for each bond",
       "choice_b":"$1000 divided by $25 = 40 shares of stock for each bond",
       "choice_c":"$800 divided by $25 = 32 shares of stock for each bond",
       "choice_d":"$100 divided by $25 = 4 shares of stock for each bond",
       "correct_answer":"B",
       "explanation":"$1000 (par value) divided by $25 (Conversion price) = 40 shares."
    },
    {
       "id":843,
       "practice_test_id":2,
       "topic_id":3,
       "question":"An investor has just purchased shares of XYZ common stock. XYZ goes ex-dividend tomorrow for 10 cents per share. Which of the following is not true?",
       "choice_a":"The price of the investor\u0027s shares will decline tomorrow",
       "choice_b":"The FINRA sets the ex-dividend date",
       "choice_c":"The investor will have to pay taxes on the dividend",
       "choice_d":"The company will send out the dividend on the ex-dividend date",
       "correct_answer":"D",
       "explanation":"The question asks which answer is not true. The company will send out the dividend on the payment date, not on the ex-dividend date."
    },
    {
       "id":844,
       "practice_test_id":3,
       "topic_id":3,
       "question":"An investor has purchased 10 corporate bonds at a price of 135. At the end of the day, the bonds are quoted at 136.25. How much have the bonds risen in dollars?",
       "choice_a":"$125",
       "choice_b":"$12.50",
       "choice_c":"$1.25",
       "choice_d":"$0.13",
       "correct_answer":"A",
       "explanation":"1 bond point is worth $10.00. 1.25 points, therefore are worth $12.50 X 10 bonds = $125."
    },
    {
       "id":845,
       "practice_test_id":4,
       "topic_id":3,
       "question":"An investor has purchased 10M of XYZ 9\u0027s due March 1, 2035 at 110. The bonds closed that day at 109 \u00BC. What was the investor\u0027s gain or loss?",
       "choice_a":"$750 gain",
       "choice_b":"$75 gain",
       "choice_c":"$75 loss",
       "choice_d":"$750 loss",
       "correct_answer":"C",
       "explanation":"10M = $10,000 in principal. The bonds closed down \u00BE of a point = $7.50 x 10 bonds = $75."
    },
    {
       "id":846,
       "practice_test_id":5,
       "topic_id":3,
       "question":"An investor has purchased a bond when the par value of the bond exceeds the price the investor paid for the bond. Which of the following is true?",
       "choice_a":"The investor\u0027s nominal yield will be their highest yield",
       "choice_b":"The investor\u0027s yield to maturity will be their highest yield",
       "choice_c":"The investor will lose money at maturity",
       "choice_d":"The investor would have been better off in a money market fund",
       "correct_answer":"B",
       "explanation":"The investor has purchased the bond at a discount from its par value because par exceeds the price the investor paid for the bond. Therefore the investor\u0027s yield to maturity will be their highest yield."
    },
    {
       "id":847,
       "practice_test_id":6,
       "topic_id":3,
       "question":"An investor has purchased shares of a foreign company through an ADR. Which of the following is not true?",
       "choice_a":"The ADR may represent 1 or more shares of the company\u0027s common stock",
       "choice_b":"The dividend will be paid in US dollars",
       "choice_c":"The investor may elect to exchange the ADR for the underlying common shares",
       "choice_d":"The investor is subject to currency risk",
       "correct_answer":"B",
       "explanation":"An ADR may represent more than one share of the company\u0027s common stock and may be exchanged for the ordinary common shares. The dividend however is paid in the foreign currency and is received by the investor in US dollars as a result the investor is subject to currency risk."
    },
    {
       "id":848,
       "practice_test_id":"",
       "topic_id":3,
       "question":"An investor holding an 8% subordinated debenture will receive how much at maturity?",
       "choice_a":"$1,000",
       "choice_b":"$1,080",
       "choice_c":"$1,040",
       "choice_d":"It depends on the purchase price",
       "correct_answer":"C",
       "explanation":"An investor who has purchased an 8% corporate bond will receive the principal payment plus the last semi-annual interest payment at maturity for a total of $1040"
    },
    {
       "id":849,
       "practice_test_id":"",
       "topic_id":3,
       "question":"An investor holds 5,000 shares of a company\u0027s stock. There are 25,000 shares of outstanding stock, and in order to raise new capital, the company decides to offer another 10,000 shares for purchase. What percentage of the original offering does the investor own; and how many shares must he be offered in order to maintain this percentage?",
       "choice_a":"5%; 500 new shares",
       "choice_b":"10%; 1,000 new shares",
       "choice_c":"20%; 2,000 new shares",
       "choice_d":"25%; 2,500 new shares",
       "correct_answer":"C",
       "explanation":"5,000 shares are 20% of 25,000; the investor must be offered the same 20% or 2,000 shares. At the end of the sale, he will own 7,000 shares, or 20% of 35,000."
    },
    {
       "id":850,
       "practice_test_id":"",
       "topic_id":3,
       "question":"An investor may buy stock from the GGC Company in all of the following ways except:",
       "choice_a":"She may exchange other shares directly with the company during a private offering.",
       "choice_b":"She may buy shares from other investors in the secondary market.",
       "choice_c":"She may buy shares from other investors in the Over-the-Counter (OTC) market.",
       "choice_d":"She may buy shares directly from the company during a public offering.",
       "correct_answer":"A",
       "explanation":"An investor may not exchange other shares of stock directly with the company in a private offering."
    },
    {
       "id":851,
       "practice_test_id":"",
       "topic_id":3,
       "question":"An investor owns 100 shares of 7% cumulative preferred stock in the CCR Company, which has not paid dividends in 4 years. How much is he owed this year when the company will pay its dividends?",
       "choice_a":"$700",
       "choice_b":"$350",
       "choice_c":"$2,800",
       "choice_d":"$3,500",
       "correct_answer":"D",
       "explanation":"5 years x 100 shares x $7 = $3500"
    },
    {
       "id":852,
       "practice_test_id":"",
       "topic_id":3,
       "question":"An investor owns 1000 shares of the Omega Company, a company listed on the NYSE. Omega Company has announced a 5% stock dividend to be paid in stock of its subsidiary company, Theta Brands. The investor will receive:",
       "choice_a":"50 shares of Omega Company",
       "choice_b":"5 shares of Omega Company",
       "choice_c":"50 shares of Theta Brands",
       "choice_d":"500 shares of Theta Brands",
       "correct_answer":"C",
       "explanation":"5% stock dividend on 1000 shares is equal to 50 shares, and the dividend is being paid in shares of Theta Brands."
    },
    {
       "id":853,
       "practice_test_id":"",
       "topic_id":3,
       "question":"An investor owns 500 common shares of the GGC Company which is paying a $0.12 per share dividend to stockholders. How much will he receive?",
       "choice_a":"$6.00",
       "choice_b":"$60.00",
       "choice_c":"$600.00",
       "choice_d":"$660.00",
       "correct_answer":"B",
       "explanation":"500 shares x $0.12 = $60."
    },
    {
       "id":854,
       "practice_test_id":"",
       "topic_id":3,
       "question":"An investor owns 500 preferred shares of the GGC Company which is paying 12% preferred. How much will he receive?",
       "choice_a":"$60.00",
       "choice_b":"$600.00",
       "choice_c":"$6,000.00",
       "choice_d":"$60,000.00",
       "correct_answer":"C",
       "explanation":"500 shares x $12 per share = $6,000."
    },
    {
       "id":855,
       "practice_test_id":"",
       "topic_id":3,
       "question":"An investor owns a corporate bond from the LLT Company which has a nominal yield of 7%. How much interest will she receive in one year?",
       "choice_a":"$7.00",
       "choice_b":"$70.00",
       "choice_c":"$700.00",
       "choice_d":"None of the choices listed",
       "correct_answer":"B",
       "explanation":"7% x $1,000 (par value) = $70.00."
    },
    {
       "id":856,
       "practice_test_id":"",
       "topic_id":3,
       "question":"An investor purchased a treasury bond at 95.03. How much did he pay for the bond?",
       "choice_a":"$953.00",
       "choice_b":"$9,530.00",
       "choice_c":"$950.94",
       "choice_d":"$9,500.94",
       "correct_answer":"C",
       "explanation":"The investor purchased the Treasury bond at 95.03 or 95 3/32% of $1,000 = $950.9375."
    },
    {
       "id":857,
       "practice_test_id":"",
       "topic_id":3,
       "question":"An investor purchased an 8% corporate bond at 110. List the yields in ascending order for this investor:",
       "choice_a":"YTM, current yield, nominal yield",
       "choice_b":"YTM, nominal yield, current yield",
       "choice_c":"Current yield, YTM, nominal yield",
       "choice_d":"All of the yields will be the same for this investor",
       "correct_answer":"A",
       "explanation":"The investor bought the bond at a premium, so the highest yield will be the nominal, then the current, followed by the yield to maturity."
    },
    {
       "id":858,
       "practice_test_id":"",
       "topic_id":3,
       "question":"An investor purchases convertible preferred stocks and will receive all of the following except:",
       "choice_a":"Opportunity to benefit from common stock growth",
       "choice_b":"Guaranteed dividend payments",
       "choice_c":"Lower dividend rates",
       "choice_d":"Ownership interest",
       "correct_answer":"B",
       "explanation":"Although preferred stocks pay a stated dividend rate, there is no guarantee that the dividends will be paid to investors. Dividend payments are subject to availability of funds after expenses and debt service is paid."
    },
    {
       "id":859,
       "practice_test_id":"",
       "topic_id":3,
       "question":"An investor who buys a 7% cumulative preferred stock will receive semi-annual dividends of:",
       "choice_a":"$7 per share",
       "choice_b":"7% of the corporate profits",
       "choice_c":"$3.50 per share",
       "choice_d":"3.5% of the corporate profits",
       "correct_answer":"C",
       "explanation":"The investor who buys a 7% preferred stock is entitled to $7 per year or $3.50 every 6 months."
    },
    {
       "id":860,
       "practice_test_id":"",
       "topic_id":3,
       "question":"An investor who has purchased a corporate bond has what type of relationship with the company?",
       "choice_a":"Owner",
       "choice_b":"Debtor",
       "choice_c":"None",
       "choice_d":"Creditor",
       "correct_answer":"D",
       "explanation":"An investor who has purchased a corporate bond is a creditor of the company, and the company owes them the par value of the bond, plus the semi-annual interest."
    },
    {
       "id":861,
       "practice_test_id":"",
       "topic_id":3,
       "question":"An investor who holds an 11% corporate bond which matures on March 1, 2040 will receive how much money on that date?",
       "choice_a":"$1,000",
       "choice_b":"$1,100",
       "choice_c":"$1,055",
       "choice_d":"$1,010",
       "correct_answer":"C",
       "explanation":"When a bond matures, the investor receives the principal along with the last semi-annual interest payment, or in this case: $1055."
    },
    {
       "id":862,
       "practice_test_id":"",
       "topic_id":3,
       "question":"An investor who purchases 100M of 9% corporate bonds will receive semi-annual interest payments of:",
       "choice_a":"$4.50",
       "choice_b":"$450",
       "choice_c":"$4,500",
       "choice_d":"$45",
       "correct_answer":"C",
       "explanation":"An investor who purchased $100,000 worth of a 9% corporate bond will receive $9,000 per year in interest, or $4,500 every 6 months."
    },
    {
       "id":863,
       "practice_test_id":"",
       "topic_id":3,
       "question":"An investor\u0027s bond has matured and it\u0027s time for them to get their last interest payment and the principal returned. The bond is being:",
       "choice_a":"Called",
       "choice_b":"Tendered",
       "choice_c":"Redeemed",
       "choice_d":"Refunded",
       "correct_answer":"C",
       "explanation":"Bonds are redeemed at maturity, and the investor receives the last interest payment along with the principal payment."
    },
    {
       "id":864,
       "practice_test_id":"",
       "topic_id":3,
       "question":"As the owner of an ADR, an investor would have all of the following rights except:",
       "choice_a":"freely trade ADRs",
       "choice_b":"Right to receive dividends",
       "choice_c":"Right to exchange ADRs for the underlying common shares",
       "choice_d":"The right to determine in which currency the dividend will be paid",
       "correct_answer":"D",
       "explanation":"As the holder of an ADR, you have all of the rights listed, but you cannot decide in what currency you will receive the dividend."
    },
    {
       "id":865,
       "practice_test_id":"",
       "topic_id":3,
       "question":"If a 5% stock dividend is paid to an investor who owns 800 shares of stock already, she will receive how many shares?",
       "choice_a":"4 shares",
       "choice_b":"8 shares",
       "choice_c":"40 shares",
       "choice_d":"80 shares",
       "correct_answer":"C",
       "explanation":"800 shares X 5% = 40 shares."
    },
    {
       "id":866,
       "practice_test_id":"",
       "topic_id":3,
       "question":"If an investor bought 100 shares of PPC Company stock on June 1, at $4.32 a share, and sold those 100 shares on July 1, for $5.18 a share, what was her total profit?",
       "choice_a":"$0.86",
       "choice_b":"$8.60",
       "choice_c":"$86.00",
       "choice_d":"$860.00",
       "correct_answer":"C",
       "explanation":"She spent $432 and sold for $518, thus her profit is $86.00."
    },
    {
       "id":867,
       "practice_test_id":"",
       "topic_id":3,
       "question":"If the preemptive rights have value, and the investor does not want to purchase additional shares, these shares may be:",
       "choice_a":"Exercised",
       "choice_b":"Sold",
       "choice_c":"Expired",
       "choice_d":"Closed",
       "correct_answer":"B",
       "explanation":"These shares may then be sold to another investor if the original investor does not want to purchase them."
    },
    {
       "id":868,
       "practice_test_id":"",
       "topic_id":3,
       "question":"Mr. Grey will have how many days to pay for the stock from the date of the trade (called the T date)?",
       "choice_a":"T + 3",
       "choice_b":"T + 5",
       "choice_c":"T + 4",
       "choice_d":"T + 7",
       "correct_answer":"B",
       "explanation":"Mr. Grey will have 5 days to pay for the stock as determined by the Federal Reserve Board under Regulation T of the Securities Exchange Act of 1934."
    },
    {
       "id":869,
       "practice_test_id":"",
       "topic_id":3,
       "question":"Owning common stock provides an investor with:",
       "choice_a":"Safety of principal",
       "choice_b":"Guaranteed dividend income",
       "choice_c":"Protection against market risk",
       "choice_d":"Capital growth",
       "correct_answer":"D",
       "explanation":"Capital growth is the primary objective for investors who own common stock. There are no guaranteed dividends or protection against market risk associated with common stock. Safety of principal is a benefit of owning debt, not equity securities."
    },
    {
       "id":870,
       "practice_test_id":2,
       "topic_id":3,
       "question":"The broker call loan rate is:",
       "choice_a":"The rate that member banks charge each other for overnight loans",
       "choice_b":"The rate that banks charge their most creditworthy corporate customers on loans",
       "choice_c":"The rate that the Federal Reserve Bank charges member banks on loans",
       "choice_d":"The rate that banks charge to broker dealers to finance their customers\u0027 margin purchases",
       "correct_answer":"D",
       "explanation":"The broker call rate is the rate that banks charge to broker dealers to finance their customers\u0027 margin purchases."
    },
    {
       "id":871,
       "practice_test_id":3,
       "topic_id":3,
       "question":"The date when Mr. Grey actually becomes the owner of stock he just bought is called the:",
       "choice_a":"Trade date",
       "choice_b":"Payment date",
       "choice_c":"Settlement date",
       "choice_d":"Issue date",
       "correct_answer":"C",
       "explanation":"Mr. Grey becomes the owner of record on the settlement date."
    },
    {
       "id":872,
       "practice_test_id":4,
       "topic_id":3,
       "question":"When a company holds it\u0027s annual meeting and is holding elections to fill seats on it\u0027s board of directors, which of the following is true about cumulative voting rights?",
       "choice_a":"It benefits large investors who have accumulated more shares",
       "choice_b":"It gives an advantage to the company\u0027s remaining board members",
       "choice_c":"It allows investors who own preferred and common stock to combine their voting rights",
       "choice_d":"It benefits the small investors by giving them a larger say in the voting process",
       "correct_answer":"D",
       "explanation":"The small investor benefits most from cumulative voting rights by having to ability to cast all of their votes from each election for a single board member candidate."
    },
    {
       "id":873,
       "practice_test_id":5,
       "topic_id":3,
       "question":"When dividends are distributed, the name of the first day when purchasers are no longer entitled to receive the dividends is called:",
       "choice_a":"Dividend date",
       "choice_b":"Declaration date",
       "choice_c":"Record date",
       "choice_d":"Ex-date",
       "correct_answer":"D",
       "explanation":"The ex-dividend date or the \u0022ex-date\u0022 is the first day when purchasers of the security are no longer entitled to receive the dividend that the company has declared for payment."
    },
    {
       "id":874,
       "practice_test_id":6,
       "topic_id":3,
       "question":"Which of the following allows the owner of the securities full voting rights?",
       "choice_a":"Corporate Bonds",
       "choice_b":"Preferred Stock",
       "choice_c":"Common Stock",
       "choice_d":"All of the choices listed",
       "correct_answer":"C",
       "explanation":"Common Stockholders retain the full voting rights, under normal circumstances. Bankruptcy might be one case where preferred stockholders and bond holders might gain voting rights."
    },
    {
       "id":875,
       "practice_test_id":"",
       "topic_id":3,
       "question":"Which of the following is / are true?  <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> Common stock must be issued before any other type of stock can be issued </li><li>Authorized stock represents common stock which a company may offer </li><li>Outstanding stock is stock which has not been bought by investors  </li><li>Treasury stock is stock which has been sold to investors and then repurchased by the company</li></ol>",
       "choice_a":"I, II, and III",
       "choice_b":"I, II, and IV",
       "choice_c":"I, III, and IV",
       "choice_d":"II, III, and IV",
       "correct_answer":"B",
       "explanation":"Choice III is false, because outstanding stock is the stock which has been sold to the public and which remains in their hands."
    },
    {
       "id":876,
       "practice_test_id":"",
       "topic_id":3,
       "question":"Which type of preferred stock allows the company involved to buy back the stock from the stockholders at a set price?",
       "choice_a":"Cumulative preferred",
       "choice_b":"Participating preferred",
       "choice_c":"Convertible preferred",
       "choice_d":"Callable preferred",
       "correct_answer":"D",
       "explanation":"Callable preferred is the only type of stock which benefits the company and not the investor, since the company can call in the stock. Callable stock is call protected for the first few years."
    },
    {
       "id":877,
       "practice_test_id":"",
       "topic_id":3,
       "question":"XYZ has issued subordinated debentures offering 8% to investors and they mature on March 1, 2030. XYZ is now selling subordinated debentures maturing in 2040 offering the investors a 6% interest rate. What has happened to the price of the debentures maturing in 2030?",
       "choice_a":"The price has gone down",
       "choice_b":"The price has gone up",
       "choice_c":"The price has remained unchanged",
       "choice_d":"There is no affect on the price of the older bond",
       "correct_answer":"B",
       "explanation":"The price of the debenture maturing in 2030 has gone up because interest rates have fallen."
    },
    {
       "id":878,
       "practice_test_id":"",
       "topic_id":3,
       "question":"XYZ is going through reorganization and is electing five new members of the board of directors under the cumulative method of voting. An investor owning 500 shares would have:",
       "choice_a":"500 votes to split evenly among 5 candidates",
       "choice_b":"2500 votes to split anyway they choose",
       "choice_c":"500 votes to cast 100 for each director",
       "choice_d":"2500 votes to split 500 for each candidate",
       "correct_answer":"B",
       "explanation":"An investor with 500 shares of stock voting for 5 directors would have a total of 2500 votes to cast in anyway he chooses under the cumulative method of voting."
    },
    {
       "id":879,
       "practice_test_id":"",
       "topic_id":3,
       "question":"An investor anticipating a fall in interest rates would likely purchase:",
       "choice_a":"Callable bonds",
       "choice_b":"Non-callable bonds",
       "choice_c":"Either of the above",
       "choice_d":"Neither of the above",
       "correct_answer":"B",
       "explanation":"If rates fall, bonds are likely to be called, so a callable bond would not be correct."
    },
    {
       "id":880,
       "practice_test_id":"",
       "topic_id":3,
       "question":"Under rule 2790, if a member firm receives an order from a bank\u0027s trust department for the purchase of a new issue, the member firm should do which of the following?",
       "choice_a":"Require written authorization from the bank, indemnifying the member firm from wrongdoing",
       "choice_b":"Fill the order without further inquiry",
       "choice_c":"Fill the order only if the customer\u0027s name is disclosed",
       "choice_d":"Fill the order after proper inquiry to verify that the customer is not restricted",
       "correct_answer":"D",
       "explanation":"When a bank wishes to purchase a new issue for an undisclosed principal, the member must inquire of the bank, as to whether the ultimate purchasers are prohibited persons and must receive satisfactory assurance that they are not prohibited persons. The name of the person to whom the inquiry was directed must be noted on the order ticket, and the order ticket must be initialed by a principal."
    },
    {
       "id":881,
       "practice_test_id":"",
       "topic_id":3,
       "question":"A customer enters a day order to sell 300 SIA stock at 34. SIA continues to trade in a 33 to 33.75 range. An hour before the close, he tells you that he is thinking of changing the order to a GTC order. You respond that he might consider allowing the order to remain on the books as a day order, and if it remains unexecuted at the close, to re-enter it the next day as a GTC order. You would have based this recommendation on concern for which of the following?",
       "choice_a":"Additional cost to the firm of changing the order twice in a day",
       "choice_b":"Weakening the customer\u0027s risk tolerance by encouraging him to change orders frequently",
       "choice_c":"An existing order has precedence over a new order when it comes to execution",
       "choice_d":"Day orders are less risky than GTC orders",
       "correct_answer":"C",
       "explanation":"Time priority (first come, first served) of an order is lost if there are any changes in the terms of an order. Modifications are not made to orders; rather the old one is cancelled and a new one is entered."
    },
    {
       "id":882,
       "practice_test_id":"",
       "topic_id":3,
       "question":"A customer gives specific instructions to his registered rep to purchase a security which is clearly unsuitable in light of the customer\u0027s investment objectives. Under FINRA rules, the registered rep:",
       "choice_a":"Can enter the order",
       "choice_b":"Cannot enter the order",
       "choice_c":"Can enter the order only with the prior approval of a principal",
       "choice_d":"Can enter the order only if the customer puts his verbal instructions into written form",
       "correct_answer":"A",
       "explanation":"Under FINRA rules, the rep may execute the trade at the customer\u0027s direction. The trade ticket should indicate that the order was unsolicited."
    },
    {
       "id":883,
       "practice_test_id":"",
       "topic_id":3,
       "question":"For a retired person, which of the following investments would provide the greatest protection against inflation?",
       "choice_a":"Fixed annuities",
       "choice_b":"Municipal bonds",
       "choice_c":"Corporate bonds",
       "choice_d":"Variable annuities",
       "correct_answer":"D",
       "explanation":"Fixed income instruments, like bonds and fixed annuities, are subject to purchasing power risk. Variable annuities provide protection from inflation because their monthly income can increase continually depending on the separate account\u0027s performance."
    },
    {
       "id":884,
       "practice_test_id":"",
       "topic_id":3,
       "question":"A client is considering buying a 7% municipal bond currently yielding 6.8%. As an alternative, he also has looked at a 9.5% corporate bond. Which of the following statements is true?",
       "choice_a":"The corporate bond offers a higher yield, regardless of tax bracket",
       "choice_b":"The corporate bond offers a higher yield if the client\u0027s tax bracket is 36%",
       "choice_c":"The municipal bond offers a higher yield, regardless of tax bracket",
       "choice_d":"The municipal bond offers a higher yield if the client\u0027s tax bracket is 36%",
       "correct_answer":"D",
       "explanation":"To compute the tax-equivalent yield, use the yield to maturity because the bond is priced to yield this amount. For a 36% tax bracket: tax­ equivalent yield = tax-exempt interest / (100% - 36%) = 6.8% divived 64% = 10.625%."
    },
    {
       "id":885,
       "practice_test_id":"",
       "topic_id":3,
       "question":"Which of the following would be the best time for an investor to purchase long term fixed interest rate bonds?",
       "choice_a":"When short term interest rates are high and are beginning to decline",
       "choice_b":"When short term interest rates are low and are beginning to rise",
       "choice_c":"When long term interest rates are low and are beginning to rise",
       "choice_d":"When long term interest rates are high and are beginning to decline",
       "correct_answer":"D",
       "explanation":"The best time to buy long term bonds is when long-term interest rates have peaked. In addition to the high return, as interest rates fall the value of existing bonds will rise."
    },
    {
       "id":886,
       "practice_test_id":"",
       "topic_id":3,
       "question":"A customer buys 100 shares of SIA at $10 per share. Several months later, the stock is trading at 5, at which time the registered rep offers to buy back the stock from the customer for his own account at $9 per share. This action is:",
       "choice_a":"Permitted because it allows the customer to sell at a price higher than the current market",
       "choice_b":"Prohibited because FINRA rules do not allow registered reps to guarantee customers against loss",
       "choice_c":"Permitted with the written permission of a principal",
       "choice_d":"Prohibited because it violates the Uniform Practice Code of the FINRA",
       "correct_answer":"B",
       "explanation":"A rep may never guarantee a customer against a loss."
    },
    {
       "id":887,
       "practice_test_id":"",
       "topic_id":3,
       "question":"An investor has purchased 500 shares of an aggressive growth stock. Which of the following strategies would limit his downside risk?",
       "choice_a":"Buying five calls on the stock",
       "choice_b":"Buying five puts on the stock",
       "choice_c":"Writing five puts on the stock",
       "choice_d":"Entering a buy stop order",
       "correct_answer":"B",
       "explanation":"A major reason for buying puts is to hedge against a possible loss in a long stock position. A buy stop order will only protect a customer who is short stock. A sell stop order, on the other hand, would protect a customer with a long stock position."
    },
    {
       "id":888,
       "practice_test_id":"",
       "topic_id":3,
       "question":"Which of the following investments is most suitable for an investor seeking monthly income?",
       "choice_a":"Zero-coupon bond",
       "choice_b":"Growth stock",
       "choice_c":"Mutual fund investing in small-cap issues",
       "choice_d":"GNMA",
       "correct_answer":"D",
       "explanation":"GNMA is the most suitable investment for an investor seeking monthly income. Zero coupon bonds, growth stocks, and mutual funds which invest in small-cap issues offer higher long-term growth potential, but they are not designed to provide monthly income."
    },
    {
       "id":24707,
       "practice_test_id":2,
       "topic_id":3,
       "question":"A husband and wife have an account with your firm established as JTWROS. Which of the following is / are true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The assets in the account are deemed to be community property </li><li>Either party may enter an order</li><li>If one party dies the account will become an individual account</li><li>No more than 2 parties are allowed on the account</li></ol>",
       "choice_a":"II and III",
       "choice_b":"I and IV",
       "choice_c":"II, III and IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"D",
       "explanation":"All of the choices listed are correct relating to an account established under JTWROS. The assets are deemed to be community property meaning they are owned equally by each tenant."
    },
    {
       "id":24711,
       "practice_test_id":3,
       "topic_id":3,
       "question":"Which of the following must a registered representative take to his principal for review?",
       "choice_a":"A customer refuses to provide an email address",
       "choice_b":"A customer opens multiple accounts with different investment objectives",
       "choice_c":"A customer sends in a check with his business address instead of his home address",
       "choice_d":"A customer redeems a mutual fund portfolio at a significant loss",
       "correct_answer":"B",
       "explanation":"All customer accounts must be taken to a principal of the firm for review, regardless of how many accounts a customer opens. A customer could have an account for themselves, an IRA and a custodial account all with different investment objectives. A customer check will most likely go to the cashier department. A customer is not required to provide an email address and a customer redeeming a mutual fund at a loss will be reviewed by the principal after the trade is entered. The trade will not require prior review from a principal."
    },
    {
       "id":24723,
       "practice_test_id":4,
       "topic_id":3,
       "question":"An investor had established a Roth IRA when he was 54 years old by depositing $5,000. During each of the next two years he made equal installments totaling $12,000. When he was 57 years old he made a single contribution of $6,500. No further contributions were made. Now at 60 he wants to take a lump sum distribution with the account valued at $30,125. Which of the following is correct?",
       "choice_a":"The investor may withdraw all of the money tax free",
       "choice_b":"The investor may withdraw the deposits plus the growth on the assets that are more than 5 years old tax free",
       "choice_c":"The investor may withdraw the deposits tax free but will be subject to ordinary income taxes on the growth since not all of the money was there for more than 5 years",
       "choice_d":"In order to avoid paying income taxes the investor must take payments that are substantially similar over time",
       "correct_answer":"A",
       "explanation":"All deposits made to a Roth IRA are made with after tax dollars. As such the contributions to the plan create the investor\u0027s cost basis. Since the investor is over 59\u00BD the investor may take all of the growth out of the account tax free."
    },
    {
       "id":24729,
       "practice_test_id":5,
       "topic_id":3,
       "question":"A client asks his representative about investing in municipal securities through a packaged product. The representative informs the client that he does not think that municipal securities are appropriate for the investor. The investor asks the registered representative to create a list of the products his firm conducts business in and to select the one or two he thinks are best based on fees and performance, and email the information to him. The registered representative should:",
       "choice_a":"not create the list since the products are not suitable for the client",
       "choice_b":"create the list but not select the products he feels are the best based on fees and performance",
       "choice_c":"create the list and select the products he feels are best based on fees and performance",
       "choice_d":"have the client sign a suitability statement, send the list and select the products he feels are best based on fees and performance",
       "correct_answer":"C",
       "explanation":"The client has asked for the list of products to be created based on fees and performance. The RR has stated that he does not think that municipal securities are suitable for the investor. However, since the client has asked for the information to be provided the RR should comply with the client\u0027s request and send the list of products based on fees and performance."
    },
    {
       "id":24730,
       "practice_test_id":6,
       "topic_id":3,
       "question":"Two brothers have an account with your firm registered as JTIC. One brother passes away and the wife of the decedent contacts their registered representative. The wife asks the registered representative to send her a check for her late husband\u0027s ownership of the account. Which of the following is true?",
       "choice_a":"Upon presentation of a death certificate the representative should comply with the request",
       "choice_b":"The assets of the decedent will avoid probate",
       "choice_c":"The assets of the decedent will become property of their estate",
       "choice_d":"Upon presentation of the death certificate, the account should be re-titled to reflect that the wife has title to the assets and  the check should be mailed inline with the request",
       "correct_answer":"C",
       "explanation":"The account is titled as joint tenants in common with the brother and not the wife of the decedent. The portion of the account belonging to the brother who passed away will become property of his estate and the assets will be distributed according to his Will. The registered representative will need to receive significant paperwork and must receive instructions from the executor or administrator prior to distributing any assets."
    },
    {
       "id":24744,
       "practice_test_id":"",
       "topic_id":3,
       "question":"A woman opens an account with a registered representative and notifies the RR that she would like her investment adviser to receive duplicate notifications for all activity in the account. Which of the following is true?",
       "choice_a":"Disclosing information to a third party is prohibited",
       "choice_b":"Each time there is a transaction in the account the RR should make a photocopy and fax or email it to the investment adviser",
       "choice_c":"Notification would be sent on a trade by trade basis and would appear on the customer\u0027s confirmation",
       "choice_d":"Each time there is a transaction in the account the RR should contact the purchase and sales department and have a copy sent to the investment advisers as per the customer\u0027s instructions",
       "correct_answer":"C",
       "explanation":"When a third party such as an accountant or an investment adviser is notified, the third party will receive notification of all trades and notation on the confirm will indicate that a third party has been notified."
    },
    {
       "id":20361,
       "practice_test_id":"",
       "topic_id":3,
       "question":"Which of the following refer to the types of ownership in a customer account? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Joint </li><li>Individual </li><li>Margin </li><li>Trust</li></ol>",
       "choice_a":"I, II",
       "choice_b":"III, IV",
       "choice_c":"I, II, IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"C",
       "explanation":"When a customer opens an account at a broker dealer ownership can be individual, joint, corporate, trust or partnership. Margin refers to a type of account (i.e. cash or margin account) not a type of ownership."
    },
    {
       "id":20362,
       "practice_test_id":"",
       "topic_id":3,
       "question":"When opening a new account for a customer, what information should the registered rep obtain from the customer? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Customer\u2019s full legal name </li><li>Customer\u2019s legal address (PO Boxes are acceptable) </li><li>Customer\u2019s social security or tax id number </li><li>Customer\u2019s net worth</li></ol>",
       "choice_a":"I, II, III",
       "choice_b":"II, III, IV",
       "choice_c":"I, III, IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"C",
       "explanation":"When opening a new account for a customer arep should obtain all the relevant information about the customer, including the customer\u2019s legal address. However, a customer must provide a physical address, po boxes are not acceptable."
    },
    {
       "id":20363,
       "practice_test_id":"",
       "topic_id":3,
       "question":"Which of the following is not true when a registered rep opens a new account for a customer?",
       "choice_a":"The customer must sign the new account form",
       "choice_b":"The rep who introduced the new account must be noted",
       "choice_c":"The registered principal must sign the new account form",
       "choice_d":"The firm must send the customer a copy of the new account form within 30 days of account opening",
       "correct_answer":"A",
       "explanation":"The registered principal is required to sign the new account form and a copy must be sent to the customer within 30 days. The customer is not required to sign the new account form."
    },
    {
       "id":20364,
       "practice_test_id":"",
       "topic_id":3,
       "question":"When a customer opens up a new account at a broker dealer a principal must accept the account:",
       "choice_a":"Immediately",
       "choice_b":"Before the first trade",
       "choice_c":"Within 10 days",
       "choice_d":"Either before the first trade or promptly after the first trade",
       "correct_answer":"D",
       "explanation":"A registered principal is responsible for accepting new accounts in writing either before or promptly after the first trade."
    },
    {
       "id":20365,
       "practice_test_id":"",
       "topic_id":3,
       "question":"Which of the following must a customer provide when opening a new account at a broker dealer? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Annual income </li><li>Net worth </li><li>Investment Objectives</li><li>Educational background</li></ol>",
       "choice_a":"I, II, III",
       "choice_b":"I, III, IV",
       "choice_c":"II, III, IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"A",
       "explanation":"A When opening a new account at a broker dealer a customer\u0027s educational background is not required information."
    },
    {
       "id":20366,
       "practice_test_id":"",
       "topic_id":3,
       "question":"Which of the following is true when a customer chooses the option to have his securities transferred and shipped?",
       "choice_a":"The securities are registered to the customer and shipped to a custodian bank",
       "choice_b":"The securities are registered to the broker dealer and shipped to the customer\u0027s address of record",
       "choice_c":"the securities are registered to the broker dealer and shipped to a custodian bank",
       "choice_d":"The securities are registered to the customer and shipped to the customer\u0027s address of record",
       "correct_answer":"D",
       "explanation":"When a customer opens an account at a broker dealer and chooses to have his securities transferred and shipped the certificates are registered in the customer\u0027s name and sent to the address of record."
    },
    {
       "id":20367,
       "practice_test_id":"",
       "topic_id":3,
       "question":"A broker dealer can open up a new account for a customer without which of the following pieces of information? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The customer\u2019s date of birth </li><li>The customer\u2019s educational background </li><li>The customer\u2019s financial information</li></ol>",
       "choice_a":"I only",
       "choice_b":"II only",
       "choice_c":"I, II",
       "choice_d":"I, II, III",
       "correct_answer":"D",
       "explanation":"When opening a new customer account the broker dealer must determine that the customer is legally of age, but his date of birth is not required. The customer\u2019s educational background and his financial information are also not required. However, if a customer refuses to disclose his financial information, the broker dealer may not make recommendations to the customer and may only accept unsolicited orders."
    },
    {
       "id":20368,
       "practice_test_id":"",
       "topic_id":3,
       "question":"If, when opening a new account, a customer refuses to disclose his financial information, the broker dealer:",
       "choice_a":"Tell the customer he cannot open the account unless the customer provides the information",
       "choice_b":"Open the account and have all securities transferred and shipped to the customer",
       "choice_c":"Open the account and accept only unsolicited orders from the customer",
       "choice_d":"Open the account and place only discretionary trades for the customer",
       "correct_answer":"C",
       "explanation":"If a customer refuses to provide his financial information to the broker dealer the firm may open the account for the customer, but cannot make recommendations to the customer and can only accept unsolicited orders from that customer."
    },
    {
       "id":20369,
       "practice_test_id":"",
       "topic_id":3,
       "question":"When a new customer opens an account at a broker dealer which of the following methods are available for holding the securities? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>RVP or DVP </li><li>Hold in street name </li><li>Transfer and ship </li><li>Transfer and hold</li></ol>",
       "choice_a":"III, IV",
       "choice_b":"II, III",
       "choice_c":"II, III, IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"D",
       "explanation":"Customers can choose to have their securities held as RVP/DVP, in  street name, transfer and hold or transfer and ship. If the customer sets the account up as an RVP / DVP account all securities will be delivered to the customer\u0027s bank for payment."
    },
    {
       "id":20370,
       "practice_test_id":"",
       "topic_id":3,
       "question":"If a customer wishes to have his statements and confirmations held by the broker dealer all of the following are true except:",
       "choice_a":"All mail will be sent to the customer\u0027s address of record",
       "choice_b":"Mail may be held for up to 2 months if the customer is traveling domestically",
       "choice_c":"Mail may not be sent to someone other than the customer himself",
       "choice_d":"A request to hold mail must be made in writing by the customer",
       "correct_answer":"C",
       "explanation":"All mail is generally sent to the customer\u0027s address of record. If a customer wishes to have the broker dealer hold his mail then the request must be in writing, and the BD may hold the mail for 2 months if the customer is traveling within the US and for 3 months if the customer is out of the country.  Additionally a customer may request, in writing, to have his confirmations and statements sent to a person holding a power of attorney."
    },
    {
       "id":20371,
       "practice_test_id":2,
       "topic_id":3,
       "question":"If a customer wishes to open an account with his wife and wants his ownership of the account to revert to her upon his death, he would title the account:",
       "choice_a":"Joint tenants in common",
       "choice_b":"Joint tenants with rights of survivorship",
       "choice_c":"Trust",
       "choice_d":"Transfer on death",
       "correct_answer":"B",
       "explanation":"By opening a joint tenants with rights of survivorship account the account ownership is equal between the 2 spouses. Upon the customer\u0027s death, his portion of the account would revert to the wife as she is the surviving owner listed on the account."
    },
    {
       "id":20372,
       "practice_test_id":3,
       "topic_id":3,
       "question":"If a customer wishes to open an account with his wife and wants his ownership of the account to revert to his estate upon his death, he would title the account:",
       "choice_a":"Joint tenants in common",
       "choice_b":"Joint tenants with rights of survivorship",
       "choice_c":"Trust",
       "choice_d":"Transfer on death",
       "correct_answer":"A",
       "explanation":"If one owner dies in an account titled tenants in common that person\u0027s ownership in the account reverts to his or her estate and not to the surviving owners listed on the account."
    },
    {
       "id":20373,
       "practice_test_id":4,
       "topic_id":3,
       "question":"If a customer wishes to open an account at a broker dealer and wants his ownership of the account to revert to his beneficiary upon his death, he would title the account:",
       "choice_a":"Individual",
       "choice_b":"Transfer on Death",
       "choice_c":"Trust",
       "choice_d":"Discretionary",
       "correct_answer":"B",
       "explanation":"A transfer on Death account allows a customer to name a beneficiary when they open the account. While the customer is alive the beneficiary has no control over the decisions made in the account, however, upon the customer\u0027s death the account will revert to the beneficiary."
    },
    {
       "id":20374,
       "practice_test_id":5,
       "topic_id":3,
       "question":"When opening a tenants in common account at a broker dealer, which of the following needs to be signed by the customers?",
       "choice_a":"A letter of intent",
       "choice_b":"A new account form",
       "choice_c":"A joint account agreement",
       "choice_d":"A power of attorney",
       "correct_answer":"C",
       "explanation":"A joint account agreement needs to be signed by all the owners in order to open a joint account. New account forms are signed by the principal, but not the customer. A letter of intent is only needed if the customer is purchasing mutual fund shares and has not reached a breakpoint. And a power of attorney is only needed if the customer is opening a discretionary account."
    },
    {
       "id":20375,
       "practice_test_id":6,
       "topic_id":3,
       "question":"All of the following are needed to release the assets of a decedent except:",
       "choice_a":"A death certificate",
       "choice_b":"Inheritance tax waivers",
       "choice_c":"A power of attorney",
       "choice_d":"Letters testamentary",
       "correct_answer":"C",
       "explanation":"A power of attorney is not required to release the assets of a decedent as a power of attorney becomes null and void upon a person\u0027s death."
    },
    {
       "id":20376,
       "practice_test_id":"",
       "topic_id":3,
       "question":"In which of the following accounts must margin be specifically allowed in the underlying documentation?",
       "choice_a":"A Trust account",
       "choice_b":"A Corporate account",
       "choice_c":"A Partnership account",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"In trust, corporate and partnership accounts margin is prohibited unless it is specifically provided for in the underlying documentation. If the documentation makes no mention of margin, margin is not permitted."
    },
    {
       "id":20377,
       "practice_test_id":"",
       "topic_id":3,
       "question":"If a customer opens a standarddiscretionary account at a broker dealer all of the following are true except:",
       "choice_a":"The RR is given the authority to determine the asset",
       "choice_b":"The RR is given the authority to decide whether to buy or sell",
       "choice_c":"The RR is given the authority to pay for customer\u0027s trades at other firms",
       "choice_d":"The RR is given the authority to determine the quantity of the securities traded",
       "correct_answer":"C",
       "explanation":"In a discretionary trade the RR has discretion over the three A\u0027s: asset; action; and amount. The RR is not given full power of attorney and therefore not allowed to remove assets from the account to pay for trades at other firms."
    },
    {
       "id":20378,
       "practice_test_id":"",
       "topic_id":3,
       "question":"Which of the following statements are true regarding the management of discretionary accounts? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> Discretionary accounts must be approved by a registered principal </li><li>Each discretionary order must be approved by the principal prior to order entry </li><li>The broker dealer must keep a record of all discretionary trades </li><li>Each discretionary order must be marked \u0022discretionary\u0022</li></ol>",
       "choice_a":"I, II",
       "choice_b":"I, III, IV",
       "choice_c":"II, III, IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"B",
       "explanation":"Discretionary accounts must be approved by the principal and each discretionary trade must be marked as such on the order ticket, and copies must be kept by the firm. A principal is required to review each discretionary trade after it\u0027s placed not before."
    },
    {
       "id":20379,
       "practice_test_id":"",
       "topic_id":3,
       "question":"All of the following are examples of fiduciaries except:",
       "choice_a":"A broker dealer",
       "choice_b":"A sheriff",
       "choice_c":"A conservator",
       "choice_d":"An administrator",
       "correct_answer":"A",
       "explanation":"A fiduciary is a third party acting on a customer\u0027s behalf when dealing with the broker dealer. Sheriffs, conservators and administrators are all examples of fiduciaries, a broker dealer is not."
    },
    {
       "id":20380,
       "practice_test_id":"",
       "topic_id":3,
       "question":"If a customer is opening an account for a child where there is one custodian and one minor child listed on the account her or she is most likely opening a:",
       "choice_a":"UGMA",
       "choice_b":"UTMA",
       "choice_c":"both a and b",
       "choice_d":"neither a nor b",
       "correct_answer":"C",
       "explanation":"Both UGMA and UTMAs require that there be only one custodian and one child per account. UGMAs and UTMAs differ in the timing when the assets are transferred to the control of the minor who has now become an adult."
    },
    {
       "id":20381,
       "practice_test_id":"",
       "topic_id":3,
       "question":"Which of the following activities are prohibited in a UTMA account?",
       "choice_a":"Uncovered options",
       "choice_b":"Short sales",
       "choice_c":"Penny stocks",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"Custodians of UTMAs are governed by the Prudent Man Rule which prohibits any transactions which subject the account to undue risk. Uncovered options, short sales and penny stocks are all considered too risky for a custodial account."
    },
    {
       "id":20382,
       "practice_test_id":"",
       "topic_id":3,
       "question":"Under NYSE rules, if when opening a cash account for a new customer, a registered rep discovers that the customer is employed at another broker dealer, the rep must do which of the following:",
       "choice_a":"Notify the NYSE",
       "choice_b":"Notify the customer\u0027s employer verbally",
       "choice_c":"Receive permission from the regulators to open the account",
       "choice_d":"Receive permission from the customer\u0027s employer to open the account",
       "correct_answer":"D",
       "explanation":"Under NYSE rules if a registered rep wants to open an account with another broker dealer then the opening firm must contact the rep\u0027s employer in writing and receive permission."
    },
    {
       "id":20383,
       "practice_test_id":"",
       "topic_id":3,
       "question":"Under MSRB rules, if when opening a margin account for a new customer, a registered rep discovers that the customer is employed at another broker dealer, the rep must do which of the following:",
       "choice_a":"Notify the MSRB",
       "choice_b":"Notify the customer\u0027s employer in writing",
       "choice_c":"Receive permission from the regulators to open the account",
       "choice_d":"Receive permission from the customer\u0027s employer to open the account",
       "correct_answer":"B",
       "explanation":"Under MSRB rules if a registered rep wants to open a margin account with another broker dealer then the opening firm must contact the rep\u0027s employer in writing advising them of the customer\u0027s intent."
    },
    {
       "id":20384,
       "practice_test_id":"",
       "topic_id":3,
       "question":"Under FINRA rules, if when opening a margin account for a new customer, a registered rep discovers that the customer is employed at another broker dealer, the rep must do which of the following:",
       "choice_a":"Notify FINRA immediately",
       "choice_b":"Notify the customer\u0027s employer in writing",
       "choice_c":"Receive permission from the regulators to open the account",
       "choice_d":"Receive permission from the customer\u0027s employer to open the account",
       "correct_answer":"B",
       "explanation":"Under FINRA rules if a registered rep wants to open a margin account with another broker dealer then the opening firm must contact the rep\u0027s employer in writing advising them of the customer\u0027s intent."
    },
    {
       "id":20385,
       "practice_test_id":"",
       "topic_id":3,
       "question":"Under FINRA rules, if when opening a cash account for a new customer, a registered rep discovers that the customer is employed at another broker dealer, the rep must do which of the following:",
       "choice_a":"Notify FINRA at once",
       "choice_b":"Notify the customer\u0027s employer in writing",
       "choice_c":"Receive permission from the regulators to open the account",
       "choice_d":"Receive permission from the customer\u0027s employer to open the account",
       "correct_answer":"B",
       "explanation":"Under FINRA rules if a registered rep wants to open a cash account with another broker dealer then the opening firm must contact the rep\u0027s employer in writing advising them of the customer\u0027s intent."
    },
    {
       "id":20386,
       "practice_test_id":"",
       "topic_id":3,
       "question":"Which of the following is true of the ACAT process when a customer requests to have his securities transferred to another broker dealer?",
       "choice_a":"The carrying firm has 1 business day to validate the positions and an additional 3 business days to complete the transfer",
       "choice_b":"The carrying firm has 3 business days to validate the positions and an additional 3 business days to complete the transfer",
       "choice_c":"The carrying firm has 3 business days to validate the positions and an additional 4 business days to complete the transfer",
       "choice_d":"The carrying firm has 1 business day to validate the positions and an additional 4 business days to complete the transfer",
       "correct_answer":"A",
       "explanation":"The ACAT process allows the carrying firm one business day to either validate or take exception to the customer\u2019s positions. The firm then has an additional 3 business days to complete the transfer of those securities to the new broker dealer."
    },
    {
       "id":20387,
       "practice_test_id":"",
       "topic_id":3,
       "question":"When opening a new margin account at a broker dealer which of the following is not required?",
       "choice_a":"A signed margin agreement",
       "choice_b":"A signed credit agreement",
       "choice_c":"A signed loan consent",
       "choice_d":"A signed hypothecation agreement",
       "correct_answer":"C",
       "explanation":"The margin agreement details the terms of the margin at the broker dealer, the credit agreement states how interest is charged on the margin loan and the hypothecation agreement states that the customer agrees to allow the broker dealer to pledge his securities to the bank as collateral for the loan. All of these must be signed by the customer. The loan consent allows the broker dealer to loan out the customer\u0027s securities for short sales and is not required to open a margin account."
    },
    {
       "id":20423,
       "practice_test_id":"",
       "topic_id":3,
       "question":"Which of the following are true when a customer takes a withdrawal from a 529 college savings plan and uses the money to pay for educational expenses?",
       "choice_a":"The principal will be taxed, but the growth will be federally tax free",
       "choice_b":"The growth will be taxed, but the principal is federally tax free",
       "choice_c":"Both the principal and the growth are federally taxable",
       "choice_d":"Both the interest and the growth are federally tax free",
       "correct_answer":"D",
       "explanation":"When a customer makes a contribution to a 529 plan he does so with after tax dollars, so the tax has already been paid. When he withdraws money to use for educational expenses, the growth is federally tax free and may be state tax free depending on where the customer resides."
    },
    {
       "id":20424,
       "practice_test_id":"",
       "topic_id":3,
       "question":"Which of the following regarding 529 plans is a true statement?",
       "choice_a":"Only college savings plans have income limits for the donors",
       "choice_b":"Contribution limits vary from state to state",
       "choice_c":"Contributions are made pre-tax",
       "choice_d":"The account becomes the property of the beneficial owner upon the date of the first withdrawal",
       "correct_answer":"B",
       "explanation":"There are no income limitations on donors to 529 plans though the contribution limits may vary by state. The donor makes contributions to the account with after tax money and will always remain the owner of the account. Ownership of a 529 plan does not revert to the beneficial owner at any point."
    },
    {
       "id":20425,
       "practice_test_id":"",
       "topic_id":3,
       "question":"Which of the following are considered benefits of a 529 plan? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Contributions grow tax deferred  </li><li>A pre-paid tuition plan locks in today\u0027s tuition rates for future enrollment at specific school  </li><li>Withdrawals are federally tax free if used for educational expenses  </li><li>Depending on the state, withdrawals may be state tax free </li></ol>",
       "choice_a":"I, III",
       "choice_b":"III, IV",
       "choice_c":"I, III, IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"D",
       "explanation":"A 529 plan allows for contributions to grow tax deferred and withdrawals to be federally and, many times, state tax free. If the customer decides on a prepaid tuition program he will lock in the price of a future education."
    },
    {
       "id":20454,
       "practice_test_id":"",
       "topic_id":3,
       "question":"A custodial account being managed for the benefit of a minor is long 500 shares of BNM. BNM is offering new shares to finance the building of a new factory. Each share of BNM will receive 1 right to purchase the new BNM shares. It takes 2 rights plus $28 dollars per share to purchase the new BNM shares. BNM is trading in the marketplace at $30. Which of the following actions would the custodian be allowed to take? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Sell the rights at the intrinsic value </li><li>Sell the rights above the intrinsic value </li><li>Sell the rights below the intrinsic value </li><li>Exercise the rights</li></ol>",
       "choice_a":"II and IV",
       "choice_b":"I, II, and IV",
       "choice_c":"IV only",
       "choice_d":"I, II, III, IV",
       "correct_answer":"D",
       "explanation":"The custodian may take all of the actions listed. A custodian is prohibited from allowing the rights to expire. Therefore, the custodian must either sell or exercise the rights. The is no regulation as to the price at which the rights may be sold."
    },
    {
       "id":20455,
       "practice_test_id":"",
       "topic_id":3,
       "question":"Under FINRA regulations a customer of a member firm may upon request inspect which of the following?",
       "choice_a":"P & L statement for 6 months trading",
       "choice_b":"P & L statement for 90 days trading",
       "choice_c":"Income statement",
       "choice_d":"Balance sheet",
       "correct_answer":"D",
       "explanation":"Under FINRA regulations a customer of a member firm may inspect a member firm\u0027s balance sheet. Member firms who carry customer account and maintain control over customer cash and securities must provide a balance sheet to customers upon request."
    },
    {
       "id":20481,
       "practice_test_id":"",
       "topic_id":3,
       "question":"All but which of the following if established would involve a fiduciary?",
       "choice_a":"Trust account",
       "choice_b":"Transfer on Death account",
       "choice_c":"Guardian account",
       "choice_d":"Estate account",
       "correct_answer":"B",
       "explanation":"The transfer on Death or TOD account designation on an account simply states who the assets are to go to in the event of the account holder\u0027s death. This does not involve or create a fiduciary relationship."
    },
    {
       "id":20485,
       "practice_test_id":"",
       "topic_id":3,
       "question":"A client\u0027s secretary stops by your office and hands you your client\u0027s business card. On the back of the card is the following order \u0022Sell my 500 shares of ABC at the market\u0022 and the back of the card is signed by the client. You have known the client and his secretary for over 10 years. Which of the following is true?",
       "choice_a":"You may execute the order without further instructions",
       "choice_b":"You may execute the order once the back office has compared the signature with the client\u0027s signature on file",
       "choice_c":"You must call the client to verify the order",
       "choice_d":"You may execute the order if the secretary assures you that the client handed her the card within the last 24 hours",
       "correct_answer":"C",
       "explanation":"An agent may never accept an order for a client\u0027s account from a third party. Even though the client signed the card it would be difficult to authenticate such a signature without the agent seeing the client write the instructions personally."
    },
    {
       "id":20498,
       "practice_test_id":"",
       "topic_id":3,
       "question":"Which of the following are false as it relates to the operation of an account registered in the names of more than one party and established as JTIC? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Either party may enter an order </li><li>Mail relating to the account may be sent to either address with the agreement all tenants </li><li>Checks may be made out to either party with the agreement of all tenants </li><li>The account may be established between no more than two tenants</li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and III",
       "choice_c":"III and IV",
       "choice_d":"I and IV",
       "correct_answer":"C",
       "explanation":"Either party on the account may enter an order for the account. The mailing of confirms and statements may go to both addresses or to only one address if all tenants agree. Checks on the account must be made out to all names on the account and an account may be established for more than two parties so long as all of the parties are adults."
    },
    {
       "id":20499,
       "practice_test_id":"",
       "topic_id":3,
       "question":"Which of the following are true as it relates to the operation of an account registered in the names ofmore than oneparty and established as JTIC? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Either party may enter an order </li><li>Mail relating to the account may be sent to either address with the agreement all tenants </li><li>Checks may be made out to either party with the agreement of all tenants </li><li>The account may be established between no more than two tenants</li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and IV",
       "choice_c":"I, III and IV",
       "choice_d":"I, II and III",
       "correct_answer":"A",
       "explanation":"Either party on the account may enter an order for the account. The mailing of confirms and statements may go to both addresses or to only one address if all tenants agree. There may be more than two tenants in a JTIC account."
    },
    {
       "id":20501,
       "practice_test_id":"",
       "topic_id":3,
       "question":"Which of the following is a feature of a 529 college plan? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>High contribution limit  </li><li>Pre tax contributions </li><li>Federally tax free withdrawals for college expenses  </li><li>Contributions subject to income restrictions</li></ol>",
       "choice_a":"I and III",
       "choice_b":"I and IV",
       "choice_c":"I, III and IV",
       "choice_d":"I,II, III, IV",
       "correct_answer":"A",
       "explanation":"529 plans allow for high contribution limits. There are no income limits for contributors to a 529 plan. Students may make withdrawals from 529 plans federally tax free to meet college expenses."
    },
    {
       "id":20502,
       "practice_test_id":2,
       "topic_id":3,
       "question":"Which of the following is not a feature of a 529 college plan? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>High contribution limit  </li><li>Pre tax contributions </li><li>Federally tax free withdrawals for college expenses  </li><li>Contributions subject to income restrictions</li></ol>",
       "choice_a":"II and IV",
       "choice_b":"I and III",
       "choice_c":"I and IV",
       "choice_d":"II and III",
       "correct_answer":"A",
       "explanation":"529 plans do not allow contributions to be made with pre tax dollars. There are no income limits for contributors to a 529 plan"
    },
    {
       "id":21062,
       "practice_test_id":3,
       "topic_id":3,
       "question":"A client calls his representative wishing to place an order to sell 500 ERT at the market. The representative reviews the client\u0027s account and does not see the shares of ERT in the client\u0027s account. The client instructs the representative to mark the ticket as selling long. Which of the following must the representative do?",
       "choice_a":"Get the prior approval of the principal",
       "choice_b":"Check to see if the shares of ERT appear on the easy to borrow list",
       "choice_c":"Identify where the shares of ERT are held and if that can be delivered",
       "choice_d":"Execute the order and deliver shares of ERT held in street name by the broker dealer",
       "correct_answer":"C",
       "explanation":"The ticket can be marked as selling long only if the representative can determine if the customer has possession of the shares and can deliver the stock certificate promptly. The broker dealer may not deliver other shares on behalf of the client when the sell order is marked as selling long."
    },
    {
       "id":21078,
       "practice_test_id":4,
       "topic_id":3,
       "question":"A customer who has suffered significant losses in his account is seeking legal remedies to recoup the lost funds. As part of your firm\u0027s account opening process customers are required to sign a pre dispute arbitration clause. the customer requests that a copy of the pre dispute clause be sent to him for his lawyer to review. Your firm must send the papers:",
       "choice_a":"within 10 business days of request",
       "choice_b":"within 5 business days of request",
       "choice_c":"within 3 business days of request",
       "choice_d":"within 20 business days of request",
       "correct_answer":"A",
       "explanation":"A customer who requests a copy of a signed pre dispute arbitration clause must be sent the paperwork within 10 business days of request."
    },
    {
       "id":21088,
       "practice_test_id":5,
       "topic_id":3,
       "question":"An investor who is fully invested and with no free cash or SMA in his account sells $25,000 worth of TRY and later uses the proceeds to purchase $32,000 worth of XYA. The customer fails to send in any additional funds by the expiration of the fourth business day. Which of the following actions should the broker dealer take?",
       "choice_a":"Request and extension for the $7,000",
       "choice_b":"Sell out the $32,000 worth of XYA and freeze the account for 90 days",
       "choice_c":"Break the trade and restore the original position",
       "choice_d":"Sell out $7,000 worth of XYA and freeze the account for 90 days",
       "correct_answer":"D",
       "explanation":"An extension may not be granted after the expiration of the fourth business day. Since the customer only failed to pay for $7,000 of the new purchase that is the amount that must be sold out. Even though most of the purchase was paid for, the account must still be frozen for 90 days. During the 90 day freeze no orders may be executed prior to the cash being in the account."
    },
    {
       "id":21090,
       "practice_test_id":6,
       "topic_id":3,
       "question":"As it relates to an account established as joint tenants in common, Which of the following is / are not true?  <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>If one party dies the assets will become the property of the survivor  </li><li>Each party identifies a specific percentage ownership in the account </li><li>If one part dies the assets in the account will become part of the decedent\u0027s estate </li><li>Accounts must be established with equal ownership among the parties</li></ol>",
       "choice_a":"I and IV",
       "choice_b":"I only",
       "choice_c":"II and IV",
       "choice_d":"II and III",
       "correct_answer":"A",
       "explanation":"If one party in an account dies the assets belonging to that party will become part of the decedent\u0027s estate. Each party in the account must specify their ownership percentage for the assets in the account. Accounts established as JTIC do not require equal ownership among the parties."
    },
    {
       "id":21093,
       "practice_test_id":"",
       "topic_id":3,
       "question":"A customer is seeking to execute an order with your broker dealer. Utilizing FINRA\u0027s 5 percent policy what will be the basis for the mark down?",
       "choice_a":"The highest offer",
       "choice_b":"The highest bid",
       "choice_c":"The lowest offer",
       "choice_d":"The lowest bid",
       "correct_answer":"B",
       "explanation":"The key to this question is \u0022mark down\u0022. A mark down is only charged when the customer is the seller of a security. As such the marked down will be calculated based on the highest (best) bid."
    },
    {
       "id":24767,
       "practice_test_id":"",
       "topic_id":3,
       "question":"Mr. Jones has sent in an email expressing his unhappiness with the way his options account has been handled by the firm. The customer feels that the trading in his account was not inline with his investment objectives. Which two of the following are true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The rep should reply to the email within 24 hours </li><li>A copy of the email must be maintained at the branch </li><li>A copy of the email should be maintained at an office with a central file </li><li>A principal should review and respond to the complaint within 15 days</li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and III",
       "choice_c":"I and IV",
       "choice_d":"III and IV",
       "correct_answer":"B",
       "explanation":"If a customer sends in a written complaint, a copy of the complaint must be kept in the branch office and in an office of supervisory jurisdiction (OSJ). The OSJ will maintain a central complaint file for all of the branches within its jurisdiction."
    },
    {
       "id":523,
       "practice_test_id":"",
       "topic_id":4,
       "question":"An office would be considered to be a branch office if:",
       "choice_a":"It is advertised in a telephone directory",
       "choice_b":"The member firm pays the expenses of the office",
       "choice_c":"It is identified as an office of the member firm by a sign on the office door",
       "choice_d":"All of the choices listed are branches",
       "correct_answer":"D",
       "explanation":"All of the choices listed would be considered branch offices."
    },
    {
       "id":524,
       "practice_test_id":"",
       "topic_id":4,
       "question":"An open-end mutual fund that offers investors a sales charge reduction based on the amount of money invested with the fund company must notify investors of the availability of a sales charge reduction at least:",
       "choice_a":"Quarterly",
       "choice_b":"Semi annually",
       "choice_c":"Annually",
       "choice_d":"Monthly",
       "correct_answer":"C",
       "explanation":"A mutual fund that offers a sales charge reduction must notify investors of the availability of the sales charge reduction at least annually."
    },
    {
       "id":525,
       "practice_test_id":"",
       "topic_id":4,
       "question":"An OSJ must be inspected by a principal of the member firm:",
       "choice_a":"Monthly",
       "choice_b":"Quarterly",
       "choice_c":"Semi-annually",
       "choice_d":"Annually",
       "correct_answer":"D",
       "explanation":"Every member must review and inspect each OSJ at least annually."
    },
    {
       "id":526,
       "practice_test_id":"",
       "topic_id":4,
       "question":"As a registered representative, you present a report to a customer about the past performance and past recommendations of the MMC Company\u0027s stock; this report must contain all but which of the following?",
       "choice_a":"The prices and dates when the recommendations were made",
       "choice_b":"The recommendations in all similar securities for the past three years",
       "choice_c":"General market conditions",
       "choice_d":"A statement as to whether any of the officers or directors own, have options, or have warrants for any of the MMC stock",
       "correct_answer":"B",
       "explanation":"A report which cites past performance of previous recommendations must contain the recommendations in all similar securities for the past 12 months, one year; this report must contain the information above as well as statements, if the MMC Company has other securities managed or co-managed in an underwriting by your firm, and listing the supporting documents for the recommendation."
    },
    {
       "id":527,
       "practice_test_id":"",
       "topic_id":4,
       "question":"As it relates to a member firm conducting business with the public, all of the following are violations except:",
       "choice_a":"Stating that a new issue has been approved for sale by the SEC",
       "choice_b":"Printing &quot;FINRA&quot; in large type on business cards",
       "choice_c":"Charging a customer a larger than normal commission for executing a specific order",
       "choice_d":"Failing to execute a customer\u0027s order for a speculative security",
       "correct_answer":"C",
       "explanation":"A member firm may charge a customer a larger than ordinary commission for the execution of a specific order, so long as it is disclosed to the customer. A member firm must always execute a customer\u0027s order"
    },
    {
       "id":528,
       "practice_test_id":"",
       "topic_id":4,
       "question":"Creating false activity in a security to attract new purchasers is a fraudulent practice known as:",
       "choice_a":"Painting the tape",
       "choice_b":"Trading ahead",
       "choice_c":"Front running",
       "choice_d":"Active concealment",
       "correct_answer":"A",
       "explanation":"This is known as painting the tape, matched purchases, or matched sales."
    },
    {
       "id":529,
       "practice_test_id":"",
       "topic_id":4,
       "question":"During a new issue registration, false information is included in the prospectus to buyers. Which of the following may be held liable to investors? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Officers of the issuer </li><li>Accountants </li><li>Syndicate members </li><li>People who signed the registration statement</li></ol>",
       "choice_a":"I and II",
       "choice_b":"I and III",
       "choice_c":"I, II, and III",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"D",
       "explanation":"All of the parties listed may be held liable to the purchasers of the new issue."
    },
    {
       "id":530,
       "practice_test_id":"",
       "topic_id":4,
       "question":"During the cooling off period, a Registered Representative may do which of the following?",
       "choice_a":"Send a client a preliminary prospectus and a research report",
       "choice_b":"Send a client a preliminary prospectus and a market letter",
       "choice_c":"Send a client a preliminary prospectus and the underwriting agreement",
       "choice_d":"Send a client a preliminary prospectus only",
       "correct_answer":"D",
       "explanation":"During the cooling off period, a Registered Representative may send out a preliminary prospectus only."
    },
    {
       "id":531,
       "practice_test_id":"",
       "topic_id":4,
       "question":"Each broker dealer must designate a principal whose job it is to:",
       "choice_a":"Report violations of professional conduct by broker dealers to the SEC",
       "choice_b":"Supervise all of the actions of a firm and its employees",
       "choice_c":"Report violations of state and federal laws to the proper authorities",
       "choice_d":"Report violations of securities rules and regulations to the SEC",
       "correct_answer":"B",
       "explanation":"A principal is designated to supervise all of the actions of a firm and its employees; a principal must prevent any violation of industry, state, or federal laws or regulations."
    },
    {
       "id":532,
       "practice_test_id":"",
       "topic_id":4,
       "question":"Encouraging an investor to purchase a mutual fund share just prior to its ex-dividend date is known as:",
       "choice_a":"Break point sales",
       "choice_b":"An enticement",
       "choice_c":"Selling dividends",
       "choice_d":"An appropriate strategy known as dividend capture",
       "correct_answer":"C",
       "explanation":"Selling dividends is a violation. The representative uses the pending dividend as an enticement to get the customer to make the purchase."
    },
    {
       "id":533,
       "practice_test_id":"",
       "topic_id":4,
       "question":"Every FINRA member must ensure against employee dishonesty. In order to protect the investing public each firm must post a:",
       "choice_a":"Recourse bond",
       "choice_b":"Blanket bond",
       "choice_c":"Escrow",
       "choice_d":"Fidelity bond",
       "correct_answer":"D",
       "explanation":"A fidelity bond ensures against employee dishonesty."
    },
    {
       "id":534,
       "practice_test_id":"",
       "topic_id":4,
       "question":"Gifts to employees of another member firm may be made:",
       "choice_a":"Under no circumstances",
       "choice_b":"With permission of the employer only",
       "choice_c":"For a maximum of $100 per person per year and must be given to the employer",
       "choice_d":"For a maximum of $100 per person per year given to the employee",
       "correct_answer":"C",
       "explanation":"A gift given to an employee of another member must be given directly to the employer for distribution to the employee and may have a maximum value of $100 per person per year."
    },
    {
       "id":535,
       "practice_test_id":"",
       "topic_id":4,
       "question":"If a purchaser of an open-end investment company sells the fund within seven business days of the purchase:",
       "choice_a":"The underwriter forfeits all of the sales charge to the broker dealer",
       "choice_b":"The broker dealer forfeits all of the concession to the underwriter",
       "choice_c":"The customer will receive a full refund of his total investment",
       "choice_d":"The customer will receive a full refund of his total investment less a redemption fee",
       "correct_answer":"B",
       "explanation":"If a customer redeems their fund shares within seven days of purchase, the broker dealer will forfeit all of the concession to the underwriter."
    },
    {
       "id":536,
       "practice_test_id":"",
       "topic_id":4,
       "question":"If an investment company is sold under the Spread Load Plan, the maximum amount of total sales charge that may be deducted from any single deposit in the first year of the plan is:",
       "choice_a":"8\u00BD%",
       "choice_b":"9%",
       "choice_c":"20%",
       "choice_d":"50%",
       "correct_answer":"C",
       "explanation":"The maximum allowable sales charge that can be deducted from any one payment is 20% for a plan organized under the Spread Load Act of 1970."
    },
    {
       "id":537,
       "practice_test_id":1,
       "topic_id":4,
       "question":"If FINRA finds that a member has violated the rules regarding fair advertising, FINRA may require the member to:",
       "choice_a":"File the proposed ads 45 days prior to their first use",
       "choice_b":"File the proposed ads 30 days prior to their first use",
       "choice_c":"File the proposed ads 10 days prior to their first use",
       "choice_d":"File the proposed ads 90 days prior to heir first use",
       "correct_answer":"C",
       "explanation":"If FINRA has found the member\u0027s advertisements to be in violation of the Rules of Fair Practice, they may require the member to file the ads ten days before they are used."
    },
    {
       "id":538,
       "practice_test_id":2,
       "topic_id":4,
       "question":"If the sales charge is 8% and the bid price is 9.20, what do you divide by to get the asked price?",
       "choice_a":92,
       "choice_b":0.92,
       "choice_c":9.2,
       "choice_d":60,
       "correct_answer":"B",
       "explanation":"To find the public offering price, divide the NAV, 9.20, by the complement of the sales charge, or in this case: .92"
    },
    {
       "id":539,
       "practice_test_id":3,
       "topic_id":4,
       "question":"In order to charge the maximum allowable sales charge of 8 \u00BD%, the mutual fund company must offer all of the following except:",
       "choice_a":"Breakpoint sales charge reductions",
       "choice_b":"Conversion privileges",
       "choice_c":"Rights of accumulation",
       "choice_d":"Reinvestment of distributions at NAV",
       "correct_answer":"B",
       "explanation":"In order for a mutual fund company to charge the maximum allowable sales charge of 8 \u00BD%, the mutual fund company must offer all of the features listed except conversion privileges."
    },
    {
       "id":540,
       "practice_test_id":4,
       "topic_id":4,
       "question":"In order to engage in a private securities transaction, a representative must do which of the following?",
       "choice_a":"Obtain the broker dealer\u0027s prior approval",
       "choice_b":"Provide the employing firm with all documentation concerning the investment and the proposed transaction",
       "choice_c":"Avoid selling away",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"A representative must do all of the choices listed prior to engaging in a private securities transaction."
    },
    {
       "id":541,
       "practice_test_id":5,
       "topic_id":4,
       "question":"In selecting a broker dealer to handle transactions for the company\u0027s portfolio, an investment company may use which of the following considerations? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>  A broker dealer whose qualifications meet the needs of the company </li><li> A broker dealer who has sold a substantial amount of the investment company\u0027s shares </li><li>A broker dealer who has sold the investment company\u0027s shares over a substantial period of time  </li><li> A broker dealer who has a selling agreement with the investment company, allowing him to sell the shares and has sold such shares</li></ol>",
       "choice_a":"I only",
       "choice_b":"IV only",
       "choice_c":"I and II",
       "choice_d":"I, II, III and IV",
       "correct_answer":"A",
       "explanation":"The only method an investment company may use to select a brokerage firm to execute the fund\u0027s orders is based on the qualifications of the firm and the needs of the fund."
    },
    {
       "id":542,
       "practice_test_id":6,
       "topic_id":4,
       "question":"Member firms are required to maintain a file ofall retail and institutional communicationsfor:",
       "choice_a":"One year",
       "choice_b":"Two years",
       "choice_c":"Three years",
       "choice_d":"Six years",
       "correct_answer":"C",
       "explanation":"Allretail and institutional communicationsmust be kept for three years, two years readily accessible."
    },
    {
       "id":543,
       "practice_test_id":"",
       "topic_id":4,
       "question":"Open-end funds and closed-end funds differ in sales charge in what way?",
       "choice_a":"Open-end funds charge sales charge and closed-end funds charge no sales charge",
       "choice_b":"Open-end funds charge more sales charge than closed-end funds",
       "choice_c":"Investors pay the sales charge for open-end funds, while the fund pays the sales charge for closed-end funds",
       "choice_d":"Open-end funds carry a front end sales charge, while closed-end funds carry a back-end load sales charge",
       "correct_answer":"A",
       "explanation":"Open-end funds charge a sales charge, born by the investor, while closed-end funds do not charge a sales charge at all."
    },
    {
       "id":544,
       "practice_test_id":"",
       "topic_id":4,
       "question":"Sales charges in excess of what amount must be returned to an investor who cancels their contractual plan organized under the Act of 1940 between 45 days and 18 months?",
       "choice_a":"15%",
       "choice_b":"40%",
       "choice_c":"30%",
       "choice_d":"9%",
       "correct_answer":"A",
       "explanation":"An investor who cancels their contractual plan between 45 days and 18 months is entitled to a refund of sales charges in excess of 15% of the payments."
    },
    {
       "id":545,
       "practice_test_id":"",
       "topic_id":4,
       "question":"The act that requires non-exempt issuers of securities to file a registration statement with the SEC is:",
       "choice_a":"The Securities Act of 1933",
       "choice_b":"The Securities Exchange Act of 1934",
       "choice_c":"The Corporate Registration Act of 1936",
       "choice_d":"The Trust Indenture Act of 1939",
       "correct_answer":"A",
       "explanation":"The Securities Act of 1933 requires non-exempt issuers to file a registration statement with the SEC."
    },
    {
       "id":546,
       "practice_test_id":"",
       "topic_id":4,
       "question":"The illegal practice of making transactions which are excessive in frequency or size to generate higher commissions is called:",
       "choice_a":"Pegging",
       "choice_b":"Front running",
       "choice_c":"Churning",
       "choice_d":"Capping",
       "correct_answer":"C",
       "explanation":"The practice of making excessive transactions to generate greater commissions is called churning."
    },
    {
       "id":547,
       "practice_test_id":"",
       "topic_id":4,
       "question":"The maximum allowable sales charge for a variable annuity is:",
       "choice_a":"9%",
       "choice_b":"There is no stated maximum",
       "choice_c":"10%",
       "choice_d":"6%",
       "correct_answer":"B",
       "explanation":"There is no statedmaximum allowable sales charge for a variable annuity. The sales charge must be reasonable based on the total payments made to the account."
    },
    {
       "id":548,
       "practice_test_id":"",
       "topic_id":4,
       "question":"The maximum allowable sales charge on an open-end mutual fund is:",
       "choice_a":"8.5% of the NAV",
       "choice_b":"9% of the POP",
       "choice_c":"8.5% of the POP",
       "choice_d":"9% of the NAV",
       "correct_answer":"C",
       "explanation":"The maximum allowable sales charge on an open-end fund is 8\u00BD% of the POP."
    },
    {
       "id":549,
       "practice_test_id":"",
       "topic_id":4,
       "question":"The maximum dollar value of a gift is:",
       "choice_a":"Limited to $100 per year per firm",
       "choice_b":"Limited to $100 per year per employee",
       "choice_c":"Limited to $100 per year per employee of another brokerage firm",
       "choice_d":"The is no limit as to the size of a gift",
       "correct_answer":"D",
       "explanation":"The limit on the gift is only on gifts to employees of other firms.There is no limit to the size of a gift that may be given outside the industry."
    },
    {
       "id":550,
       "practice_test_id":"",
       "topic_id":4,
       "question":"The maximum sales charge that may be assessed by a contractual plan company in any one year is:",
       "choice_a":"9%",
       "choice_b":"16%",
       "choice_c":"20%",
       "choice_d":"50%",
       "correct_answer":"D",
       "explanation":"The maximum sales charge that may be assessed by a contractual plan company organized under the Investment Company Act of 1940 is 50% of the first year\u0027s payments."
    },
    {
       "id":552,
       "practice_test_id":"",
       "topic_id":4,
       "question":"The FINRA Rules of Fair Practice cover:",
       "choice_a":"Discipline of members and employees for violations of FINRA rules",
       "choice_b":"Arbitration of disputes between members, employees and customers",
       "choice_c":"Fair and equitable principles of trade",
       "choice_d":"Deliveries, ex-dividends dates, due bills and other dealings between member firms",
       "correct_answer":"C",
       "explanation":"The Rules of Fair Practice cover member dealings with the public. Ethical conduct is required in all dealings with the public."
    },
    {
       "id":553,
       "practice_test_id":"",
       "topic_id":4,
       "question":"FINRA\u0027s gift rule applies to all of the following except:",
       "choice_a":"Non-cash gifts",
       "choice_b":"Cash Gratuities",
       "choice_c":"Entertainment",
       "choice_d":"Employment contracts to provide temporary services to another member",
       "correct_answer":"D",
       "explanation":"The FINRA rule regarding gifts or payments to employees of another member covers all of those things listed except contract employees of another member firm who are exempt from the gift rule."
    },
    {
       "id":554,
       "practice_test_id":"",
       "topic_id":4,
       "question":"The purchaser of a registered offering must receive a prospectus:",
       "choice_a":"At or prior to the solicitation of the sale",
       "choice_b":"No later than the time the confirmation of purchase is sent",
       "choice_c":"Within five business days",
       "choice_d":"Within seven business days",
       "correct_answer":"A",
       "explanation":"The purchaser must be given a prospectus at or before the time of the solicitation."
    },
    {
       "id":555,
       "practice_test_id":"",
       "topic_id":4,
       "question":"The responsibilities of the principal in a branch office of a securities firm include all but which of the following?",
       "choice_a":"To ensure that all of the rules in the policy and procedure manual are followed by all employees",
       "choice_b":"To write and update the policy and procedure manual for their firm",
       "choice_c":"To review and approve new accounts, advertising and sales literature, transactions, and correspondence",
       "choice_d":"To ensure professional and legal conduct by all members of the principal\u0027s firm",
       "correct_answer":"B",
       "explanation":"While the policy and procedure manual must be maintained and updated regularly, it is not one of the responsibilities of the principals to physically do this."
    },
    {
       "id":556,
       "practice_test_id":"",
       "topic_id":4,
       "question":"The Rules of Fair Practice are applicable to which of the following? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>  Partner, officers and directors </li><li> Branch managers </li><li>Registered Representatives </li><li>Traders</li></ol>",
       "choice_a":"I only",
       "choice_b":"I and II",
       "choice_c":"I, II and III",
       "choice_d":"I, II, III and IV",
       "correct_answer":"D",
       "explanation":"The Rules of Fair Practice would apply to all of the individuals listed."
    },
    {
       "id":557,
       "practice_test_id":"",
       "topic_id":4,
       "question":"The rules regarding free-riding and withholding apply to:",
       "choice_a":"All over-the-counter securities",
       "choice_b":"New issues that sell at a premium",
       "choice_c":"New issues of bonds and open-end mutual funds shares",
       "choice_d":"All NYSE listed securities",
       "correct_answer":"B",
       "explanation":"Free Riding and withholding regulations are concerned with the full and fair distribution of new issues that trade at a premium, or hot issues."
    },
    {
       "id":558,
       "practice_test_id":"",
       "topic_id":4,
       "question":"The Securities Act of 1933 is concerned with which of the following? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Primary market transactions </li><li>Disclosure </li><li>Non-exempt issuers </li><li>All issuers of securities</li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and III",
       "choice_c":"I, II, and III",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"C",
       "explanation":"The Securities Act of 1933 is not concerned with exempt issuers of securities, although no one is exempt from the anti-fraud provision of the Act."
    },
    {
       "id":559,
       "practice_test_id":1,
       "topic_id":4,
       "question":"TRY is going public and is offering 20,000,000 shares for sale at $11 each. Which of the following have to appear on the cover of the prospectus? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Number of shares </li><li>Proceeds to the company </li><li>Names of syndicate members </li><li>SEC disclaimer</li></ol>",
       "choice_a":"IV only",
       "choice_b":"I and III",
       "choice_c":"I, II, and IV",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"D",
       "explanation":"All of those listed must appear on the cover of the prospectus."
    },
    {
       "id":561,
       "practice_test_id":2,
       "topic_id":4,
       "question":"When making an investment recommendation to a customer, you, as a registered representative, must:",
       "choice_a":"Present predictions based on past performance",
       "choice_b":"Present reports of the firm\u0027s previous recommendations",
       "choice_c":"Present predictions strictly as opinion or belief, not as fact",
       "choice_d":"Present predictions based on customer\u0027s past investments",
       "correct_answer":"C",
       "explanation":"Any predictions about the performance of an investment cannot be presented as a fact, but rather must be presented as your opinion or belief."
    },
    {
       "id":562,
       "practice_test_id":3,
       "topic_id":4,
       "question":"When presenting a recommendation, a representative must avoid all of the following except:",
       "choice_a":"Making guarantees of profits or promises of no losses",
       "choice_b":"Knowingly misrepresenting any facts about the firm, the investor, or the investment",
       "choice_c":"Maintaining a joint investment account with a customer approved by the firm in advance",
       "choice_d":"Sharing in the profits or losses of an account without making any financial contributions",
       "correct_answer":"C",
       "explanation":"A representative may maintain a joint account with a customer whom the firm has approved in advance; she will share in the profits or losses only in direct relation to the amount of her contribution to the account."
    },
    {
       "id":563,
       "practice_test_id":4,
       "topic_id":4,
       "question":"Which of the following are true regarding a breakpoint sales charge reduction? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>It results in a lower POP </li><li>It is based on dollars invested </li><li>The POP does not change </li><li>They are available to corporations</li></ol>",
       "choice_a":"II and IV",
       "choice_b":"I and III",
       "choice_c":"I, II, and IV",
       "choice_d":"II, III and IV",
       "correct_answer":"C",
       "explanation":"All of the choices listed are true, except III."
    },
    {
       "id":564,
       "practice_test_id":5,
       "topic_id":4,
       "question":"Which of the following are required to register as principals with FINRA? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>  An individual soliciting orders from the public who is also a limited partner of the member firm </li><li> A manager of an office of supervisory jurisdiction  </li><li>Directors who are actively engaged in the securities business of the member firm </li><li> An assistant vice president in charge of training for the member firm</li></ol>",
       "choice_a":"I, II, III and IV",
       "choice_b":"II, III and IV",
       "choice_c":"II and III",
       "choice_d":"III and IV",
       "correct_answer":"B",
       "explanation":"The person who is a limited partner may not control the firm and therefore would not be required to register as a principal. All of the others must register as a principal, as they either supervise, train or control the firm."
    },
    {
       "id":565,
       "practice_test_id":6,
       "topic_id":4,
       "question":"Which of the following are subject to the advertising rules found under FINRA Rules of Fair Practice? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>  A seminar conducted by a registered representative that is open to customers </li><li> A principal appearing on a television program discussing investments </li><li>An oral presentation by a principal at a customer seminar </li><li> A testimonial from a non-compensates endorser</li></ol>",
       "choice_a":"I, II, III and IV",
       "choice_b":"II and III",
       "choice_c":"II, III and IV",
       "choice_d":"I, II and III",
       "correct_answer":"A",
       "explanation":"All of the situations listed would be subject to the Rules of Fair Practice."
    },
    {
       "id":566,
       "practice_test_id":"",
       "topic_id":4,
       "question":"Which of the following are true regarding a brokerage firm giving a gift to the employee of another member? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The giving member must have the permission of the employing member </li><li>It may not be based on sales </li><li> It may not be based on the promise of sales </li><li>It covers employment contracts</li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and IV",
       "choice_c":"I, II, and III",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"C",
       "explanation":"All of the choices listed are correct, except it does not cover employment contracts with another member firm."
    },
    {
       "id":567,
       "practice_test_id":"",
       "topic_id":4,
       "question":"Which of the following are true regarding form letters sent to 75 customers? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>They are considered retail communication </li><li>They must be approved in advance </li><li>They are considered institutional communication if less than 5 % of the recipients are retail investors </li><li>They are subject to file requirements</li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and IV",
       "choice_c":"I, II, and IV",
       "choice_d":"II and III",
       "correct_answer":"C",
       "explanation":"A form lettersent to more than 25 investors in 30 day period is considered retail communication if even a single retail investor may see any part of the form letter; it must be approved in advance by a principal and it is subject to file requirements."
    },
    {
       "id":568,
       "practice_test_id":"",
       "topic_id":4,
       "question":"Which of the following does FINRA considerretail communications? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Telemarketing scripts  </li><li>Text for seminars  </li><li>Market letters  </li><li>Performance reports</li></ol>",
       "choice_a":"II and III",
       "choice_b":"I and III",
       "choice_c":"III and IV",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"D",
       "explanation":"All of the items are considered retail communications if the communication is seen or sent to more than 25 retail investors in a 30 day period."
    },
    {
       "id":569,
       "practice_test_id":"",
       "topic_id":4,
       "question":"All of the following are considered retail communications, except:",
       "choice_a":"Market letter",
       "choice_b":"Research report",
       "choice_c":"Films",
       "choice_d":"A group email to 15 clients who are interested in growth funds",
       "correct_answer":"D",
       "explanation":"A group email to 15 clients who are interested in growth funds would be considered correspondence. If the email went to 25 or more clients it would be considered retail communication."
    },
    {
       "id":570,
       "practice_test_id":"",
       "topic_id":4,
       "question":"Which of the following is misleading? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Multiple hedge clauses  </li><li>Implied regulatory endorsement </li><li>Promises of free services </li><li>Using outside research</li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and IV",
       "choice_c":"I and III",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"A",
       "explanation":"Multiple hedge clauses and implied regulatory endorsement are violations and misleading. Free services must be free to everyone with no payment required."
    },
    {
       "id":571,
       "practice_test_id":"",
       "topic_id":4,
       "question":"Which of the following is not true regarding selling dividends?",
       "choice_a":"A registered representative may not use the pending dividend payment as the sole basis for recommending stock purchase",
       "choice_b":"If the investor buys shares just prior to the ex-date, he will have a portion of his investment money returned",
       "choice_c":"After the investor receives the dividend, he will still be liable for taxes on the dividend amount",
       "choice_d":"The investor who purchases the stock just prior to the record date will have a higher current yield",
       "correct_answer":"D",
       "explanation":"An investor who purchases the shares just prior to the ex-date will not have a higher current yield."
    },
    {
       "id":572,
       "practice_test_id":"",
       "topic_id":4,
       "question":"Which of the following is or are associated persons of a member firm: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> Registered representative </li><li>Trader</li><li>Director </li><li>Manager</li></ol>",
       "choice_a":"I and II",
       "choice_b":"I and III",
       "choice_c":"II and IV",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"D",
       "explanation":"All of those listed would be considered associated people, and they would be required to register."
    },
    {
       "id":573,
       "practice_test_id":"",
       "topic_id":4,
       "question":"Which of the following statements are true regarding the sales charge on a spread load contractual plan under Section 27H of the Investment Company Act of 1940? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>  The maximum sales charge cannot exceed 9% of the total amount invested </li><li> No more than 20% of any monthly payment may be applied to the sales charge </li><li>No more than an average of 16% of the first 48 payments may be applied to the sales charge</li></ol>",
       "choice_a":"I only",
       "choice_b":"II only",
       "choice_c":"I and III",
       "choice_d":"I, II, and III",
       "correct_answer":"D",
       "explanation":"All of the choices listed are correct regarding a spread load contractual plan organized under section 27H."
    },
    {
       "id":574,
       "practice_test_id":"",
       "topic_id":4,
       "question":"Which of the following would not be considered a branch office of a FINRA member firm?",
       "choice_a":"An office of the broker dealer that is engaged in investment banking only and does not conduct other business",
       "choice_b":"A residence used by a registered representative to conduct her business",
       "choice_c":"An office that is listed in a telephone directory as an office of the member firm",
       "choice_d":"An office that is supervised by an OSJ of the member",
       "correct_answer":"B",
       "explanation":"The home office of a representative would not be considered a branch office because it would not be advertised to the public as an office of the firm."
    },
    {
       "id":575,
       "practice_test_id":"",
       "topic_id":4,
       "question":"Which of the following would not be considered retail communication under FINRA Rule 2210? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Form letters sent to ten customers discussing a recommendation </li><li>A letter sent to a customer discussing their portfolio </li><li>Internal communications sent to branch offices marked \u0022not for use with the public\u0022 </li><li>Material sent to a branch office to be displayed and made available to customers</li></ol>",
       "choice_a":"I, II, and III",
       "choice_b":"II and III",
       "choice_c":"II only",
       "choice_d":"III and IV",
       "correct_answer":"A",
       "explanation":"Only the material to be displayed and made available to customers would be considered to beretail communication FINRA Rule 2210."
    },
    {
       "id":576,
       "practice_test_id":"",
       "topic_id":4,
       "question":"Why does a mutual fund make breakpoint sales charge reductions available to investors?",
       "choice_a":"To encourage investors to invest larger sums of money into a mutual fund",
       "choice_b":"To guarantee parents and their adult children greater returns when they invest in separate accounts",
       "choice_c":"To encourage investors to invest in more than one mutual fund",
       "choice_d":"To encourage personal investors only, by excluding corporations and trusts, to invest greater sums for greater returns",
       "correct_answer":"A",
       "explanation":"A mutual fund encourages investors, be they individuals, corporations, trusts, or accounts for minors, to invest larger sums of money in the same mutual fund; this increased investment benefits everyone in the process."
    },
    {
       "id":577,
       "practice_test_id":"",
       "topic_id":4,
       "question":"You are a representative for a small broker dealer and your customer wants to buy 500 shares of TGB Enterprises, which is coming public next week. Your trader calls the syndicate manager to ask if your firm can be allocated the shares. If your firm can get your customer the shares, your firm will be paid:",
       "choice_a":"Syndicate fee",
       "choice_b":"Management fee",
       "choice_c":"Additional takedown",
       "choice_d":"Selling concession",
       "correct_answer":"D",
       "explanation":"The firm will be a part of the selling group and will be paid the selling commission."
    },
    {
       "id":578,
       "practice_test_id":"",
       "topic_id":4,
       "question":"You are looking to increase your book of business and are planning to step up your marketing effort. Which of the following would not be considered retail communication?",
       "choice_a":"A research report",
       "choice_b":"Prospecting script",
       "choice_c":"Invitation to a seminar",
       "choice_d":"A letter to a customer requesting a meeting to discuss her portfolio",
       "correct_answer":"D",
       "explanation":"The letter to a particular customer asking to meet with them would not be considered retail communication. The letter would be consideredcorrespondence."
    },
    {
       "id":579,
       "practice_test_id":"",
       "topic_id":4,
       "question":"You are recommending a mutual fund to your client and have discussed the fund\u0027s holdings and performance. You have presented the prospectus to your client. The prospectus is an advertising prospectus, and provides performance data. The prospectus must disclose performance for: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>One year </li><li>Three years </li><li>Five years  </li><li>Ten years</li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and IV",
       "choice_c":"I, III, and IV",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"C",
       "explanation":"A mutual fund prospectus that offers performance data must disclose its performance for 1, 5, and 10 years."
    },
    {
       "id":580,
       "practice_test_id":"",
       "topic_id":4,
       "question":"You are the owner of a restaurant and you would like to have a guitarist play in the lounge on Saturday evenings. You have known your representative for 15 years and know her to be a great jazz guitarist. You think she would like to play and ask her if she was available to do so. She would have to get permission from which of the following before accepting your offer?",
       "choice_a":"FINRA",
       "choice_b":"NYSE",
       "choice_c":"Her firm",
       "choice_d":"No one, since it is not securities related and is on her own time",
       "correct_answer":"C",
       "explanation":"The representative would have to get permission from her employer before working outside the office in any capacity."
    },
    {
       "id":581,
       "practice_test_id":"",
       "topic_id":4,
       "question":"You have just been handed a business card by a representative, and \u0022FINRA\u0022 is in bold letters in the center of the card with the firm\u2019s name and the representative\u2019s name in the lower corner of the card along with the firm\u2019s phone and fax number. Which of the following is true?",
       "choice_a":"The card is acceptable, as it has all of the required information on it",
       "choice_b":"The card is a violation of the Rules of Fair Practice, because it implies that  FINRA has approved or endorsed the firm",
       "choice_c":"The card is a violation because it does not have SIPC on the card",
       "choice_d":"FINRA takes no position regarding business cards",
       "correct_answer":"B",
       "explanation":"The card is implying that FINRA has some how approved or endorsed the firm, and is a violation."
    },
    {
       "id":582,
       "practice_test_id":1,
       "topic_id":4,
       "question":"Your brokerage firm acts as a market maker for several high volume stocks that are quoted on the NASDAQ. What is the firm\u0027s consideration for being a market maker?",
       "choice_a":"Commission",
       "choice_b":"Fees",
       "choice_c":"Spread",
       "choice_d":"5%",
       "correct_answer":"C",
       "explanation":"Firms that act as market makers in NASDAQ securities are trying to make the spread, defined as the difference between the bid and the ask."
    },
    {
       "id":583,
       "practice_test_id":2,
       "topic_id":4,
       "question":"Your brokerage firm has placed an ad in the local newspaper advertising its new line of services being offered to investors. The firm must maintain the ad for how long?",
       "choice_a":"3 years",
       "choice_b":"2 years",
       "choice_c":"18 months",
       "choice_d":"12 months",
       "correct_answer":"A",
       "explanation":"Brokerage firms must maintain their advertising for at least three years."
    },
    {
       "id":584,
       "practice_test_id":3,
       "topic_id":4,
       "question":"Your customer has invested $7,000 in a mutual fund two months ago. She now wants to invest a significant amount of her savings in this fund. She will need some time to reach the breakpoint for a sales charge reduction and would like to include her original purchase of $7,000. Which of the following is true regarding her letter of intent?",
       "choice_a":"The letter of intent may not be backdated to include the original purchase",
       "choice_b":"Your client should make a lump sum investment to gain the maximum appreciation on her portfolio",
       "choice_c":"The letter of intent may be backdated to include the original purchase, and there will be a sales charge reduction made for the original investment only",
       "choice_d":"The letter of intent may be backdated to include the original amount to realize a reduced sales charge",
       "correct_answer":"D",
       "explanation":"The letter of intent can be backdated up to 90 days to include the original purchase."
    },
    {
       "id":586,
       "practice_test_id":4,
       "topic_id":4,
       "question":"Your customer wishes to invest $50,000 in three different mutual fund companies, with income as his main objective. You should notify your customer that if he invested the entire $50,000 with one fund company, he could save money because of the quantity discount on large purchases available through:",
       "choice_a":"Automatic reinvestment of dividends and capital gains",
       "choice_b":"The availability of a withdrawal plan",
       "choice_c":"The possibility of exchanging one fund for another without paying a sales charge",
       "choice_d":"Combination privileges and break points",
       "correct_answer":"D",
       "explanation":"A breakpoint schedule will allow an investor to pay a reduced sales charge for larger purchases. A combination privilege allows the purchase of several different portfolios to be seen as one purchase when determining a sales charge."
    },
    {
       "id":587,
       "practice_test_id":5,
       "topic_id":4,
       "question":"Your firm has just started a sales contest for the office. The representative who has the highest gross commission for the current quarter will win an all expense paid trip for two to Hawaii. Under FINRA rules this is:",
       "choice_a":"Not permitted, as it is valued over the $100 limit",
       "choice_b":"Not permitted, as it would be seen as an enticement for the representative and encourages churning",
       "choice_c":"Not permitted without approval of FINRA",
       "choice_d":"Permitted, as it is an internal sales contest",
       "correct_answer":"D",
       "explanation":"This would be permitted, as it is an internal sales contest. You may influence your own employees, just not the employees of other firms."
    },
    {
       "id":588,
       "practice_test_id":6,
       "topic_id":4,
       "question":"Which of the followingwould beconsidered to beretail communication?",
       "choice_a":"The broker dealer\u0027s intranet",
       "choice_b":"Emails to less than 25 potential customers within 30 days",
       "choice_c":"Emails to several existing customers",
       "choice_d":"Instant messages to 25 or more potential customers",
       "correct_answer":"D",
       "explanation":"The company\u0027sintranet would only be available to its employees, and emails to existing customers and to fewer than 25 potential customers is considered correspondence."
    },
    {
       "id":589,
       "practice_test_id":"",
       "topic_id":4,
       "question":"All of the following are considered correspondence except:",
       "choice_a":"A variety or emails sent to 100 existing customers in a 2 week period",
       "choice_b":"Emails to 20 potential customers",
       "choice_c":"Emails to 30 potential customers in a 3 week period",
       "choice_d":"Customized written communication with an existing customer",
       "correct_answer":"C",
       "explanation":"Correspondence is customized communication with the client. Once an email is sent to 25 customers or potential customers, it is no longer correspondence, it becomes retail communication. A variety of emails, indicates that the emails are personalized communication between the rep and the customers."
    },
    {
       "id":591,
       "practice_test_id":"",
       "topic_id":4,
       "question":"A l securities principal must approve which of the following?",
       "choice_a":"Handouts for seminars",
       "choice_b":"Emails to 35 potential customers",
       "choice_c":"Instant messages to 40 potential customers",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"The principal is required to review and approve all retail communications before fist use. All of the items listed are retail communications."
    },
    {
       "id":592,
       "practice_test_id":"",
       "topic_id":4,
       "question":"A registered rep sent an email to John Q Smith, a potential client who was referred by his client Harry Jones. The email:",
       "choice_a":"Is considered a solicitation",
       "choice_b":"Is considered a referral",
       "choice_c":"Is considered correspondence",
       "choice_d":"Requires FINRA approval",
       "correct_answer":"C",
       "explanation":"If an email is sent to fewer than 25 potential customers in a 30 day period, it is correspondence."
    },
    {
       "id":593,
       "practice_test_id":"",
       "topic_id":4,
       "question":"Copies of instant messages sent to 50 potential customers must be kept for:",
       "choice_a":"5 years",
       "choice_b":"3 years",
       "choice_c":"10 years",
       "choice_d":"The life of the firm",
       "correct_answer":"B",
       "explanation":"All electronic communication must be retained for three years."
    },
    {
       "id":594,
       "practice_test_id":"",
       "topic_id":4,
       "question":"A securities principal is responsible for approving all of the following except:",
       "choice_a":"An instant message sent by a rep to his client",
       "choice_b":"A group text send to 30 clients",
       "choice_c":"A reprint of a magazine article sent by a rep to his client",
       "choice_d":"A group email sent to 30 potential customers",
       "correct_answer":"A",
       "explanation":"A principal must approve all retail communication. The IM is the only choice listed that is not retail communication, it is correspondence."
    },
    {
       "id":595,
       "practice_test_id":"",
       "topic_id":4,
       "question":"FINRA prohibits which of the following?",
       "choice_a":"The use of excessive hedge clauses in electronic communications",
       "choice_b":"Making misleading statements in electronic communications",
       "choice_c":"Implying that FINRA endorses the broker dealer",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"FINRA rules prohibit all of the choices."
    },
    {
       "id":596,
       "practice_test_id":"",
       "topic_id":4,
       "question":"According to FINRA Conduct Rules, which of the following are considered advertisements?",
       "choice_a":"Bulletin boards",
       "choice_b":"Blogs",
       "choice_c":"Banner ads",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"The FINRA Conduct Rules state that publicly available websites, as well as blogs, banner ads and bulletin boards are considered advertising."
    },
    {
       "id":597,
       "practice_test_id":"",
       "topic_id":4,
       "question":"Password protected websites are:",
       "choice_a":"Advertising",
       "choice_b":"Retail communication",
       "choice_c":"Correspondence",
       "choice_d":"Prohibited by FINRA Conduct Rules",
       "correct_answer":"B",
       "explanation":"According to FINRA, all information displayed on a member\u0027s website, including that which is displayed in any area that is password protected, is retail communication."
    },
    {
       "id":598,
       "practice_test_id":"",
       "topic_id":4,
       "question":"As per FINRA Rule 2210, electronic communications with the public:",
       "choice_a":"Must be based on the principles of fair dealing",
       "choice_b":"Must include price predictions",
       "choice_c":"Are prohibited unless the individual is an existing client",
       "choice_d":"Must be pre-filed with FINRA 15 days prior to use",
       "correct_answer":"A",
       "explanation":"All communications with the public must be based on the principles of Fair Dealing. It is a violation of the rule to omit material information, or to give misleading information via electronic communication."
    },
    {
       "id":599,
       "practice_test_id":"",
       "topic_id":4,
       "question":"All of the following are true except:",
       "choice_a":"Emails to 25 or more potential clients must be approved by the principal prior to use",
       "choice_b":"A principal must approve a research report before it is posted on the firm\u0027s website",
       "choice_c":"All correspondence requires principal approval prior to use",
       "choice_d":"Electronic advertising requires prior principal approval",
       "correct_answer":"C",
       "explanation":"A principal must approve all retail communication prior to use, whether it is written or electronic. Correspondence must be reviewed and maintained by the firm, but does not require prior principal approval."
    },
    {
       "id":600,
       "practice_test_id":"",
       "topic_id":4,
       "question":"FINRA Rule 3110, as it relates to books and records, states all of the following except:",
       "choice_a":"If a registered rep\u0027s email is sent from home, it is not part of the firm\u0027s records",
       "choice_b":"If a registered rep\u0027s email is sent from the office, it is part of the firm\u0027s records",
       "choice_c":"If a registered rep sends an instant message from home, it is part of the firm\u0027s records",
       "choice_d":"If a registered rep sends an instant message from the office, it is part of the firm\u0027s records",
       "correct_answer":"A",
       "explanation":"Rule 3110 states that when a rep sends an electronic communication regarding the firm\u0027s business (IM or email) from any location, it becomes part of the firm\u0027s records, and must be maintained for three years."
    },
    {
       "id":601,
       "practice_test_id":"",
       "topic_id":4,
       "question":"A registered rep has created an online static blog where she writes about her thoughts on the equity market. This is an example of:",
       "choice_a":"A violation of the Rules of Fair Practice",
       "choice_b":"A violation of the Code of Procedure",
       "choice_c":"Correspondence, which is exempt from principal approval",
       "choice_d":"Retail communication, which requires principal approval",
       "correct_answer":"D",
       "explanation":"The FINRA Conduct Rules state that publicly available websites, including static blogs, are retail communication and require prior principal approval."
    },
    {
       "id":602,
       "practice_test_id":"",
       "topic_id":4,
       "question":"A registered rep makes a recommendation to a customer via email. Which of the following is/are true?",
       "choice_a":"The rep must make a reasonable effort to obtain the customer\u0027s investment objective and financial situation",
       "choice_b":"The rep must have reasonable grounds for believing the recommendation is suitable for the client",
       "choice_c":"The email would be considered correspondence",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"Regardless of how a recommendation is made to a customer, the rep must obtain suitability information from the client and then have reasonable grounds for believing the recommendation is suitable. Any email sent to an individual client is considered to be correspondence."
    },
    {
       "id":603,
       "practice_test_id":"",
       "topic_id":4,
       "question":"Member Conduct Rules state that registered reps must avoid conflicts of interest when dealing with customers. With respect to equity research reports:",
       "choice_a":"Written research reports are exempt from the conflict of interest rules",
       "choice_b":"Electronic research reports are exempt from the conflict of interest rules",
       "choice_c":"Both of the choices listed",
       "choice_d":"Neither of the choices listed",
       "correct_answer":"D",
       "explanation":"Both written and electronic research reports require that conflicts of interest be disclosed to the public."
    },
    {
       "id":604,
       "practice_test_id":"",
       "topic_id":4,
       "question":"A broker dealer\u0027s public website is:",
       "choice_a":"Retail communication",
       "choice_b":"A public appearance",
       "choice_c":"Not covered by FINRA rules",
       "choice_d":"Not covered by FINRA rules if it is password protected",
       "correct_answer":"A",
       "explanation":"A broker dealer\u0027s public and password protected website is considered to be retail communication."
    },
    {
       "id":605,
       "practice_test_id":"",
       "topic_id":4,
       "question":"Which of the following are important with respect to a broker dealer\u0027s website?",
       "choice_a":"The name of the firm should be prominently displayed",
       "choice_b":"Risk disclosure should clearly state the potential risks",
       "choice_c":"Information on the website must be updated to keep information current",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"Choices A, B and C are all important considerations when a broker dealer maintains a public website."
    },
    {
       "id":606,
       "practice_test_id":"",
       "topic_id":4,
       "question":"All of the following are examples of advertising or retail communication except:",
       "choice_a":"Blogs",
       "choice_b":"A group message to 20 clients",
       "choice_c":"Websites",
       "choice_d":"Bulletin boards",
       "correct_answer":"B",
       "explanation":"A group message to 20 clients is considered correspondence.  If the message went to 25 or more clients it would be considered retail communication."
    },
    {
       "id":607,
       "practice_test_id":2,
       "topic_id":4,
       "question":"If a broker dealer refers to its membership in FINRA on its website:",
       "choice_a":"It is required by the Conduct Rules",
       "choice_b":"The firm must provide a hyperlink to the FINRA website",
       "choice_c":"Both of the choices listed",
       "choice_d":"Neither of the choices listed",
       "correct_answer":"B",
       "explanation":"There is no requirement that a member refer to FINRA on its website. However, if the firm chooses to mention its FINRA membership, it must provide a hyperlink to FINRA\u0027s homepage that is close to the FINRA reference on the site."
    },
    {
       "id":608,
       "practice_test_id":3,
       "topic_id":4,
       "question":"The FINRA logo:",
       "choice_a":"May be used on a firm\u0027s website",
       "choice_b":"Must be approved for use by FINRA on the firm\u0027s website",
       "choice_c":"Both of the choices listed",
       "choice_d":"Neither of the choices listed",
       "correct_answer":"A",
       "explanation":"The FINRA logo may be used on the firm website so long as there is a hyperlink to FINRA\u0027s website. The logo is not required to be used and FINRA does not approve anything."
    },
    {
       "id":609,
       "practice_test_id":4,
       "topic_id":4,
       "question":"A supervisor must review all:",
       "choice_a":"Employees incoming electronic communications",
       "choice_b":"Employees outgoing communications",
       "choice_c":"Both of the choices listed",
       "choice_d":"Neither of the choices listed",
       "correct_answer":"C",
       "explanation":"All firms must have procedures in place to have a supervisor review all employees incoming and outgoing electronic communications."
    },
    {
       "id":610,
       "practice_test_id":5,
       "topic_id":4,
       "question":"Regarding electronic communications between a firm\u0027s research department and non-research departments, all of the following are true except:",
       "choice_a":"Pre-approval of FINRA is required",
       "choice_b":"Pre-approval by the principal is required for certain public communications",
       "choice_c":"Copies of the electronic communications are sent to the firm\u0027s legal department",
       "choice_d":"Copies of the electronic communications are sent to the firm\u0027s compliance department",
       "correct_answer":"A",
       "explanation":"Both the NYSE and FINRA rules require that electronic communications between the research and non-research departments be copied to the firm\u0027s legal and compliance departments."
    },
    {
       "id":611,
       "practice_test_id":6,
       "topic_id":4,
       "question":"Which of the following are true when a broker dealer receives a complaint from a customer?",
       "choice_a":"When a customer mails a complaint to the firm, it must be reported to FINRA",
       "choice_b":"When a customer faxes a complaint to the firm, it must be reported to FINRA",
       "choice_c":"When a customer emails a complaint to the firm, it must be reported to FINRA",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"All customer complaints are reported to FINRA."
    },
    {
       "id":612,
       "practice_test_id":"",
       "topic_id":4,
       "question":"If a registered rep sends a business related email to his client via his Yahoo email account, all of the following are true except:",
       "choice_a":"The communication is not required to be supervised by the firm since it was sent from outside the office",
       "choice_b":"The communication is required to be supervised by the firm",
       "choice_c":"The communication must be retained by the firm for three years",
       "choice_d":"The firm may have policies that prohibit this communication",
       "correct_answer":"A",
       "explanation":"Not all firms allow reps to send emails from their personal addresses. If the firm does not prohibit this practice, the electronic communications are to be supervised and maintained at the firm."
    },
    {
       "id":613,
       "practice_test_id":"",
       "topic_id":4,
       "question":"According to FINRA, e-faxes:",
       "choice_a":"Are not considered electronic communications",
       "choice_b":"Do not require supervision",
       "choice_c":"Both of the choices listed",
       "choice_d":"Neither of the choices listed",
       "correct_answer":"D",
       "explanation":"According to FINRA rules, e-faxes are considered to be an electronic form of communication and as such, require the appropriate supervision."
    },
    {
       "id":614,
       "practice_test_id":"",
       "topic_id":4,
       "question":"With respect to reviewing a registered rep\u0027s emails at the firm, a supervisor:",
       "choice_a":"May not delegate this responsibility",
       "choice_b":"May delegate only to Series 24 licensed principal",
       "choice_c":"Is ultimately responsible for the review",
       "choice_d":"Is required to perform this review every 30 days",
       "correct_answer":"C",
       "explanation":"Firms are required to have procedures in place for reviewing rep\u0027s emails, though not necessarily every 30 days. The review may be done by a supervisor or it may be delegated to another person with the proper knowledge, experience and training. It is not required for the reviewer to be a Series 24 principal."
    },
    {
       "id":615,
       "practice_test_id":"",
       "topic_id":4,
       "question":"Which of the following electronic communications require supervision by a principal?",
       "choice_a":"Blogs",
       "choice_b":"Group emails",
       "choice_c":"Bulletin boards",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"The principal is required to supervise all electronic communications including blogs, group emails and bulletin boards."
    },
    {
       "id":616,
       "practice_test_id":"",
       "topic_id":4,
       "question":"If a broker dealer\u0027s website requires a person to type in a password to gain access to the site, this is considered:",
       "choice_a":"Customized communications with the public",
       "choice_b":"Retail communication",
       "choice_c":"Advertising",
       "choice_d":"Prohibited, as FINRA Conduct Rules require that all broker dealer websites be public websites, and therefore can not be password protected sites.",
       "correct_answer":"B",
       "explanation":"When a website is password protected, a firm has the ability to target their audience if any retail investors have been issued login information, the content contained in that area is considered to be retail communication."
    },
    {
       "id":617,
       "practice_test_id":"",
       "topic_id":4,
       "question":"How long is a firm required to keep copies of emails sent to more than 25 people in a 30 day period?",
       "choice_a":"The firm is not required to keep copies of group emails",
       "choice_b":"5 years, readily accessible for 2 years",
       "choice_c":"3 years, readily accessible for 2 years",
       "choice_d":"10 years, readily accessible for 3 years",
       "correct_answer":"C",
       "explanation":"Copies of all retail communication needs to be kept for three years, with the most recent two years readily accessible."
    },
    {
       "id":618,
       "practice_test_id":"",
       "topic_id":4,
       "question":"Joe is a registered rep at XYZ broker dealer. According to FINRA rules, if Joe sends the same email to 15 prospective clients, which of the following is true?",
       "choice_a":"The emails are considered to be group emails",
       "choice_b":"The emails are classified as retail communication",
       "choice_c":"The emails are classified as correspondence",
       "choice_d":"The emails must be pre-approved by the compliance officer",
       "correct_answer":"C",
       "explanation":"If the same email is sent to fewer than 25 prospects, the email is still considered correspondence. Just like with letters, once the email is sent to 25 or more individuals it becomes retail communication. There is no FINRA requirement that the compliance officer pre-approve correspondence."
    },
    {
       "id":619,
       "practice_test_id":"",
       "topic_id":4,
       "question":"Electronic advertising must:",
       "choice_a":"Be approved by the principal prior to use",
       "choice_b":"Be filed with FINRA",
       "choice_c":"Both of the choices listed",
       "choice_d":"Neither of the choices listed",
       "correct_answer":"C",
       "explanation":"All advertising whether written or electronic, must be approved by the principal prior to use and filed with FINRA as part of retail communication under Rule 2210."
    },
    {
       "id":620,
       "practice_test_id":"",
       "topic_id":4,
       "question":"When a registered rep sends an instant message to a client, all of the following are true except:",
       "choice_a":"The instant message is considered correspondence",
       "choice_b":"The instant message must be maintained by the firm",
       "choice_c":"The instant message must be supervised by the firm",
       "choice_d":"The instant message may omit material facts",
       "correct_answer":"D",
       "explanation":"An instant message is an example of electronic correspondence. As with written correspondence, it may not contain any false or misleading information, or omit any material facts."
    },
    {
       "id":621,
       "practice_test_id":"",
       "topic_id":4,
       "question":"Which of the following is not considered to be retail communication?",
       "choice_a":"An email to 35 existing clients",
       "choice_b":"A marketing letter sent to 50 banks",
       "choice_c":"Password protected areas of a broker dealer\u0027s website",
       "choice_d":"An instant message to 35 potential customers",
       "correct_answer":"B",
       "explanation":"A marketing letter sent to 50 banks would not be considered retail communication as the banks are considered to be institutional investors. The marketing letter in this case is considered to be institutional communication."
    },
    {
       "id":622,
       "practice_test_id":"",
       "topic_id":4,
       "question":"All of the following areretail communication except:",
       "choice_a":"A research report",
       "choice_b":"A marketing letter",
       "choice_c":"Group email",
       "choice_d":"A blog only accessible to select institutional customers",
       "correct_answer":"D",
       "explanation":"A blog only accessible to select institutional customers would be institutional communication not retail communication."
    },
    {
       "id":623,
       "practice_test_id":"",
       "topic_id":4,
       "question":"If a registered rep enters an Internet chat room, which of the following is true?",
       "choice_a":"The rep may make exaggerated statements if he is not sending a research report to the customer",
       "choice_b":"The rep may make misleading statements to entice a prospective customer",
       "choice_c":"The rep may not reference past performance to indicate potential future results",
       "choice_d":"The rep may make unwarranted statements to entice a customer",
       "correct_answer":"C",
       "explanation":"Any post in a chat roomby the rep must adhere to FINRA\u0027s rules regarding fair practice. Therefore, no unwarranted or exaggerated claims or misleading statements are allowed. And as always, past performance is no indication of future performance."
    },
    {
       "id":624,
       "practice_test_id":"",
       "topic_id":4,
       "question":"According to FINRA rules, correspondence includes all of the following except:",
       "choice_a":"A letter sent to 10 customers with similar investment objectives",
       "choice_b":"A letter to an individual client",
       "choice_c":"50 emails to existing clients",
       "choice_d":"7 instant messages to prospective clients",
       "correct_answer":"C",
       "explanation":"Sending emails to more than 25 existing or potential clients is considered retail communication. 25 or more IMs to current or prospective clients is considered to be retail communication as well. All of the other choices are sent to less than 25 each and are correspondence"
    },
    {
       "id":625,
       "practice_test_id":"",
       "topic_id":4,
       "question":"Which of the following must be maintained by the broker dealer for three years?",
       "choice_a":"A business related email sent by the rep to his customer from his personal email address",
       "choice_b":"A business related email sent by the rep to his customer from his firm\u0027s email address",
       "choice_c":"A business related instant message sent by the rep to his customer from his personal email address",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"Whether the customer is communicating from home or office, the firm is required to maintain copies of his business related electronic communications for three years."
    },
    {
       "id":626,
       "practice_test_id":2,
       "topic_id":4,
       "question":"With regard to a broker dealer\u0027s website, all of the following are true except:",
       "choice_a":"Public websites are considered retail communication",
       "choice_b":"Research reports must be approved by the principal before being posted on the website",
       "choice_c":"Password protected websites are considered retail communication",
       "choice_d":"FINRA logos are prohibited on a broker dealer\u0027s website",
       "correct_answer":"D",
       "explanation":"Password protected websites are considered to be retail communication if access is given to individual investors. The FINRA logo may be used on the site but is not required to be displayed. A hyperlink to the FINRA website must appear in close proximity to the logo."
    },
    {
       "id":627,
       "practice_test_id":3,
       "topic_id":4,
       "question":"All of the following require prior principal approval except:",
       "choice_a":"Research reports being posted on the company\u0027s website",
       "choice_b":"An instant message sent to 15 existing customers",
       "choice_c":"An email being sent to 25 prospects in a 30 day period",
       "choice_d":"A static internet blog posted by a registered rep",
       "correct_answer":"B",
       "explanation":"Any static post on the internet requires a principal\u0027s prior approval. Items that go on the company\u0027s website must be approved as well as any posts to a registered representative\u0027s professional website used for business. Any items deemed to be retail communication must receive principal approval prior to being used. An IM to less than 25 people in a 30 day period is correspondence and does not require approval."
    },
    {
       "id":628,
       "practice_test_id":4,
       "topic_id":4,
       "question":"Which of the following need to be taken into consideration when a broker dealer maintains a website?",
       "choice_a":"The information contained must be current",
       "choice_b":"The firm\u0027s name must be prominently displayed",
       "choice_c":"Risk disclosures must be displayed appropriately",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"All of the choices are important when a broker dealer maintains a website."
    },
    {
       "id":629,
       "practice_test_id":5,
       "topic_id":4,
       "question":"All of the following are true except:",
       "choice_a":"Electronic communications referring to the reliability of a firm\u0027s electronic trading systems may not be exaggerated",
       "choice_b":"A broker dealer must update the information on its website at least annually",
       "choice_c":"Risk disclosures must be displayed on the broker dealer\u0027s website",
       "choice_d":"The broker dealer is not required to mention its FINRA membership on its website",
       "correct_answer":"B",
       "explanation":"There is no exact requirement for how often a broker dealer must update its website. However, the information contained must be \u0022current\u0022 so as not to mislead the public. Reference to FINRA membership on a member\u0027s website is not obligatory. If the firm chooses to mention its FINRA membership it must furnish a hyperlink to FINRA\u0027s homepage."
    },
    {
       "id":630,
       "practice_test_id":6,
       "topic_id":4,
       "question":"With regard to correspondence which of the following is true?",
       "choice_a":"An email to 50 potential customers is correspondence",
       "choice_b":"Each email to individual customers must be approved by the principal",
       "choice_c":"The principal may randomly select certain emails for review",
       "choice_d":"The principal need not review correspondence, only retail communication",
       "correct_answer":"C",
       "explanation":"A principal is required to review correspondence, and approve all retail communication. The same email sent to 25 or more individuals is retail communication However, due to the volume of correspondence the firm\u0027s supervisory procedures may allow them to review correspondence randomly."
    },
    {
       "id":641,
       "practice_test_id":"",
       "topic_id":4,
       "question":"The NYSE and FINRA both require a general partner, officer or principal of the member organization to:",
       "choice_a":"Supervise diligently all accounts handled by registered representatives of the organization",
       "choice_b":"Use due diligence to ensure recommendations are suitable",
       "choice_c":"Specifically approve the opening of any account prior to or promptly after the completion of any transaction for the account of a client",
       "choice_d":"Do all of the choices listed",
       "correct_answer":"D",
       "explanation":"All of the statements are true according to both NYSE and FINRA rules."
    },
    {
       "id":642,
       "practice_test_id":"",
       "topic_id":4,
       "question":"Your client asks whether he should invest in a particular investment company. You should tell him to check the investment company\u0027s: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Investment policy </li><li>Track record </li><li>Portfolio </li><li>Sales load</li></ol>",
       "choice_a":"I, II and III only",
       "choice_b":"I and IV only",
       "choice_c":"III only",
       "choice_d":"I, II, III and IV",
       "correct_answer":"D",
       "explanation":"All of these elements should be checked when assessing a fund."
    },
    {
       "id":643,
       "practice_test_id":"",
       "topic_id":4,
       "question":"Which of the following must a registered representative consider before recommending a municipal security?",
       "choice_a":"Customer\u0027s state of residence",
       "choice_b":"Customer\u0027s tax status",
       "choice_c":"Municipal security\u0027s rating",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"The customer\u0027s state of residence and tax status are essential when determining suitability of a municipal security. The security\u0027s rating is also important because it measures the safety and quality of the bond."
    },
    {
       "id":644,
       "practice_test_id":"",
       "topic_id":4,
       "question":"A 27-year-old client is in a low tax bracket and wants an aggressive long-term investment. If his rep recommends a high-rated municipal general obligation bond, the rep has:",
       "choice_a":"Violated the suitability requirements of FINRA and MSRB rules",
       "choice_b":"Recommended a suitable investment because GOs are good long-term investments",
       "choice_c":"Committed no violation because municipal bonds weather the ups and downs of the markets well committed no violation if the customer",
       "choice_d":"Offered the client away to reduce taxes",
       "correct_answer":"A",
       "explanation":"In recommending a conservative, tax-exempt investment to this customer, the representative has failed to make a suitable recommendation given the client\u0027s objectives. Municipal bonds are better suited for individuals in high tax brackets. Further, these bonds offer little upside appreciation potential."
    },
    {
       "id":645,
       "practice_test_id":"",
       "topic_id":4,
       "question":"Which of the following is (are) accurate interpretations of the FINRA\u0027s rules governing the use of retail communication? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Copies of all communications must be kept on file for three years. </li><li>All retail communication must carry written approval from a principal of the firm or designee. </li><li>All communications regardless of the type of security being promoted, must be submitted to FINRA for review within ten days of first use. </li><li>Sales and product promotion materials distributed to registered reps and other employees are considered to be the basis of retail communication and must be submitted for FINRA review even though such materials are not intended for public distribution.</li></ol>",
       "choice_a":"I only",
       "choice_b":"I and II only",
       "choice_c":"II, III and IV only",
       "choice_d":"I, II, III and IV",
       "correct_answer":"B",
       "explanation":"A broker dealer\u0027s retail communication must be approved in writing by a principal of the firm before the intended use date and must be kept on file for at least three years. Choice III is incorrect because it is phrased as a universal statement,the filing of certain communications with FINRA have other requirements . Choice IV is incorrect because materials designed for internal use (and so labeled) are not considered retail communication."
    },
    {
       "id":646,
       "practice_test_id":"",
       "topic_id":4,
       "question":"Which of the following must a rep do when making cold calls? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Immediately record the names and telephone numbers of customers who ask to not be called again </li><li>Inform the customer of the name and telephone number or address of the broker dealer </li><li>Limit calls to between the hours of 8:00 am and 9:00 pm of the time zone in which the customer is located </li><li>Do not call customers who make a do not call request</li></ol>",
       "choice_a":"I and II only",
       "choice_b":"I and IV only",
       "choice_c":"II and III only",
       "choice_d":"I, II, III and IV",
       "correct_answer":"D",
       "explanation":"The Telephone Consumer Protection Act requires that reps contact prospects between the hours of 8 a.m. and 9 p.m. in their time zone, and disclose the name, telephone number and address number of the broker-dealer. If a prospect asks not to be called again, the name and telephone number of the prospect must be forward for inclusion on the firm\u0027s Do Not Call List, and calls cannot be made by anyone from the same firm for a period of five years."
    },
    {
       "id":24742,
       "practice_test_id":2,
       "topic_id":4,
       "question":"When speaking to a client all of the following are not permissible for a registered representative to say, except:",
       "choice_a":"It think it is a good time to liquidate your oil and gas DPP and invest the proceeds into IOU stock it is going to appreciate by at least 10 points in the next few months",
       "choice_b":"If you purchase 200 shares of ABC I will make sure you get 200 share of GET enterprises, our next initial public offering",
       "choice_c":"At 35 XCV looks very attractive our research department has targeted the stock to go to 50 in the next quarter",
       "choice_d":"When thinking about an investment in a CMO, one could view it as similar to an investment in a bond or bond fund as it is designed to provide regular income",
       "correct_answer":"C",
       "explanation":"An RR may never compare a CMO to another interest bearing security. It is also a serious violation to engage in quid pro quo trading by stating that the client will get shares in an upcoming IPO if the client purchases another investment. An RR may never state that a stock WILL go up, any prediction about price must be stated as a belief and not as a fact. Of the choices listed, only the recommendation stating that there is a price target would not be a violation."
    },
    {
       "id":24746,
       "practice_test_id":3,
       "topic_id":4,
       "question":"New Growth Broker Dealers is underwriting KLM Techno, Inc. A new offering coming to market to be listed on the NASDAQ. The firm and its agents are excited about the prospects for the company. To gauge the demand for the shares, the firm would send:",
       "choice_a":"a red herring",
       "choice_b":"an offering circular",
       "choice_c":"a final prospectus",
       "choice_d":"a research report",
       "correct_answer":"A",
       "explanation":"To determine the level of interest in a new issue the firm would send out a red herring also known as a preliminary prospectus. The preliminary prospectus must be sent in hard copy."
    },
    {
       "id":20341,
       "practice_test_id":4,
       "topic_id":4,
       "question":"According to FINRA Rule 2210 communication includes all of the following: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Communication sent to retail customers  </li><li>Communication sent to institutional customers  </li><li>Written or electronic communication distributed to25 or fewer retail customers in a30 calendar day period  </li><li>Written or electronic internal memos</li></ol>",
       "choice_a":"I & II",
       "choice_b":"III & IV",
       "choice_c":"I, II & III",
       "choice_d":"I, II, III, IV",
       "correct_answer":"C",
       "explanation":"According to Rule 2210 Communication is defined as all written or electronic communication sent to retail and institutional customers; including correspondence which means any communication made to 25 or fewer retail customers in a 30 day period, but does not include a member\u0027s internal memos."
    },
    {
       "id":20342,
       "practice_test_id":5,
       "topic_id":4,
       "question":"All of the following are true regarding FINRA Rule 2210 except:",
       "choice_a":"Governments are treated as institutional investors",
       "choice_b":"High net worth individual investors are treated as institutional investors",
       "choice_c":"Registered persons of a FINRA member are treated as institutional investors",
       "choice_d":"Some employee benefit plans are treated as institutional investors",
       "correct_answer":"B",
       "explanation":"High net worth individual customers are treated as retail, not institutional investors; whereas governments, persons registered with a FINRA member and those employee benefit plans which meet IRS requirements and have at least 100 participants are treated as institutional investors."
    },
    {
       "id":20343,
       "practice_test_id":6,
       "topic_id":4,
       "question":"A broker dealer that is a FINRA member wishes to send out an electronic newsletter to 30 retail customers in a 30 day period. Which of the following statements is true?",
       "choice_a":"The communication must be approved by FINRA prior to first use",
       "choice_b":"The communication must be approved by FINRA within 10 days of first use",
       "choice_c":"The communication must be approved by a registered principal prior to first use",
       "choice_d":"The communication must be approved by a registered principal within 10 days of first use",
       "correct_answer":"C",
       "explanation":"All retail communication, whether written or electronic, must be approved by a registered principal prior to first use. FINRA requires the member to file the communication, but does not approve it."
    },
    {
       "id":20344,
       "practice_test_id":"",
       "topic_id":4,
       "question":"A FINRA member firm is exempt from filing retail communications with the Department in which of the following situations?",
       "choice_a":"if another FINRA member has already filed the communication and received confirmation that it meets all acceptable FINRA standards",
       "choice_b":"if a registered principal has approved the communication and placed a copy in the firm\u0027s internal file",
       "choice_c":"the communication is being sent to 25 or more customers in a 30 day period",
       "choice_d":"There are no exemptions. FINRA members must always file retail communications with the Department",
       "correct_answer":"A",
       "explanation":"Even if the registered principal has approved the communication the member must still file all written or electronic communications with FINRA, unless another member has already filed the same communication and received a response letter stating the communication meets the acceptable FINRA standards."
    },
    {
       "id":20345,
       "practice_test_id":"",
       "topic_id":4,
       "question":"When a member files retail communications with FINRA what is required to be kept in an internal file at the firm? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>A copy of the communication with the date it was first used  </li><li>The name of the principal who approved the communication  </li><li>The date the principal approved the communication  </li><li>The date FINRA approved the communication</li></ol>",
       "choice_a":"I, II",
       "choice_b":"I, II, III",
       "choice_c":"III, IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"B",
       "explanation":"The communication kept on file at the firm must include the name of the principal who approved the communication and the date as well as the date of first use. And though the member is required to file with FINRA, it does not approve retail communications."
    },
    {
       "id":20346,
       "practice_test_id":"",
       "topic_id":4,
       "question":"A broker dealer who has been in business 6 months must do which of the following?",
       "choice_a":"Pre-file all information regarding the firm\u0027s public website within 10 days of first use",
       "choice_b":"Pre-file all television and radio ads within 10 days of first use",
       "choice_c":"Both A and B",
       "choice_d":"Neither A nor B",
       "correct_answer":"C",
       "explanation":"During its first year of business a broker dealer is required to pre- file all retail communications with FINRA 10 days prior to first use."
    },
    {
       "id":20347,
       "practice_test_id":"",
       "topic_id":4,
       "question":"According to FINRA Rule 2210, if an established broker dealer communicates with retail customers electronically, which of the following are required to be pre-filed 10 days prior to first use?",
       "choice_a":"Retail communications regarding direct participation programs",
       "choice_b":"Retail communication regarding preferred stock",
       "choice_c":"Retail communication concerning municipal bonds",
       "choice_d":"Retail communication regarding GNMAs",
       "correct_answer":"A",
       "explanation":"Established broker dealers are normally required to post file their retail communication with FINRA. One notable exception is if the communication relates to direct participation programs."
    },
    {
       "id":20348,
       "practice_test_id":"",
       "topic_id":4,
       "question":"As it related to FINRA Rule 2210 which of the following are true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Established firms are generally required to pre-file all retail communication 10 days prior to first use </li><li>First year firms are generally required to pre-file all retail communication 10 days prior to first use  </li><li>Established firms are generally required to post file all retail communication within 10 days of first use  </li><li>First year firms are generally required to post file all retail communication within 10 days of first use</li></ol>",
       "choice_a":"I & II",
       "choice_b":"II & III",
       "choice_c":"III & IV",
       "choice_d":"I & IV",
       "correct_answer":"B",
       "explanation":"FINRA\u0027s rule on retail communication states that while established broker dealers generally post file all retail communication within 10 days of first use, first year broker dealers must pre-file 10 days prior to first use."
    },
    {
       "id":20349,
       "practice_test_id":"",
       "topic_id":4,
       "question":"Which of the following are true regarding FINRA Rule 2210? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>At FINRA\u0027s discretion, members may be subject to a spot check of their written and electronic communication  </li><li>A company\u0027s prospectus is exempt from FINRA filing  </li><li>If an established member deviates from acceptable standards FINRA can require that firm to pre-file future retail communications  </li><li>Copies of all retail communications must be kept by the broker dealer  for 3 years</li></ol>",
       "choice_a":"I & III",
       "choice_b":"II & IV",
       "choice_c":"II, III, IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"D",
       "explanation":"All of the above statements are true with respect to Rule 2210."
    },
    {
       "id":20350,
       "practice_test_id":"",
       "topic_id":4,
       "question":"All of the following are prohibited in a member\u0027s written communication with the public except:",
       "choice_a":"\u0022FINRA Endorsed\u0022",
       "choice_b":"\u0022FINRA Guaranteed",
       "choice_c":"\u0022FINRA Approved\u0022",
       "choice_d":"\u0022FINRA Reviewed\u0022",
       "correct_answer":"D",
       "explanation":"The securities regulators do not endorse, guarantee or approve members, securities or sales practices. Therefore a member cannot state that in any communication they have with the customers. A firm may, however, use the phrase \u0022FINRA Reviewed\u0022 in its customer  communications."
    },
    {
       "id":20351,
       "practice_test_id":"",
       "topic_id":4,
       "question":"If a FINRA member wishes to include a recommendation in its customer communication, which of the following are true?",
       "choice_a":"The firm must have a reasonable basis for making the recommendation",
       "choice_b":"The firm must disclose if they are a market maker in the security they are recommending",
       "choice_c":"The firm must disclose if they have been a manager or co-manager in any of the issuers public securities offerings in the prior 12 months",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"The firm must have a reasonable basis for making the recommendation and mustalso disclose any information that could be construed as a possible conflict of interest."
    },
    {
       "id":20352,
       "practice_test_id":"",
       "topic_id":4,
       "question":"Which of the folloing must be pre-fileed with FINRA: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>A bond advertisement for a highly volatile issue of bonds </li><li>An advertisement for an issue of preferred stock posted in a chatroom </li><li>A mutual fund advertisement created by the investment company </li><li>An advertisement placed in a national newspaper announcing a broker dealer\u2019s opening of a new branch office</li></ol>",
       "choice_a":"I & II",
       "choice_b":"I & III",
       "choice_c":"II, III, IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"B",
       "explanation":"An advertisement for a highly volatile securities future or bond issue, as well as investment company ads created by the investment company, must be pre-filed with FINRA 10 days prior to first use. Communications that are posted in a chat room and those that do not make any financial recommendations are not required to be either pre or post-filed with FINRA."
    },
    {
       "id":20353,
       "practice_test_id":2,
       "topic_id":4,
       "question":"According to FINRA Rule 2210, copies of all institutional communications must be kept by the broker dealer for a minimum of how long?",
       "choice_a":"1 year",
       "choice_b":"2 years",
       "choice_c":"3 years",
       "choice_d":"5 years",
       "correct_answer":"C",
       "explanation":"Copies of all institutional communications must be retained by the broker dealer for 3 years."
    },
    {
       "id":20354,
       "practice_test_id":3,
       "topic_id":4,
       "question":"According to FINRA Rule 2210, copies of al retailcommunication must be kept by the broker dealer for a minimum of how long?",
       "choice_a":"1 year",
       "choice_b":"2 years",
       "choice_c":"3 years",
       "choice_d":"5 years",
       "correct_answer":"C",
       "explanation":"Copies of all retail communications must be retained by the broker dealer for 3 years."
    },
    {
       "id":20355,
       "practice_test_id":4,
       "topic_id":4,
       "question":"All of the following are considered institutional investors under FINRA Rule 2210 except:",
       "choice_a":"An investment advisor with $30 million in total assets",
       "choice_b":"An individual with $40 million in total assets",
       "choice_c":"A government entity",
       "choice_d":"An insurance company with $75 million in total assets",
       "correct_answer":"B",
       "explanation":"Investment advisors, government entities, insurance companies, banks and S\u0026Ls and employee benefit plans with at least 100 participants are automatically considered institutional investors under the Rule. However, an individual person must have at least $50 million in total assets to qualify as such."
    },
    {
       "id":20356,
       "practice_test_id":5,
       "topic_id":4,
       "question":"Joe Smith, a registered representative of DCH, Inc. a registered broker dealer, will be making a public appearance next week. In his speech he will be making a recommendation of TRF common stock. What information must Joe disclose?",
       "choice_a":"If there is any conflict of interest in making the public appearance",
       "choice_b":"Whether Joe has a long or short position in the stock",
       "choice_c":"Whether Joe owns rights or warrants on the stock",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"Any time an associated person makes a public appearance he must disclose if there is a potential conflict of interest. This includes disclosing if the person has any financial interest in the security he is recommending."
    },
    {
       "id":20357,
       "practice_test_id":6,
       "topic_id":4,
       "question":"When making a public appearance, members must file which of the following with FINRA? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Any power point slides that will be used in the presentation </li><li>All handouts that will be distributed to the participants  </li><li>The script that the presenter will be using</li></ol>",
       "choice_a":"III only",
       "choice_b":"I & II",
       "choice_c":"II & III",
       "choice_d":"I, II, III",
       "correct_answer":"D",
       "explanation":"According to FINRA Rule 2210, when a member is making a public appearance any script, slides or handouts are treated as retail communication and must be filed with FINRA."
    },
    {
       "id":20358,
       "practice_test_id":"",
       "topic_id":4,
       "question":"When an established broker dealer wishes to place a recruitment ad in a local newspaper all of the following are true except:",
       "choice_a":"The ad does not have to state the name of the firm",
       "choice_b":"The ad does not need principal approval",
       "choice_c":"The ad cannot contain exaggerated claims",
       "choice_d":"The ad is considered retail communication",
       "correct_answer":"B",
       "explanation":"A recruitment ad is treated as retail communication by FINRA. Therefore, it must be approved by a licensed principal. And although member\u0027s may place a blind recruitment ad (without the firm\u0027s name on it), the ad cannot make any exaggerated claims about opportunities in the securities business."
    },
    {
       "id":20359,
       "practice_test_id":"",
       "topic_id":4,
       "question":"XYZ broker dealer, a first year broker dealer, has decided to create a website for the firm. When adding content to the site which of the following is/are true:",
       "choice_a":"electronic communication must follow the same filing rules as written communication",
       "choice_b":"Content must be pre-filed with FINRA 10 days prior to first use",
       "choice_c":"neither a nor b",
       "choice_d":"both a and b",
       "correct_answer":"D",
       "explanation":"Electronic communication is treated in exactly the same manner as written communication. Therefore, the content on the website must be approved by the principal and the firm is required to file the information with FINRA."
    },
    {
       "id":20360,
       "practice_test_id":"",
       "topic_id":4,
       "question":"Advertisements for municipal bonds must be approved by which of the following entities?",
       "choice_a":"FINRA",
       "choice_b":"The MSRB",
       "choice_c":"The firm\u0027s licensed principal",
       "choice_d":"No approval is necessary for municipal bond advertisements",
       "correct_answer":"C",
       "explanation":"All communication with the public must be approved by a licensed principal. FINRA and the MSRB do not approve advertising, though members are subject to the regulator\u0027s filing requirements."
    },
    {
       "id":21073,
       "practice_test_id":"",
       "topic_id":4,
       "question":"When reviewing content to be disseminated by the broker dealer or by a registered representative concerning business activities, which of the following determine the classification for the communication?",
       "choice_a":"The content and the number and type of recipients",
       "choice_b":"How the content was delivered",
       "choice_c":"If the content is required to be filed with FINRA",
       "choice_d":"If the content requires principal approval",
       "correct_answer":"A",
       "explanation":"When reviewing content to be disseminated by the broker dealer or by a registered representative concerning business activities the content and the number and type of recipients will be the determining factor in classifying the communication. There is no difference between electronic or written forms of distribution."
    },
    {
       "id":21080,
       "practice_test_id":"",
       "topic_id":4,
       "question":"Your client is looking at various options for purchasing a variable annuity your firm has recommended to her. Which of the following would be considered abusive sales practices under FINRA guidelines? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Suggesting she take a home equity loan on the home she owns which is fully paid for </li><li>Suggesting she withdraw the money from a variable life insurance police she purchased 3 years ago </li><li>Suggesting she convert the funds from an another annuity with less features she established 2 years ago </li><li>Suggesting she convert the funds from a negotiable CD with 1 year remaining until maturity</li></ol>",
       "choice_a":"I only",
       "choice_b":"II and II",
       "choice_c":"I, II, and III",
       "choice_d":"I, II, III, IV",
       "correct_answer":"C",
       "explanation":"It is never appropriate to recommend that an investor use the equity in a home to invest. Recommending that the investor convert funds from another variable contract established in the last few years would most likely subject the investor to significant surrender charges and would not be suitable. Both of these practices have been identified as being abusive sales practices by FINRA. Since the CD is negotiable it can be sold in the market without subjecting the investor to surrender charges or penalties. Using the proceeds from the sale would not be abusive."
    },
    {
       "id":24773,
       "practice_test_id":"",
       "topic_id":4,
       "question":"A wholesaler picks up an FA at her office and takes her to a very exclusive country club for a round of golf and lunch. The wholesaler is a member of the club and the club is not open to the public. Which of the following is true?",
       "choice_a":"This would be allowed as it is entertainment",
       "choice_b":"This would not be allowed as the club is not open to the public",
       "choice_c":"This would not be allowed as the round of golf and lunch would likely exceed the $100 gift limit",
       "choice_d":"This would be allowed if the principal of the FA\u0027s firm approved it",
       "correct_answer":"A",
       "explanation":"This indeed would be allowed as entertainment. The wholesaler is attending the golf outing and lunch. The key is that it cannot be too frequent and the party attends with the FA."
    },
    {
       "id":24774,
       "practice_test_id":"",
       "topic_id":4,
       "question":"An FA goes out to lunch with a wholesaler and the wholesaler provides the FA with sales literature relating to her fund. The FA returns to the office and wants to recommend the fund to one of his clients. Which of the following is true?",
       "choice_a":"The branch manager must approve the fund",
       "choice_b":"The FA must send a prospectus with the literature",
       "choice_c":"The branch manager must file the literature with FINRA within 10 days",
       "choice_d":"The FA may only recommend the fund if the fund is on the firm\u0027s preferred list",
       "correct_answer":"B",
       "explanation":"IF the FA wanted to send the sales literature relating to the fund to a prospective investor the FA would have to send a prospectus to the potential investor at the same time."
    },
    {
       "id":292,
       "practice_test_id":"",
       "topic_id":5,
       "question":"An individual owns a variable life insurance policy with an assumed interest rate of 5%. The separate account earns 4%; the individual would expect: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The death benefit to go up </li><li>The death benefit to go down </li><li>The cash value to go up </li><li>The cash value to go down</li></ol>",
       "choice_a":"II and IV",
       "choice_b":"I and III",
       "choice_c":"I and II",
       "choice_d":"II and III",
       "correct_answer":"D",
       "explanation":"The individual would expect the death benefit to go down and the cash value to go up. The AIR is only concerned about the death benefit, not with the cash value. As long as the performance of the separate account is positive, the cash value goes up."
    },
    {
       "id":293,
       "practice_test_id":"",
       "topic_id":5,
       "question":"An individual who cancels his variable life policy during the free look period will receive:",
       "choice_a":"Cash value only",
       "choice_b":"Cash value, plus any sales charges in excess of 10% of the payments",
       "choice_c":"Refund of all premiums",
       "choice_d":"Refund of premiums minus sales charges",
       "correct_answer":"C",
       "explanation":"An individual who cancels his policy during the free look period will receive a refund of all premiums paid."
    },
    {
       "id":294,
       "practice_test_id":"",
       "topic_id":5,
       "question":"An individual who cancels her variable life policy during the free look period will receive:",
       "choice_a":"Cash value only",
       "choice_b":"Cash value, plus a refund of any sales charges in excess of 10 % of the payments",
       "choice_c":"Refund of all premiums",
       "choice_d":"Refund of premiums minus any sales charges",
       "correct_answer":"C",
       "explanation":"An individual who cancels her policy during the free look period will receive a refund of all premiums paid."
    },
    {
       "id":295,
       "practice_test_id":"",
       "topic_id":5,
       "question":"An investment company has an NAV of $8 and is $7 offered. The cost to a customer would be:",
       "choice_a":"$7",
       "choice_b":"$7 + commission",
       "choice_c":"$8",
       "choice_d":"$8 + commission",
       "correct_answer":"B",
       "explanation":"This fund has to be a closed-end fund because the offer is lower than the NAV. The investor would pay $7 plus commission."
    },
    {
       "id":296,
       "practice_test_id":1,
       "topic_id":5,
       "question":"An investment company may do all of the following except:",
       "choice_a":"Borrow money to redeem shares",
       "choice_b":"Lend money to earn a profit",
       "choice_c":"Operate with fewer than 100 shareholders",
       "choice_d":"Operate with fewer than 100 accredited investors",
       "correct_answer":"C",
       "explanation":"An investment company needs 100 shareholders to start and continue. There is no requirement for accredited investors."
    },
    {
       "id":297,
       "practice_test_id":2,
       "topic_id":5,
       "question":"An investment company that invests in a portfolio of bonds and holds them until maturity is most likely:",
       "choice_a":"A long term bond fund",
       "choice_b":"A contractual plan",
       "choice_c":"A face amount certificate",
       "choice_d":"A UIT",
       "correct_answer":"D",
       "explanation":"An investment company that invests in a fixed portfolio of bonds and holds them until maturity is most likely a fixed UIT."
    },
    {
       "id":298,
       "practice_test_id":3,
       "topic_id":5,
       "question":"An investment company that is not a unit investment trust or a face-amount certificate company would be a:",
       "choice_a":"Mutual fund",
       "choice_b":"Management company",
       "choice_c":"Open-end company",
       "choice_d":"Closed-end company",
       "correct_answer":"B",
       "explanation":"A management company is the formal name for either an open-end or closed-end fund."
    },
    {
       "id":299,
       "practice_test_id":4,
       "topic_id":5,
       "question":"An investment company:",
       "choice_a":"Is organized either as a corporation or a trust",
       "choice_b":"Pools investor\u0027s money into a single account, which they invest for the greatest return",
       "choice_c":"Offer individual investors the opportunity to have their money managed by professionals",
       "choice_d":"All of the choices listed are correct",
       "correct_answer":"D",
       "explanation":"An investment company does all of the choices listed for the benefit of the individual investor."
    },
    {
       "id":300,
       "practice_test_id":5,
       "topic_id":5,
       "question":"An investment company\u0027s registration statement must:",
       "choice_a":"Be filed before any offering becomes effective",
       "choice_b":"Contain detailed information on the officers and directors of the company",
       "choice_c":"Contain plans for borrowing, investing, and areas of concentration, if any",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"The registration statement must contain all of the choices listed."
    },
    {
       "id":301,
       "practice_test_id":6,
       "topic_id":5,
       "question":"An investor buying an immediate annuity buys:",
       "choice_a":"Accumulation units that are fixed in number",
       "choice_b":"Annuity units that are fixed in number",
       "choice_c":"Accumulation units that vary in number",
       "choice_d":"Annuity units that vary in number",
       "correct_answer":"B",
       "explanation":"An investor who purchases an immediate annuity buys annuity units that remain fixed in number."
    },
    {
       "id":302,
       "practice_test_id":"",
       "topic_id":5,
       "question":"An investor has annuitized her variable annuity. Which of the following are true?         <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Accumulation units have been exchanged for annuity units </li><li>Annuity units have been exchanged for accumulation units </li><li>The number of accumulation units is fixed </li><li>The number of annuity units is fixed</li></ol>",
       "choice_a":"II and III",
       "choice_b":"I and IV",
       "choice_c":"II and IV",
       "choice_d":"I and III",
       "correct_answer":"B",
       "explanation":"When an investor annuitizes a contract, they trade in their accumulation units for annuity units, and the number of annuity units remains fixed."
    },
    {
       "id":303,
       "practice_test_id":"",
       "topic_id":5,
       "question":"An investor has been dollar cost averaging into a growth fund. The following are his contributions to date: <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li>Jan $500 at $50 per share </li><li>Feb $500 at $25 per share </li><li>Mar $500 at $10 per share </li><li>Apr $500 at $20 per share</li></ol>What is his average cost?",
       "choice_a":22.09,
       "choice_b":25,
       "choice_c":19.05,
       "choice_d":24.6,
       "correct_answer":"C",
       "explanation":"First you must determine how many shares the investor purchased with each $500 investment. To do this you must divide $500 by the share price for each of the four investments and add them together to get 105 shares. To find the average cost, take the total dollars invested and divide by the number of shares: 2000/105 = 19.046 or 19.05."
    },
    {
       "id":304,
       "practice_test_id":"",
       "topic_id":5,
       "question":"An investor has been dollar cost averaging into a mutual fund account for 24 months. The mutual fund shares have been consistently rising over the last two years. The investor will notice that:",
       "choice_a":"They have purchased more shares as the price has increased",
       "choice_b":"They have purchased the same number of shares",
       "choice_c":"They have purchased less shares as the price has increased",
       "choice_d":"They are losing money as their average price increases",
       "correct_answer":"C",
       "explanation":"The investor will notice that they have purchased fewer shares as the price of the mutual fund share has increased."
    },
    {
       "id":305,
       "practice_test_id":"",
       "topic_id":5,
       "question":"An investor has chosen to receive the capital gains and dividend distributions from a mutual fund portfolio. Which of the following is true?",
       "choice_a":"Their tax liability has gone up because they have received the distributions",
       "choice_b":"Their capital gains rate is higher than it would have been if they re-invested the distributions",
       "choice_c":"Their proportional ownership of the fund has gone down",
       "choice_d":"Their proportional ownership of the fund has remained constant",
       "correct_answer":"C",
       "explanation":"A mutual fund investor\u0027s proportional ownership of the portfolio will decrease when they elect to receive distributions instead of reinvesting them."
    },
    {
       "id":307,
       "practice_test_id":"",
       "topic_id":5,
       "question":"An investor in a UIT will receive what as their evidence of ownership in the UIT?",
       "choice_a":"Trust certificates",
       "choice_b":"Shares of beneficial interest",
       "choice_c":"Exchangeable share",
       "choice_d":"Units of ownership",
       "correct_answer":"B",
       "explanation":"Investors who purchase a UIT will receive shares of beneficial ownership."
    },
    {
       "id":308,
       "practice_test_id":"",
       "topic_id":5,
       "question":"An investor in a variable annuity may change their payout option:",
       "choice_a":"Under no circumstances",
       "choice_b":"If their financial needs change significantly",
       "choice_c":"To convert to a lump sum withdrawal",
       "choice_d":"Upon the death of a spouse for joint with last survivor",
       "correct_answer":"A",
       "explanation":"An investor may never change their payout option once it has been set."
    },
    {
       "id":309,
       "practice_test_id":"",
       "topic_id":5,
       "question":"An investor in the XYZ high growth fund could best be described as:",
       "choice_a":"A creditor of XYZ",
       "choice_b":"A stockholder in XYZ",
       "choice_c":"An owner of XYZ",
       "choice_d":"A shareholder with an undivided interest in the fund",
       "correct_answer":"D",
       "explanation":"Any investor in a mutual fund is a shareholder in that fund or portfolio only."
    },
    {
       "id":310,
       "practice_test_id":"",
       "topic_id":5,
       "question":"An investor purchasing an investment company is told the price is \u0022market plus commission\u0022. He would be purchasing:",
       "choice_a":"An open-end investment company",
       "choice_b":"A closed-end investment company",
       "choice_c":"A fund with redeemable shares outstanding",
       "choice_d":"An open-end diversified common stock fund",
       "correct_answer":"B",
       "explanation":"An investor who purchases a closed-end fund will pay the market price plus a commission to execute the order."
    },
    {
       "id":311,
       "practice_test_id":"",
       "topic_id":5,
       "question":"An investor that wires money into their mutual fund account at 10:00 AM on the record date:",
       "choice_a":"Will not receive the dividend",
       "choice_b":"Will receive the dividend",
       "choice_c":"Will only receive the dividend if it\u0027s based on bond interest payments",
       "choice_d":"Will only receive the dividend if it\u0027s based upon common dividends",
       "correct_answer":"B",
       "explanation":"An investor who purchases an open-end mutual fund share on the record date will receive the dividend."
    },
    {
       "id":312,
       "practice_test_id":"",
       "topic_id":5,
       "question":"An investor who owns a fixed annuity is subject to:",
       "choice_a":"Expense risk",
       "choice_b":"Investment risk",
       "choice_c":"Purchasing power risk",
       "choice_d":"Mortality risk",
       "correct_answer":"C",
       "explanation":"An investor who purchases a fixed annuity is subject to purchasing power risk."
    },
    {
       "id":313,
       "practice_test_id":"",
       "topic_id":5,
       "question":"An investor who purchases an annuity is known as:",
       "choice_a":"Annuitized",
       "choice_b":"Annuitant",
       "choice_c":"Annuitor",
       "choice_d":"Annuitee",
       "correct_answer":"B",
       "explanation":"An investor who purchases an annuity is known as the annuitant."
    },
    {
       "id":314,
       "practice_test_id":"",
       "topic_id":5,
       "question":"An investor wires $10,000 into his mutual fund on Tuesday March 11 and the money is credited to his account at 3PM. He will be the owner of record:",
       "choice_a":"Friday, March 14th",
       "choice_b":"Wednesday, March 12th",
       "choice_c":"Tuesday, March 11th",
       "choice_d":"Tuesday, March 18th",
       "correct_answer":"C",
       "explanation":"New shares will be created for the investor as soon as the mutual fund company calculates the NAV. The investor becomes an owner of record on that day."
    },
    {
       "id":315,
       "practice_test_id":"",
       "topic_id":5,
       "question":"An investor with $20,000 invested in the XYZ growth fund is:",
       "choice_a":"A stockholder in XYZ",
       "choice_b":"An owner of XYZ",
       "choice_c":"An owner of an undivided interest in the XYZ growth portfolio",
       "choice_d":"Both an owner of XYZ and an owner of an undivided interest in the XYZ growth portfolio",
       "correct_answer":"C",
       "explanation":"An investor in a mutual fund portfolio has an undivided interest in that portfolio and is not an investor or stockholder in the fund company itself."
    },
    {
       "id":316,
       "practice_test_id":"",
       "topic_id":5,
       "question":"An open-end mutual fund may charge 8.5% of the POP if:",
       "choice_a":"They offer breakpoint sales charge reductions; the more money invested, the lower the sales charge",
       "choice_b":"They offer rights of accumulation reductions; the more subsequent investments by one investor, the lower the sales charge based on the value of the investor\u0027s account",
       "choice_c":"They offer automatic reinvestment of dividends and capital gains of the NAV",
       "choice_d":"They offer all of the choices listed",
       "correct_answer":"D",
       "explanation":"An open-end mutual fund may charge 8.5% of the POP, if, and only if, they offer all of the choices listed reductions."
    },
    {
       "id":317,
       "practice_test_id":"",
       "topic_id":5,
       "question":"An open-end mutual fund share goes ex-dividend:",
       "choice_a":"2 business days prior to the record date",
       "choice_b":"1 business day prior to the record date",
       "choice_c":"1 business day after the record date",
       "choice_d":"As stated in the prospectus",
       "correct_answer":"C",
       "explanation":"An open-end mutual fund share goes ex-dividend one business day after the record date."
    },
    {
       "id":318,
       "practice_test_id":"",
       "topic_id":5,
       "question":"An open-end investment company must calculate its net asset value:",
       "choice_a":"Daily as of 12:00 noon",
       "choice_b":"Daily as of the close of the New York Stock Exchange",
       "choice_c":"Twice daily, as of 12:00 noon and the close of the New York Stock Exchange",
       "choice_d":"As stated in the prospectus",
       "correct_answer":"D",
       "explanation":"All mutual funds must calculate their NAV as stated in the prospectus."
    },
    {
       "id":319,
       "practice_test_id":"",
       "topic_id":5,
       "question":"An open-end mutual fund has how long to forward proceeds to a customer who has requested redemption?",
       "choice_a":"5 business days",
       "choice_b":"5 calendar days",
       "choice_c":"7 business days",
       "choice_d":"7 calendar days",
       "correct_answer":"D",
       "explanation":"A customer\u0027s redemption request must be honored and the fund company must forward the proceeds to the investor within 7 calendar days."
    },
    {
       "id":320,
       "practice_test_id":"",
       "topic_id":5,
       "question":"An open-end mutual fund has the following:<img src='/question_assets/series6/320.png'></img> If the fund wants to retain its status as a regulated investment company under sub-chapter M, it must send out to its shareholders at least?",
       "choice_a":"$42,133,000",
       "choice_b":"$34,983,000",
       "choice_c":"$38,870,000",
       "choice_d":"$51,270,000",
       "correct_answer":"B",
       "explanation":"A mutual fund must send out 90% of its net investment income to shareholders in order to retain its tax advantages. Net investment income = dividend income + interest income – expenses, or 22,450,000 + 21,670,000-5,250,000=38,870,000 X 90% = 34,983,000."
    },
    {
       "id":321,
       "practice_test_id":"",
       "topic_id":5,
       "question":"As an investor in an open-end mutual fund, you have the right to vote on all of the following except:",
       "choice_a":"Recapitalization",
       "choice_b":"Election of the Board of Directors",
       "choice_c":"Termination of 12b-1 fee",
       "choice_d":"Changes in the portfolio to reflect market conditions",
       "correct_answer":"D",
       "explanation":"As an investor in an open-end mutual fund, you can vote for all of the things listed except changes in the portfolio."
    },
    {
       "id":322,
       "practice_test_id":"",
       "topic_id":5,
       "question":"As it relates to an open-end investment company, which of the following are true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li> Shares are priced by formula </li><li>They issue redeemable securities </li><li>Shareholders have pre-emptive rights </li><li>Shareholders purchase shares based on a forward pricing method</li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and III",
       "choice_c":"II, III, and IV",
       "choice_d":"I, II, and IV",
       "correct_answer":"D",
       "explanation":"All of the choices listed are features of an open-end investment company, except shareholders do not have preemptive rights."
    },
    {
       "id":323,
       "practice_test_id":1,
       "topic_id":5,
       "question":"As it relates to life insurance, all of the following are deducted from the separate account except:",
       "choice_a":"Mortality risk fee",
       "choice_b":"Expense risk fee",
       "choice_c":"Administrative fee",
       "choice_d":"Investment management fee",
       "correct_answer":"C",
       "explanation":"The administrative fee is a one time fee to set up the policy, and is deducted from the gross premium."
    },
    {
       "id":324,
       "practice_test_id":2,
       "topic_id":5,
       "question":"Generally the minimum investment for a contractual plan is:",
       "choice_a":"$10 per month",
       "choice_b":"$50 per month",
       "choice_c":"$75 per month",
       "choice_d":"$20 per month",
       "correct_answer":"D",
       "explanation":"The minimum monthly investment for most contractual plans is $20 per month."
    },
    {
       "id":325,
       "practice_test_id":3,
       "topic_id":5,
       "question":"How does a no-load fund differ from a usual mutual fund?",
       "choice_a":"No-load funds charge a smaller sales charge",
       "choice_b":"No-load funds charge no sales charge",
       "choice_c":"No-load funds may sell shares only to selling group members",
       "choice_d":"Underwriters sell no-load funds at a discount from the POP",
       "correct_answer":"B",
       "explanation":"No-load funds do not charge a sales charge to investors who may buy directly from the mutual fund."
    },
    {
       "id":326,
       "practice_test_id":4,
       "topic_id":5,
       "question":"If an investor wants to purchase an annuity by making regularly scheduled payments into the contract, he should invest in which of the following types of annuities?",
       "choice_a":"Single payment deferred annuity",
       "choice_b":"Multiple payment periodic annuity",
       "choice_c":"Regular payment immediate annuity",
       "choice_d":"Periodic payment deferred annuity",
       "correct_answer":"D",
       "explanation":"A periodic payment deferred annuity allows an investor to make regularly scheduled payments into a contract annuity which has a deferred payout time."
    },
    {
       "id":327,
       "practice_test_id":5,
       "topic_id":5,
       "question":"In order for an investment company to change its investment objectives, approval must be obtained from:",
       "choice_a":"FINRA",
       "choice_b":"The SEC",
       "choice_c":"A majority vote of the outstanding shares",
       "choice_d":"All of the choices listed",
       "correct_answer":"C",
       "explanation":"In order for an investment company to change its investment objective, it must be approved by a majority of the outstanding shares."
    },
    {
       "id":328,
       "practice_test_id":6,
       "topic_id":5,
       "question":"In order to issue shares to the public, an investment company must have a minimum net worth of:",
       "choice_a":"$25,000",
       "choice_b":"$50,000",
       "choice_c":"$100,000",
       "choice_d":"$250,000",
       "correct_answer":"C",
       "explanation":"An investment company must have a net worth of $100,000 to start and continue."
    },
    {
       "id":329,
       "practice_test_id":"",
       "topic_id":5,
       "question":"In order to make a public offering, an investment company must have a minimum net worth of:",
       "choice_a":"$300,000",
       "choice_b":"$100,000",
       "choice_c":"$50,000",
       "choice_d":"$25,000",
       "correct_answer":"B",
       "explanation":"An investment company must have a minimum net worth of $100,000 to start and continue."
    },
    {
       "id":330,
       "practice_test_id":"",
       "topic_id":5,
       "question":"In order to register with the SEC, an investment company must have all of the following except:",
       "choice_a":"100 accredited investors",
       "choice_b":"Minimum net worth of $100,000",
       "choice_c":"Clearly defined investment objectives",
       "choice_d":"At least 100 shareholders",
       "correct_answer":"A",
       "explanation":"In order to register an investment company with the SEC, the investment does not need 100 accredited investors."
    },
    {
       "id":331,
       "practice_test_id":"",
       "topic_id":5,
       "question":"In order to start and continue an investment company, it must have at least:",
       "choice_a":"1,000 shareholders",
       "choice_b":"100 shareholders",
       "choice_c":"10 shareholders",
       "choice_d":"90 shareholders",
       "correct_answer":"B",
       "explanation":"An investment company must have at least 100 shareholders to start and to continue."
    },
    {
       "id":332,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Insurance companies deduct a fee from the separate account of an annuity to cover the risk involved in issuing these annuity contracts; which is not one of the risks involved?",
       "choice_a":"Operating expense risk",
       "choice_b":"Sales risk",
       "choice_c":"Mortality risk",
       "choice_d":"Unexpected rise in the cost of doing business risk",
       "correct_answer":"B",
       "explanation":"There is no such thing as a sales risk involved in issuing annuities."
    },
    {
       "id":333,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Investment companies are required to report to shareholders:",
       "choice_a":"Monthly",
       "choice_b":"Semi-annually",
       "choice_c":"Annually",
       "choice_d":"No reports are required",
       "correct_answer":"B",
       "explanation":"Investment companies must send reports to shareholders an annual audited report plus an unaudited semi-annual update."
    },
    {
       "id":334,
       "practice_test_id":"",
       "topic_id":5,
       "question":"List the following in order first to last for a closed end fund:  <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Ex date </li><li>Payable date </li><li> Declaration date </li><li>Record date</li></ol>",
       "choice_a":"III, II, I, IV",
       "choice_b":"III, I, IV, II",
       "choice_c":"II, I, IV, III",
       "choice_d":"III, IV, II, I",
       "correct_answer":"B",
       "explanation":"The dividend process goes declaration date, ex-date, record date, and payment date."
    },
    {
       "id":335,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Many large mutual fund companies offer the following privileges to their investors except:",
       "choice_a":"Combination privileges",
       "choice_b":"Conversion and exchange privileges",
       "choice_c":"30-Day emergency withdrawal",
       "choice_d":"The right to exchange personal shares owned for mutual fund shares",
       "correct_answer":"D",
       "explanation":"An investor may not exchange other securities for shares of a mutual fund."
    },
    {
       "id":336,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Most mutual funds do not sell their shares directly to investors; this selling is the responsibility of the:",
       "choice_a":"Broker dealer",
       "choice_b":"Investment advisor",
       "choice_c":"The underwriter",
       "choice_d":"The selling agent",
       "correct_answer":"C",
       "explanation":"The underwriter, also known as the sponsor or the distributor, is responsible for selling mutual fund shares."
    },
    {
       "id":337,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Mutual funds, classified as a conduit of investment income, are taxed in the following way:",
       "choice_a":"They are not taxed on their income distributed to investors, as long as the fund distributes at least 90% of its net investment income",
       "choice_b":"They are taxed on the first 90% of their net investment income, but they are tax free on the last 10%",
       "choice_c":"They are taxed every month on the net investment income at a rate of 10%",
       "choice_d":"They pay no taxes since they are only a conduit and not earning income for themselves, but rather for their investors",
       "correct_answer":"A",
       "explanation":"The answer is correct as it stands."
    },
    {
       "id":338,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Once registered, an investment company may do all of the following except:",
       "choice_a":"Act as a bank or savings and loan",
       "choice_b":"Raise money",
       "choice_c":"Lend money",
       "choice_d":"Borrow money",
       "correct_answer":"A",
       "explanation":"A registered investment company is prohibited from acting as a bank, or a savings and loan."
    },
    {
       "id":339,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Open-end mutual funds are priced:",
       "choice_a":"By supply and demand",
       "choice_b":"As a percentage of NAV",
       "choice_c":"By formula",
       "choice_d":"As a percentage of POP",
       "correct_answer":"C",
       "explanation":"Open-end mutual funds are always priced by formula."
    },
    {
       "id":340,
       "practice_test_id":"",
       "topic_id":5,
       "question":"The 12b-1 fee charged by a mutual fund may be used to pay all of the following except:",
       "choice_a":"Printing of Prospectus",
       "choice_b":"Radio advertisement",
       "choice_c":"Investment advisor fees",
       "choice_d":"Sponsoring a tennis match",
       "correct_answer":"C",
       "explanation":"A 12b-1 fee may be used to pay promotional and distribution expenses only."
    },
    {
       "id":341,
       "practice_test_id":"",
       "topic_id":5,
       "question":"The assumed interest rate (AIR) is all of the following except:",
       "choice_a":"The benchmark selected by the insurance company for the separate account\u0027s performance",
       "choice_b":"A guaranteed rate of return",
       "choice_c":"Used to adjust the value of the annuity based on the actual performance of the separate account",
       "choice_d":"An earnings target that the insurance company sets for the separate account",
       "correct_answer":"B",
       "explanation":"The AIR is not a guaranteed rate of return; rather it is used to adjust the value of the annuity based on the actual performance of the separate account."
    },
    {
       "id":342,
       "practice_test_id":"",
       "topic_id":5,
       "question":"The assumed interest rate will affect which of the following: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>  The amount of the annuity payment  </li><li> The value of the accumulation unit  </li><li>The amount of the payment into the plan  </li><li>The value of the annuity unit</li></ol>",
       "choice_a":"I and III",
       "choice_b":"II and III",
       "choice_c":"III and IV",
       "choice_d":"I and IV",
       "correct_answer":"D",
       "explanation":"The assumed interest rate only affects the value of the annuity unit and the amount of the annuity payment."
    },
    {
       "id":343,
       "practice_test_id":1,
       "topic_id":5,
       "question":"The board of directors does all but the following:",
       "choice_a":"Manage the investment portfolio",
       "choice_b":"Define the investment objectives",
       "choice_c":"Hire the investment advisor, the custodian bank, and the transfer agent",
       "choice_d":"Determine what type of funds to offer",
       "correct_answer":"A",
       "explanation":"The board of directors does not manage the investment portfolio."
    },
    {
       "id":344,
       "practice_test_id":2,
       "topic_id":5,
       "question":"The contract between an investment company and its investment advisor must:",
       "choice_a":"Show the compensation paid by the investment company to the advisor",
       "choice_b":"Be approved annually by the directors",
       "choice_c":"Be approved annually by the shareholders",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"All of the choices listed are correct regarding the investment advisor\u0027s contract."
    },
    {
       "id":345,
       "practice_test_id":3,
       "topic_id":5,
       "question":"The contract for an investment advisory must be approved by: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The Board of directors </li><li>The Shareholders </li><li>The outstanding shares  </li><li>The FINRA board of governors</li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and III",
       "choice_c":"II and IV",
       "choice_d":"I and III",
       "correct_answer":"D",
       "explanation":"The contract for the mutual fund\u0027s investment advisor must be approved by a majority vote of the Board of Directors and the outstanding shares."
    },
    {
       "id":346,
       "practice_test_id":4,
       "topic_id":5,
       "question":"The custodian bank of an investment company does which of the following?",
       "choice_a":"Physically holds all of the fund\u0027s cash and securities",
       "choice_b":"Holds all of the fund\u0027s assets for safekeeping",
       "choice_c":"Provides bookkeeping and other clerical functions for the investment company",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"The custodian bank of an investment company does all of the choices listed jobs, as well as ensuring that only approved persons have access to the account."
    },
    {
       "id":347,
       "practice_test_id":5,
       "topic_id":5,
       "question":"The different groups which make up an investment company are which of the following?",
       "choice_a":"The board of directors, the investment advisor, the mortgage bank, and the transfer agent",
       "choice_b":"The board of directors, the custodian advisor, the mortgage bank, and the transfer agent",
       "choice_c":"The board of directors, the custodian bank, the mortgage bank, and the transfer agent",
       "choice_d":"The board of directors, the investment advisor, the custodian bank, and the transfer agent",
       "correct_answer":"D",
       "explanation":"This is the complete, correct list."
    },
    {
       "id":348,
       "practice_test_id":6,
       "topic_id":5,
       "question":"The entity that is responsible for selling open-end mutual fund shares to investors is:",
       "choice_a":"Broker dealer",
       "choice_b":"Distributor",
       "choice_c":"Custodian",
       "choice_d":"Transfer agent",
       "correct_answer":"B",
       "explanation":"The distributor is responsible for selling the mutual fund shares. They act as the underwriter for the open-end fund."
    },
    {
       "id":349,
       "practice_test_id":"",
       "topic_id":5,
       "question":"The entity that is responsible for selling open-end mutual fund shares to investors is:",
       "choice_a":"Broker dealer",
       "choice_b":"Sponsor",
       "choice_c":"Custodian",
       "choice_d":"Transfer agent",
       "correct_answer":"B",
       "explanation":"The sponsor is responsible for selling the mutual fund shares to investors."
    },
    {
       "id":350,
       "practice_test_id":"",
       "topic_id":5,
       "question":"The following closed-end funds are listed in the Wall Street Journal: <img src='/question_assets/series6/350.png'></img> A customer purchasing the American Fund at the current market price would pay:",
       "choice_a":"$23.75 + sales charge",
       "choice_b":"$24.25 + commission",
       "choice_c":"$24.25 + sales charge",
       "choice_d":"$23.75 + commission",
       "correct_answer":"B",
       "explanation":"The American Fund is a closed-end fund. The investor would pay 24.25, plus a commission to the broker, for executing the order."
    },
    {
       "id":351,
       "practice_test_id":"",
       "topic_id":5,
       "question":"The following closed-end funds are listed in the Wall Street Journal: <img src='/question_assets/series6/351.png'></img>A customer purchasing the Bunker Hill Fund at the current market price would pay:",
       "choice_a":"$21.50 + sales charge",
       "choice_b":"$21.50 + commission",
       "choice_c":"$21.85 + sales charge",
       "choice_d":"$21.85 + commission",
       "correct_answer":"B",
       "explanation":"An investor would purchase the shares of the closed-end fund at the offering price, and would pay a commission to the firm to execute the order."
    },
    {
       "id":352,
       "practice_test_id":"",
       "topic_id":5,
       "question":"The GGC balanced fund, has a POP of $10 and has paid dividends of $0.55 per share. Find its current yield.",
       "choice_a":"$5.50",
       "choice_b":"55%",
       "choice_c":"$55",
       "choice_d":"5.50%",
       "correct_answer":"D",
       "explanation":"Current yield equals annual income ($0.55) divided by current price($10), or 5.5%. CY = AI/CP"
    },
    {
       "id":353,
       "practice_test_id":"",
       "topic_id":5,
       "question":"The GGF Fund is a diversified mutual fund with net assets of $1,000,000. How much must it invest in securities of other issuers?",
       "choice_a":"$250,000",
       "choice_b":"$500,000",
       "choice_c":"$750,000",
       "choice_d":"None of the choices listed",
       "correct_answer":"C",
       "explanation":"This fund must invest 75% of its net assets in securities of other issuers in order to market itself as a diversified mutual fund."
    },
    {
       "id":354,
       "practice_test_id":"",
       "topic_id":5,
       "question":"The investment advisor of an investment company does all but which of the following?",
       "choice_a":"Manages the fund\u0027s portfolio and may not borrow from it",
       "choice_b":"Is a person hired by the board of directors and may not have any security related convictions",
       "choice_c":"Determines the tax consequences of distributions and strategies",
       "choice_d":"Is the highest paid member of the investment company\u0027s team",
       "correct_answer":"B",
       "explanation":"The investment advisor is always a company, not a single person."
    },
    {
       "id":355,
       "practice_test_id":"",
       "topic_id":5,
       "question":"The Investment Company Act of 1940 does not allow an investment company to:",
       "choice_a":"Purchase securities on margin",
       "choice_b":"Sell options",
       "choice_c":"Borrow from banks to redeem shares",
       "choice_d":"Lend money",
       "correct_answer":"A",
       "explanation":"An investment company may not purchase securities on margin."
    },
    {
       "id":356,
       "practice_test_id":"",
       "topic_id":5,
       "question":"The largest expense of a mutual fund is:",
       "choice_a":"Its sales charge",
       "choice_b":"Its management fee",
       "choice_c":"Its custodial fee",
       "choice_d":"Its redemption fee",
       "correct_answer":"B",
       "explanation":"The largest expense of a mutual fund is the management fee paid to the investment advisor."
    },
    {
       "id":357,
       "practice_test_id":"",
       "topic_id":5,
       "question":"The maximum amount that a diversified fund may invest in any one target company is:",
       "choice_a":"10%",
       "choice_b":"5%",
       "choice_c":"7%",
       "choice_d":"8.50%",
       "correct_answer":"B",
       "explanation":"A diversified mutual fund may invest no more than 5% of its assets in any one company."
    },
    {
       "id":358,
       "practice_test_id":"",
       "topic_id":5,
       "question":"The maximum sales charge on mutual fund contractual plans under the Investment Company Act of 1940 is:",
       "choice_a":"9%",
       "choice_b":"8\u00BD%",
       "choice_c":"8%",
       "choice_d":"7\u00BD%",
       "correct_answer":"A",
       "explanation":"The maximum amount of sales charge that may be deducted from a contractual plan organized under the Act of 1940 is 9% of the total payments."
    },
    {
       "id":360,
       "practice_test_id":"",
       "topic_id":5,
       "question":"The minimum net capital for an investment company is:",
       "choice_a":"$25,000",
       "choice_b":"$50,000",
       "choice_c":"$1,000,000",
       "choice_d":"$100,000",
       "correct_answer":"D",
       "explanation":"The minimum net capital for an investment company is $100,000."
    },
    {
       "id":361,
       "practice_test_id":"",
       "topic_id":5,
       "question":"The MMF Fund is a diversified mutual fund with net assets of $1,000,000. How much may it invest in any one company?",
       "choice_a":"$5,000",
       "choice_b":"$10,000",
       "choice_c":"$50,000",
       "choice_d":"$100,000",
       "correct_answer":"C",
       "explanation":"This fund may invest a maximum of 5% or $50,000 in any one fund in order to be a diversified mutual fund."
    },
    {
       "id":362,
       "practice_test_id":1,
       "topic_id":5,
       "question":"The MMF Mutual Fund has assets of $1,000,000 and liabilities of $250,000, and 75,000 outstanding shares of stock. What is the net asset value per share of the outstanding stock?",
       "choice_a":"$16.66",
       "choice_b":"$13.33",
       "choice_c":"$10.00",
       "choice_d":"$7.50",
       "correct_answer":"C",
       "explanation":"$1,000,000 - $250,000 = $750,000 / 75,000 = $10.00."
    },
    {
       "id":363,
       "practice_test_id":2,
       "topic_id":5,
       "question":"The money in the separate account of a variable annuity is invested differently in direct investment and indirect investment; which of the following is not true?",
       "choice_a":"Direct investment invests in stocks and bonds, while indirect investment invests in mutual fund shares",
       "choice_b":"Direct investment requires an investment advisor to manage the portfolio, while indirect investment does not",
       "choice_c":"Under the Investment Company Act of 1940, direct investment is considered an open-end investment company, while indirect investment is considered a closed-end investment company",
       "choice_d":"Under the Investment Company Act of 1940, direct investment companies must register as an open-end investment company, while indirect investment companies must register as a unit investment trust",
       "correct_answer":"C",
       "explanation":"A direct investment company invests in stocks and bonds and mutual funds, requires an investment advisor and is considered an open-end investment company; an indirect investment company invests in mutual fund shares, does not require an investment advisor, and is considered a unit investment trust. (not a closed-end fund)"
    },
    {
       "id":364,
       "practice_test_id":3,
       "topic_id":5,
       "question":"The percentage of sales charge on variable annuity contracts is based upon:",
       "choice_a":"The total amount paid out of the separate account",
       "choice_b":"The total value of the separate account",
       "choice_c":"The total paid into the separate account",
       "choice_d":"The total paid into the separate account, plus the sales charge",
       "correct_answer":"D",
       "explanation":"The sales charge is deducted from the gross amount invested and the net amount is invested in the separate account. The sales charge is based upon the total amount, which is the amount invested in the separate account plus the sales charge."
    },
    {
       "id":365,
       "practice_test_id":4,
       "topic_id":5,
       "question":"The PPF Fund is a diversified mutual fund with net assets of $10,000,000. What is the maximum amount of any company\u0027s outstanding voting stock which this fund may own?",
       "choice_a":"$10,000",
       "choice_b":"$100,000",
       "choice_c":"$1,000,000",
       "choice_d":"None of the choices listed",
       "correct_answer":"D",
       "explanation":"This fund may not own more than 10% of any company\u0027s outstanding stock in order to be a diversified mutual fund."
    },
    {
       "id":366,
       "practice_test_id":5,
       "topic_id":5,
       "question":"The pricing formula for an open-end mutual fund is:",
       "choice_a":"NAV = assets - liabilities",
       "choice_b":"POP – SC = NAV",
       "choice_c":"NAV + SC = POP",
       "choice_d":"Supply + demand = POP",
       "correct_answer":"C",
       "explanation":"The pricing formula for an open-end investment company is always NAV + SC = POP."
    },
    {
       "id":367,
       "practice_test_id":6,
       "topic_id":5,
       "question":"The purpose of a letter of intent is:",
       "choice_a":"To let the mutual fund know what the person is considering",
       "choice_b":"To allow an investor to reach a breakpoint within 13 months of his first investment",
       "choice_c":"To provide a binding agreement for both the customer and the fund company for investment planning purposes",
       "choice_d":"To allow the fund company to create an escrow fund to protect itself should the investor default",
       "correct_answer":"B",
       "explanation":"A letter of intent simply allows an investor to reach a breakpoint within 13 months of his first investment; it is binding on the fund company, not on the individual."
    },
    {
       "id":368,
       "practice_test_id":"",
       "topic_id":5,
       "question":"The Securities Act of 1933 requires that all investment company offerings do all of the following except:",
       "choice_a":"Register with the Securities Exchange Commission",
       "choice_b":"Have a net worth at a minimum of $250,000",
       "choice_c":"Give all purchasers a prospectus",
       "choice_d":"Follow specific guidelines on its offerings and keep investors informed",
       "correct_answer":"B",
       "explanation":"The Securities Act of 1933 did not require an investment company to have a net worth, but in order to register with the Securities Exchange Commission, a company must have a minimum net worth of $100,000."
    },
    {
       "id":369,
       "practice_test_id":"",
       "topic_id":5,
       "question":"The transfer agent of an investment company does which of the following?",
       "choice_a":"Handles the issuance, cancellation, and redemption of fund shares",
       "choice_b":"Handles name changes",
       "choice_c":"Receives an agreed upon fee for his services",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"The transfer agent does all of the choices listed for an investment company."
    },
    {
       "id":370,
       "practice_test_id":"",
       "topic_id":5,
       "question":"To determine the net asset value of a fund, use the following formula:",
       "choice_a":"Assets plus liabilities equals net asset value",
       "choice_b":"Net asset value equals liabilities minus assets",
       "choice_c":"Assets minus liabilities equals net asset value",
       "choice_d":"Net asset value equals liabilities plus assets",
       "correct_answer":"C",
       "explanation":"Assets - liabilities = NAV, a most important formula."
    },
    {
       "id":371,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Under a periodic payment plan, the minimum investment required after the initial purchase is:",
       "choice_a":"$10",
       "choice_b":"$20",
       "choice_c":"$25",
       "choice_d":"$50",
       "correct_answer":"B",
       "explanation":"The minimum monthly investment is $20 per month."
    },
    {
       "id":373,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Under FINRA Rules of Fair Practice, the maximum sales charge allowed for mutual funds is:",
       "choice_a":"9% of the net asset value",
       "choice_b":"8\u00BD% of the net asset value",
       "choice_c":"8\u00BD% of the total amount invested",
       "choice_d":"9% of the total amount invested",
       "correct_answer":"C",
       "explanation":"The maximum allowable sales charge for an open-end mutual fund is 8\u00BD% of the payments."
    },
    {
       "id":374,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Under the provisions of the Investment Company Act of 1940, the maximum sales charge allowed over the life of a front-end load contractual plan may not exceed:",
       "choice_a":"50%",
       "choice_b":"20%",
       "choice_c":"15%",
       "choice_d":"9%",
       "correct_answer":"D",
       "explanation":"The maximum allowable sales charge over the life of the plan is 9% of the total payments."
    },
    {
       "id":375,
       "practice_test_id":"",
       "topic_id":5,
       "question":"What is the major difference between life insurance and an annuity?",
       "choice_a":"Life insurance provides a smaller payout than an annuity",
       "choice_b":"Life insurance requires a smaller investment than an annuity",
       "choice_c":"Life insurance provides financial compensation to one\u0027s beneficiaries after the investor\u0027s death, while an annuity provided financial compensation to the investor while he is alive",
       "choice_d":"Life insurance pays out in the event of either death or disability while an annuity doesn\u0027t require either death or disability to pay out",
       "correct_answer":"C",
       "explanation":"Life insurance provides financial compensation to one\u2019s beneficiaries after the investor\u2019s death, while an annuity providedsfinancial compensation to the investor while he is alive."
    },
    {
       "id":376,
       "practice_test_id":"",
       "topic_id":5,
       "question":"What is the maximum percentage of directors of an investment company who may be officers, employees, or investment advisors of the company?",
       "choice_a":"40%",
       "choice_b":"50%",
       "choice_c":"49%",
       "choice_d":"75%",
       "correct_answer":"C",
       "explanation":"A maximum of 49% of the board may hold another position with the fund company."
    },
    {
       "id":377,
       "practice_test_id":"",
       "topic_id":5,
       "question":"What is the mutual fund pricing formula?",
       "choice_a":"NAV – SC = POP",
       "choice_b":"NAV + SC = POP",
       "choice_c":"SC + POP = NAV",
       "choice_d":"NAV x SC = POP",
       "correct_answer":"B",
       "explanation":"Net asset value (NAV) plus service charge (SC) equals the public offering price (POP)."
    },
    {
       "id":378,
       "practice_test_id":"",
       "topic_id":5,
       "question":"What kind of investment company makes no provision for future purchases or redemptions?",
       "choice_a":"An open-end fund",
       "choice_b":"A closed-end fund",
       "choice_c":"A unit investment trust",
       "choice_d":"A face-amount certificate company",
       "correct_answer":"B",
       "explanation":"A closed-end fund makes no provisions for re-purchasing or redeeming its shares."
    },
    {
       "id":379,
       "practice_test_id":"",
       "topic_id":5,
       "question":"When an investor changes from the pay-in stage of the annuity to the payout stage of the contract, the investor is said to have:",
       "choice_a":"Annuitized the contract",
       "choice_b":"Annualized the contract",
       "choice_c":"Accumulated the contract",
       "choice_d":"None of the choices listed",
       "correct_answer":"A",
       "explanation":"Annuitizing a contract occurs when an investor changes from paying into an annuity and begins to receive payouts from this annuity."
    },
    {
       "id":380,
       "practice_test_id":"",
       "topic_id":5,
       "question":"When you were single, you purchased a variable life insurance policy. You have since gotten married and want to exchange it for a whole life policy to protect your family. How long from the policy\u0027s issuance do you have to make the conversion?",
       "choice_a":"18 months",
       "choice_b":"12 months",
       "choice_c":"24 months",
       "choice_d":"16 month",
       "correct_answer":"C",
       "explanation":"An individual has 24 months to switch a variable life policy to a whole life policy. The insurance company may not require another physical."
    },
    {
       "id":381,
       "practice_test_id":1,
       "topic_id":5,
       "question":"Which is not correct about mutual fund investors\u0027 voting rights?",
       "choice_a":"All votes are won by a simple majority of outstanding shares",
       "choice_b":"All votes are won by a simple majority of shareholders",
       "choice_c":"Votes are taken on a number of major issues regarding the fund",
       "choice_d":"Votes are taken on financial issues as well as policies and Board of Directors",
       "correct_answer":"B",
       "explanation":"All votes are won by a simple majority of shares, not shareholders; thus if one investor has 100 shares and another has 500, the second has 5 times as many votes."
    },
    {
       "id":382,
       "practice_test_id":2,
       "topic_id":5,
       "question":"Which is true about the board of directors?",
       "choice_a":"The board is elected by the vote of the outstanding shares",
       "choice_b":"The board must be made up of at least 60% non-interested or non-affiliated persons",
       "choice_c":"The board may be made up of a maximum of 40% of interested persons, such as a broker, attorney, or immediate family member",
       "choice_d":"None of the choices listed",
       "correct_answer":"A",
       "explanation":"Elected by a vote of the shareholders, the board must be made up of at least a majority of non-interested persons."
    },
    {
       "id":383,
       "practice_test_id":3,
       "topic_id":5,
       "question":"Which of the following are true regarding a variable annuity? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The unit values are calculated once per business day </li><li>Investors have voting rights </li><li>Unit value depends on performance </li><li>The maximum sales charge is 9% of the total payments</li></ol>",
       "choice_a":"I and III",
       "choice_b":"II and IV",
       "choice_c":"I, II, and III",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"C",
       "explanation":"All of the answers are true except there is no setmaximum sales chargefor a variable annuity."
    },
    {
       "id":384,
       "practice_test_id":4,
       "topic_id":5,
       "question":"Which of the following are true regarding dollar cost averaging? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>It is effective in a short period of time </li><li>It is more effective when the dollar amount varies </li><li>It is a long term investment strategy </li><li>It is more effective when the share price varies</li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and IV",
       "choice_c":"I and III",
       "choice_d":"III and IV",
       "correct_answer":"D",
       "explanation":"Dollar cost averaging is a long term investment strategy that is most effective when the share price varies. The investor invests a fixed amount over a long period of time into a fund with a fluctuating share price."
    },
    {
       "id":385,
       "practice_test_id":5,
       "topic_id":5,
       "question":"Which of the following are true regarding the mortality risk with regard to a variable annuity? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>It is absorbed by the annuitant  </li><li>It is absorbed by the insurance company </li><li>A fee is deducted from the separate account </li><li>A fee is deducted from the general account</li></ol>",
       "choice_a":"II and III",
       "choice_b":"I and IV",
       "choice_c":"II and IV",
       "choice_d":"I and III",
       "correct_answer":"A",
       "explanation":"The mortality risk with an annuity is the risk that the annuitant lives too long. It is absorbed by the insurance company and a fee is deducted from the separate account to help underwrite that risk."
    },
    {
       "id":386,
       "practice_test_id":6,
       "topic_id":5,
       "question":"Which of the following are types of sales loads: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Front-end </li><li>Back-end </li><li>Contingent deferred sales charge </li><li>12 b-1 fee</li></ol>",
       "choice_a":"I and II",
       "choice_b":"I and III",
       "choice_c":"I, II, and III",
       "choice_d":"I, II, III, IV",
       "correct_answer":"D",
       "explanation":"All of the choices listed are types of sales loads. A sales load is anything that reduces the return to an investor, and a 12b-1 fee is a type of sales load."
    },
    {
       "id":387,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Which of the following funds would most likely have the highest management fee?",
       "choice_a":"A long term bond fund",
       "choice_b":"A Long term growth fund",
       "choice_c":"An aggressive growth fund",
       "choice_d":"An option income fund",
       "correct_answer":"C",
       "explanation":"The aggressive growth fund would have the highest fee. The more aggressive the fund\u0027s objective, the higher the fee."
    },
    {
       "id":388,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Which of the following investment companies allows the holders to continuously redeem the shares at the net asset value? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>  Unit investment trusts </li><li> Diversified closed-end funds </li><li>Open-end companies </li><li>Face-amount certificate companies</li></ol>",
       "choice_a":"III only",
       "choice_b":"I and III",
       "choice_c":"II and IV",
       "choice_d":"I, II, III and IV",
       "correct_answer":"A",
       "explanation":"Only an open-end fund will allow the holders to continuously redeem their shares at the NAV."
    },
    {
       "id":389,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Which of the following investment companies is sold with a commission added to the contract price?",
       "choice_a":"Open-end management companies",
       "choice_b":"Unit investment trusts",
       "choice_c":"Face-amount certificate companies",
       "choice_d":"Closed-end investment companies",
       "correct_answer":"D",
       "explanation":"A closed-end investment company share is sold at the market price, plus a commission."
    },
    {
       "id":390,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Which of the following is not a feature of closed-end funds?",
       "choice_a":"Single fixed offering through an IPO",
       "choice_b":"Common and preferred shares and debt securities",
       "choice_c":"Shares are purchased from company and redeemed to company",
       "choice_d":"Shares priced by supply and demand",
       "correct_answer":"C",
       "explanation":"Closed-end funds have shares that may be purchased only from the fund company during the IPO; then secondary market transactions take place between investors."
    },
    {
       "id":391,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Which of the following is not a feature of open-end funds?",
       "choice_a":"Unlimited continuous primary offering",
       "choice_b":"Shares are priced by supply and demand",
       "choice_c":"Full and fractional shares",
       "choice_d":"Common shares only",
       "correct_answer":"B",
       "explanation":"Open-end fund shares are priced by the formula NAV + SC = POP."
    },
    {
       "id":392,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Which of the following is not a function of an investment company\u0027s custodian bank?",
       "choice_a":"Providing safekeeping of securities",
       "choice_b":"Providing portfolio advice regarding transactions",
       "choice_c":"Maintaining books and records for accumulation plans",
       "choice_d":"Safekeeping cash",
       "correct_answer":"B",
       "explanation":"The custodian bank does not provide advice."
    },
    {
       "id":393,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Which of the following is not a type of annuity?",
       "choice_a":"Fixed annuity",
       "choice_b":"Variable annuity",
       "choice_c":"Contractual annuity",
       "choice_d":"Combination annuity",
       "correct_answer":"C",
       "explanation":"There is no such thing as a contractual annuity."
    },
    {
       "id":394,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Which of the following is not considered when determining a mutual fund\u0027s net investment income?",
       "choice_a":"Dividends received",
       "choice_b":"Interest payments received",
       "choice_c":"Expenses paid",
       "choice_d":"Large capital gains",
       "correct_answer":"D",
       "explanation":"A mutual fund\u0027s net investment income only looks at interest and dividends received and expenses paid by the fund."
    },
    {
       "id":395,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Which of the following is not true about a single payment deferred annuity?",
       "choice_a":"The investor funds the contract completely with one payment",
       "choice_b":"The value of the separate account\u0027s portfolio will increase with additional investments by the investor",
       "choice_c":"The investor defers receiving payments from the contract until some point usually after retirement",
       "choice_d":"Money invested is used to purchase accumulation units",
       "correct_answer":"B",
       "explanation":"In a single payment deferred annuity, there are no additional investments as the contract is funded by one single payment; there may be distributions which are reinvested."
    },
    {
       "id":396,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Which of the following is not true about a single payment immediate annuity?",
       "choice_a":"The investor funds the contract completely with one payment",
       "choice_b":"The number of annuity units remains fixed and the value changes as the value of the securities fluctuates",
       "choice_c":"The investor defers receiving payments from the contract until some point usually after retirement",
       "choice_d":"Money invested is used to purchase annuity units",
       "correct_answer":"C",
       "explanation":"With a single payment immediate annuity the investor begins receiving payments from the contract immediately, usually within 60 days."
    },
    {
       "id":397,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Which of the following is not true about types of withdrawals from annuity contracts?",
       "choice_a":"Lump sum and random withdrawals are paid on a first in last out (FILO) basis",
       "choice_b":"Lump sum and random withdrawals may be taxed at an extra 10% if the annuitant is less than 59\u00BD years old",
       "choice_c":"Annuitized contracts pay out monthly payments, part of which is taxable as growth, and part of which is not taxable as after tax money invested",
       "choice_d":"Annuitized contracts, if the investor is less than 59\u00BD years old, are not subject to the 10% tax penalty",
       "correct_answer":"A",
       "explanation":"Lump sum and random payments are always done on a LIFO, last in first out, basis; thus the growth is considered to be the last in portion and is taxed as ordinary income."
    },
    {
       "id":398,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Which of the following is true about securities in a fund\u0027s portfolio?",
       "choice_a":"The NAV will decrease if the fund distributes dividends or capital gains",
       "choice_b":"The NAV will increase if the fund receives investment income",
       "choice_c":"The NAV will be unchanged by sales charges, portfolio purchases and sales and investor purchases and sales",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"All of the choices listed are true about the NAV and the securities in a portfolio."
    },
    {
       "id":399,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Which of the following is true regarding the ex-dividend date for an open-end mutual fund? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>It is set by FINRA </li><li>It is the day before the record date </li><li>It is set by the board of directors </li><li>It is the day after the record date.</li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and III",
       "choice_c":"I and IV",
       "choice_d":"III and IV",
       "correct_answer":"D",
       "explanation":"The ex-dividend date for an open-end mutual fund is set by the board of directors and is the day after the record date."
    },
    {
       "id":400,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Which of the following may vary? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>  The number of annuity units  </li><li> The number of accumulation units    </li><li>The price of accumulation units  </li><li>The price of annuity units</li></ol>",
       "choice_a":"I and IV",
       "choice_b":"II and III",
       "choice_c":"II, III, and IV",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"C",
       "explanation":"Only the price of an annuity unit may vary while the price and number of accumulation units may vary."
    },
    {
       "id":401,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Which of the following options would provide the highest monthly payout on an immediate annuity?",
       "choice_a":"Straight Life Annuity",
       "choice_b":"Life with 20 Year Period Certain",
       "choice_c":"Lump Sum",
       "choice_d":"Life with 10 Year Period Certain",
       "correct_answer":"A",
       "explanation":"A Straight Life Annuity always has the highest monthly pay out of the options with a life contingency. With the Straight Life Option, the monthly payments end when the annuitant dies, which lowers the risk to the company, and results in a higher monthly pay out to the annuitant. With the Period Certain Options, there could be a longer pay out to a beneficiary based on the time period selected. Because of the potentially longer time period than the life of the annuitant, there is a higher risk to the company. Because of this increased risk, the monthly payments will be lower. The Lump Sum Option is only a one time payment, not a monthly payment."
    },
    {
       "id":402,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Which of the following statements is true about closed-end investment companies?",
       "choice_a":"The amount of outstanding shares is constantly increasing",
       "choice_b":"They are sold at the current ask price",
       "choice_c":"They are sold at the current net asset value",
       "choice_d":"They are continually offering new shares for sale",
       "correct_answer":"B",
       "explanation":"Closed-end investment company shares are sold at the current asking price in the marketplace."
    },
    {
       "id":403,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Which of the following statements regarding variable annuities are correct? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The maximum sales charge permitted is 8 \u00BD% </li><li>The percentage of the sales charge is computed on the amount deposited in the separate plan account plus the sales charge </li><li>The issuer must be paid promptly by the selling member  </li><li>FINRA members may not sell the contract to a nonmember at a price that is lower than the price paid by customers</li></ol>",
       "choice_a":"I, II and III",
       "choice_b":"II, III and IV",
       "choice_c":"I, II and IV",
       "choice_d":"I, II, III and IV",
       "correct_answer":"D",
       "explanation":"All of the choices listed are correct as they relate to the sale of variable annuities."
    },
    {
       "id":404,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Which of the following types of insurance policy provides the insured with a guaranteed death benefit equal to the face amount of the policy, plus a guaranteed cash value which the policyholder may borrow against?",
       "choice_a":"Whole life",
       "choice_b":"Variable life",
       "choice_c":"Universal life",
       "choice_d":"Variable universal life",
       "correct_answer":"A",
       "explanation":"A whole life policy provides the insured with a guaranteed death benefit equal to the face amount of the policy plus a guaranteed cash value which the policyholder may borrow against."
    },
    {
       "id":405,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Which type of life insurance policy has no scheduled premium payments and has a face amount which can be adjusted according to the policyholder\u0027s needs?",
       "choice_a":"Whole life",
       "choice_b":"Variable life",
       "choice_c":"Universal life",
       "choice_d":"Variable universal life",
       "correct_answer":"C",
       "explanation":"A universal life insurance policy has no scheduled premium payments and has a face amount which can be adjusted according to the policyholder\u0027s needs."
    },
    {
       "id":406,
       "practice_test_id":2,
       "topic_id":5,
       "question":"Which type of life insurance policy invests in a separate account and allows the policyholder to determine when the premiums are paid and how large those payments are?",
       "choice_a":"Whole life",
       "choice_b":"Variable life",
       "choice_c":"Universal life",
       "choice_d":"Variable universal life",
       "correct_answer":"D",
       "explanation":"A variable universal life insurance policy allows the policyholder to determine when the premiums are paid and how large those payments are."
    },
    {
       "id":407,
       "practice_test_id":3,
       "topic_id":5,
       "question":"Which type of life insurance policy is considered both an insurance policy and a security because the company offers part of the funds as a fixed death benefit and invests part in securities such as stock, bonds, or mutual funds?",
       "choice_a":"Whole life",
       "choice_b":"Variable life",
       "choice_c":"Universal life",
       "choice_d":"Variable universal life",
       "correct_answer":"B",
       "explanation":"A variable life insurance policy is considered both an insurance policy and a security because the company offers part of the funds as a fixed death benefit and invests part in securities such as stock, bonds, and mutual funds."
    },
    {
       "id":408,
       "practice_test_id":4,
       "topic_id":5,
       "question":"Why do variable annuities contain more risk than a fixed annuity contract?",
       "choice_a":"Because the number of accumulation units is fixed",
       "choice_b":"Because they invest in stocks, bonds, or mutual funds",
       "choice_c":"Because they are considered both a security and an insurance company product",
       "choice_d":"Because the money may be invested either directly or indirectly",
       "correct_answer":"B",
       "explanation":"Variable annuities contain more risk because the funds are invested in stocks, bonds, and mutual funds, which may increase or decrease in value."
    },
    {
       "id":409,
       "practice_test_id":5,
       "topic_id":5,
       "question":"You are recommending a fixed UIT to an investor. The portfolio most likely contains which of the following:",
       "choice_a":"Common stock",
       "choice_b":"Bonds",
       "choice_c":"Preferred stock",
       "choice_d":"Both stocks and bonds",
       "correct_answer":"B",
       "explanation":"A fixed UIT will invest in a large block of bonds and hold them until maturity then distribute the proceeds to investors."
    },
    {
       "id":410,
       "practice_test_id":6,
       "topic_id":5,
       "question":"You have been following a mutual fund in the newspaper. The XYZ fund has an NAV of $11.05 and a POP of $10.90. Which of the following is true?",
       "choice_a":"There was a large drop in the futures market over night and the market is expected to drop on the open",
       "choice_b":"XYZ is an open-end fund that is losing money",
       "choice_c":"XYZ is an open-end fund with a back end load",
       "choice_d":"XYZ is a closed-end fund",
       "correct_answer":"D",
       "explanation":"XYZ is a closed-end mutual fund whose shares are priced by supply and demand."
    },
    {
       "id":411,
       "practice_test_id":"",
       "topic_id":5,
       "question":"You have been investing in a variable annuity that invests indirectly in the stock market. The separate account would have to be registered as:",
       "choice_a":"A UIT",
       "choice_b":"A closed-end investment company",
       "choice_c":"An open-end investment company",
       "choice_d":"An investment fund",
       "correct_answer":"A",
       "explanation":"If the separate account invests indirectly, it buys mutual funds. The separate account would have to be registered as a UIT."
    },
    {
       "id":412,
       "practice_test_id":"",
       "topic_id":5,
       "question":"You work for the management company, which has been hired by the mutual fund to make appropriate investments based on the fund\u0027s objectives. Your firm is paid for its services and receives:",
       "choice_a":"Commissions",
       "choice_b":"A percentage of the profits",
       "choice_c":"A percentage of the NAV",
       "choice_d":"A percentage of the POP",
       "correct_answer":"C",
       "explanation":"The management company always receives a fee based on the NAV of the fund."
    },
    {
       "id":413,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Your client has been paying $1,200 per year towards the premium for his variable life insurance policy. All of the following come out from the gross premium received by the insurance company except:",
       "choice_a":"Sales load",
       "choice_b":"Administrative fee",
       "choice_c":"Premium tax",
       "choice_d":"Mortality fee",
       "correct_answer":"D",
       "explanation":"All if those listed come out of the gross premium except the mortality fee that is deducted from the separate account."
    },
    {
       "id":414,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Your customer has just bought $10,000 worth of Kashmir Growth fund. The trade will settle on:",
       "choice_a":"The third business day",
       "choice_b":"The fourth business day",
       "choice_c":"The next business day",
       "choice_d":"The same day",
       "correct_answer":"D",
       "explanation":"The investor has purchased shares of an open-end mutual fund. Every new investor gets a new share and becomes an owner of record on the day of the purchase."
    },
    {
       "id":415,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Your customer invested in a fund with a NAV of $9.75 and a sales charge of 2.5%; what was his POP?",
       "choice_a":"$5.00",
       "choice_b":"$10.00",
       "choice_c":"$9.50",
       "choice_d":"None of the choices listed",
       "correct_answer":"B",
       "explanation":"POP = 9.75/100%-2.5% = 9.75/97.5% = 9.75/.975 = $10.00; be sure to know this formula."
    },
    {
       "id":416,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Your customer thinks that the telecommunication sector is likely to rebound over the next 24 months. He wants to liquidate his shares in the XYZ income opportunity fund, which has an NAV of $11 and a POP of $11.70. He has 500 shares and wants to move the money into the XYZ telecommunication fund, which has a NAV of $10 and a POP of $10.50. XYZ offers conversion privileges. How many shares can he buy?",
       "choice_a":"550 shares",
       "choice_b":"522.5 shares",
       "choice_c":"585 shares",
       "choice_d":"512 shares",
       "correct_answer":"A",
       "explanation":"The investor will be able to buy 550 shares of the new fund because the fund offers conversion privileges. The investor sells his shares at the NAV of $11 X 500 = $5,500, and buys the new shares at the NAV of $10. $5,500 / 10 = 550."
    },
    {
       "id":417,
       "practice_test_id":"",
       "topic_id":5,
       "question":"A mutual fund has an NAV of $13.37 and a POP of $14.22. An investor is charged a 4% sales charge on a lump sum purchase of $50,000. How many shares are purchased?",
       "choice_a":"3,516",
       "choice_b":"3,564",
       "choice_c":"3,590",
       "choice_d":"3,739",
       "correct_answer":"C",
       "explanation":"To determine how many shares are purchased at the 4% sales charge, reduce the lump­sum investment by the 4% and divide by the NAV <br>50,000 - 4% = 48,000. 48,000/13.37 = 3590 shares."
    },
    {
       "id":418,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Capital gains distributions may be combined with income distributions to calculate annual yield on mutual fund shares under which of the following circumstances?",
       "choice_a":"When the income distributions contain short-term capital gains",
       "choice_b":"When both distributions are accompanied by a source of distribution state­ment",
       "choice_c":"When both distributions resulted from activities occurring within the same year",
       "choice_d":"Under no circumstances",
       "correct_answer":"D",
       "explanation":"Capital gains distributions may never be combined with income distributions for this purpose."
    },
    {
       "id":419,
       "practice_test_id":"",
       "topic_id":5,
       "question":"A broker-dealer that buys mutual fund shares from an underwriter may be allowed a discount under which of the following circumstances?",
       "choice_a":"Broker-dealer has signed a selling agreement and is buying shares in antic­ipation of receiving a customer order",
       "choice_b":"Broker-dealer is buying to fill a customer\u0027s order and has a selling agree­ment in force with the underwriter",
       "choice_c":"Broker-dealer is registered with the SEC",
       "choice_d":"All of the choices listed",
       "correct_answer":"B",
       "explanation":"Discounts are available only to broker­ dealers that have signed selling agreements with the principal underwriter. Discounts then can be applied to any and all purchases. Purchases by a member may be made only to fill existing, not anticipated, orders. Purchases can also be made for a member firm\u0027s investment account."
    },
    {
       "id":420,
       "practice_test_id":"",
       "topic_id":5,
       "question":"An investment company that is not a unit investment trust or a face-amount certificate company is a (n):",
       "choice_a":"Mutual fund",
       "choice_b":"Management company",
       "choice_c":"Open-end company",
       "choice_d":"Closed-end company",
       "correct_answer":"B",
       "explanation":"Closed-end and open-end companies are both forms of management companies. Mutual fund is another name for open-end investment company."
    },
    {
       "id":421,
       "practice_test_id":"",
       "topic_id":5,
       "question":"The ex-date for a closed-end mutual fund is set by the:",
       "choice_a":"Board of Directors of the Fund",
       "choice_b":"FINRA",
       "choice_c":"SEC",
       "choice_d":"Underwriter",
       "correct_answer":"B",
       "explanation":"The ex-dates for closed-end funds (typically 2 business days before the record date) are by FINRA. The ex-date for open-end funds (typically the business day following the record date) is determined by the Board of Directors of the fund."
    },
    {
       "id":422,
       "practice_test_id":"",
       "topic_id":5,
       "question":"If a mutual fund has a bid price of $9.15 and a sales charge of 8.5%, what is the price an investor will pay for each share of this fund? (Round to the nearest cent.)",
       "choice_a":"$8.37",
       "choice_b":"$9.93",
       "choice_c":"$10",
       "choice_d":"$10.76",
       "correct_answer":"C",
       "explanation":"Mutual fund shares are purchased at the POP. To find the POP use the formula: POP = NAV/(100% 0 SC%).In this example, 9.15/.915 = POP of $10."
    },
    {
       "id":423,
       "practice_test_id":"",
       "topic_id":5,
       "question":"An investment company share purchased at its net asset value that can be redeemed later at the then-current net asset value is a share issued by a(n):",
       "choice_a":"Open-end investment company",
       "choice_b":"Closed-end investment company",
       "choice_c":"Front-end load company",
       "choice_d":"No-load open-end investment company",
       "correct_answer":"D",
       "explanation":"A share purchased at its NAV and sold at its NAV is a no-load fund. NAV plus the sales charge equals the POP; if there is no sales charge, the NAV equals the POP."
    },
    {
       "id":424,
       "practice_test_id":"",
       "topic_id":5,
       "question":"All of the following investments are defined under the Investment Company Act of 1940 except:",
       "choice_a":"Real estate investment trust",
       "choice_b":"Management company",
       "choice_c":"Face-amount certificate",
       "choice_d":"Unit investment trust",
       "correct_answer":"A",
       "explanation":"Securities issued by a real estate investment trust (REIT) are not governed by the Investment Company Act of 1940. A mutual fund, a face-amount certificate and a unit investment trust are included in the federal definition of an investment company."
    },
    {
       "id":425,
       "practice_test_id":"",
       "topic_id":5,
       "question":"You would expect the highest capital appreciation to be the objective of which of the following types of mutual funds?",
       "choice_a":"Income",
       "choice_b":"Municipal bond",
       "choice_c":"Balanced",
       "choice_d":"Specialized",
       "correct_answer":"D",
       "explanation":"An objective of high capital appreciation is most likely realized by a stock fund. A specialized fund is one that invests in one particular industry or region. Its main objective is capital or price appreciation. All of the other choices are income oriented."
    },
    {
       "id":426,
       "practice_test_id":"",
       "topic_id":5,
       "question":"An open end investment company may do all of the following except:",
       "choice_a":"Continuously offer shares",
       "choice_b":"Borrow money",
       "choice_c":"Lend money",
       "choice_d":"Issue bonds",
       "correct_answer":"D",
       "explanation":"A mutual fund cannot issue any senior securities, although it may purchase just about any type of security as an investment. All shares of a mutual fund must be of the same class."
    },
    {
       "id":427,
       "practice_test_id":"",
       "topic_id":5,
       "question":"A fund must inform its shareholders of their right to reinvest dividends at NAV:",
       "choice_a":"Quarterly",
       "choice_b":"Annually",
       "choice_c":"At the time of each distribution",
       "choice_d":"At the time of original purchase only",
       "correct_answer":"B",
       "explanation":"A fund must notify shareholders at least annually of their right to reinvest, and it usually accomplishes this through the annual report it sends to every investor."
    },
    {
       "id":428,
       "practice_test_id":"",
       "topic_id":5,
       "question":"A FINRA broker dealer trading in shares of an open end investment company cannot buy shares of the fund:",
       "choice_a":"To cover existing orders",
       "choice_b":"For the firm\u0027s own investment purposes",
       "choice_c":"At a discount",
       "choice_d":"For the purpose of resale at a later date",
       "correct_answer":"D",
       "explanation":"A broker dealer may purchase shares only to fulfill existing orders or for its own investment account, not for inventory."
    },
    {
       "id":429,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Your firm is the underwriter of a new mutual fund organized under a 12b-1 plan. Which of the following statements may you make in any mailings you send out or phone calls you make to your clients?",
       "choice_a":"The fund has the added advantage of being a no load investment",
       "choice_b":"You will not have to pay any sales charges with this fund because we are buying it as a long-term investment",
       "choice_c":"Investments in no-load funds of this type carry some risks, and you should review the prospectus carefully",
       "choice_d":"None of the choices listed",
       "correct_answer":"D",
       "explanation":"Any statement or reference to a mutual fund offered under a 12b-1 plan that implies it is a no load fund is considered misleading and a violation of FINRA Rules."
    },
    {
       "id":430,
       "practice_test_id":2,
       "topic_id":5,
       "question":"In the case of an unsolicited order, a prospectus must be delivered to the purchaser of a unit investment trust:",
       "choice_a":"Before the purchase",
       "choice_b":"With the first confirmation",
       "choice_c":"With each confirmation",
       "choice_d":"Between 45 days and 18 months following the initial deposit",
       "correct_answer":"B",
       "explanation":"A purchaser of newly issued securities must receive a prospectus no later than with receipt of the confirmation of his purchase. Any solicitation, however, must be accompanied by a prospectus."
    },
    {
       "id":431,
       "practice_test_id":3,
       "topic_id":5,
       "question":"Under which of the following circumstances will a FINRA member that buys mutual fund shares from the principal underwriter be entitled to a discount from the POP?",
       "choice_a":"The member buys in anticipation of receiving purchase orders from customers within a few hours and signs a selling agreement with the underwriter",
       "choice_b":"The member buys to fill customer purchase orders already in hand and executes a selling agreement with the underwriter",
       "choice_c":"The member is a market maker, buying for the firm\u0027s trading account",
       "choice_d":"Discounts from the POP are never allowed",
       "correct_answer":"B",
       "explanation":"FINRA rules prohibit principal underwriters of investment company securities from selling at a discount below the POP unless (1) the buyer is a FINRA member firm, (2) a selling agreement exists between the two firms and (3) the buying firm is filling customer purchase orders or buying shares for the firm\u0027s proprietary investment account. Under no circumstances may FINRA members make a market in mutual fund shares."
    },
    {
       "id":432,
       "practice_test_id":4,
       "topic_id":5,
       "question":"A mutual fund has a bid price of $9.15 and a sales charge of 8.5%. What is the price an investor will pay for each share of this fund? (Round to the nearest cent.)",
       "choice_a":"$8.37",
       "choice_b":"$9.93",
       "choice_c":"$10",
       "choice_d":"$10.76",
       "correct_answer":"C",
       "explanation":"Mutual fund shares are purchased at the POP To find the POP use the following formula: NAV (bid) POP = 100% - SC% In this example, 9.15/.915 = POP of $10."
    },
    {
       "id":433,
       "practice_test_id":5,
       "topic_id":5,
       "question":"If an investment company invests in a fixed portfolio of municipal or corporate bonds, it is classified as a :",
       "choice_a":"Growth fund",
       "choice_b":"Utilities fund",
       "choice_c":"Unit investment trust",
       "choice_d":"Face-amount certificate company",
       "correct_answer":"C",
       "explanation":"A unit investment trust issues shares that represent units of a particular portfolio. Man­agement has no authority, or only limited authority, to change the portfolio. The portfolio is fixed; it is not traded."
    },
    {
       "id":434,
       "practice_test_id":6,
       "topic_id":5,
       "question":"According to the Investment Company Act of 1940, all of the following statements are true except:",
       "choice_a":"An investment company\u0027s board of directors may consist of up to 70% of the officers or employees of the investment company open-end investment companies must make payment for redeemed securities within seven calendar days after their tender an investment company must have a minimum of $100,000 capitalization to be offered to the public",
       "choice_b":"Shareholders have the right to vote on a company\u0027s change from a closed-end to an open-end investment company",
       "choice_c":"An investment company\u0027s board of directors may include no more than 40% interested persons.",
       "choice_d":"Investment companies are required to redeem shares within 7 calendar days of request.",
       "correct_answer":"A",
       "explanation":"Shareholders have a right to vote on substantial investment company issues and board of director members. Investment companies must have a minimum of 100 shareholders and $100,000 of capitalization before they can do business."
    },
    {
       "id":435,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Under the Member Conduct Rules, the maximum sales charge on any transaction involving an open end investment company is:",
       "choice_a":"8.5 percent of the net asset value",
       "choice_b":"9 percent of the net asset value",
       "choice_c":"8.5 percent of the offering price",
       "choice_d":"9 percent of the offering price",
       "correct_answer":"C",
       "explanation":"Open end investment companies, also known as mutual funds, are limited to a maximum sales charge of 8.5 percent of the offering price."
    },
    {
       "id":436,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Your client asks whether he should invest in a particular investment company. You should tell him to check the investment company\u0027s: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Investment policy </li><li>Track record </li><li>Portfolio </li><li>Sales load</li></ol>",
       "choice_a":"I, II and III only",
       "choice_b":"I and IV only",
       "choice_c":"III only",
       "choice_d":"I, II, III and IV",
       "correct_answer":"D",
       "explanation":"All of these elements should be checked when assessing a fund."
    },
    {
       "id":437,
       "practice_test_id":"",
       "topic_id":5,
       "question":"A customer invests $18,000 in a mutual fund and signs a letter of intent for $25,000 in order to qualify for a breakpoint. One year later, the shares are valued at $25,100 even though he has made no new investments. Which of the following statements is true?",
       "choice_a":"The investment no longer qualifies for a breakpoint",
       "choice_b":"The rep should remind the customer that he signed a letter of intent 12 months ago",
       "choice_c":"Shares held in escrow will be liquidated at the appreciated value",
       "choice_d":"The letter of intent is considered to be fulfilled",
       "correct_answer":"B",
       "explanation":"A letter of intent must be met with dollars invested within 13 months. The customer needs to invest an additional $7,000 to fulfill his letter of intent. The rep should remind the customer of his intention to qualify for the reduced sales charge."
    },
    {
       "id":438,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Last year, SIA Mutual Fund paid dividends of $1.50 per share and distributed $.80 per share in capital gains. The fund has a bid price of $13.50 and an asked price of $14.20. An investor, who purchased shares in this fund nine months before the distributions, received $100 in eligible dividend income and $53 in capital gains. The investor will: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Not be required to pay any federal taxes on the dividend income </li><li>Be required to pay federal taxes at ordinary income rates on the dividend income </li><li>Be required to pay capital gains tax on $53 </li><li>Not be required to pay capital gains tax on $53</li></ol>",
       "choice_a":"I and III",
       "choice_b":"I and IV",
       "choice_c":"II and III",
       "choice_d":"II and IV",
       "correct_answer":"C",
       "explanation":"The investor will pay taxes on both the dividend income and the capital gains."
    },
    {
       "id":439,
       "practice_test_id":"",
       "topic_id":5,
       "question":"A broker dealer selling open end investment company shares will be required to return its entire selling concession if the principal underwriter has to repurchase those shares from a customer within how many business days of trade date?",
       "choice_a":7,
       "choice_b":15,
       "choice_c":30,
       "choice_d":60,
       "correct_answer":"A",
       "explanation":"Customers have the right to redeem their shares, with full sales charges rebated, within seven business days of purchase. Any concession earned by the member selling the shares must be returned to the principal underwriter of the fund."
    },
    {
       "id":440,
       "practice_test_id":"",
       "topic_id":5,
       "question":"A customer will receive a price based on the net asset value computed:",
       "choice_a":"The previous business day",
       "choice_b":"The same day regardless of when the order is received",
       "choice_c":"The next time the fund computes it",
       "choice_d":"Within the next two business days",
       "correct_answer":"C",
       "explanation":"Orders to redeem shares are executed at the next computed price."
    },
    {
       "id":441,
       "practice_test_id":"",
       "topic_id":5,
       "question":"When an investment representative explains mutual funds to a prospective investor, which of the following statements can he use? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>\u0022Mutual fund shares are liquid, so you can switch from fund to fund without tax liability.\u0022 </li><li>\u0022A fund always redeems shares at NAV so you have very little chance of a financial loss.\u0022 </li><li>\u0022The redemption value of mutual fund shares fluctuates according to the value of the fund\u0027s portfolio.\u0022 </li><li>\u0022Because mutual funds must make payment within seven days of redemption, you always can receive a return of your original investment.</li></ol>",
       "choice_a":"I, II and IV",
       "choice_b":"I and III",
       "choice_c":"III",
       "choice_d":"III and IV",
       "correct_answer":"C",
       "explanation":"Mutual funds redemption values fluctuate according to the value of the securities in the funds portfolios. An adviser may not state that the investor could always receive a turn of the original investment which is false. The choice is also incorrect because the adviser said that mutual fund switching can be done without tax liability. Switching funds creates a tax liabilty and an investor is not always able receive a return of the original investment."
    },
    {
       "id":442,
       "practice_test_id":"",
       "topic_id":5,
       "question":"SEC rules and regulations regarding securities issued by investment companies prohibit: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Closed end funds from issuing preferred stock </li><li>Open end funds from issuing preferred stock </li><li>Closed end funds from issuing bonds </li><li>Open end funds from issuing bonds</li></ol>",
       "choice_a":"I and III",
       "choice_b":"I and IV",
       "choice_c":"II and III",
       "choice_d":"II and IV",
       "correct_answer":"D",
       "explanation":"Closed end funds can issue more than one class of securities, including debt issues and preferred stock. Open end funds can issue only one class of voting stock; they cannot issue any senior security."
    },
    {
       "id":443,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Your client has asked about the automatic dividend reinvestment SIA Fund offers. In describing the differences between dividend reinvestment and receiving distributions in cash, you can make which of the following statements? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>\u0022One benefit of dividend reinvestment is that distributions reinvested are tax deferred, whereas dividends received in cash are taxable in the year received.\u0022 </li><li>\u0022The taxation of the dividend distribution is not affected by your choice to reinvest or receive the dividend in cash.\u0022 </li><li>\u0022Your proportionate ownership in SIA Fund will decline if you elect to receive dividend distributions in cash.\u0022 </li><li>\u0022Your proportionate ownership in SIA Fund is guaranteed to increase if you elect dividend reinvestment.</li></ol>",
       "choice_a":"I and III",
       "choice_b":"I and IV",
       "choice_c":"II and III",
       "choice_d":"II and IV",
       "correct_answer":"C",
       "explanation":"Dividend reinvestment does not defer taxation of the distribution and a shareholder\u0027s proportionate share of the fund will decline if other investors reinvest their dividends. Dividends reinvested are not tax deferred nor do they guarantee that an investor will increase his proportionate interest in the fund. An investor\u0027s percentage ownership will decline if other investors reinvest when the investor does not, but no one can guarantee that it will increase if the investor does reinvest."
    },
    {
       "id":444,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Last year, SIA Mutual Fund paid dividends of $1.50 per share and distributed $.80 per share in capital gains. The fund has a bid price of $13.50 and an asked price of $14.20. An investor who purchased shares in this fund nine months before the distributions receives $100 in eligible dividend income and $53 in capital gains. If this is the individual\u0027s only investment, he will: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Not be required to pay any federal taxes on the dividend income </li><li>Be required to pay federal taxes at the ordinary income rate on the dividend income </li><li>Be required to pay capital gains tax on$53 </li><li>Not be required to pay capital gains tax on $53</li></ol>",
       "choice_a":"I and III",
       "choice_b":"I and IV",
       "choice_c":"II and III",
       "choice_d":"II and IV",
       "correct_answer":"C",
       "explanation":"Investors are required to pay taxes on all distributions from mutual funds, whether reinvested or received in cash. Dividends are taxable as ordinary income and capital gains distributions are taxed at capital gains rates."
    },
    {
       "id":445,
       "practice_test_id":"",
       "topic_id":5,
       "question":"A mutual fund has an 8% sales load, a redemption fee of one half of 1% and a current offering price of $10.70. If your customer redeems 1,000 shares of the fund, the customer will receive",
       "choice_a":"$9,572.38",
       "choice_b":"$9,794.78",
       "choice_c":"$9,844",
       "choice_d":"$10,646.50",
       "correct_answer":"B",
       "explanation":"Mutual fund shares are redeemed at the NAV. In this example, find the NAV by subtracting the sales charge from the POP. 8% x 10.70 = .8556. 10.70 x .8556 = 9.846. If 1000 shares are to be redeemed at 9.84, the investor receives $9,844. A redemption fee of one half of 1% reduces the $9,844 to 9,794.78."
    },
    {
       "id":446,
       "practice_test_id":"",
       "topic_id":5,
       "question":"An investment company must register with the SEC and, in doing so, must provide all of the following information except its:",
       "choice_a":"Intention to borrow money",
       "choice_b":"Intended trading practices",
       "choice_c":"Present or future plans to issue senior securities",
       "choice_d":"Intention to concentrate its investments in a single industry",
       "correct_answer":"B",
       "explanation":"Investment companies need not outline their trading practices. However, a registration statement must describe any intent to borrow money or issue senior securities. A company\u0027s concentration of investments is part of its required investment policy description."
    },
    {
       "id":447,
       "practice_test_id":"",
       "topic_id":5,
       "question":"The Investment Company Act of 1940 requires that a mutual fund must: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Issue a statement of investment policy </li><li>Have $100,000 minimum capitalization </li><li>Ensure that 51% of the directors are neither officers nor investment advisers of the company</li></ol>",
       "choice_a":"I only",
       "choice_b":"II only",
       "choice_c":"II and III only",
       "choice_d":"I, II and III",
       "correct_answer":"D",
       "explanation":"The Investment Company Act of 1940 requires that an investment company issue a state­ment of investment policy, have $100,000 minimum capitalization and that 51% of the directors are neither officers nor investment advisers of the company, 51% of the board of directors cannot be affiliated with the investment company."
    },
    {
       "id":448,
       "practice_test_id":"",
       "topic_id":5,
       "question":"To advertise itself as a diversified investment portfolio company, an investment company must do which of the following?",
       "choice_a":"Invest at least 75 percent of its assets in a portfolio of corporate and other non­proprietary securities",
       "choice_b":"Avoid portfolio concentration by limiting investment amounts per issuer to no more than 5 percent of the fund\u0027s total  assets",
       "choice_c":"Avoid control relationships and entanglements with individual companies by limiting investments to no more than 10 percent of any company\u0027s voting class securities",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"An investment company may describe itself as diversified, only if it follows the three qualifications stated."
    },
    {
       "id":449,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Under the Investment Company Act of 1940, redemption payments for mutual fund shares must be made within how many days?",
       "choice_a":5,
       "choice_b":7,
       "choice_c":10,
       "choice_d":15,
       "correct_answer":"B",
       "explanation":"If a customer tenders mutual fund shares for redemption, payment must be made within seven days under the 1940 act."
    },
    {
       "id":450,
       "practice_test_id":"",
       "topic_id":5,
       "question":"All of the following are redeemable securities except:",
       "choice_a":"Mutual funds",
       "choice_b":"REITS",
       "choice_c":"Unit trusts",
       "choice_d":"Variable annuities",
       "correct_answer":"B",
       "explanation":"A redeemable security is one for which there is no secondary market. In other words, in order to sell (redeem), the investor must go back to the issuer or its agent. REITs trade in the secondary market; some are listed, some trade OTC."
    },
    {
       "id":451,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Open end investment companies, but not closed end investment companies, can: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Make continuous offerings of shares provided that the original registration statement and prospectus are periodically updated  </li><li>Be listed on registered national exchanges  </li><li>Redeem their shares  </li><li>Issue common but not preferred stock</li></ol>",
       "choice_a":"I, II and III",
       "choice_b":"I and III",
       "choice_c":"I, III and IV",
       "choice_d":"II and IV",
       "correct_answer":"C",
       "explanation":"Open end investment companies offer shares through continuous primary offerings. Only common shares are issued, and they must be redeemed by the issuer upon the written request of the shareholder. Closed end company shares trade on registered exchanges or over the counter."
    },
    {
       "id":452,
       "practice_test_id":"",
       "topic_id":5,
       "question":"The NAV of mutual fund shares is calculated:",
       "choice_a":"Daily",
       "choice_b":"Monthly",
       "choice_c":"As prescribed in the prospectus",
       "choice_d":"Whenever the number of shares out standing increases",
       "correct_answer":"C",
       "explanation":"BEST CHOICE A mutual fund\u0027s NAV is calculated according to a formula described in the prospectus, but under no circumstances may calculation occur less frequently than once per business day."
    },
    {
       "id":453,
       "practice_test_id":"",
       "topic_id":5,
       "question":"The Investment Company Act of 1940 states that:",
       "choice_a":"It is unnecessary for the prospectus to disclose the management fee",
       "choice_b":"Open end companies may issue common stock only",
       "choice_c":"An investment company must have $5 million capital before its securities can be offered to the public",
       "choice_d":"No more than 50% of the board of directors of an investment company may be officers or employees of the company or investment advisers to the company",
       "correct_answer":"B",
       "explanation":"Open end companies may issue only one class of equity common stock. The prospec­tus must state the management fee. An investment company needs only $100,000 and 100 investors in order to offer itself to the public. No more than 49% of the board of directors can be made up of officers or employees of the company."
    },
    {
       "id":454,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Your customer buys SIA Growth Fund and enjoys a substantial paper capital gain. When he believes the market has reached its peak, he switches into SIA Income Fund within the SIA family of funds. He incurs a small service fee, but is not charged an additional sales charge. What is the tax effect?",
       "choice_a":"Any gain or loss is deferred until he liquidates the SIA Income Fund",
       "choice_b":"The tax basis of SIA Income Fund is adjusted to reflect the gain in SIA Growth Fund",
       "choice_c":"It is a tax free exchange",
       "choice_d":"Any gain in SIA Growth Fund is taxable because the exchange is treated as a sale and a purchase",
       "correct_answer":"D",
       "explanation":"The exchange is treated as a sale, regardless of the holding period and the fact that it does not involve a new sales charge. The gain or loss on SIA Growth Fund is determined by comparing the cost basis with the net asset value of the shares at the time of exchange. Any difference is a capital gain or loss."
    },
    {
       "id":455,
       "practice_test_id":"",
       "topic_id":5,
       "question":"A municipal securities dealer informed SIA municipal bond fund that it was the leading distributor of SIA shares and that it was only fair that, in return, SIA should employ the dealer in effecting more transactions for the fund\u0027s portfolio. Which of the following is true about this request?",
       "choice_a":"It is permissible, because MSRB rules do not cover municipal bond issuers or funds",
       "choice_b":"It is permissible, because it suggests a more reciprocal arrangement between the two parties",
       "choice_c":"It is not permissible, because it violates the MSRB anti-reciprocity rule",
       "choice_d":"It is not permissible, because municipal securities dealers are not allowed to execute trades for the portfolios of funds whose shares they underwrite",
       "correct_answer":"C",
       "explanation":"An investment company must select a dealer to execute its portfolio transactions based on services provided. It is a violation of the anti-reciprocity rule (MSRB Rule G-31) for an investment company to choose a firm to trade its portfolio based solely on sales of units or shares of the fund"
    },
    {
       "id":456,
       "practice_test_id":2,
       "topic_id":5,
       "question":"A sales agreement between a principal underwriter and a member enabling the latter to receive a discount from the public offering price must: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Be in writing </li><li>Provide for a full refund by the member to the underwriter equaling the full concession of the original sale if the issuer repurchases the security within seven business days after the confirmation </li><li>Provide that the member shall maintain the offer price when selling to the public</li></ol>",
       "choice_a":"I only",
       "choice_b":"I and II only",
       "choice_c":"II and III only",
       "choice_d":"I, II and III",
       "correct_answer":"D",
       "explanation":"All valid sales agreements must be in writing, provide for a seven day refund and include a stipulation that the member will maintain the public offering price."
    },
    {
       "id":457,
       "practice_test_id":3,
       "topic_id":5,
       "question":"The public offering price for a mutual fund as quoted in the financial press reflects:",
       "choice_a":"The maximum sales charge the fund dis­tributor collects",
       "choice_b":"The average sales charge for the preceding 12 months the fund distributor collects",
       "choice_c":"The minimum sales charge the fund distributor collects",
       "choice_d":"No sales charge because the offering price depends on the quantity purchased",
       "correct_answer":"A",
       "explanation":"The public offering price for a quoted mutual fund includes the maximum sales charge the fund distributor can assess."
    },
    {
       "id":458,
       "practice_test_id":4,
       "topic_id":5,
       "question":"All of the following statements concerning investment companies are true except:",
       "choice_a":"A non-diversified company is any management company not classified as a diversified company",
       "choice_b":"To be considered a diversified investment company, the company must invest at least 75% of its total assets in securities",
       "choice_c":"An investment company that invests the majority of its assets in one company or industry is considered a non-diversified company",
       "choice_d":"A diversified company can be an open­ end investment company only",
       "correct_answer":"D",
       "explanation":"A diversified company could be either a closed-end company or an open-end company. An investment company can follow the diversification formula of 75%/5%/10% and still invest within one industry (i.e. a technology fund)."
    },
    {
       "id":459,
       "practice_test_id":5,
       "topic_id":5,
       "question":"Your married customers, age 48 and 50, have a combined annual income of over $200,000. Their portfolio consists of domestic bonds and a few common stocks. They are concerned about the effects of rising inflation in the United States and seek to invest a portion of their portfolio in a fund that will provide additional diversification. Which of the following mutual funds is the most suitable for these customers?",
       "choice_a":"SIA Tax free Municipal Bond Fund",
       "choice_b":"SIA Investment-grade Bond Fund",
       "choice_c":"SIA Overseas Opportunities Fund",
       "choice_d":"SIA Government Income Fund",
       "correct_answer":"C",
       "explanation":"Investment in an overseas equity fund will provide diversification not subject to U.S. inflation."
    },
    {
       "id":460,
       "practice_test_id":6,
       "topic_id":5,
       "question":"An open end investment company wishes to change its investment objective. It may do so only with a:",
       "choice_a":"Majority vote of the outstanding shares",
       "choice_b":"Majority vote of the outstanding shareholders",
       "choice_c":"Two-thirds vote of the outstanding shareholders",
       "choice_d":"Unanimous vote of the board of directors",
       "correct_answer":"A",
       "explanation":"The Investment Company Act of 1940 requires the fund to have a clearly defined investment objective. The only action that can be taken to change the investment objective is a majority vote of the outstanding shares (shares vote, not shareholders)."
    },
    {
       "id":461,
       "practice_test_id":"",
       "topic_id":5,
       "question":"A mutual fund that charges 12b-1 fees may use the money to cover all of the following except:",
       "choice_a":"Sales fees",
       "choice_b":"Management fees",
       "choice_c":"Promotion costs",
       "choice_d":"Printing costs",
       "correct_answer":"B",
       "explanation":"12b-1 fees may not be used to pay the portfolio manager\u0027s fees, but they may cover the expenses of printing and mailing prospectuses, sales promotions and fees and any other activity relating to the distribution of fund shares."
    },
    {
       "id":462,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Which of the following depicts the way mutual fund shares are quoted in financial media?",
       "choice_a":"Bid = NAV; Ask = NAV plus an average sales charge",
       "choice_b":"Bid = NAV less any redemption fee; Ask = NAV plus an average sales charge",
       "choice_c":"Bid = NAV; Ask = NAV plus the maximum sales charge",
       "choice_d":"Bid = NAV less any redemption fee; Ask = NAV plus the maximum sales charge",
       "correct_answer":"C",
       "explanation":"The bid is synonymous with NAV for a mutual fund, which represents the price an inves&shy;tor receives when shares are redeemed. The ask represents the price an investor pays to purchase shares, which is the NAV plus a sales charge. The media always quotes the offering price for a fund based upon the maximum sales charge allowed."
    },
    {
       "id":463,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Closed-end investment company shares may be: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Traded in the secondary marketplace, including the exchanges and OTC markets </li><li>Sold in the OTC primary market only </li><li>Redeemed by the closed-end investment company </li><li>Traded by institutional investors</li></ol>",
       "choice_a":"I only",
       "choice_b":"I and IV",
       "choice_c":"II only",
       "choice_d":"III and IV",
       "correct_answer":"B",
       "explanation":"Once a closed-end investment company has distributed all of its authorized shares, those shares are traded in the secondary market."
    },
    {
       "id":464,
       "practice_test_id":"",
       "topic_id":5,
       "question":"In a mutual fund portfolio, it is permissible to buy all of the following except:",
       "choice_a":"Index options",
       "choice_b":"Junk bonds",
       "choice_c":"Shares of other mutual funds",
       "choice_d":"Stock on margin",
       "correct_answer":"D",
       "explanation":"Mutual funds may not purchase securities on margin because, in the event of a margin call, they have no recourse to investors\u0027 funds. A fund is not prohibited from buying options, low-quality bonds, or any other mutual funds."
    },
    {
       "id":465,
       "practice_test_id":"",
       "topic_id":5,
       "question":"When a customer transfers the proceeds of a sale from one fund to another within the same family of funds, what are the tax consequences?",
       "choice_a":"No gains or losses are recognized until the final redemption.",
       "choice_b":"Gains are taxed at the time of the transfer, but losses are deferred until the final redemption.",
       "choice_c":"Losses are deducted at the time of the transfer, but gains are deferred until the final redemption.",
       "choice_d":"All gains and losses are recognized on the transfer date.",
       "correct_answer":"D",
       "explanation":"Although a transfer within a family of funds is not subject to a sales charge, there is liability for any taxes due. The IRS considers this round-trip transaction as a sale and a purchase. Any losses or gains must be declared on that year\u0027s tax form."
    },
    {
       "id":466,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Which of the following statements best describes a breakpoint sale?",
       "choice_a":"Compensation paid to a registered rep generated by commissions from a client who has reached another breakpoint after the registered rep no longer works for the member",
       "choice_b":"Sale of investment company shares in dollar amounts just below the point at which the sales charge is reduced on quantity transactions in order to make a higher commission",
       "choice_c":"Sale of investment company shares in anticipation of a distribution scheduled to be paid shortly",
       "choice_d":"All of the choices listed",
       "correct_answer":"B",
       "explanation":"A breakpoint sale is a violation of FINRA\u0027s Conduct Rules. It occurs when a broker counsels a client to purchase shares in an amount immediately below the amount that would qualify the client for a discounted sales charge."
    },
    {
       "id":467,
       "practice_test_id":"",
       "topic_id":5,
       "question":"If a mutual fund has a bid price of $9.15 and a sales charge of 8.5%, what is the price an investor will pay for each share of this fund?",
       "choice_a":"$8.37",
       "choice_b":"$9.93",
       "choice_c":"$10",
       "choice_d":"$10.76",
       "correct_answer":"C",
       "explanation":"Mutual fund shares are purchased at the POP. To find the POP use the formula: POP = NAV/(100% - SC%).In this example, 9.15/.915 = POP of $10."
    },
    {
       "id":468,
       "practice_test_id":"",
       "topic_id":5,
       "question":"An investment company share purchased at its net asset value that can be redeemed later at the then-current net asset value is a share issued by a(n):",
       "choice_a":"Open-end investment company",
       "choice_b":"Closed-end investment company",
       "choice_c":"Front-end load company",
       "choice_d":"No-load, open-end investment company",
       "correct_answer":"D",
       "explanation":"A share purchased at its NAV and sold at its NAV is a no-load fund. NAV + the sales charge = the POP; if there is no sales charge, the NAV = the POP."
    },
    {
       "id":469,
       "practice_test_id":"",
       "topic_id":5,
       "question":"A fund must inform its shareholders of their right to reinvest dividends at NAV:",
       "choice_a":"Quarterly",
       "choice_b":"Annually",
       "choice_c":"At the time of each distribution",
       "choice_d":"At the time of original purchase only",
       "correct_answer":"B",
       "explanation":"A fund must notify shareholders of their right to reinvest at least annually and it usually accomplishes this through the annual report sent to every investor."
    },
    {
       "id":470,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Under which of the following circumstances will a FINRA member that buys mutual fund shares from the principal underwriter be entitled to a discount from the POP?",
       "choice_a":"The member buys in anticipation of receiving purchase orders from customers within a few hours and signs a selling agreement with the underwriter",
       "choice_b":"The member buys to fill customer purchase orders already in hand and executes a selling agreement with the underwriter",
       "choice_c":"The member is a market maker, buying for the firm\u0027s trading account",
       "choice_d":"Discounts from the POP are never allowed",
       "correct_answer":"B",
       "explanation":"FINRA rules prohibit principal under writers of investment company securities from selling at a discount below the POP unless (1) the buyer is an FINRA member firm, (2) a selling agreement exists between the two firms, and (3) the buying firm is filling customer purchase orders or buying shares for the firm\u0027s proprietary investment account. Under no circumstances may FINRA members make a market in mutual fund shares"
    },
    {
       "id":24718,
       "practice_test_id":"",
       "topic_id":5,
       "question":"An investor has begun a dollar cost averaging plan and has made the following contributions resulting the in following purchases: <img src='/question_assets/series6/24718.png'></img> What is the investor\u0027s average cost?",
       "choice_a":"$13.33",
       "choice_b":"$15",
       "choice_c":"$7.50",
       "choice_d":"$17.50",
       "correct_answer":"A",
       "explanation":"To determine the investor\u0027s average cost use the following formula: Total dollars invested / total number of shares purchased. In this case, $400/30= $13.33."
    },
    {
       "id":24720,
       "practice_test_id":"",
       "topic_id":5,
       "question":"An investor who has been investing in an open end mutual fund has placed $540 into the fund over the last several months. The investments have purchased 22 shares. The investor now wants to sell 8 of these shares to meet an unexpected expense. The mutual fund has an NAV of $26.10 and a POP of $27.05. What is the investor\u0027s gain or loss on the shares?",
       "choice_a":"$12.48 gain",
       "choice_b":"$20.08 gain",
       "choice_c":"$12,48 loss",
       "choice_d":"$20.08 loss",
       "correct_answer":"A",
       "explanation":"To determine the investor\u0027s gain or loss you must first find out the investor\u0027s average cost. This is found by taking total amount invested and dividing it by the number of shares purchased. $540/ 22 shares = $24.54. The investor will sell the shares at the current NAV of $26.10 for a gain of $1.56 per share. The investor is selling 8 shares for a total gain of $12.48"
    },
    {
       "id":24735,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Which of the following is true relating to the taxation of annuities?",
       "choice_a":"They are deferred until the annuity phase or until the investor closes out the contract",
       "choice_b":"They are fully taxable in the annuity phase of the contract",
       "choice_c":"They are fully taxable during the accumulation phase",
       "choice_d":"They are taxed annually after the annuity phase ends",
       "correct_answer":"A",
       "explanation":"An annuity is a non qualified account and as such the money is deposited with after tax dollars. The investor\u0027s deposits will be returned to them tax free. The taxation on the growth will be deferred until the investor annuitizes the contract or until the investor closes out the contract and takes a lump sum distribution."
    },
    {
       "id":24745,
       "practice_test_id":"",
       "topic_id":5,
       "question":"An investor wishing to purchase open end mutual funds with the performance characteristics of the S \u0026 P index would be said to have an investing style that is:",
       "choice_a":"Aggressive",
       "choice_b":"Passive",
       "choice_c":"Based on bottom up analysis",
       "choice_d":"Based on top down analysis",
       "correct_answer":"B",
       "explanation":"An investor who is seeking an investment that tracks the performance of an index such as the S \u0026 P 500 is engaging in a passive investment strategy. The assets in the fund are selected based on the makeup of the stocks in the index. Portfolio managers do not select the assets to be purchased or sold."
    },
    {
       "id":24747,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Sally Smith, a new investor, has just paid down a major portion of her student loan and is meeting with you as a representative for the first time. When discussing the performance characteristics of an open end fund you should explain to her which two of the following would cause an increase in the net asset value of the fund?  <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The net asset value of the fund will increase when the fund pays a dividend to shareholders </li><li>The net asset value will increase when the securities in the fund appreciate </li><li>The net asset value of the fund will increase when the fund receives income </li><li>The net asset value of the fund will increase when capital gains are distributed</li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and III",
       "choice_c":"II and IV",
       "choice_d":"I and III",
       "correct_answer":"B",
       "explanation":"The NAV of a mutual fund will increase when the value of the securities in the fund increase or when the fund receives investment income in the form of an interest payment or dividend payment. If the fund distributes assets as is the case in choices I and IV the NAV of the fund will decrease."
    },
    {
       "id":24748,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Sally Smith, a new investor, has just paid down a major portion of her student loan and is meeting with you as a representative for the first time. When discussing the performance characteristics of an open end fund you should explain to her which two of the following would not cause an increase in the net asset value of the fund? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The net asset value of the fund will increase when the fund pays a dividend to shareholders </li><li>The net asset value will increase when the securities in the fund appreciate </li><li>The net asset value of the fund will increase when the fund receives income </li><li>The net asset value of the fund will increase when capital gains are distributed</li></ol>",
       "choice_a":"I and IV",
       "choice_b":"II and III",
       "choice_c":"I and II",
       "choice_d":"II and IV",
       "correct_answer":"A",
       "explanation":"The NAV of a mutual fund will increase when the value of the securities in the fund increase or when the fund receives investment income in the form of an interest payment or dividend payment. If the fund distributes assets as is the case in choices I and IV the NAV of the fund will decrease."
    },
    {
       "id":24749,
       "practice_test_id":"",
       "topic_id":5,
       "question":"An investor owns $5,000 worth of TRY closed end fund and is inquiring about the liquidation procedures for the fund. As the investor\u0027s registered representative you should tell him.",
       "choice_a":"You will liquidate the fund at the net asset value",
       "choice_b":"You will liquidate the fund the fund at the net asset value less a redemption fee",
       "choice_c":"You will liquidate the shares in the open market and will be charged a fee for the liquidation",
       "choice_d":"You will liquidate the shares in the open market and since closed end funds do not charge a sales charge you will not pay any fees upon liquidation",
       "correct_answer":"C",
       "explanation":"TRY is a closed end fund and the shares are bought and sold in the open market. An investor who is looking to sell shares in a closed end fund would enter an order to sell the shares and would be charged a commission by the brokerage firm to execute the order."
    },
    {
       "id":24751,
       "practice_test_id":"",
       "topic_id":5,
       "question":"A large investor has placed a significant amount of money into an open end mutual fund. The investor owns 10 percent of the total outstanding shares of the fund. Which of the following is correct?",
       "choice_a":"The large investor has a continuous preemptive right",
       "choice_b":"The large investor owns an undivided interest in the fund",
       "choice_c":"The large investor will have a say regarding asset allocation",
       "choice_d":"The large investor will have a right to specific assets held by the fund",
       "correct_answer":"B",
       "explanation":"Regardless of how big or small the investor\u0027s holdings are in a mutual fund all investors own an undivided interest in the portfolio."
    },
    {
       "id":24755,
       "practice_test_id":"",
       "topic_id":5,
       "question":"An investor wants to place money into a pooled investment that will offer him the opportunity to move money between managed portfolios at the NAV to time the market. Which of the following investments would be the best asset selection for this investor?",
       "choice_a":"A UIT",
       "choice_b":"A closed end fund",
       "choice_c":"An ETF",
       "choice_d":"An open end fund",
       "correct_answer":"D",
       "explanation":"The only investment that would allow the investor to move money between portfolios at the NAV would be the open end mutual fund. A closed end fund and an ETF can trade at, above or below the NAV. Therefore, these choices are eliminated. A UIT is not the correct choice because UITs usually have portfolios that are either fixed or that invest in specific funds as part of a variable product."
    },
    {
       "id":20426,
       "practice_test_id":2,
       "topic_id":5,
       "question":"A variable annuity is:",
       "choice_a":"A retirement vehicle",
       "choice_b":"A mutual fund-like product",
       "choice_c":"An insurance product",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"A variable annuity is a retirement vehicle offered by insurance companies whereby investors, contributions in mutual fund shares /seperate account grows tax deferred until retirement."
    },
    {
       "id":20427,
       "practice_test_id":3,
       "topic_id":5,
       "question":"An investor who is concerned with liquidity risk would be least likely to purchase which of the following?",
       "choice_a":"Common stock",
       "choice_b":"Variable annuities",
       "choice_c":"Money market securities",
       "choice_d":"Mutual fund shares",
       "correct_answer":"B",
       "explanation":"Common stock, money market securities and mutual funds are all liquid investments. A variable annuity follows the same rules as a traditional IRA in that the investor cannot liquidate the annuity before the age of 59\u00BD without a penalty and tax consequence."
    },
    {
       "id":20429,
       "practice_test_id":4,
       "topic_id":5,
       "question":"All of the following are true with regards to a variable annuity\u0027s separate account except:",
       "choice_a":"If the separate account is a direct investment account it is classified as an open end investment company",
       "choice_b":"If the variable annuity\u0027s separate account is an indirect investment account it is classified as a UIT",
       "choice_c":"The separate account may only be used to invest in mutual fund shares",
       "choice_d":"The separate account may not be commingled with the general account of the insurance company",
       "correct_answer":"C",
       "explanation":"A variable annuity\u0027s separate account is named as such because the assets in the account must be kept separate from the insurance company\u0027s general account. If the separate account invests in mutual fund shares the account is an indirect investment account and is classified as a UIT under the Investment Company Act of 1940. If the separate account invests in individual stocks and bonds it is a direct investment account and is classified as an open end investment company."
    },
    {
       "id":20430,
       "practice_test_id":5,
       "topic_id":5,
       "question":"All of the following purchase options can be used by investors investing in variable annuities except:",
       "choice_a":"Periodic payment immediate annuity",
       "choice_b":"Single premium immediate annuity",
       "choice_c":"Periodic payment deferred annuity",
       "choice_d":"Single premium deferred annuity",
       "correct_answer":"A",
       "explanation":"Investors may invest in variable annuities by making a single contribution and either:  begin taking immediate payments or defer payments until a later date. If an investor chooses to make multiple payments into the annuity they must choose to defer payments. The insurance company prohibits the investor from receiving payments while they are still investing in the separate account."
    },
    {
       "id":20431,
       "practice_test_id":6,
       "topic_id":5,
       "question":"Which of the following risks would an investor in a fixed annuity be subject to? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Inflation risk  </li><li>Purchasing power risk  </li><li>Investment risk  </li><li>Systematic risk</li></ol>",
       "choice_a":"I, II",
       "choice_b":"II, IV",
       "choice_c":"I, II, IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"A",
       "explanation":"Investors in fixed annuities are guaranteed a fixed rate of return on their investment. They are at risk that the fixed return will not outpace the rate of inflation (inflation risk) and that their money won\u0027t buy as much in the future as it does today (purchasing power risk). There is no investment risk to the investor, that risk is borne by the insurance company, as is the systematic risk."
    },
    {
       "id":20432,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Which of the following is/are true of a variable annuity\u0027s pay-in and pay-out phase? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The value of accumulation units can vary  </li><li>The number of accumulation units can vary  </li><li>The value of the annuity units can vary  </li><li>The number of annuity units can vary</li></ol>",
       "choice_a":"I, II, IV",
       "choice_b":"I, III, IV",
       "choice_c":"I, II, III",
       "choice_d":"II, III, IV",
       "correct_answer":"C",
       "explanation":"In the pay-in phase of a variable annuity the investors purchases annuity units which can fluctuate in value as the separate account goes up and down. The investor can also make multiple purchases, which can affect the number of accumulation units he owns. During the pay-out phase the annuity units are now fixed in number because the investor is no longer buying additional units, however the value of the units is still subject to fluctuation."
    },
    {
       "id":20433,
       "practice_test_id":"",
       "topic_id":5,
       "question":"When an investor annuitizes a variable annuity contract the amount of the monthly payment is based on all of the following except:",
       "choice_a":"The customer\u0027s age",
       "choice_b":"The customer\u0027s gender",
       "choice_c":"The investment management fee",
       "choice_d":"The performance of the separate account in relation to the AIR",
       "correct_answer":"C",
       "explanation":"When determining the size of the monthly check for an annuitant the insurance company factors in the annuitant\u0027s age, sex and payout option as well as the value of the account and its performance in relation to the AIR."
    },
    {
       "id":20434,
       "practice_test_id":"",
       "topic_id":5,
       "question":"When determining the amount of an annuitant\u0027s monthly check which of the following is/are true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>If the separate account outperforms the AIR this month\u0027s check will be larger than last month\u0027s check  </li><li>If the separate account performance equals the AIR this month\u0027s check will be larger than last month\u0027s check  </li><li>If the separate account underperforms the AIR this month\u0027s check will be less than last month\u0027s check </li></ol>",
       "choice_a":"I only",
       "choice_b":"II only",
       "choice_c":"I, III",
       "choice_d":"I, II, III",
       "correct_answer":"C",
       "explanation":"The assumed interest rate (AIR) is a benchmark that helps determine the size of a monthly annuity check. If the separate account outperforms the AIR this month\u0027s check will be larger than last month\u0027s. If the separate account performance equals the AIR this month\u0027s check will be equal to last month\u0027s check. If the separate account under performs the AIR this month\u0027s check will be smaller than last month\u0027s check."
    },
    {
       "id":20435,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Variable annuities are considered retirement vehicles and as such are required to follow many of the same rules as traditional IRAs. All of the following apply to both variable annuities and traditional IRAs except:",
       "choice_a":"Withdrawals before the age of 59\u00BD are subject to a 10% penalty",
       "choice_b":"Excess contributions are subject to a 6% penalty",
       "choice_c":"Withdrawals due to death are not subject to a 10% penalty",
       "choice_d":"Withdrawals due to disability are not subject to a 10% penalty",
       "correct_answer":"B",
       "explanation":"Both variable annuities and IRAs are subject to a premature withdrawal penalty that will be negated in the event of death or disability. Only the IRA has contribution limits, the variable annuity does not."
    },
    {
       "id":20436,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Which of the following risks are borne by the insurance company when a customer purchases a variable annuity? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Investment risk  </li><li>Operating expense risk  </li><li>Mortality risk  </li><li>Inflation risk</li></ol>",
       "choice_a":"I, II",
       "choice_b":"II, III",
       "choice_c":"II, III, IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"B",
       "explanation":"The insurance company assumes the operating expense risk i.e. if the costs to operate the annuity are high than the insurance company anticipated they are responsible for covering those costs, not the investor; and the mortality risk insofar as the insurance company has promised to pay the annuitant for as long as he or she lives. If the annuitant outlives the insurance company\u0027s estimated life expectancy the insurance company is contractually obligated to continue paying the annuitant until the date of death."
    },
    {
       "id":20437,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Which of the following is a risk to investors in variable annuities?",
       "choice_a":"Investment risk",
       "choice_b":"Inflation risk",
       "choice_c":"Purchasing power risk",
       "choice_d":"Mortality risk",
       "correct_answer":"A",
       "explanation":"An investor in a variable annuity bears all of the investment risk. In other words there is no guarantee that the customer\u0027s annuity will rise in value. However, because of the variable nature of the investment, the inflation and purchasing power risk are mitigated. Mortality risk is a risk the insurance company, not the investor assumes."
    },
    {
       "id":20438,
       "practice_test_id":"",
       "topic_id":5,
       "question":"All of the following are risks to an investor in variable annuities except:",
       "choice_a":"Capital risk",
       "choice_b":"Liquidity risk",
       "choice_c":"Legislative risk",
       "choice_d":"Reinvestment risk",
       "correct_answer":"D",
       "explanation":"Reinvestment risk is a risk associated with callable securities and mortgage back securities. When a bond or preferred share is called away, or a mortgage is refinanced, an investor will have all or a portion of his investment returned to him earlier that he anticipated; and he may not be able to receive the same high rate of return when trying to reinvest that money."
    },
    {
       "id":20466,
       "practice_test_id":"",
       "topic_id":5,
       "question":"A prominent financial services executive retires from his position at a large financial services firm. 6 months after retiring he is asked to serve as a member of the board of directors for a mutual fund company. He is interested in serving but also wants to enjoy his retirement and wants to know what the minimum term he must serve is. His adviser should tell him.",
       "choice_a":"2 years",
       "choice_b":"3 years",
       "choice_c":"1 year",
       "choice_d":"You may serve as long or as short a term as you would like",
       "correct_answer":"C",
       "explanation":"A member of the board for a mutual fund company must serve a minimum term of 1 year."
    },
    {
       "id":20474,
       "practice_test_id":2,
       "topic_id":5,
       "question":"A new variable annuity product is being introduced by a large well respected company. The variable annuity product would be required to be registered with:  <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The SEC </li><li>The NYSE </li><li>The appropriate Insurance regulators </li><li>FINRA</li></ol>",
       "choice_a":"I and III",
       "choice_b":"II and IV",
       "choice_c":"I, II, and III",
       "choice_d":"I,II,III, IV",
       "correct_answer":"A",
       "explanation":"A variable annuity is both a security and an insurance product. As such the annuity must be registered with the SEC and the appropriate insurance regulators"
    },
    {
       "id":20479,
       "practice_test_id":3,
       "topic_id":5,
       "question":"A member of the board for a mutual fund company may serve for a maximum of how many years without being reelected?",
       "choice_a":"1 year",
       "choice_b":"3 years",
       "choice_c":"5 years",
       "choice_d":"10 years",
       "correct_answer":"C",
       "explanation":"A member of the board for a mutual fund company may serve for a maximum of 5 years without being reelected by the shareholders"
    },
    {
       "id":20495,
       "practice_test_id":4,
       "topic_id":5,
       "question":"Sales Co broker dealer is acting as the principal underwriter for GTY mutual fund. Sales Co enters into a selling agreement with RKL broker dealer that will allow RKL Broker Dealer to:",
       "choice_a":"Act as a broker when executing orders for the GTY portfolio",
       "choice_b":"Act as an adviser for GTY portfolio",
       "choice_c":"Purchase shares of GTY at  a discount from POP and immediately resell them at the POP",
       "choice_d":"Purchase share of GTY at a discount from POP in order to fill  bonafide   customer orders that it anticipates receiving",
       "correct_answer":"C",
       "explanation":"A selling agreement allows a broker dealer who is a selling group member to purchase shares of the mutual fund at a discount from the POP to fill customer orders that it already has by selling the shares immediately to those customers at the POP."
    },
    {
       "id":20497,
       "practice_test_id":5,
       "topic_id":5,
       "question":"Sales Co broker dealer is acting as the principal underwriter for GTY mutual fund. Sales Co enters into a selling agreement with RKL Broker dealer that allows RKL to distribute GTY mutual fund shares and to receive part of the selling concession for sales to its clients. RKL broker dealer would be required to return any sales concession received for sales of mutual fund shares which are redeemed within:",
       "choice_a":"3 days",
       "choice_b":"5 days",
       "choice_c":"7 days",
       "choice_d":"10 days",
       "correct_answer":"C",
       "explanation":"RKL broker dealer would be required to return any sales concession received for sales of mutual fund shares which are redeemed within 7 days of purchase by the customer."
    },
    {
       "id":21081,
       "practice_test_id":6,
       "topic_id":5,
       "question":"A lifetime income rider would be most suitable for an investor who is considering purchasing an annuity in which of the following circumstances? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The investor is already retired  </li><li>The investor anticipates a long retirement  </li><li>The investor has not yet retired  </li><li>The investor does not anticipate a long retirement</li></ol>",
       "choice_a":"II and III",
       "choice_b":"I and III",
       "choice_c":"I and II",
       "choice_d":"II and IV",
       "correct_answer":"A",
       "explanation":"A lifetime income rider would be most suitable for an investor who is not yet retired and who anticipates a long retirement."
    },
    {
       "id":21087,
       "practice_test_id":"",
       "topic_id":5,
       "question":"As it is related to retail communication regarding investment companies containing performance ranking data, which of the following is true?",
       "choice_a":"The communication is subject to a 10 day pre filing requirement",
       "choice_b":"The communication must be filed 10 days after its first use",
       "choice_c":"The performance ranking data must be submitted to FINRA\u0027s statistical analysis department",
       "choice_d":"The use of performance data is not allowed in retail communication",
       "correct_answer":"A",
       "explanation":"Retail communication regarding investment companies containing performance ranking data must be filed with FINRA 10 days prior to first use. If the communication does not contain performance ranking data it must be filed 10 days after first use."
    },
    {
       "id":21107,
       "practice_test_id":"",
       "topic_id":5,
       "question":"Investors who purchase which of the following would be required to receive a prospectus?  <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Unit investment trust  </li><li>Variable annuity  </li><li>Investment company shares  </li><li>A new issue of AAA rate corporate bonds</li></ol>",
       "choice_a":"II and III",
       "choice_b":"I and IV",
       "choice_c":"I, II, and IV",
       "choice_d":"I, II, III, IV",
       "correct_answer":"D",
       "explanation":"An investor who purchases any of the choices listed must receive a prospectus. a UIT is a type of investment company investors must receive a prospectus when purchasing a UIT."
    },
    {
       "id":36993,
       "practice_test_id":"",
       "topic_id":5,
       "question":"You have a client who wants to use mutual funds to time the market. He feels that he can move his money between sectors and in and out of the market to maximize returns. Which fund class would be best suited for this investor?",
       "choice_a":"A shares",
       "choice_b":"B shares",
       "choice_c":"C shares",
       "choice_d":"D shares",
       "correct_answer":"C",
       "explanation":"While mutual funds are not seen as short term trading vehicles, for an investor who is going to actively move money between funds and in and out of the market a C share would be the most suitable. A C share charges a level load based on the value of the share. A shares charge a front end load, B shares charge a back end load and D shares charge a level load and a back end load."
    },
    {
       "id":129,
       "practice_test_id":"",
       "topic_id":6,
       "question":"What is the greatest risk when purchasing a CMO?",
       "choice_a":"Default",
       "choice_b":"Foreclosure",
       "choice_c":"Interest rate risk",
       "choice_d":"Prepayment risk",
       "correct_answer":"D",
       "explanation":"The greatest risk when purchasing a CMO is the risk of early refinancing or prepayment risk."
    },
    {
       "id":130,
       "practice_test_id":"",
       "topic_id":6,
       "question":"What is the major risk involved in owning common stock?",
       "choice_a":"A common stockholder is the last person to get paid if the company is liquidated",
       "choice_b":"A company may decide not to pay dividends",
       "choice_c":"A company may decide to pay very small dividends, but it must pay some amount to its stockholders",
       "choice_d":"The stock may fall in value",
       "correct_answer":"D",
       "explanation":"The greatest risk is that the investor will lose some or all of his money if the stock falls in value or if the company fails."
    },
    {
       "id":131,
       "practice_test_id":"",
       "topic_id":6,
       "question":"When an investor is bearish on the market he can profit by:",
       "choice_a":"Buying common stocks",
       "choice_b":"Buying preferred stocks",
       "choice_c":"Selling short common stocks",
       "choice_d":"Selling long common stocks",
       "correct_answer":"C",
       "explanation":"Short selling is a strategy used by investors who are bearish on the market. The objective of this strategy is to sell borrowed shares at a high price and buy them back some time in the future at a lower price."
    },
    {
       "id":132,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Which equity income fund traditionally pays the highest percentage of their earnings to shareholders in the form of dividends?",
       "choice_a":"Utility stocks",
       "choice_b":"Common stock",
       "choice_c":"Preferred stock",
       "choice_d":"Government bonds",
       "correct_answer":"A",
       "explanation":"Utilities traditionally pay out the highest percentage of earnings as dividends."
    },
    {
       "id":133,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Which kind of risk is involved if the investor may lose part or all of his investment?",
       "choice_a":"Market risk",
       "choice_b":"Capital risk",
       "choice_c":"Credit risk",
       "choice_d":"Re-investment risk",
       "correct_answer":"B",
       "explanation":"If an investor may lose part or all of his capital, it is called capital risk."
    },
    {
       "id":134,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Which of the following are bearish? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Call seller </li><li>Put seller </li><li>Call buyer </li><li>Put buyer</li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and III",
       "choice_c":"I and IV",
       "choice_d":"II and IV",
       "correct_answer":"C",
       "explanation":"Call sellers and put buyers are both bearish. They want the value of the stock to fall."
    },
    {
       "id":135,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Which of the following expose the investor to unlimited risk? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Arbitrage </li><li>Short sale of stock </li><li>Sale of a naked call </li><li>Converting ADRs into the common shares</li></ol>",
       "choice_a":"I and II",
       "choice_b":"II and III",
       "choice_c":"III and IV",
       "choice_d":"I and III",
       "correct_answer":"B",
       "explanation":"The sale of a naked call and the short sale of stock subject the investor to unlimited risk."
    },
    {
       "id":136,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Which of the following investments exposes the investor to the most purchasing power risk?",
       "choice_a":"Growth fund",
       "choice_b":"Income fund",
       "choice_c":"Money market fund",
       "choice_d":"Fixed annuity",
       "correct_answer":"D",
       "explanation":"A fixed annuity will not provide any real protection from inflation and will subject the investor to the most purchasing power risk."
    },
    {
       "id":137,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Which of the following investors has unlimited risk?",
       "choice_a":"A call buyer",
       "choice_b":"A put buyer",
       "choice_c":"A call seller",
       "choice_d":"A put seller",
       "correct_answer":"C",
       "explanation":"The seller of a call has unlimited risk because there is no limit to how high the stock can go."
    },
    {
       "id":138,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Which of the following is a reason an investor would purchase a mutual fund through a contractual plan?",
       "choice_a":"To obtain the best price possible for the mutual fund shares",
       "choice_b":"To purchase shares with a lower sales charge",
       "choice_c":"To purchase mutual fund shares at a lower average price",
       "choice_d":"To purchase a mutual fund when they cannot meet the minimum initial investment",
       "correct_answer":"D",
       "explanation":"An investor would most likely purchase a mutual fund through a contractual plan because they cannot meet the initial minimum investment."
    },
    {
       "id":139,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Which of the following is not true?",
       "choice_a":"Common stock is the only investment which will meet a growth objective",
       "choice_b":"Growth funds seek capital gains and produce significant dividend income",
       "choice_c":"Growth funds seeking capital appreciation will invest in the common stock of corporations whose business is growing very rapidly",
       "choice_d":"Growth funds will invest in corporations whose business is growing more rapidly than the economy as a whole",
       "correct_answer":"B",
       "explanation":"Growth funds seek capital gains and do not produce significant dividend income."
    },
    {
       "id":140,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Which of the following strategies is the most likely way an investor would try to accumulate mutual fund shares?",
       "choice_a":"UIT",
       "choice_b":"Contractual plan",
       "choice_c":"Lump sum deposit",
       "choice_d":"Dollar cost averaging",
       "correct_answer":"D",
       "explanation":"Dollar cost averaging is much more widely used as a way to accumulate shares in an open-end mutual fund."
    },
    {
       "id":141,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Which of the following subjects the investor to unlimited risk?",
       "choice_a":"Selling stock short",
       "choice_b":"Converting a bond into the underlying common stock",
       "choice_c":"Purchase of a call",
       "choice_d":"Selling a naked put",
       "correct_answer":"A",
       "explanation":"Selling stock short will expose an investor to unlimited risk because there is no limit to how high as stock price can go."
    },
    {
       "id":142,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Why is it important for the investor to consider the tax implications of investing in municipal bonds?",
       "choice_a":"The rate of interest from municipal bonds is higher than other types of bonds",
       "choice_b":"Investors in the higher tax brackets may gain greater benefit from the tax break than investors in a lower tax bracket since interest is federally tax-free",
       "choice_c":"The rate of interest is lower in corporate bonds than in municipal bonds",
       "choice_d":"The investor may earn more interest in other types of securities",
       "correct_answer":"B",
       "explanation":"Because interest earned from municipal bonds is free of federal income tax, investors may be better off, after taxes, investing in a lower yield municipal bond."
    },
    {
       "id":143,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Your customer has purchased 75,000 shares of Semteck Electronics, which has an average daily volume of 120,000 shares. What should your customer be most concerned with?",
       "choice_a":"Systematic risk",
       "choice_b":"Non-systematic risk",
       "choice_c":"Marketability risk",
       "choice_d":"Legislative risk",
       "correct_answer":"C",
       "explanation":"Your customer has a large position in a company that stock trades a small number of shares each day. He should be concerned about marketability risk, the risk that he will not be able to sell his shares when he needs to without driving the price down."
    },
    {
       "id":144,
       "practice_test_id":1,
       "topic_id":6,
       "question":"Your customer is concerned about inflation but also wants some safety of principal. You should recommend:",
       "choice_a":"Contractual annuity",
       "choice_b":"Combination annuity",
       "choice_c":"Payment deferred annuity",
       "choice_d":"Immediate payment annuity",
       "correct_answer":"B",
       "explanation":"The combination annuity is perfect since it has a fixed portion with no risk, and a variable portion, which will tend to outpace inflation."
    },
    {
       "id":145,
       "practice_test_id":2,
       "topic_id":6,
       "question":"Your customer is inquiring about a particular bond investment. Which of the following would be of most concern to him?",
       "choice_a":"Nominal yield",
       "choice_b":"Current yield",
       "choice_c":"Yield to maturity",
       "choice_d":"Price",
       "correct_answer":"C",
       "explanation":"The yield to maturity or the YTM is the investor\u0027s overall return on a bond and would be the most important."
    },
    {
       "id":146,
       "practice_test_id":3,
       "topic_id":6,
       "question":"Your customer is interested in the largest monthly payment from her annuity now that she has retired. Which of the following payout options will give her the greatest monthly payment?",
       "choice_a":"Joint with last survivor",
       "choice_b":"Life with period certain",
       "choice_c":"Life without period",
       "choice_d":"Life only/straight life",
       "correct_answer":"D",
       "explanation":"The payout options in order from largest monthly payment to smallest are: life only/straight life, life with period certain, and lastly, joint with last survivor."
    },
    {
       "id":147,
       "practice_test_id":4,
       "topic_id":6,
       "question":"Your customer needs immediate access to his money, which is the list in order from most suitable to least suitable",
       "choice_a":"Money market funds, stocks and bonds and mutual funds, annuities, and real estate",
       "choice_b":"Stocks and bonds, money market funds, annuities, and CMOs",
       "choice_c":"Stocks and bonds, annuities, CMOs, and real estate",
       "choice_d":"Real estate, money market funds, stocks and bonds, and annuities",
       "correct_answer":"A",
       "explanation":"The most liquid investment is money market funds, followed by stocks and bonds and mutual funds, annuities, CMOs, direct participation programs, and finally real estate."
    },
    {
       "id":148,
       "practice_test_id":5,
       "topic_id":6,
       "question":"Your customer wants a guaranteed rate of return for her annuity. Which type of annuity should a representative recommend for her?",
       "choice_a":"Fixed annuity",
       "choice_b":"Variable annuity",
       "choice_c":"Contractual annuity",
       "choice_d":"Combination annuity",
       "correct_answer":"A",
       "explanation":"A fixed annuity guarantees a fixed rate of return, regardless of whether or not the portfolio produces the guaranteed rate of return."
    },
    {
       "id":149,
       "practice_test_id":6,
       "topic_id":6,
       "question":"Your customer wants a no-risk annuity. Which type of investment should a representative recommend for him?",
       "choice_a":"Fixed annuity",
       "choice_b":"Variable annuity",
       "choice_c":"Contractual annuity",
       "choice_d":"Combination annuity",
       "correct_answer":"A",
       "explanation":"A fixed annuity has no investment risk, so your customer should be offered a fixed annuity."
    },
    {
       "id":150,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Your customer wants to invest in a conservative income producing investment and is inquiring about GNMAs. She wants to know the minimum dollar amount required to purchase a pass through certificate. You should tell her:",
       "choice_a":"$10,000",
       "choice_b":"$1,000",
       "choice_c":"$25,000",
       "choice_d":"There is no minimum, you can invest almost any sum",
       "correct_answer":"B",
       "explanation":"The minimum dollar amount to purchase a GNMA pass through certificate is $1,000."
    },
    {
       "id":151,
       "practice_test_id":"",
       "topic_id":6,
       "question":"ABC Corporation declares a 5-4 stock split. On the ex-date, the price of ABC common will be reduced by:",
       "choice_a":"20%",
       "choice_b":"25%",
       "choice_c":"50%",
       "choice_d":"80%",
       "correct_answer":"A",
       "explanation":"As a result of a stock split, an investor will have more shares at less value per share, but overall value will remain the same. For example: Investor owns 100 shares at $50 per share worth $5000. After a 5-4 split, the investor will have 125 shares (100 x 5 / 4); the total ownership interest of $5000 is divided by the new number of shares to determine the per share price of $40. The decrease of 50 to 40 is a 20% reduction. As a rule of thumb, the percent decrease in price will always be less than the percent increase in the number of shares. The percent increase in shares in a 5-4 split is 25%."
    },
    {
       "id":152,
       "practice_test_id":"",
       "topic_id":6,
       "question":"ABC, Inc. will issue new stock through a rights offering. Terms of the offering are 10 rights plus $10 to purchase one new share of stock, with any fractional shares to be considered whole shares. ABC is currently trading at $13. If your customer owns 85 shares of ABC and wishes to subscribe to the new offering, how many shares can he purchase at the subscription price, and how much money will be required?",
       "choice_a":"Eight shares, and $80",
       "choice_b":"Eight shares, and $90",
       "choice_c":"Nine shares, and $80",
       "choice_d":"Nine shares, and $90",
       "correct_answer":"D",
       "explanation":"Your customer is entitled to 90 rights with his current holding of 85 shares (fractional shares are rounded up). Because each share requires 10 rights and $10, the customer can purchase 90 shares and must pay $90."
    },
    {
       "id":153,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Cumulative voting gives an advantage to the:",
       "choice_a":"Majority over minority stockholders",
       "choice_b":"Management over the board of directors",
       "choice_c":"Minority over the majority shareholders",
       "choice_d":"Participating preferred over the nonparticipating preferred holders",
       "correct_answer":"C",
       "explanation":"Cumulative voting allows shareholders to aggregate their votes and cast them as they please. They could cast all of their votes for a single candidate. Cumulative voting makes it easier for a minority group of shareholders to gain representation on the board. Choice A is incorrect because this voting style encourages minority representation on the board, not helping the majority stockholders. Choice B is incorrect because this voting style assists the minority vs. majority shareholders, not management vs. directors. Choice D is incorrect because preferred shareholders (both types) are normally nonvoting."
    },
    {
       "id":154,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Which of the following statements is true of a company offering cumulative nonparticipating preferred stock?",
       "choice_a":"It pays the preferred dividend before paying the coupons due on its outstand­ing bonds.",
       "choice_b":"It pays past and current preferred dividends before paying dividends on common.",
       "choice_c":"It pays the current dividends on the preferred, but not the past dividends on the preferred, before paying a dividend on the common. It forces conversion of the preferred that is trading at a discount to par, thereby eliminating the necessity of paying past due dividends.",
       "choice_d":"",
       "correct_answer":"B",
       "explanation":"The company must pay current and unpaid past dividends on cumulative preferred stock before common stockholders can receive a dividend. Bondholders are always paid interest before dividends on preferred shares."
    },
    {
       "id":155,
       "practice_test_id":"",
       "topic_id":6,
       "question":"A stock power is a(n):",
       "choice_a":"Document delegating discretion to purchase or sell securities to another party",
       "choice_b":"Authorization delegating voting power to another person",
       "choice_c":"Document authorizing transfer of ownership to another party that can be attached to a stock or bond certificate",
       "choice_d":"Legal right of the owner to vote stock as he chooses",
       "correct_answer":"C",
       "explanation":"A stock power is an instrument separate from the stock certificate by which an owner indicates the intent to transfer ownership of the securities. Answer A describes a type of power of attorney, and answer B describes a proxy. A stock power is also called a power of substitution."
    },
    {
       "id":156,
       "practice_test_id":"",
       "topic_id":6,
       "question":"An annual report sent to shareholders will include which of the following? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Balance sheet </li><li>Income statement </li><li>Statement of change in stockholders\u0027 equity </li><li>Cash flow statement</li></ol>",
       "choice_a":"I and II only",
       "choice_b":"I, II and III only",
       "choice_c":"I and III only",
       "choice_d":"I, II, III, and IV",
       "correct_answer":"D",
       "explanation":"The annual report sent to shareholders is an audited statement including the balance sheet, income statement and shareholder\u0027s equity, or net worth. The inclusion of a cash flow statement is also required."
    },
    {
       "id":157,
       "practice_test_id":"",
       "topic_id":6,
       "question":"A corporation needs shareholder approval for which of the following?",
       "choice_a":"A cash dividend",
       "choice_b":"A 4 for 1 split",
       "choice_c":"A 10% stock dividend",
       "choice_d":"The repurchase of 100,000 of its own shares",
       "correct_answer":"B",
       "explanation":"Stockholders have a right to vote on such items as mergers, reorganizations, recapitalizations and stock splits. The payment of divi­dends, cash or stock, is decided by the Board of Directors as is the repurchase of shares."
    },
    {
       "id":158,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Holders of which of the following securities do not receive dividends?",
       "choice_a":"Warrants",
       "choice_b":"Common stock",
       "choice_c":"Preferred stock",
       "choice_d":"Convertible preferred stock",
       "correct_answer":"A",
       "explanation":"Dividends are not paid to holders of warrants. Dividends are paid to common and preferred shareholders."
    },
    {
       "id":159,
       "practice_test_id":"",
       "topic_id":6,
       "question":"The holders of which of the following securities are considered owners of the issuing corporation? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Mortgage bonds </li><li>Convertible debentures </li><li>Preferred stock </li><li>Common stock</li></ol>",
       "choice_a":"I, II and III only",
       "choice_b":"III and IV only",
       "choice_c":"IV only",
       "choice_d":"I, II, III and IV",
       "correct_answer":"B",
       "explanation":"Persons that own stock in a company are considered owners. Both common and preferred shareholders have ownership (equity) in a corporation. Bondholders are creditors of the corporation. Although convertible bonds convert into shares of common stock, convertible bonds remain debt of a corporation until they are converted."
    },
    {
       "id":160,
       "practice_test_id":"",
       "topic_id":6,
       "question":"SIA Corp., Whose common stock is trading at $32, has issued $40,000,000 of 8.125% debentures due 10-1-24. Each bond issued has a warrant attached enabling the holder to buy 4 shares of SIA common at $40 per share. If all of the warrants are exercised, SIA Corp. will receive:",
       "choice_a":"$6.4 million",
       "choice_b":"$10.0 million",
       "choice_c":"$12.8 million",
       "choice_d":"$20.0 million",
       "correct_answer":"A",
       "explanation":"There are a total of 40,000 warrants outstanding ($40,000,000 of debentures divided by $1,000 par value per bond). Each warrant entitles the holder to buy 4 shares of common stock. Therefore, if all warrants are exercised, holders will be purchasing 160,000 shares (4 x 40,000) at $40 per share. 160,000 x $40 = $6.4 million."
    },
    {
       "id":161,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Which two of the following statements regarding ADRs are not true? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Owners have voting rights. </li><li>Owners have preemptive rights. </li><li>Owners have the right to dividends. </li><li>Owners are subject to currency risk.</li></ol>",
       "choice_a":"I and II",
       "choice_b":"I and IV",
       "choice_c":"II and III",
       "choice_d":"III and IV",
       "correct_answer":"A",
       "explanation":"ADR holders do not vote and do not have preemptive rights. The issuing bank has these rights. Holders do have the right to dividends and are subject to currency risk."
    },
    {
       "id":162,
       "practice_test_id":"",
       "topic_id":6,
       "question":"ABC declares a $.12 dividend to shareholders of record as of Tuesday, January 15th. The stock will go ex-dividend on:",
       "choice_a":"Sunday, January 13th",
       "choice_b":"Thursday, January 10th",
       "choice_c":"Friday, January 11th",
       "choice_d":"Monday , January 14th",
       "correct_answer":"D",
       "explanation":"The ex-dividend date for stock is 1 business day prior to the record date."
    },
    {
       "id":163,
       "practice_test_id":"",
       "topic_id":6,
       "question":"All of the following are rights of common stockholders except?",
       "choice_a":"Right to elect the board of directors",
       "choice_b":"Right to vote for executive compensation",
       "choice_c":"Right to vote for a stock split",
       "choice_d":"Right to maintain their percentage of ownership in the company",
       "correct_answer":"B",
       "explanation":"A stockholder does not get to vote directly for executive compensation."
    },
    {
       "id":164,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Choose the fund with the lowest beta:",
       "choice_a":"Index fund",
       "choice_b":"Growth fund",
       "choice_c":"Long-term income fund",
       "choice_d":"Money market fund",
       "correct_answer":"D",
       "explanation":"A money market fund has no beta. The NAV is stable and is always equal to $1."
    },
    {
       "id":165,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Common stockholders do not have the right to vote on which of the following issues?",
       "choice_a":"Election of the Board of Directors",
       "choice_b":"Stock splits",
       "choice_c":"Issuance of additional common shares",
       "choice_d":"Bankruptcy",
       "correct_answer":"D",
       "explanation":"Common stockholders do not have voting power in the matter of bankruptcy."
    },
    {
       "id":166,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Dividends are all of the following except:",
       "choice_a":"A portion of the earnings of the company",
       "choice_b":"A source of income for the investor",
       "choice_c":"Generally paid quarterly",
       "choice_d":"A figure determined by subtracting the current yield from the current market price.",
       "correct_answer":"D",
       "explanation":"Dividend yield(or current yield) is found by dividing the annual income by the current market price."
    },
    {
       "id":167,
       "practice_test_id":"",
       "topic_id":6,
       "question":"From the choices listed below, pick the investment that is the most secure with regard to its ability to meet its payments in a timely fashion",
       "choice_a":"AAA subordinated debenture",
       "choice_b":"AA mortgage bond",
       "choice_c":"AA equipment trust certificate",
       "choice_d":"AA collateral trust certificate",
       "correct_answer":"A",
       "explanation":"The question asks which is the most secure as it relates to the issuer\u0027s ability to pay the interest and principal in a timely fashion. The rating has more weight than the collateral."
    },
    {
       "id":168,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Limited liability means:",
       "choice_a":"The stockholder is limited in the amount of money he can invest",
       "choice_b":"The stockholder is limited in the amount of control he has over the liabilities",
       "choice_c":"The stockholder is limited in the amount of money he can lose, which is no more than he has invested",
       "choice_d":"The stockholder is limited in the number of shares of stock he can buy",
       "correct_answer":"C",
       "explanation":"The investor cannot be held liable for any amount of money in excess of his invested capital."
    },
    {
       "id":169,
       "practice_test_id":1,
       "topic_id":6,
       "question":"Stockholders have all of the following rights except:",
       "choice_a":"The right to review all corporate financial data",
       "choice_b":"The right to inspect the books and records",
       "choice_c":"The right to receive their proportional share of the funds left after bankruptcy or liquidation and all creditors have been paid",
       "choice_d":"The right to obtain a list of stockholders\u0027 names",
       "correct_answer":"A",
       "explanation":"The stockholders may inspect the company\u0027s books and records but they do not have the right to review any other corporate financial data."
    },
    {
       "id":170,
       "practice_test_id":2,
       "topic_id":6,
       "question":"The two methods of voting by common stockholders differ in which way?",
       "choice_a":"The statutory method allows the votes to be distributed evenly among the candidates the investor wishes to vote for, while the cumulative method allows the stockholders to cast all of their votes for one candidate.",
       "choice_b":"The cumulative method allows the votes to be distributed evenly among the candidates the investor wishes to vote for, while the statutory method allows the stockholders to cast all of their votes for one candidate.",
       "choice_c":"The speculative method allows the votes to be distributed in any amounts among the candidates as the investor wishes, while the commission method allows the stockholders to cast all of their votes for several candidates.",
       "choice_d":"The commission method allows the votes to be distributed in any amounts among the candidates as the investor wishes, while the speculative method allows the stockholders to cast all of their votes for several candidates.",
       "correct_answer":"A",
       "explanation":"The statement is true as it stands."
    },
    {
       "id":171,
       "practice_test_id":3,
       "topic_id":6,
       "question":"What is the pre-emptive right of common stockholders?",
       "choice_a":"The right to consider themselves the owners of the company",
       "choice_b":"The right to direct the everyday functions of the company",
       "choice_c":"The right to maintain their percentage interest in the company",
       "choice_d":"The right to buy or sell their stock as they wish",
       "correct_answer":"C",
       "explanation":"If the company wishes to offer more stock for sale, they must first offer the new shares to the existing stockholders. If the existing stockholders decide not to purchase these new shares, the new shares can then be offered to the public."
    },
    {
       "id":172,
       "practice_test_id":4,
       "topic_id":6,
       "question":"When an issuer is in the process of raising additional capital, they can do a preemptive rights offering. The advantages to the company\u0027s existing shareholders include all of the following except:",
       "choice_a":"Right to buy new shares below the CMV",
       "choice_b":"Right to sell existing shares back to the issuer",
       "choice_c":"Right to sell the rights in the secondary market",
       "choice_d":"Right to maintain a proportional investment in the company",
       "correct_answer":"B",
       "explanation":"Subscription or pre-emptive rights are an investment tool for the issuer to raise new capital from the market place. There is no advantage to either the investor or the issuer if the issuer repurchases the rights."
    },
    {
       "id":173,
       "practice_test_id":5,
       "topic_id":6,
       "question":"Which of the following represents an ownership interest in a publicly traded company? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Preferred stock </li><li>Mortgage bond </li><li>Common stock </li><li>Authorized Stock</li></ol>",
       "choice_a":"I Only",
       "choice_b":"I and III",
       "choice_c":"I, II and III",
       "choice_d":"I, II, III and IV",
       "correct_answer":"B",
       "explanation":"Common and preferred stock both represent equity or ownership of a corporation. Authorized stock has not yet been issued, but may be sold in the future to investors."
    },
    {
       "id":174,
       "practice_test_id":6,
       "topic_id":6,
       "question":"Which type of preferred stock is likely to have the lowest stated dividend rate?",
       "choice_a":"Cumulative preferred",
       "choice_b":"Participating preferred",
       "choice_c":"Callable preferred",
       "choice_d":"Straight preferred",
       "correct_answer":"A",
       "explanation":"Cumulative preferred stock has the feature of accruing dividends that are missed and paying them out prior to paying out common stock dividends. This protective feature is a benefit to the shareholder and in exchange, the stated dividend rate is relatively lower."
    },
    {
       "id":175,
       "practice_test_id":"",
       "topic_id":6,
       "question":"XYZ has issued 7% convertible preferred stock that can be exchanged for common shares for $50 per share. The preferred stock is quoted sat $140. What is the parity price of the common?",
       "choice_a":"$7 per share",
       "choice_b":"$28 per share",
       "choice_c":"$70 per share",
       "choice_d":"$200 per share",
       "correct_answer":"C",
       "explanation":"We can determine the number of shares by dividing par value by the conversion price. In this case $100 / $50 = 2 shares Parity price = CMV of the preferred stock / # of shares = 140/ 2= 70"
    },
    {
       "id":176,
       "practice_test_id":"",
       "topic_id":6,
       "question":"XYZ has paid a 14 cent dividend for the last 16 quarters. The price of XYZ has risen dramatically over the last 12 months. Which of the following is true?",
       "choice_a":"The yield on XYZ has fallen",
       "choice_b":"The yield on XYZ has risen",
       "choice_c":"Interest rates have risen",
       "choice_d":"Interest rates have fallen",
       "correct_answer":"A",
       "explanation":"As the price of XYZ has risen, the yield on the stock has fallen. Prices and yields always move in an inverse relationship."
    },
    {
       "id":177,
       "practice_test_id":"",
       "topic_id":6,
       "question":"XYZ has paid a 14 cent dividend for the last 16 quarters. The price of XYZ has risen dramatically over the last 12 months. Which of the following is true?",
       "choice_a":"The yield on XYZ has fallen",
       "choice_b":"The yield on XYZ has risen",
       "choice_c":"Interest rates have risen",
       "choice_d":"Interest rates have fallen",
       "correct_answer":"A",
       "explanation":"As the price of XYZ has risen, the yield on the stock has fallen. Prices and yields always move in an inverse relationship."
    },
    {
       "id":178,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Recommendations a broker-dealer makes to a customer must be suitable for the customer based on an investigation of the customer\u0027s <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Investment objectives </li><li>Financial background </li><li>Tax status</li></ol>",
       "choice_a":"I only",
       "choice_b":"I and II only",
       "choice_c":"II and III only",
       "choice_d":"I, II, and III",
       "correct_answer":"D",
       "explanation":"A broker-dealer should take into account a customer\u0027s financial status, tax bracket and investment objectives when recommending a security."
    },
    {
       "id":179,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Two of your customers, age 34 and 30, have been married for two years. Both work, and they have one child. They live in the suburbs and are planning to buy a home. They need a safe place to invest the amount they have saved for their down payment for about six months. Which of the following mutual funds is the most suitable for these customers?",
       "choice_a":"SIA Capital Appreciation Fund",
       "choice_b":"SIA Growth & Income Fund",
       "choice_c":"SIA Cash Reserves Money Market Fund",
       "choice_d":"SIA Investment grade Bond Fund",
       "correct_answer":"C",
       "explanation":"These customers are preparing to make a major purchase within the next few months. They require a highly liquid investment to keep their money safe for a short amount of time. The money-market fund best matches this objective."
    },
    {
       "id":180,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Customers who are conservative, in their fifties are interested in preservation of principal and high current income from their investments. In which order, from first to last, are the following bonds ranked in terms of their suitability to the customers\u0027 needs? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>A1 Pittsburg Gas 9 1/4s of \u002725 </li><li>AA+ Cleveland Transit 9 1/4s of \u002725 </li><li>Aaa Iowa Telecom 9 1 /4s of \u002725 </li><li>AAA-  Michigan Electric 9 1/4s of \u002725</li></ol>",
       "choice_a":"III, II, IV, I",
       "choice_b":"IV,III,I,II",
       "choice_c":"I, II, III, IV",
       "choice_d":"III, IV, II, I",
       "correct_answer":"D",
       "explanation":"A plus or minus sign in a Standard & Poor\u0027s rating indicates that the bonds fall within, respectively, the top or bottom of that particular category. Moody\u0027s uses a \u00221\u0022 after the letter rating to indicate the highest quality bonds within a category. Based on the ratings given, the highest quality bond is the Texas Telecom, rated Aaa, followed in order by the bonds rated AAA- , AA+ and A1."
    },
    {
       "id":181,
       "practice_test_id":"",
       "topic_id":6,
       "question":"A client would like to have $50,000 set aside when his child starts college, but does not want to invest in anything that could endanger the principal. In this situation, you should recommend:",
       "choice_a":"Treasury STRIPS",
       "choice_b":"Corporate bonds with high rates of interest",
       "choice_c":"Municipal bonds for their tax benefits",
       "choice_d":"Common stock",
       "correct_answer":"A",
       "explanation":"Zero coupon bonds offer no current income which is appropriate for this client who wants all the return paid at a future date for college expenses."
    },
    {
       "id":182,
       "practice_test_id":"",
       "topic_id":6,
       "question":"A person\u0027s investment decisions should be based primarily on their: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Risk tolerance </li><li>Representative\u0027s recommendations </li><li>Investment needs</li></ol>",
       "choice_a":"I only",
       "choice_b":"I and III only",
       "choice_c":"II and III only",
       "choice_d":"I, II and III",
       "correct_answer":"B",
       "explanation":"Understanding and acceptance of risk and investment objectives should determine an individual\u0027s investment decisions. Recommendations by a representative represent possible actions, but the client must make a decision based on whether the investment is suitable."
    },
    {
       "id":183,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Variable rate municipal bonds are subject to all of the following risks except:",
       "choice_a":"Interest rate",
       "choice_b":"Default",
       "choice_c":"Liquidity",
       "choice_d":"Legislative",
       "correct_answer":"A",
       "explanation":"A variable rate bond is one whose coupon is adjusted periodically (semi-annually or annually) to reflect current interest rates. Therefore, if rates rise, forcing prices down, the coupon on a variable rate bond will be adjusted upward, thereby tending to keep the bond\u0027s price at or near par. Therefore, there is no interest rate risk associated with these bonds. On the other hand, if rates fall, the coupon will be adjusted downward, keeping the bond\u0027s price at or around par. Normally, a fall in interest rates force prices up but not with variable rate bonds."
    },
    {
       "id":184,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Which of the following securities is subject to the greatest financial risk?",
       "choice_a":"SIA, Inc. common stock",
       "choice_b":"BAA rated SIA convertible bond",
       "choice_c":"Series EE bond",
       "choice_d":"A rated municipal bond",
       "correct_answer":"A",
       "explanation":"Common stock is a junior security. It is considered less safe than any type of bond because it has the lowest claim to assets in the event of the issuing firm\u0027s liquidation."
    },
    {
       "id":185,
       "practice_test_id":"",
       "topic_id":6,
       "question":"A customer wishes to buy SIA bonds. You, as his representative, have advised that the trade is unsuitable. If he decides to go ahead with the purchase, you must do which of the following?",
       "choice_a":"Execute the trade specifically as the customer has directed you to do",
       "choice_b":"Execute the trade if the FINRA approves",
       "choice_c":"Execute the trade only if the customer has previous trading experience in similar securities",
       "choice_d":"Not execute the trade",
       "correct_answer":"A",
       "explanation":"If a customer wishes to purchase a security that the registered representative feels is unsuitable, the trade may be executed if the customer specifically directs it. The ticket should be marked unsolicited."
    },
    {
       "id":186,
       "practice_test_id":"",
       "topic_id":6,
       "question":"A customer is in the 15% federal income tax bracket. His main investment objective is maximum current income. Which of the following securities should the registered representative recommend?",
       "choice_a":"U.S. government bond",
       "choice_b":"City of Atlanta general obligation bond",
       "choice_c":"Zero coupon bond",
       "choice_d":"Investment grade corporate bond",
       "correct_answer":"D",
       "explanation":"The investor is in a low tax bracket; therefore, the tax exempt municipal bond is not a suitable investment. To maximize income, the best recommendation is the corporate bond, which offers a higher yield than a government bond with a similar maturity."
    },
    {
       "id":187,
       "practice_test_id":"",
       "topic_id":6,
       "question":"If your customer is pursuing an aggressive stock buying strategy; which of the following is most suitable for him?",
       "choice_a":"SIA stock with a beta coefficient of 1.0",
       "choice_b":"DEF stock with a beta coefficient of .93",
       "choice_c":"GHI stock with a beta coefficient of 1.20",
       "choice_d":"Convertible bonds of a blue-chip company",
       "correct_answer":"C",
       "explanation":"Beta coefficients over 1 signify that the stock will fluctuate more than the market as a whole. In general, the higher the beta, the greater the risk. Such risk-taking is appropriate for investors who seek aggressive stock-buying strategies and have both the financial ability and the temperament to withstand downturns in the market."
    },
    {
       "id":188,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Which of the following securities is the least suitable recommendation for a qualified money-purchase plan account?",
       "choice_a":"Blue-chip common stock",
       "choice_b":"Investment grade municipal bond",
       "choice_c":"Treasury bill",
       "choice_d":"A-rated corporate bond",
       "correct_answer":"B",
       "explanation":"Because municipal bonds offer tax-exempt interest payments, they generally offer lower yields. On withdrawal, distributions are 100% taxable, so why buy lower yielding munis providing tax-exempt interest income when, on withdrawal, the interest income will be taxable as ordinary income?"
    },
    {
       "id":189,
       "practice_test_id":"",
       "topic_id":6,
       "question":"If a customer is concerned about interest rate risk, which of the following securities is least appropriate?",
       "choice_a":"Treasury bills",
       "choice_b":"Project notes",
       "choice_c":"10-year corporate bonds",
       "choice_d":"18-year municipal bonds",
       "correct_answer":"D",
       "explanation":"Interest rate risk is the danger that interest rates will rise over the life of the debt instrument and adversely affect a bond\u0027s price. This risk is greatest for long-term bonds. Short-term debt securities are impacted the least if interest rates change. Project notes are fairly short-term and have little interest rate risk"
    },
    {
       "id":190,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Two conservative customers in their fifties are interested in preservation of principal and high current income from their investments. In which order, from first to last, are the following bonds ranked in terms of their suitability to their needs? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>A Chicago Gas 9 1/4s of \u002725 </li><li>AA+ Detroit Transit 9 1/4s of \u002725 </li><li>Aaa Penn Telecom 9 1/4s of \u002725 </li><li>AAA- Denver Electric 9 1/4s of \u002725</li></ol>",
       "choice_a":"III, II, IV, I",
       "choice_b":"IV, III, I, II",
       "choice_c":"I, II, III, IV",
       "choice_d":"III, IV, II, I",
       "correct_answer":"D",
       "explanation":"A plus or minus sign in a Standard \u0026 Poor\u0027s rating indicates that the bonds fall within, respectively, the top or bottom of that particular category. Moody\u0027s uses a \u00221\u0022 after the letter rating to indicate the highest quality bonds within a category. Based on the ratings given, the highest quality bond is the Texas Telecom, rated Aaa, followed in order by the bonds rated AAA-, AA+, and Al."
    },
    {
       "id":191,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Which of the following securities carries the highest degree of purchasing power risk?",
       "choice_a":"Blue-chip stock",
       "choice_b":"Short-term note",
       "choice_c":"Long-term, high-grade bond",
       "choice_d":"Convertible cumulative preferred stock",
       "correct_answer":"C",
       "explanation":"The longer a fixed-income investment is held, the more vulnerable the investor is to purchasing power risk from inflation. Although preferred stock is also a fixed-income investment, convertible preferred will increase in value with the underlying common stock."
    },
    {
       "id":192,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Which of the following securities should an investment representative recommend to a customer who wants to set up an IRA?",
       "choice_a":"Municipal bond fund shares",
       "choice_b":"Term insurance contract",
       "choice_c":"Growth stock",
       "choice_d":"Put options",
       "correct_answer":"C",
       "explanation":"Growth stocks potentially provide long-term returns suitable for a retirement account. A municipal bond fund is incorrect because IRA distributions are 100% taxable which makes the investment in tax exempt securities unattractive. Insurance is not permitted in an IRA account and speculative options are inappropriate for a retirement account."
    },
    {
       "id":24714,
       "practice_test_id":"",
       "topic_id":6,
       "question":"A 45 year old in the 28 percent tax bracket is speaking to you as his representative seeking an investment to augment his 401K plan. Which of the following would be the best recommendation for your client?",
       "choice_a":"Variable annuity, accumulation units",
       "choice_b":"Variable annuity, annuity units",
       "choice_c":"A growth mutual fund",
       "choice_d":"An S & P 500 index fund",
       "correct_answer":"A",
       "explanation":"An investor who is looking to augment or supplement a retirement plan would be most suitable for a deferred variable annuity contract. During the accumulation phase the money is allowed to grow tax deferred and the investor will own accumulation units."
    },
    {
       "id":24724,
       "practice_test_id":"",
       "topic_id":6,
       "question":"An investor with a 2 year time horizon has $75,000 to invest. He is seeking semiannual payments of interest income. Which of the following would you recommend?",
       "choice_a":"Treasury note",
       "choice_b":"Treasury bond",
       "choice_c":"2 year STRIP",
       "choice_d":"Treasury bill",
       "correct_answer":"A",
       "explanation":"Of the choices listed the only option that actually pays interest is the Treasury note. All of the other choices are discount securities which do not pay interest. Discounted securities appreciate to their par or face value at maturity."
    },
    {
       "id":24739,
       "practice_test_id":"",
       "topic_id":6,
       "question":"A registered representative has a long standing client who is 73 years old. The RR speaks to the client twice per month. The RR also has the client\u0027s 43 year old daughter as a client. During the last several months the client has consistently said that his investment objectives have changed and he is now looking for income and wants to purchase a particular income fund. The representative notices that the client often seems to forget speaking to the RR. However, each time they speak he says he wants to purchase the income fund and that his objectives have changed. The registered representative should:",
       "choice_a":"Purchase the fund for the client and mark the order unsolicited",
       "choice_b":"Invite the daughter to the next meeting with the client",
       "choice_c":"Have the daughter obtain written power of attorney for client\u0027s account",
       "choice_d":"Refuse to execute the order",
       "correct_answer":"A",
       "explanation":"The registered representative should execute the order at the customer\u0027s request. Inviting the daughter to the meeting is not a correct choice as an RR may never disclose details of the investor\u0027s holdings to another party without the customer\u0027s consent. The choices in the question make you take an action. If there was an option to consult a principal of the firm prior to executing an order, that would be a better option."
    },
    {
       "id":24740,
       "practice_test_id":1,
       "topic_id":6,
       "question":"Your client is in his mid fifties and will be retiring several years. He wants to make several changes to his portfolio and is seeking steady income and protection of principal. As his representative which of the following would you most likely recommend?",
       "choice_a":"Buy a portfolio of corporate bonds maturing in 2-7 years",
       "choice_b":"Buy a portfolio of AAA rate municipal bonds with 30 year maturity",
       "choice_c":"Buy a portfolio the highest yielding municipal securities",
       "choice_d":"Buy a portfolio of high yielding corporate bonds",
       "correct_answer":"A",
       "explanation":"The invest is looking for income and safety of principal, the High yield bonds are not appropriate as they contain too much risk. The AAA rate munis would subject the investor to too much principal risk if interest rates changed. The short term corporate bonds therefore at the best choice in this situation."
    },
    {
       "id":20418,
       "practice_test_id":2,
       "topic_id":6,
       "question":"John Sno, a 38 year old customer with a 5 year old daughter, wants to begin saving for his daughter\u2019s college education. He is interested in a 529 plan. You tell him:",
       "choice_a":"He can choose a 529 plan that is a prepaid tuition plan and begin contributing immediately",
       "choice_b":"He can choose a 529 plan that is a college savings plan and begin contributing immediately",
       "choice_c":"Both A and B",
       "choice_d":"Neither A nor B",
       "correct_answer":"C",
       "explanation":"A 529 plan can be set up as either a prepaid tuition plan, which locks in today\u2019s tuition cost at a specific college; or as a college savings plan, which allows the contributions to grow tax deferred."
    },
    {
       "id":20419,
       "practice_test_id":3,
       "topic_id":6,
       "question":"Which of the following are considered benefits of a 529 plan?",
       "choice_a":"Contributions grow tax deferred",
       "choice_b":"The cost of tuition a specific school can be locked in",
       "choice_c":"The donor maintains ownership of the account",
       "choice_d":"All of the choices listed",
       "correct_answer":"D",
       "explanation":"Contributions to a 529 plan grow tax deferred and can be used to pre-pay the cost of tuition at a specific college at today\u0027s rate. And unlike an Education IRA, the individual who set up the plan retains ownership of the contributions."
    },
    {
       "id":20420,
       "practice_test_id":4,
       "topic_id":6,
       "question":"Your customer has twin boys who are about to enter kindergarten. He realizes the need to begin saving for their college education and is trying to decide between a 529 plan and an educational IRA. You tell him: <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>The amount you can contribute to the 529 plan exceeds what you can contribute to the educational IRA </li><li>Both the 529 plan and the IRA allow you to make pre-tax contributions </li><li>Only the IRA allows withdrawals for educational expenses to be taken tax free </li><li>A benefit to the 529 is that if one of the boys chooses not to go to college the money in the plan can be used entirely for his brother\u2019s education</li></ol>",
       "choice_a":"I, II",
       "choice_b":"II, III",
       "choice_c":"I, IV",
       "choice_d":"II, IV",
       "correct_answer":"C",
       "explanation":"When deciding between an education IRA and a 529 plan it is important to note that the contribution limitations for an educational IRA are much lower than for a 529 plan. Additionally, contributions are made with after tax dollars, and withdrawals for education are usually tax free in both the IRA and the 529 plan. And only in the 529 can the money be transferred, without tax or penalty, to another \u201Creasonably related\u201D person to be used for that individual\u2019s education."
    },
    {
       "id":20421,
       "practice_test_id":5,
       "topic_id":6,
       "question":"If a client wishes to open an account for a minor whereby he, the donor, retains ownership of the account he would most likely open a:",
       "choice_a":"Coverdell IRA",
       "choice_b":"529 plan",
       "choice_c":"UGMA",
       "choice_d":"UTMA",
       "correct_answer":"B",
       "explanation":"In a 529 plan the donor remains the owner of the account even when the minor reaches the age of majority. In a Coverdell IRA, UGMA and UTMA, account the minor is the beneficial owner of the account from its inception."
    },
    {
       "id":20422,
       "practice_test_id":6,
       "topic_id":6,
       "question":"All of the following are true regarding 529 plans except:",
       "choice_a":"Once established the account becomes the property of the minor",
       "choice_b":"The account can be established as a college savings plan",
       "choice_c":"Withdrawals for educational expenses are federally tax free",
       "choice_d":"The account can be established as a prepaid tuition plan",
       "correct_answer":"A",
       "explanation":"When a 529 plan is created the donor makes after tax contributions to the account and the withdrawals are federally tax free if used for educational expenses. The account is set up for the benefit of a minor, but the donor remains the owner of the account."
    },
    {
       "id":20428,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Which of the following is most suitable for a customer who is looking for growth potential with a minimum guaranteed rate of return?",
       "choice_a":"A balanced fund",
       "choice_b":"A variable annuity",
       "choice_c":"A money market fund",
       "choice_d":"A combination annuity",
       "correct_answer":"D",
       "explanation":"A combination annuity provides a guaranteed rate of return by investing  in the general account plus a variable rate of return by investing in the separate account."
    },
    {
       "id":20443,
       "practice_test_id":"",
       "topic_id":6,
       "question":"An investor owns $50,000 worth of US T\u0027 bonds with an interest rate of 5%. The investor is in the 30% tax bracket at the federal level and 9% at the state level. The investor will have a tax liability based on the income of:",
       "choice_a":"$25,000",
       "choice_b":"$750",
       "choice_c":"$225",
       "choice_d":"$975",
       "correct_answer":"B",
       "explanation":"Interest on US T bonds is not taxed at the state or local level. The interest is only taxed that federal level. In this case the investor earned $2,500 in interest and is in the 30% tax rate. The tax liability is $750. ($2,500 X 30%)"
    },
    {
       "id":20484,
       "practice_test_id":"",
       "topic_id":6,
       "question":"A client who is interested in investing in a whole loan private label CMO is asking you about the collateral and guarantees associated with the security. Upon review of the security you should tell him:",
       "choice_a":"The securities are backed by the full faith and credit of Ginnie Mae",
       "choice_b":"The securities are tied to a pool of mortgages backed by Freddie Mac",
       "choice_c":"The securities are tied to a pool of mortgages backed by Fannie Mae",
       "choice_d":"The securities are tied to a pool of mortgages backed by a letter of credit and or insurance taken out by the issuer",
       "correct_answer":"D",
       "explanation":"A private labeled CMO is created when a broker dealer purchases a large portfolio of mortgages and sells off the interest in the pool to investors in CMOs. Whole loan CMOs are backed by the pool of mortgages which in turn may have insurance or a letter of credit backing the loans in the pool, not the CMO itself."
    },
    {
       "id":20487,
       "practice_test_id":"",
       "topic_id":6,
       "question":"An investor purchases an 8 percent corporate bond in the marketplace at par. After holding the bond fully paid for, the investor has a total return of 5 percent. Why is the investor\u0027s total return lower than the coupon rate?",
       "choice_a":"Interest rate have fallen",
       "choice_b":"The bond\u0027s total return takes into account commissions and markups paid to acquire the bond",
       "choice_c":"Interest rates have risen",
       "choice_d":"The investor paid accrued interest when the bond was purchased and the accrued interest lowers the total return",
       "correct_answer":"C",
       "explanation":"An investor\u0027s total return is found by adding the income received from the investment with any appreciation in price. If the investment falls in price the loss in value would be subtracted from the total return. The reason the investor\u0027s total return is lower than the coupon rate is due to the fact that interest rates have increased and this caused the bond to fall in price."
    },
    {
       "id":20488,
       "practice_test_id":"",
       "topic_id":6,
       "question":"A long standing client is seeking to make an initial deposit into a college plan for his son\u0027s college expenses. His son will start college in 11 years. Which of the following is the lowest priority when determining the amount of the initial deposit?",
       "choice_a":"Client\u0027s current income",
       "choice_b":"The current average cost of college",
       "choice_c":"The time until his son starts college",
       "choice_d":"The projected annual increase in tuition",
       "correct_answer":"A",
       "explanation":"The lowest priority would be the client\u0027s current income as the client is seeking to make an initial deposit. The deposit will be coming from savings so the amount of the client\u0027s savings would be far more important. The other factors can be used to estimate what the anticipated cost of college may be and are therefore of high importance."
    },
    {
       "id":20496,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Who would realize the greatest benefit as it relates to a defined benefit plan? <ol style='margin-left: 25px; list-style-type: upper-roman;'><li>Employees who have fewer years until retirement </li><li>Employees with many years until retirement  </li><li>Employees who have high salaries  </li><li>Employees who have modest salaries</li></ol>",
       "choice_a":"I and III",
       "choice_b":"I only",
       "choice_c":"II and III",
       "choice_d":"II and IV",
       "correct_answer":"A",
       "explanation":"Employees with the highest salaries with the fewest years until retirement would realize the greatest benefit from participation in a defined benefit plan. A defined benefit plan provides a stated benefit such as a set percentage of the employee\u0027s income during retirement"
    },
    {
       "id":21063,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Which of the following investments would be least suitable for an investor seeking a short term, liquid investment providing safety of principal?",
       "choice_a":"T\u0027 Bills",
       "choice_b":"Auction rate securities",
       "choice_c":"Money market funds",
       "choice_d":"30-90 day brokered CDs",
       "correct_answer":"B",
       "explanation":"Auction rate securities are long term bonds that reset the interest rate paid on the bonds at set intervals. ARS are 20-30 years in maturity which pay interest based on the auction rate every 7, 28 or 35 days. If the auction fails investors will not be able to sell the bonds immediately."
    },
    {
       "id":36991,
       "practice_test_id":"",
       "topic_id":6,
       "question":"SIA \u0026 Co. is considering borrowing funds through the sale of zero coupon bonds. As it relates to the interest payments on the issue, which of the following is true?",
       "choice_a":"Investors will pay taxes at maturity and SIA  & Co. will take the interest tax deduction at maturity",
       "choice_b":"Investors will pay taxes annually and SIA  & Co. will take the interest tax deduction at maturity",
       "choice_c":"Investors, will pay taxes at maturity and SIA  & Co. will take the interest tax deduction annually",
       "choice_d":"Investors, will pay taxes annually and SIA  & Co. will take the interest tax deduction at annually",
       "correct_answer":"B",
       "explanation":"Investors who purchase zero coupon bonds must pay taxes annually on the phantom income produced by the appreciation of the bonds. Issuers of zero coupon bonds, in this case SIA \u0026 Co must take the interest tax deduction at maturity when the interest is actually paid by the issuer."
    },
    {
       "id":36990,
       "practice_test_id":"",
       "topic_id":6,
       "question":"An investor who is risk averse is reviewing an opportunity to purchase a corporate bond issued by ABC Corporation. Which of the following would provide the investor with the greatest understanding of the bond\u0027s risk?",
       "choice_a":"Term",
       "choice_b":"Collateral",
       "choice_c":"Yield",
       "choice_d":"Price",
       "correct_answer":"C",
       "explanation":"The bond\u0027s yield is the best measure of risk. The higher the yield, the greater the risk associated with the bond. Bonds with a significant amount of risk of default or credit risk will have the highest yield to compensate investors for taking on that risk."
    },
    {
       "id":39172,
       "practice_test_id":"",
       "topic_id":6,
       "question":"A new customer is interested in pursuing income. Regarding risk tolerance she says; \u201CI\u2019m a bit defensive about that, I\u2019d rather be in investments that are non-volatile\u201D. Of the following which would be most suitable for her?",
       "choice_a":"Short-term government bonds",
       "choice_b":"High yield corporate debt instruments",
       "choice_c":"Growth stocks",
       "choice_d":"Raw land limited partnerships",
       "correct_answer":"A",
       "explanation":"Of the above investments only short-term government bonds will produce the objective (income) with little price volatility."
    },
    {
       "id":39173,
       "practice_test_id":2,
       "topic_id":6,
       "question":"A registered representative\u2019s customer is bullish on US equity securities across a number of industry categories. The customer is hoping to participate in an anticipated upward movement of an index that would represent as many of these industry categories as possible. Aligning with her market outlook, which of the following investments would you recommend as being most closely related to the movement of equities in general and therefore the most suitable recommendation?",
       "choice_a":"Standard & Poor\u0027s depository receipts (SPDRs)",
       "choice_b":"American depositary receipts (ADRs)",
       "choice_c":"Real Estate Investment Trusts (REITs)",
       "choice_d":"Variable rate demand obligations (VRDOs)",
       "correct_answer":"A",
       "explanation":"Of the choices shown, only the spider (SPDR) is an index fund designed to replicate and track the performance of the S\u0026P 500, a broad-based equity index. None of the remaining choices represent a broad base of equities. For example, REITs represent real estate holdings and VRDOs represent short-term debt obligations."
    },
    {
       "id":39174,
       "practice_test_id":3,
       "topic_id":6,
       "question":"A married couple having a long-term growth objective is considering a mutual fund but they express a specific aversion to high annual fund expenses. Given their objective and preferences, a suitable recommendation would be a:",
       "choice_a":"common stock fund with a low portfolio turnover.",
       "choice_b":"dividend producing fund with a high portfolio turnover.",
       "choice_c":"long-term corporate bond fund that is actively managed.",
       "choice_d":"preferred stock fund that is actively managed.",
       "correct_answer":"A",
       "explanation":"Of the choices given, common stock is the only investment capable of providing long-term growth. A preferred stock fund or a dividend producing fund will provide income via the dividends collected but not provide much growth. Bond funds provide income and are not designed to meet a growth objective. Lower portfolio turnover (less trading in and out of the fund portfolio) should result in lower annual fund expenses."
    },
    {
       "id":39175,
       "practice_test_id":4,
       "topic_id":6,
       "question":"A new customer in his early thirties has $100,000 to invest. He is single, has no dependents and tells you he is willing to tolerate a high degree of risk. He adds confidently that he has no anticipation of tapping into these invested funds for at least 15 years. With this profile, what would be a suitable recommendation regarding asset allocation for the customer\u2019s portfolio?",
       "choice_a":"$70,000 equities, $20,000 debt, and $10,000 money-market instruments",
       "choice_b":"$45,000 debt, $35,000 equities, and $20,000 money-market instruments",
       "choice_c":"$35,000 debt, $35,000 equities, $30,000 real estate investment trusts",
       "choice_d":"$65,000 debt, $30,000 equities and $5,000 money-market instruments",
       "correct_answer":"A",
       "explanation":"Given his 15-year time horizon and his willingness to tolerate higher levels of risk, a recommendation having a higher percentage of the portfolio in equities would be most suitable for this investor. Of the asset mixes presented only one has the majority invested in equities while the others have higher or equal concentrations in debt securities and would likely be too conservative."
    },
    {
       "id":39176,
       "practice_test_id":5,
       "topic_id":6,
       "question":"A new customer says her investment philosophy is value oriented as opposed to growth oriented. Looking for a stock recommendation and considering that value is her primary objective, which of the following stock characteristics would she be least likely to consider?",
       "choice_a":"A stock with an above average price-to-earnings ratio.",
       "choice_b":"A stock with consistent and high dividend yields.",
       "choice_c":"A stock with a low price-to-earnings ratio.",
       "choice_d":"A stock that is presently selling at a price 15% below its current book value.",
       "correct_answer":"A",
       "explanation":"A value investor focuses on stocks with low PE ratios, low price-to-book values, and historically high dividend yields. Conversely, a growth investor looks for stocks with above-average price-to-earnings ratios. Therefore, a stock with an above average price-to-earnings ratio would be least attractive or suitable for this investor."
    },
    {
       "id":39177,
       "practice_test_id":6,
       "topic_id":6,
       "question":"A married couple expresses having an investment objective of long-term growth. They have a joint account and mutually agree that they are willing to accept a reasonable amount of risk. Which type of mutual fund is the most suitable for them given their objective and risk tolerance?",
       "choice_a":"Common stock fund",
       "choice_b":"Money market fund",
       "choice_c":"Corporate bond fund",
       "choice_d":"Municipal bond fund",
       "correct_answer":"A",
       "explanation":"Of these broad fund categories offered, and given their willingness to accept a reasonable amount of risk, only a common stock fund could be expected to meet their long-term growth objective and would therefore be the most suitable."
    },
    {
       "id":39178,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Among factors to be discussed with clients pertaining to suitability, which of the following pairs would always be included?",
       "choice_a":"Liquidity preferences and number of dependents",
       "choice_b":"Professional licenses or designations and education level",
       "choice_c":"Income and languages spoken",
       "choice_d":"Eligibility for employment bonuses and monthly expenses",
       "correct_answer":"A",
       "explanation":"Regarding suitability a number of factors would be considered but they would primarily have to do with investment needs and objectives, risk tolerance and financial ability. The only pair noted above that would be relevant to these is the preference or need for liquidity and the number of dependents lending to one\u2019s financial abilities and responsibilities."
    },
    {
       "id":39179,
       "practice_test_id":"",
       "topic_id":6,
       "question":"A client profile can be summed up as follows; safety of principal, tax-free income and the need for liquidity. Of the following which would be the most suitable?",
       "choice_a":"Short-term municipal bond mutual fund",
       "choice_b":"High-yield dividend income mutual fund",
       "choice_c":"Income bonds",
       "choice_d":"Exploratory oil and gas DPP",
       "correct_answer":"A",
       "explanation":"Only the short-term municipal bond mutual fund would meet all three investment criteria. A mutual fund is liquid, municipal bond portfolios are relatively safe, and the bonds provide income free from federal tax. High-yield income funds usually invest in lower rated bonds to achieve a higher yield, income bonds only pay interest if the company can afford to meet the obligation, and exploratory oil \u0026 gas programs carry a high degree of risk."
    },
    {
       "id":39180,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Consider the following customer profile; joint account, married, ages 44 and 47, combined annual income of $280,000, residents of Florida. With a conservative risk tolerance, they have been heavily invested in bonds up to this point. They are now willing to move outside their traditional comfort zone and accept higher risk to invest $150,000 of their $3,000,000 portfolio in a fund that will provide additional diversification and specifically offer a possible hedge against the effects of inflation. Which of the following mutual funds is the most suitable for this account?",
       "choice_a":"International equity opportunities fund",
       "choice_b":"Tax-free Florida State municipal bond fund",
       "choice_c":"Tax-free Florida State municipal bond fund",
       "choice_d":"US Treasury income fund",
       "correct_answer":"A",
       "explanation":"Investment in an international equity fund will not only provide diversification to a portfolio already heavily invested in bonds, but will also provide a potential hedge against U.S. inflation. The remaining choices all invest in debt securities that are generally not a suitable hedge against inflation. Nor would they add diversification to the aforementioned existing portfolio."
    },
    {
       "id":39181,
       "practice_test_id":"",
       "topic_id":6,
       "question":"You have a corporate client with the intention of investing a large sum and prefers a managed fund. The objective is simple; current income. The corporate charter allows for moderate risk. Given the profile which of the following would be suitable?",
       "choice_a":"Preferred stock fund",
       "choice_b":"Aggressive growth fund",
       "choice_c":"Money market fund",
       "choice_d":"High-yield bond fund",
       "correct_answer":"A",
       "explanation":"Preferred stock generates current income in the form of dividends and would thus be suitable here. The other choices would have to be eliminated as follows; aggressive growth funds strive for capital appreciation rather than current income, money market funds have low yields that would not align with the yields an income investor would seek, and while high-yield bonds would provide current income, they entail too high a degree of risk."
    },
    {
       "id":39182,
       "practice_test_id":"",
       "topic_id":6,
       "question":"A client expresses that she wants the investment objective for a small $20,000 investment she wants to add to her portfolio to be income. She notes that the income stream should be reliable. She suggests four investments she thinks might be worth taking a look at. Of the four she suggests you would immediately point out that one of them is not suitable to meet her objective. Which is it?",
       "choice_a":"Income bonds",
       "choice_b":"U.S. Treasury notes",
       "choice_c":"Preferred stock",
       "choice_d":"Corporate bonds",
       "correct_answer":"A",
       "explanation":"Remember that income bonds, also known as adjustment bonds, pay interest only if the issuer has enough earnings to make those payments. They are often issued by companies coming out of bankruptcy and therefore could never be suitable for someone who has an income investment objective, particularly for someone who wants that income stream to be considered reliable."
    },
    {
       "id":39183,
       "practice_test_id":"",
       "topic_id":6,
       "question":"You are asked to make a recommendation to a client who notes having a moderate-risk tolerance. She is seeking long-term capital gains and places a high value on professional and active management to maximize potential returns. Which of the following would be best suited to her investment profile?",
       "choice_a":"Large-cap growth fund",
       "choice_b":"S&P 500 Index fund",
       "choice_c":"International index fund",
       "choice_d":"Small-cap growth fund",
       "correct_answer":"A",
       "explanation":"A large-cap growth fund is the most appropriate choice for a moderate-risk client because large capitalization stocks are generally less volatile than small capitalization stocks and generally seek to provide long-term capital growth. This is a more suitable choice than either of the index funds because those are not actively managed but invest instead to always align with the index."
    },
    {
       "id":39184,
       "practice_test_id":"",
       "topic_id":6,
       "question":"If a client is in a low tax bracket and wishes to invest only a moderate sum to gain some protection from inflation, which of the following would you offer as a suitable recommendation?",
       "choice_a":"Mutual fund with a growth objective investing in mid-cap companies.",
       "choice_b":"Municipal bond unit investment trust offering tax advantages.",
       "choice_c":"Money market mutual fund offering protection of principal.",
       "choice_d":"GNMA fund offering monthly dividends.",
       "correct_answer":"A",
       "explanation":"Historically, equities provide greater protection from inflation than debt securities do. Growth funds invest primarily in equities. Note that all of the remaining choices invest in debt securities."
    },
    {
       "id":39185,
       "practice_test_id":"",
       "topic_id":6,
       "question":"For a small portion of a $700,000 investment portfolio a client is comfortable seeking a fund with capital appreciation as its investment objective. Which of the following would meet that objective?",
       "choice_a":"Specialized fund investing primarily in the healthcare industry.",
       "choice_b":"Income fund investing primarily in high rated corporate bonds.",
       "choice_c":"Municipal bond fund investing only in Georgia State municipal bonds.",
       "choice_d":"Balanced fund actively managed to align with expected near term market conditions.",
       "correct_answer":"A",
       "explanation":"The objective of capital appreciation is most likely realized by an equity fund. Of the choices offered only a specialized fund would have such an objective. These are funds that invest in stocks of one particular industry or region."
    },
    {
       "id":39186,
       "practice_test_id":"",
       "topic_id":6,
       "question":"A customer expresses the desire to collect regular dividends, wants a high degree of safety for the principal amount he intends to invest at this time and is seeking something that might offer tax advantages for someone like himself in a high-income tax bracket. Which of the following funds might be most suitable?",
       "choice_a":"Municipal bond fund",
       "choice_b":"Corporate bond fund",
       "choice_c":"Money market fund",
       "choice_d":"Aggressive growth fund",
       "correct_answer":"A",
       "explanation":"Of the choices offered, only the municipal bond fund could offer any tax advantages because interest received from the bonds is generally exempt from federal income tax. Regarding safety, a municipal bond fund satisfies that objective as well as they are generally considered second only to U.S. government securities. All of the funds shown could meet the dividend criteria."
    },
    {
       "id":39187,
       "practice_test_id":"",
       "topic_id":6,
       "question":"A client expresses a goal to utilize funds he currently holds for a specific purpose in 5 to 7 years. Because he knows what his timeline is and currently has the funds in hand, he notes a very conservative / risk averse tolerance for this investment. As an after-thought he mentions that some type of investment with a stated maturity or expiration date is probably what he is envisioning but not something that would preclude divesting earlier if needed. Which of the following investment vehicle groups might be suitable to begin a conversation focusing on his needs, timeline and criteria?",
       "choice_a":"Treasury bonds, unit investment trusts and corporate bonds",
       "choice_b":"Treasury bills, hedge funds and specialized funds",
       "choice_c":"Listed options, exchange traded equity funds and major market index mutual funds",
       "choice_d":"Treasury bills, municipal bonds and variable annuities",
       "correct_answer":"A",
       "explanation":"Of the groupings shown, only Treasury bonds, unit investment trusts and corporate bonds could each meet this investor\u2019s criteria. Each of these has a stated maturity but can also be divested of earlier if need be. Given the stated maturity dates each could be selected to accommodate the specified time line noted and each can be chosen to align with the client\u2019s risk-averse criteria. For example, choosing AAA rated corporate bonds or a UIT that invests solely in government or AAA rated corporate debt instruments. Within the remaining groupings at least one selection within each of them would violate one or more of the investors stated criteria."
    },
    {
       "id":39188,
       "practice_test_id":1,
       "topic_id":6,
       "question":"A client notes that a few years ago debt securities tended to do well relative to the overall market but last year equities soared. While he isn\u2019t prepared to pick individual stocks or bonds himself, he asks if there are any investments relying on the expertise of others to do that and where he can rely on them to adjust the portfolio in accordance with future market expectations. Given his investment criteria you might best recommend?",
       "choice_a":"a balanced fund.",
       "choice_b":"a hedge fund.",
       "choice_c":"a specialized fund.",
       "choice_d":"an aggressive growth fund.",
       "correct_answer":"A",
       "explanation":"Balanced funds invest in both stocks and bonds. Fund managers attempt to adjust the percentage invested in the two types of securities in accordance with market expectations in order to maximize the yield obtained. The percentages invested in each class of security are not mandated by industry regulation and are therefore at the discretion of the fund manager."
    },
    {
       "id":39189,
       "practice_test_id":2,
       "topic_id":6,
       "question":"An investor\u2019s primary objective is to choose a mutual fund where dividends paid into the portfolio can be expected regardless of current market conditions. She also notes capital growth as being a reasonable secondary objective for her, given her risk tolerance. If recommending a mutual fund to this investor, which of the following industry groups would best fulfill her criteria?",
       "choice_a":"Public utilities",
       "choice_b":"Military contractors",
       "choice_c":"Blockchain technology",
       "choice_d":"Consumer retail",
       "correct_answer":"A",
       "explanation":"Utilities are defensive industries meaning that they tend to perform with some consistency regardless of market conditions. While capital growth is a reasonable expectation for utilities, their payment of dividends is historically consistent, fulfilling the investor\u2019s investment criteria."
    },
    {
       "id":39190,
       "practice_test_id":3,
       "topic_id":6,
       "question":"A client expresses an interest in investing in a portfolio that is fixed using municipal or corporate bonds. He prefers an investment with no, or limited active management so as to avoid high expense ratios. Which of the following would be a suitable recommendation?",
       "choice_a":"A unit investment trust holding debt instruments.",
       "choice_b":"A growth fund investing primarily in new issues.",
       "choice_c":"A utilities fund paying high dividends.",
       "choice_d":"An exchange traded fund for the purpose of allowing quick liquidation.",
       "correct_answer":"A",
       "explanation":"Of the options shown only a unit investment trust offers a portfolio with no, or limited active management. A unit investment trust issues shares that represent units of a fixed portfolio; one that is not actively traded."
    },
    {
       "id":39193,
       "practice_test_id":4,
       "topic_id":6,
       "question":"A new client comes to you with an existing investment portfolio that is 45% growth stocks, 10% foreign stocks and 45% income producing stocks. She tells you she is satisfied with its performance so far but might be open to some diversification using a mutual fund or exchange traded fund. She has a moderate risk tolerance. Which of the following would best accommodate her objective to diversify?",
       "choice_a":"Corporate bond fund",
       "choice_b":"Emerging markets fund",
       "choice_c":"Global equity growth fund",
       "choice_d":"Domestic growth and income fund",
       "correct_answer":"A",
       "explanation":"All of the client\u2019s current investments are in equities. The portfolio holds income stocks, growth stocks and foreign equity securities, but what is missing are debt securities. If the objective is to further diversify the current portfolio, the corporate bond fund would be the best choice of those shown."
    },
    {
       "id":39195,
       "practice_test_id":5,
       "topic_id":6,
       "question":"A new client insists that whatever the individual securities, equities or debt, he wants to invest in managed portfolios. He notes that it is very important to him that a portfolio is being monitored and amended to meet market expectations. Given the stated criteria, which of the following would not be suitable?",
       "choice_a":"Unit investment trusts",
       "choice_b":"Open-end mutual funds",
       "choice_c":"Closed-end mutual funds",
       "choice_d":"Exchange traded funds",
       "correct_answer":"A",
       "explanation":"The Investment Company Act of 1940 defines closed and open-end funds as subclassifications of management companies; actively managed portfolios. So too are exchange traded funds. Unit investment trusts however are separate investment company classifications and do not have managed portfolios. Therefore, they would not be suitable to meet this investor\u2019s criteria."
    },
    {
       "id":39196,
       "practice_test_id":6,
       "topic_id":6,
       "question":"A new client expresses that being able to get into and out of investments easily and quickly is important to her. She begins to talk about several investment types but you point out that two of them would not be suitable given her stated criteria. Which two are they?",
       "choice_a":"Unit investment trusts and open-end mutual funds",
       "choice_b":"Real estate investment trusts and exchange traded funds",
       "choice_c":"Exchange listed equities and closed-end funds",
       "choice_d":"Exchange traded funds and corporate bonds",
       "correct_answer":"A",
       "explanation":"Closed-end funds, exchange traded funds, listed equities, corporate bonds and real estate investment trusts trade actively in the secondary market. Open-end mutual funds and unit investment trusts do not trade in the secondary market making them unsuitable given this investor\u2019s stated criteria."
    },
    {
       "id":39198,
       "practice_test_id":"",
       "topic_id":6,
       "question":"A client with a well-balanced portfolio of both equity and debt securities wants to diversify allocating roughly 10% to real estate. He is concerned however about real estate being illiquid. Given this concern, which of the following real estate investments is most suitable?",
       "choice_a":"Purchasing shares of a real estate investment trust.",
       "choice_b":"Investing in a real estate limited partnership.",
       "choice_c":"Purchasing a small commercial retail building",
       "choice_d":"Purchasing a residential condominium to lease out.",
       "correct_answer":"A",
       "explanation":"Shares of a real estate investment trust (REIT) are best suited to the client because they trade in the secondary market making them easily divested of. None of the other options shown are considered liquid or easily divested of."
    },
    {
       "id":39199,
       "practice_test_id":"",
       "topic_id":6,
       "question":"An investor adamant that his investments be liquid is considering investing in American depositary receipts (ADRs). He is familiar and comfortable with all of the risks associated with investing in foreign companies. Considering his concerns about liquidity though, such an investment would:",
       "choice_a":"be suitable because shares of ADRs, whether listed on a US exchange or unlisted, trade freely in US markets.",
       "choice_b":"be suitable because they are only subject to market risk as is any security that trades freely in the open market.",
       "choice_c":"be unsuitable because the potential receipt of dividends in a foreign currency makes them subject to currency risk.",
       "choice_d":"be unsuitable given they represent ownership in a foreign entity making them subject to political risk.",
       "correct_answer":"A",
       "explanation":"American depositary receipts (ADRs) may be unsuitable for investors who are averse to political, currency, or market risk in general. However, if the investors only risk aversion has to do with liquidity, they would be deemed suitable because shares trade freely on US exchanges or in over the counter markets."
    },
    {
       "id":39200,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Your client, who is in a high-income tax bracket and has a high net worth mentions several investments that she is thinking about that might be beneficial to her. Obviously, she is concerned about any tax consequences. Considering her profile, of the investments she\u2019s spoken about which of the following would be the most suitable recommendation?",
       "choice_a":"Low yielding municipal bonds",
       "choice_b":"High yielding non-investment-grade corporate bonds",
       "choice_c":"An exchange traded fund investing in blockchain technolog",
       "choice_d":"A real estate investment trust",
       "correct_answer":"A",
       "explanation":"Of the choices shown only municipal bonds offer a tax consequence that lends itself to being more suitable for high income, high net worth investors; tax-free interest payments. Conversely, corporate bond interest, ETF dividends and income from real estate investment trusts are all taxable."
    },
    {
       "id":39201,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Your customer prefers investments that are short term and liquid because he sometimes needs unanticipated access to funds for cash flow purposes to run his business. He\u2019s considering auction rate securities given the higher rates of return he can realize with them as opposed to those offered by Treasury securities he is now holding in his account. For this customer auction rate securities would be:",
       "choice_a":"unsuitable because they are variable rate bonds with 20 to 30-year maturities and are therefore intended to be held long-term.",
       "choice_b":"unsuitable because interest rates are reset at predetermined intervals, typically weekly or monthly.",
       "choice_c":"suitable given that the rate of return is guaranteed short-term and reset over predetermined intervals going forward.",
       "choice_d":"suitable because they are short-term bonds and completely liquid at all times.",
       "correct_answer":"A",
       "explanation":"Auction rate securities (ARSs) are long-term variable rate bonds and therefore not suitable for an investor favoring short-term investments. These securities however are tied to short term interest rates which are reset at predetermined intervals using a Dutch auction system. A lack of demand for the securities can perpetuate a failed auction and until that can be rectified immediate access to funds can be limited, another reason they would not be suitable for this investor."
    },
    {
       "id":39202,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Your client who has a high net worth and substantial income is interested in debt securities with favorable tax consequences. His investor profile however shows an aversion to credit risk which you must consider before making any tax favored investment recommendations. Which of the following would not be a suitable recommendation for this client?",
       "choice_a":"Industrial revenue bonds",
       "choice_b":"General obligation bonds",
       "choice_c":"New housing authority bonds",
       "choice_d":"US treasury securities",
       "correct_answer":"A",
       "explanation":"Industrial revenue bonds are a form of municipal security which are issued to build or support facilities that the municipality then leases, generally to a corporate entity. Like most municipals they offer favorable tax consequences for those in high income tax brackets or with a high net worth. However, they represent high credit risk (therefore not suitable for this investor) because the debt service is the responsibility of the corporation leasing the facility supported by the bonds, rather than the responsibility of the issuing municipality."
    },
    {
       "id":39203,
       "practice_test_id":"",
       "topic_id":6,
       "question":"As a registered municipal bond representative for your broker-dealer you have been given discretion over the account of a physician residing in New York. The client profile shows that he is conservative, avoids investment risk, and seeks long-term growth potential. Of the following choices, which would you deem to be the most suitable to include in the physician\u2019s portfolio?",
       "choice_a":"New York transit authority revenue bonds rated Aa.",
       "choice_b":"Iowa revenue bonds rated AA.",
       "choice_c":"California high-yield municipal bonds rated BB.",
       "choice_d":"Maryland Wetlands general obligation municipal bonds rated Aa.",
       "correct_answer":"A",
       "explanation":"The Iowa revenue bonds, the sub-investment grade California bonds, and the Maryland bonds have possible state disadvantages for a purchaser residing in New York. Additionally, two of them are less than investment grade. Of these choices, the in-state New York issued bonds rated Aa would be the most suitable."
    },
    {
       "id":39204,
       "practice_test_id":2,
       "topic_id":6,
       "question":"A registered representative is making a recommendation to include municipal bonds in a customer\u2019s portfolio. Assuming the representative is well acquainted with the client\u2019s investment profile including risk tolerance, which of the following would be of least consideration regarding suitability when making a recommendation?",
       "choice_a":"What purpose the funds are being raised for.",
       "choice_b":"The customer\u0027s local municipality and state of residence.",
       "choice_c":"The customer\u0027s income, tax bracket and net worth.",
       "choice_d":"How the bonds are currently rated by Moody\u0027s.",
       "correct_answer":"A",
       "explanation":"The purpose for which the funds are being raised may be of interest to the client but it would generally be of little consideration regarding suitability when making a recommendation.However, the client\u0027s residence and financial profile, including income, net worth and tax bracket factor into suitability as these will help determine the extent of the tax benefits offered by the municipal bond. The bond\u0027s rating is important in evaluating the credit risk assumed by the investor and should align with the investor\u2019s risk tolerance."
    },
    {
       "id":39205,
       "practice_test_id":3,
       "topic_id":6,
       "question":"A client\u2019s profile shows a moderate risk tolerance in general but little or no tolerance for default or credit risk. Given this preference to avoid such risk, which of the following choices would be deemed most suitable for such an investor?",
       "choice_a":"Municipal general obligation bonds.",
       "choice_b":"Municipal revenue bonds.",
       "choice_c":"High-yield corporate \u0022junk\u0022 bonds.",
       "choice_d":"Convertible corporate debentures.",
       "correct_answer":"A",
       "explanation":"The full taxing power of a municipality backs a general obligation municipal bond lending to it being the choice shown having the least amount of credit or default risk. Taxing power does not back municipal revenue bonds. Corporate debentures which are unsecured, and \u201Cjunk\u201D or high-yield corporate bonds each have a greater or inherently high degree of risk."
    },
    {
       "id":39206,
       "practice_test_id":4,
       "topic_id":6,
       "question":"A new client has transferred her account and all of its holdings to your broker-dealer. While getting to know her and constructing a client profile, she mentions wanting to add some municipal bonds to her portfolio because she feels her income and tax bracket warrants doing so. All of the following should be used to determine the suitability of any municipal recommendations you might make except the:",
       "choice_a":"customer\u0027s marital status and number of dependents.",
       "choice_b":"customer\u0027s annual income and tax bracket.",
       "choice_c":"customer\u0027s state and local municipal residence.",
       "choice_d":"structure of the customer\u0027s existing portfolio.",
       "correct_answer":"A",
       "explanation":"While a customer\u2019s marital status and number of dependents are a part of a customer\u2019s profile, they would not be critical factors when assessing municipal bond recommendations being suitable. When recommending municipal bonds and determining suitability, a registered representative should consider the customer\u0027s tax bracket, state of residence, recognizing that intrastate issues may be double or triple tax exempt, and existing portfolio structure; debt holdings versus equity holdings and whether municipal issues are already being held."
    },
    {
       "id":39207,
       "practice_test_id":5,
       "topic_id":6,
       "question":"One of your clients is considering purchasing a bond. He has narrowed the selection down to either a 2% yielding municipal bond offered by the state he lives in, or a 4.5% yielding corporate bond. He\u2019s at a loss as to how to determine which one would actually give him the greatest return for his investment. While many profile items would factor into suitability, one is critical for you to do the required calculation needed to answer his specific question. Which is it?",
       "choice_a":"His current tax bracket.",
       "choice_b":"His length of residency in the municipal issuers state.",
       "choice_c":"His current portfolio holdings.",
       "choice_d":"His current net worth.",
       "correct_answer":"A",
       "explanation":"In order to make the most suitable recommendation, you must do a tax-equivalent yield (corporate) or tax-free equivalent yield (municipal) calculation. For either formula you need the investor\u0027s tax bracket. Current portfolio holdings and net worth, while factoring into suitability, have no bearing on the calculation. Nor would the length of time he\u2019s resided in the state."
    },
    {
       "id":39210,
       "practice_test_id":6,
       "topic_id":6,
       "question":"A new client in her early 40\u2019s notes that she is finally ready to consider tax deferred growth as an objective for a sum of cash she has been setting aside specifically for retirement income. Up to this point in time she has been diligent in funding an IRA each year and contributes as much as is allowed to her employer\u2019s 401k plan. Which of the following would be the most suitable for meeting her objective?",
       "choice_a":"A variable annuity",
       "choice_b":"AAA rated corporate bond",
       "choice_c":"Tax-free municipal bond",
       "choice_d":"Growth & income mutual fund",
       "correct_answer":"A",
       "explanation":"The only investment listed here offering tax-deferred growth and suitable for achieving supplemental retirement income outside of her IRA and 401k is a variable annuity. Ideally, VAs should be funded with readily available cash rather than using funds liquidated from existing investments."
    },
    {
       "id":39211,
       "practice_test_id":"",
       "topic_id":6,
       "question":"Given the following client profiles, for which might a variable annuity be a suitable recommendation?",
       "choice_a":"Age 51, with cash available and no anticipated need to access the funds until retirement.",
       "choice_b":"Age 71, retired for five years hoping to preserve capital currently invested in corporate bonds to leave to six children.",
       "choice_c":"Age 34, recently unemployed with several thousand dollars in severance pay available to invest.",
       "choice_d":"Age 29, with no need to access the funds until needed for college funding for two children beginning in roughly ten years.",
       "correct_answer":"A",
       "explanation":"Generating a supplemental income stream for retirement, not preservation of capital should be the primary objective present when considering a VA. Having cash on hand, rather than liquidating existing investments should also be a consideration for choosing a VA as suitable. Finally, for anyone who may need access to the funds invested for any reason other than supplementing retirement income, a VA would not be considered a suitable recommendation."
    }
  ]